import { __decorate, __metadata, __param, __extends, __read, __assign, __values, __spread } from 'tslib';
import { CommonModule, isPlatformBrowser, DOCUMENT } from '@angular/common';
import { InjectionToken, Inject, Input, HostBinding, Component, ViewEncapsulation, NgModule, ChangeDetectionStrategy, ElementRef, Directive, EventEmitter, ChangeDetectorRef, Output, ViewContainerRef, ComponentFactoryResolver, TemplateRef, Optional, Self, SkipSelf, ContentChild, ContentChildren, QueryList, HostListener, ViewChild, forwardRef, Renderer2, ViewChildren, PLATFORM_ID, NgZone, ɵɵdefineInjectable, ɵɵinject, Injectable, Pipe, ApplicationRef, Injector } from '@angular/core';
import { NgControl, AbstractControl, FormControlName, ControlContainer, NgForm, ReactiveFormsModule, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

/**
 * Configuration for Haven Design System's default SVG icon sprite.
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';

function IconComponent__svg_title_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "title", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r0.titleId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.title);
} }
function IconComponent__svg_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "use");
    ɵngcc0.ɵɵelementStart(2, "svg", 5);
    ɵngcc0.ɵɵelementStart(3, "g", 6);
    ɵngcc0.ɵɵelementContainer(4, 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    var _r2 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("href", "assets/icons.svg#u-outline", null, "xlink");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function IconComponent__svg_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "use");
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("href", ctx_r3.iconHref, null, "xlink");
} }
var _c0 = ["hlButton", ""];
var _c1 = [[["hl-icon", "start", ""]], "*", [["hl-icon", "end", ""]]];
var _c2 = ["hl-icon[start]", "*", "hl-icon[end]"];
var _c3 = ["hlMinimalButton", ""];
function MinimalButtonComponent_hl_icon_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hl-icon", 2);
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("icon", ctx_r0.icon);
} }
var _c4 = ["*"];
var _c5 = ".hl-button,.hl-minimal-button{margin:0;padding:.125rem;border:.125rem solid;-webkit-appearance:none;-moz-appearance:none;appearance:none;overflow:visible;font-family:inherit;font-size:1rem;text-decoration:none;text-transform:none;background-color:transparent;color:inherit;cursor:pointer;min-height:2rem;border-radius:.25rem;display:inline-flex;justify-content:center;align-items:center;transition-duration:150ms;transition-property:background-color,box-shadow,color,transform}.hl-button:active,.hl-minimal-button:active{transform:scale(.98)}.hl-button:disabled,.hl-minimal-button:disabled{opacity:.45;cursor:not-allowed;transform:none}.hl-button [class*='__text']:not(:empty),.hl-minimal-button [class*='__text']:not(:empty){padding-left:.25rem;padding-right:.25rem}.hl-button .hl-icon,.hl-minimal-button .hl-icon{flex-shrink:0}.hl-button{position:relative;min-height:3rem;padding:.5rem 2rem;border-radius:999999px}.hl-button:hover{box-shadow:0 0 8px rgba(0,0,0,.36)}.hl-button .hl-icon:first-child{margin-left:-.5rem;margin-right:.25rem}.hl-button .hl-icon:last-child{margin-right:-.5rem;margin-left:.25rem}.hl-button[aria-busy=true]{cursor:not-allowed}.hl-button .hl-button__text{max-height:1.3rem}.hl-button .hds-spinner--svg{width:25px;height:25px}.hl-button .hds-spinner--wrapper{position:absolute;left:10px;top:10px;width:25px;height:25px;opacity:0;-webkit-animation:.5s ease-in-out forwards fadein;animation:.5s ease-in-out forwards fadein}.hl-button .hds-spinner--loading-text{display:block;opacity:0;padding:0 .25rem;left:0;right:0;display:inline-flex;top:12px;justify-content:center;transition:.5s linear;transform:translate(.25rem,-.6rem) rotateX(90deg)}.hl-button .hds-spinner--button-text{opacity:1;transition:.5s linear;transform:translate(0,0) rotateX(0);display:block}.hl-button .hds-spinner--loading .hds-spinner--wrapper{-webkit-animation:.5s ease-in-out forwards fadein;animation:.5s ease-in-out forwards fadein}.hl-button .hds-spinner--loading+.hl-button__text .hds-spinner--loading-text{opacity:1;transform:translate(.25rem,-1.3rem) rotateX(0)}.hl-button .hds-spinner--loading+.hl-button__text .hds-spinner--button-text{opacity:0;transform:translate(0,-.6rem) rotateX(90deg)}.hl-button .hds-spinner--hide .hds-spinner--wrapper{-webkit-animation:.5s ease-in-out forwards fadeout;animation:.5s ease-in-out forwards fadeout}.hl-button .hds-spinner--pristine{opacity:0!important}.hl-button.hl-button--v2,.hl-button:not([class*=hl-button--v]){--bg:var(--hds-button-background, var(--hds-theme-accent-primary, #000));--text:var(--hds-button-text, #fff);background-color:var(--bg);border-color:var(--bg);color:var(--text);transition-property:transform}.hl-button.hl-button--v2:focus,.hl-button:not([class*=hl-button--v]):focus{outline:0;box-shadow:0 0 0 .25rem var(--hds-theme-base-background),0 0 0 calc(.25rem + .0625rem) var(--hds-theme-focus-ring)}.hl-button.hl-button--v2:focus::-moz-focus-inner,.hl-button:not([class*=hl-button--v]):focus::-moz-focus-inner{border-style:none;padding:0}.hl-button.hl-button--v2:focus:-moz-focusring,.hl-button:not([class*=hl-button--v]):focus:-moz-focusring{outline:0}.hl-button.hl-button--v2:active,.hl-button:not([class*=hl-button--v]):active{box-shadow:none;transform:scale(.97)}.hl-button.hl-button--v2:disabled,.hl-button:not([class*=hl-button--v]):disabled{background-color:var(--bg);border-color:var(--bg);color:var(--text);box-shadow:none;transform:none}.hl-button.hl-button--v2.hl-button--secondary,.hl-button:not([class*=hl-button--v]).hl-button--secondary{background-color:transparent;color:var(--bg)}.hl-button.hl-button--v2.hl-button--destructive,.hl-button:not([class*=hl-button--v]).hl-button--destructive{--bg:var(--hds-button-background-destructive, #e91d00);--text:var(--hds-button-text-destructive, #fff)}.hl-button.hl-button--v1{background-color:#ff885e;border-color:#ff885e;color:#fff}.hl-button.hl-button--v1:disabled{box-shadow:none}.hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#000;border-color:currentColor}.hl-button.hl-button--v1.hl-button--destructive{background-color:transparent;border-color:#e91d00;color:#e91d00}.hl-button.hl-button--v1.hl-button--destructive:focus,.hl-button.hl-button--v1.hl-button--destructive:hover{background-color:#e91d00;color:#fff}.hl-button.hl-button--v1.hl-button--destructive:disabled{background-color:transparent;color:#e91d00}.hl-theme--blue .hl-button.hl-button--v1{background-color:#ffe157;border-color:#ffe157;color:#000}.hl-theme--blue .hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#000;border-color:currentColor}.hl-theme--blue .hl-button.hl-button--v1.hl-button--destructive{background-color:#e91d00;border-color:#e91d00;color:#fff}.hl-theme--blue-light .hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#000;border-color:currentColor}.hl-theme--blue-light .hl-button.hl-button--v1.hl-button--destructive{background-color:#e91d00;border-color:#e91d00;color:#fff}.hl-theme--orange .hl-button.hl-button--v1{background-color:#ffe157;border-color:#ffe157;color:#000}.hl-theme--orange .hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#000;border-color:currentColor}.hl-theme--orange .hl-button.hl-button--v1.hl-button--destructive{background-color:#e91d00;border-color:#e91d00;color:#fff}.hl-theme--yellow .hl-button.hl-button--v1{background-color:#ff885e;border-color:#ff885e;color:#fff}.hl-theme--yellow .hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#000;border-color:currentColor}.hl-theme--yellow .hl-button.hl-button--v1.hl-button--destructive{background-color:#e91d00;border-color:#e91d00;color:#fff}.hl-theme--yellow-light .hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#000;border-color:currentColor}.hl-theme--yellow-light .hl-button.hl-button--v1.hl-button--destructive{background-color:#e91d00;border-color:#e91d00;color:#fff}.hl-theme--gray-light .hl-button.hl-button--v1{background-color:#ff885e;border-color:#ff885e;color:#fff}.hl-theme--gray-light .hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#000;border-color:currentColor}.hl-theme--gray-light .hl-button.hl-button--v1.hl-button--destructive{background-color:#e91d00;border-color:#e91d00;color:#fff}.hl-theme--gray-dark .hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#fff;border-color:currentColor}.hl-theme--gray-dark .hl-button.hl-button--v1.hl-button--destructive{background-color:#e91d00;border-color:#e91d00;color:#fff}.hl-minimal-button{border-color:transparent}.hl-minimal-button:hover{background-color:rgba(0,0,0,.06)}.hl-minimal-button:focus{outline:0;border-color:currentColor}.hl-minimal-button:focus::-moz-focus-inner{border-style:none;padding:0}.hl-minimal-button:focus:-moz-focusring{outline:0}.hl-minimal-button:disabled{background-color:transparent}@media screen and (pointer:coarse){.hl-minimal-button{position:var(--hds-tap-target-position,relative)}.hl-minimal-button::after{content:'';position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);height:3rem;width:3rem}}";
var _c6 = ["hlLink", ""];
var _c7 = [[["", "hlButton", ""], ["", "hlMinimalButton", ""]], [["", "hlLink", ""]]];
var _c8 = ["[hlButton], [hlMinimalButton]", "[hlLink]"];
function AlertComponent_div_0_p_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("id", ctx_r1.titleId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.title, " ");
} }
function AlertComponent_div_0_button_8_Template(rf, ctx) { if (rf & 1) {
    var _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 10);
    ɵngcc0.ɵɵlistener("click", function AlertComponent_div_0_button_8_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); var ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.onAlertClose(); });
    ɵngcc0.ɵɵtext(1, " Close ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("id", ctx_r2.closeButtonId);
} }
function AlertComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelement(3, "hl-icon", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 5);
    ɵngcc0.ɵɵtemplate(5, AlertComponent_div_0_p_5_Template, 2, 2, "p", 6);
    ɵngcc0.ɵɵelementStart(6, "div", 7);
    ɵngcc0.ɵɵprojection(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, AlertComponent_div_0_button_8_Template, 2, 1, "button", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.classMap);
    ɵngcc0.ɵɵattribute("role", ctx_r0.type === "warning" || ctx_r0.type === "critical" ? "alert" : "status")("aria-labelledby", ctx_r0.title ? ctx_r0.titleId : null)("aria-describedby", ctx_r0.alertContentId)("open", ctx_r0.isOpen);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("icon", ctx_r0.iconId);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", ctx_r0.alertContentId);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canBeClosed);
} }
function BannerComponent_div_0_h2_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h2", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.title, " ");
} }
function BannerComponent_div_0_button_4_Template(rf, ctx) { if (rf & 1) {
    var _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 6);
    ɵngcc0.ɵɵlistener("click", function BannerComponent_div_0_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); var ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.onDismiss(); });
    ɵngcc0.ɵɵtext(1, " Dismiss ");
    ɵngcc0.ɵɵelementEnd();
} }
function BannerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, BannerComponent_div_0_h2_1_Template, 2, 1, "h2", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵprojection(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, BannerComponent_div_0_button_4_Template, 2, 0, "button", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.title);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.dismissible);
} }
var _c9 = [[["", "slot", "header"]], "*", [["", "slot", "footer"]]];
var _c10 = ["[slot=header]", "*", "[slot=footer]"];
function FormFieldErrorComponent_ng_container_0_hl_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hl-icon", 3);
} }
function FormFieldErrorComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, FormFieldErrorComponent_ng_container_0_hl_icon_1_Template, 1, 0, "hl-icon", 1);
    ɵngcc0.ɵɵelementStart(2, "span", 2);
    ɵngcc0.ɵɵtext(3, "Error: ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showIcon);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
function FormFieldErrorComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "strong");
    ɵngcc0.ɵɵtext(2, "Debug info: ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "code");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "json");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 1, ctx_r1.control.errors));
} }
function FormFieldComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r0.id + "-label");
    ɵngcc0.ɵɵattribute("for", ctx_r0.firstFocusableElement.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.label);
} }
function FormFieldComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r1.id + "-help-text");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.helpText);
} }
function FormFieldComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("has-error", ctx_r2.formControl.invalid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", ctx_r2.maxlength - ctx_r2.formControl.value.length, " characters ", ctx_r2.formControl.value.length === 0 ? "allowed" : "remaining", " ");
} }
var _c11 = [[["hl-toggletip"]], "*"];
var _c12 = ["hl-toggletip", "*"];
function FormQuestionComponent_ng_container_0_ng_template_3_Template(rf, ctx) { }
function FormQuestionComponent_ng_container_0_ng_template_4_Template(rf, ctx) { }
function FormQuestionComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵtemplate(3, FormQuestionComponent_ng_container_0_ng_template_3_Template, 0, 0, "ng-template", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, FormQuestionComponent_ng_container_0_ng_template_4_Template, 0, 0, "ng-template", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    var _r3 = ɵngcc0.ɵɵreference(4);
    var _r5 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.question);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r5);
} }
function FormQuestionComponent_ng_template_1_ng_template_3_Template(rf, ctx) { }
function FormQuestionComponent_ng_template_1_ng_template_5_Template(rf, ctx) { }
function FormQuestionComponent_ng_template_1_hl_form_field_error_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hl-form-field-error", 8);
} if (rf & 2) {
    var ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("control", ctx_r11.formGroup);
} }
function FormQuestionComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "fieldset");
    ɵngcc0.ɵɵelementStart(1, "legend", 4);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵtemplate(3, FormQuestionComponent_ng_template_1_ng_template_3_Template, 0, 0, "ng-template", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 6);
    ɵngcc0.ɵɵtemplate(5, FormQuestionComponent_ng_template_1_ng_template_5_Template, 0, 0, "ng-template", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, FormQuestionComponent_ng_template_1_hl_form_field_error_6_Template, 1, 1, "hl-form-field-error", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    var _r3 = ɵngcc0.ɵɵreference(4);
    var _r5 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.question, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("hl-form-question__contents", true);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.contentClasses);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.formGroup);
} }
function FormQuestionComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function FormQuestionComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 1);
} }
function FormSectionComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.heading);
} }
function FormSectionComponent_p_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.tagline);
} }
var _c13 = ["hlValidationContext", ""];
function FormComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function FormComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function FormComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function FormComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "button", 4);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r4.errorSummary === "hide" && ctx_r4.formGroup.invalid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.submitButtonText, " ");
} }
function FormComponent_ng_template_6_ng_container_0_button_2_Template(rf, ctx) { if (rf & 1) {
    var _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 8);
    ɵngcc0.ɵɵlistener("click", function FormComponent_ng_template_6_ng_container_0_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); var ctx_r11 = ɵngcc0.ɵɵnextContext(3); return ctx_r11.focusFirstInvalidControl(); });
    ɵngcc0.ɵɵtext(1, " Jump to first error ");
    ɵngcc0.ɵɵelementEnd();
} }
function FormComponent_ng_template_6_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "hl-alert", 6);
    ɵngcc0.ɵɵtemplate(2, FormComponent_ng_template_6_ng_container_0_button_2_Template, 2, 0, "button", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var title_r7 = ɵngcc0.ɵɵnextContext().title;
    var ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("canBeClosed", false)("title", title_r7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.firstInvalidControl);
} }
function FormComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, FormComponent_ng_template_6_ng_container_0_Template, 3, 3, "ng-container", 5);
} if (rf & 2) {
    var show_r8 = ctx.show;
    var ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.errorSummaryVisible && ctx_r6.formGroup.invalid && (ctx_r6.errorSummary === "show" || show_r8));
} }
var _c14 = function (a0) { return { show: a0, title: "Some questions below have errors" }; };
var _c15 = function (a0) { return { show: a0, title: "Some questions above have errors" }; };
var _c16 = ["input"];
function CheckboxComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.description);
} }
var _c17 = ["hlInput"];
function InputComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.prefix);
} }
function InputComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.suffix);
} }
function InputComponent_hl_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hl-icon", 5);
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("icon", ctx_r2.icon);
} }
var _c18 = [[["input"]]];
var _c19 = ".hl-input{display:inline-flex;align-items:center;--text-color:var(--hds-theme-base-text, #000);--placeholder-color:var(--hds-input-placeholder, rgba(0, 0, 0, 0.45));--bg:var(--hds-input-background, #fff);--border:var(--hds-input-border, currentColor);--border-focus:var(--hds-theme-accent-primary, #189ec3);--bg-error:var(--hds-input-background-error, #ffe5e5);--border-error:var(--hds-input-border-error, #e91d00);--border-focus-shadow-error:var(--hds-input-focus-shadow-error, rgba(233, 29, 0, 0.75));height:3rem;width:100%;border:.125rem solid var(--border);border-radius:.25rem;background-color:var(--bg);color:var(--text-color);transition-property:background-color,border-color,box-shadow;transition-duration:75ms;overflow:hidden}.hl-input input{-webkit-appearance:none;-moz-appearance:none;appearance:none;margin:0;padding:0 .5rem;height:3rem;flex-basis:100%;min-width:0;max-width:100%;font:inherit}.hl-input input::-webkit-input-placeholder{color:var(--placeholder-color);opacity:.45}.hl-input input::-moz-placeholder{color:var(--placeholder-color);opacity:.45}.hl-input input:-ms-input-placeholder{color:var(--placeholder-color);opacity:.45}.hl-input input::-ms-input-placeholder{color:var(--placeholder-color);opacity:.45}.hl-input input::placeholder{color:var(--placeholder-color);opacity:.45}.hl-input input,.hl-input input:invalid,.hl-input input:valid,.hl-input input[disabled]{color:currentColor;background-color:transparent;border:none}.hl-input input:focus{outline-style:auto}.hl-input:focus-within{border-color:var(--border-focus);box-shadow:0 0 8px rgba(0,0,0,.36)}.hl-input:focus-within input:focus{outline:0}.hl-input:focus-within input:focus::-moz-focus-inner{border-style:none;padding:0}.hl-input:focus-within input:focus:-moz-focusring{outline:0}.hl-input.hl-form-control--disabled{background-color:#f5f5f5;border-color:#c4c4c4;color:#8d8d8d;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.hl-input.hl-form-control--read-only{display:inline-flex;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:auto;min-width:0;background:0 0;border-color:transparent;color:#606062}.hl-input.hl-form-control--read-only:focus-within{border-color:#000;box-shadow:none}.hl-input.hl-form-control--read-only input{height:auto}.hl-input.hl-form-control--read-only input::-webkit-input-placeholder{opacity:0}.hl-input.hl-form-control--read-only input::-moz-placeholder{opacity:0}.hl-input.hl-form-control--read-only input:-ms-input-placeholder{opacity:0}.hl-input.hl-form-control--read-only input::-ms-input-placeholder{opacity:0}.hl-input.hl-form-control--read-only input::placeholder{opacity:0}.hl-input.hl-form-control--invalid,.hl-input.ng-dirty.ng-invalid,.hl-input.ng-touched.ng-invalid{background-color:var(--bg-error);border-color:var(--border-error)}.hl-input.hl-form-control--invalid:focus-within,.hl-input.ng-dirty.ng-invalid:focus-within,.hl-input.ng-touched.ng-invalid:focus-within{box-shadow:0 0 8px var(--border-focus-shadow-error)}.hl-input__icon,.hl-input__prefix,.hl-input__suffix{flex-shrink:0;margin:0 .5rem}";
var _c20 = ["inputWrapper"];
var _c21 = ["listbox"];
function ComboboxComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    var _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "li", 9);
    ɵngcc0.ɵɵlistener("click", function ComboboxComponent_ng_container_9_Template_li_click_1_listener() { var restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); var i_r5 = restoredCtx.index; var ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.selectSuggestion(i_r5); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var suggestion_r4 = ctx.$implicit;
    var i_r5 = ctx.index;
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", ctx_r3.getOptionId(i_r5));
    ɵngcc0.ɵɵattribute("aria-selected", i_r5 === ctx_r3.currentSuggestionIndex);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", suggestion_r4.description, " ");
} }
var _c22 = ["list"];
function ListboxComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "number");
    ɵngcc0.ɵɵpipe(3, "number");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2("Showing ", ɵngcc0.ɵɵpipeBind1(2, 2, ctx_r0.maxOptionsVisible), " of ", ɵngcc0.ɵɵpipeBind1(3, 4, ctx_r0.numMatchingOptions), " options");
} }
function ListboxComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "No matching options");
    ɵngcc0.ɵɵelementEnd();
} }
function ListboxComponent_ng_container_6_hl_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hl-icon", 8);
} }
function ListboxComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    var _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "li", 6);
    ɵngcc0.ɵɵlistener("click", function ListboxComponent_ng_container_6_Template_li_click_1_listener() { var restoredCtx = ɵngcc0.ɵɵrestoreView(_r8); var i_r5 = restoredCtx.index; var ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.selectIndex(i_r5); });
    ɵngcc0.ɵɵtemplate(2, ListboxComponent_ng_container_6_hl_icon_2_Template, 1, 0, "hl-icon", 7);
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var option_r4 = ctx.$implicit;
    var i_r5 = ctx.index;
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("id", ctx_r3.getOptionId(i_r5))("aria-selected", i_r5 === ctx_r3.selectedIndex);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.showSelectionIcon && i_r5 === ctx_r3.selectedIndex);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(option_r4.description);
} }
var _c23 = ["hlDropdown", ""];
var _c24 = [[["option"]]];
var _c25 = ["option"];
var _c26 = ["button"];
var _c27 = ["modalContainer"];
var _c28 = ["focusTrapStart"];
var _c29 = ["focusTrapEnd"];
function ModalComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    var _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 11);
    ɵngcc0.ɵɵlistener("click", function ModalComponent_button_7_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); var ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.dismiss(); });
    ɵngcc0.ɵɵtext(1, " Dismiss ");
    ɵngcc0.ɵɵelementEnd();
} }
function ModalComponent_footer_10_button_2_Template(rf, ctx) { if (rf & 1) {
    var _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 16);
    ɵngcc0.ɵɵlistener("click", function ModalComponent_footer_10_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); var ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.cancel(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.cancelButton.text, " ");
} }
function ModalComponent_footer_10_button_3_Template(rf, ctx) { if (rf & 1) {
    var _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 17);
    ɵngcc0.ɵɵlistener("click", function ModalComponent_footer_10_button_3_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); var ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.confirm(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r8.allowConfirm);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r8.confirmButton.text, " ");
} }
function ModalComponent_footer_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "footer", 12);
    ɵngcc0.ɵɵelementStart(1, "hl-action-group", 13);
    ɵngcc0.ɵɵtemplate(2, ModalComponent_footer_10_button_2_Template, 2, 1, "button", 14);
    ɵngcc0.ɵɵtemplate(3, ModalComponent_footer_10_button_3_Template, 2, 2, "button", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.cancelButton.hide);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.confirmButton.hide);
} }
var _c30 = ["toggleButton"];
function NavSublistComponent_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function NavSublistComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NavSublistComponent_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 9);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.toggleButtonContents.template);
} }
function NavSublistComponent_li_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 10);
    ɵngcc0.ɵɵelementStart(1, "p", 11);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", ctx_r2.listHeadingId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.heading, " ");
} }
function NavSublistComponent_li_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 10);
    ɵngcc0.ɵɵelementContainer(1, 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r7 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", item_r7.template);
} }
function NavSublistComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    var ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.toggleLabel);
} }
function NavListComponent_li_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 3);
    ɵngcc0.ɵɵelementContainer(1, 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", item_r1.template);
} }
function ProgressComponent_label_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("for", ctx_r0.progressID());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.label, "\n");
} }
function RadioGroupComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    var _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "input", 3);
    ɵngcc0.ɵɵlistener("blur", function RadioGroupComponent_div_1_Template_input_blur_1_listener() { ɵngcc0.ɵɵrestoreView(_r4); var ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onTouched(); })("change", function RadioGroupComponent_div_1_Template_input_change_1_listener() { var restoredCtx = ɵngcc0.ɵɵrestoreView(_r4); var option_r1 = restoredCtx.$implicit; var ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.selectOption(option_r1.value); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "label", 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var option_r1 = ctx.$implicit;
    var i_r2 = ctx.index;
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", ctx_r0.getOptionId(i_r2))("name", ctx_r0.id)("value", option_r1.value)("required", ctx_r0.required)("disabled", ctx_r0.disabled || option_r1.disabled)("checked", ctx_r0.value === option_r1.value);
    ɵngcc0.ɵɵattribute("aria-describedby", ctx_r0.ariaDescribedBy);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("for", ctx_r0.getOptionId(i_r2));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", option_r1.description, " ");
} }
function SkeletonPlaceholderComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 1);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.loadingText);
} }
function SkeletonTextComponent_p_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 2);
    ɵngcc0.ɵɵtext(1, " \u200B\n");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var lineWidth_r2 = ctx.$implicit;
    ɵngcc0.ɵɵstyleProp("width", lineWidth_r2);
    ɵngcc0.ɵɵattribute("aria-hidden", true);
} }
function SkeletonTextComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.loadingText);
} }
var _c31 = ["hdsStep", ""];
var _c32 = [[["", "hdsStep", ""]]];
var _c33 = ["[hdsStep]"];
function StepComponent_hl_icon_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hl-icon", 6);
} }
function StepComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.number);
} }
function StepperComponent_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "hl-step", 6);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r8 = ɵngcc0.ɵɵnextContext();
    var first_r3 = ctx_r8.first;
    var last_r4 = ctx_r8.last;
    var i_r2 = ctx_r8.index;
    var step_r1 = ctx_r8.$implicit;
    var ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("hl-step--first", first_r3)("hl-step--last", last_r4)("hl-step--active", i_r2 === ctx_r5.activeStep);
    ɵngcc0.ɵɵproperty("number", ctx_r5.stepNumber(i_r2));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(step_r1);
} }
function StepperComponent_ng_container_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    var _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵlistener("click", function StepperComponent_ng_container_3_ng_template_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); var i_r2 = ɵngcc0.ɵɵnextContext().index; var ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.setActiveStep(i_r2); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r12 = ɵngcc0.ɵɵnextContext();
    var first_r3 = ctx_r12.first;
    var last_r4 = ctx_r12.last;
    var i_r2 = ctx_r12.index;
    var step_r1 = ctx_r12.$implicit;
    var ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("hl-step--first", first_r3)("hl-step--last", last_r4)("hl-step--active", i_r2 === ctx_r7.activeStep);
    ɵngcc0.ɵɵproperty("state", ctx_r7.stepState(i_r2))("number", ctx_r7.stepNumber(i_r2));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", step_r1, " ");
} }
function StepperComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, StepperComponent_ng_container_3_ng_container_1_Template, 3, 8, "ng-container", 4);
    ɵngcc0.ɵɵtemplate(2, StepperComponent_ng_container_3_ng_template_2_Template, 2, 9, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var i_r2 = ctx.index;
    var _r6 = ɵngcc0.ɵɵreference(3);
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isIncomplete(i_r2))("ngIfElse", _r6);
} }
function TabComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
var _c34 = ["tabButton"];
function TabGroupComponent_button_1_2_ng_template_0_Template(rf, ctx) { }
function TabGroupComponent_button_1_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, TabGroupComponent_button_1_2_ng_template_0_Template, 0, 0, "ng-template", 7);
} if (rf & 2) {
    var tab_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", tab_r2.labelTemplate);
} }
function TabGroupComponent_button_1_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    var tab_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵtextInterpolate(tab_r2.label);
} }
function TabGroupComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    var _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 3, 4);
    ɵngcc0.ɵɵlistener("click", function TabGroupComponent_button_1_Template_button_click_0_listener() { var restoredCtx = ɵngcc0.ɵɵrestoreView(_r12); var i_r3 = restoredCtx.index; var ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.activateTab(i_r3); })("keydown.arrowright", function TabGroupComponent_button_1_Template_button_keydown_arrowright_0_listener() { var restoredCtx = ɵngcc0.ɵɵrestoreView(_r12); var i_r3 = restoredCtx.index; var ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.selectTab(i_r3 + 1); })("keydown.arrowleft", function TabGroupComponent_button_1_Template_button_keydown_arrowleft_0_listener() { var restoredCtx = ɵngcc0.ɵɵrestoreView(_r12); var i_r3 = restoredCtx.index; var ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.selectTab(i_r3 - 1); });
    ɵngcc0.ɵɵtemplate(2, TabGroupComponent_button_1_2_Template, 1, 1, undefined, 5);
    ɵngcc0.ɵɵtemplate(3, TabGroupComponent_button_1_ng_template_3_Template, 1, 1, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var tab_r2 = ctx.$implicit;
    var i_r3 = ctx.index;
    var _r6 = ɵngcc0.ɵɵreference(4);
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("id", ctx_r0.getButtonId(tab_r2))("tabindex", ctx_r0.selectedIndex === i_r3 ? null : -1)("aria-controls", tab_r2.id)("aria-selected", ctx_r0.selectedIndex === i_r3 ? "true" : "false");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", tab_r2.labelTemplate)("ngIfElse", _r6);
} }
function TabGroupComponent_div_2_1_ng_template_0_Template(rf, ctx) { }
function TabGroupComponent_div_2_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, TabGroupComponent_div_2_1_ng_template_0_Template, 0, 0, "ng-template", 7);
} if (rf & 2) {
    var tab_r15 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", tab_r15.tabContents);
} }
function TabGroupComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵtemplate(1, TabGroupComponent_div_2_1_Template, 1, 1, undefined, 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var tab_r15 = ctx.$implicit;
    var i_r16 = ctx.index;
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("id", tab_r15.id)("hidden", ctx_r1.selectedIndex !== i_r16 ? "" : null)("aria-labelledby", ctx_r1.getButtonId(tab_r15));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", tab_r15.tabContents);
} }
var _c35 = [[["textarea"]]];
var _c36 = ["textarea"];
var _c37 = ["tooltip"];
var _c38 = ".hl-tooltip{display:block;box-sizing:border-box;position:fixed;top:0;left:0;max-width:275px;padding:.75rem 1.25rem;border-radius:.25rem;margin-top:0;margin-bottom:0;font-size:.875rem;line-height:1.42857;letter-spacing:0;z-index:10;box-shadow:0 2px 4px rgba(0,0,0,.12);background-color:#4d4d4f;color:#fff;opacity:0;transition:opacity 75ms ease-out;pointer-events:none}@supports ((-webkit-filter:drop-shadow(0 2px 4px rgba(0,0,0,0.12))) or (filter:drop-shadow(0 2px 4px rgba(0,0,0,0.12)))){.hl-tooltip{box-shadow:unset;-webkit-filter:drop-shadow(0 2px 4px rgba(0, 0, 0, .12));filter:drop-shadow(0 2px 4px rgba(0, 0, 0, .12))}}.hl-toggletip-trigger[aria-expanded=true]+.hl-tooltip,.hl-tooltip-trigger:focus+.hl-tooltip,.hl-tooltip-trigger:hover+.hl-tooltip{opacity:1;pointer-events:initial}.hl-tooltip::before{content:'';position:absolute;height:0;width:0;border:8px solid transparent}.hl-tooltip[data-position=bottom]{margin-top:16px}.hl-tooltip[data-position=bottom]::before{top:-16px;left:50%;transform:translateX(-50%);border-bottom-color:#4d4d4f}.hl-tooltip[data-position=left]{margin-left:-16px}.hl-tooltip[data-position=left]::before{right:-16px;top:50%;transform:translateY(-50%);border-left-color:#4d4d4f}.hl-tooltip[data-position=right]{margin-left:16px}.hl-tooltip[data-position=right]::before{left:-16px;top:50%;transform:translateY(-50%);border-right-color:#4d4d4f}.hl-tooltip[data-position=top]{margin-top:-16px}.hl-tooltip[data-position=top]::before{bottom:-16px;left:50%;transform:translateX(-50%);border-top-color:#4d4d4f}.hl-toggletip{display:inline-block;height:1.25rem;width:1.25rem;flex-shrink:0}.hl-toggletip .hl-toggletip-trigger{margin:0;padding:0;border:.125rem solid transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none;overflow:visible;font-family:inherit;font-size:1rem;text-decoration:none;text-transform:none;background-color:transparent;cursor:pointer;height:100%;width:100%;border-radius:999999px;background-color:var(--hds-toggletip-accent,var(--hds-theme-accent-primary,#127691));color:#fff}.hl-toggletip .hl-toggletip-trigger:hover{box-shadow:0 0 8px rgba(0,0,0,.36)}.hl-toggletip .hl-toggletip-trigger:focus{outline:0;box-shadow:0 0 0 .125rem var(--hds-theme-base-background),0 0 0 calc(.125rem + .0625rem) var(--hds-theme-focus-ring)}.hl-toggletip .hl-toggletip-trigger:focus::-moz-focus-inner{border-style:none;padding:0}.hl-toggletip .hl-toggletip-trigger:focus:-moz-focusring{outline:0}.hl-toggletip .hl-toggletip-trigger[aria-expanded=true]{background-color:transparent;border-color:currentColor;color:var(--hds-toggletip-accent,var(--hds-theme-accent-primary,#127691))}.hl-toggletip .hl-toggletip-trigger .hl-icon{display:block;height:100%;width:100%}";
var DEFAULT_CONFIG = {
    spriteFilepath: 'assets/icons.svg',
    defaultViewBox: '0 0 96 96',
    iconConfig: {
        'brand--HL_Mark': { viewBox: '0 0 100 100' },
        'brand--HL_Plus': { viewBox: '0 0 200 100' },
        'brand--HL_Primary': { viewBox: '0 0 307 101' },
        'brand--HL_Secondary_large': { viewBox: '0 0 423 100' },
        'brand--HL_Secondary_small': { viewBox: '0 0 270 100' },
        'brand--HL_Secondary_stacked_large': { viewBox: '0 0 300 181' },
        'brand--HL_Secondary_stacked_small': { viewBox: '0 0 150 145' }
    }
};
/**
 * Injection token representing the configuration object for the SVG icon sprite
 * used by the Icon component.
 */
var HDS_ICON_SPRITE_CONFIG = new InjectionToken('HDS_ICON_SPRITE_CONFIG', {
    providedIn: 'root',
    factory: function () { return DEFAULT_CONFIG; }
});

/**
 * Renders an SVG icon from a configured sprite.
 */
var IconComponent = /** @class */ (function () {
    function IconComponent(config) {
        this.config = config;
        /**
         * Unique string that serves as a global identifier for the root HTML element
         * and its children.
         */
        this.id = "hl-icon-" + IconComponent_1.componentCount++;
        /**
         * @ignore
         */
        this.baseClass = true;
        /**
         * Whether the icon should have a circular outline.
         *
         * **Note:** This is not supported in custom icon sprites.
         */
        this.outline = false;
    }
    IconComponent_1 = IconComponent;
    Object.defineProperty(IconComponent.prototype, "titleId", {
        /**
         * ID of the SVG's `<title>` element.
         *
         * @internal
         */
        get: function () {
            return this.id + "-title";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IconComponent.prototype, "showOutline", {
        get: function () {
            return this.outline && this.config.spriteFilepath === 'assets/icons.svg';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IconComponent.prototype, "iconHref", {
        /**
         * Reference to the icon in the SVG sprite.
         *
         * @internal
         */
        get: function () {
            return this.config.spriteFilepath + "#" + this.icon;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IconComponent.prototype, "iconViewbox", {
        /**
         * SVG `viewBox` attribute for the icon. Used to maintain an appropriate
         * aspect ratio with auto width or height.
         *
         * @internal
         */
        get: function () {
            if (this.config.iconConfig && this.config.iconConfig[this.icon] && this.config.iconConfig[this.icon].viewBox) {
                return this.config.iconConfig[this.icon].viewBox;
            }
            return this.config.defaultViewBox;
        },
        enumerable: true,
        configurable: true
    });
    var IconComponent_1;
    /**
     * Tracks the number of instances of the component that have been created.
     * Used to generate IDs for child elements, if an ID was not provided.
     *
     * @internal
     */
    IconComponent.componentCount = 0;
    IconComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [HDS_ICON_SPRITE_CONFIG,] }] }
    ]; };
    __decorate([
        Input(), HostBinding(),
        __metadata("design:type", Object)
    ], IconComponent.prototype, "id", void 0);
    __decorate([
        HostBinding('class.hl-icon'),
        __metadata("design:type", Object)
    ], IconComponent.prototype, "baseClass", void 0);
    __decorate([
        HostBinding('attr.data-icon'),
        Input(),
        __metadata("design:type", String)
    ], IconComponent.prototype, "icon", void 0);
    __decorate([
        HostBinding('attr.data-size'),
        Input(),
        __metadata("design:type", String)
    ], IconComponent.prototype, "size", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], IconComponent.prototype, "title", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], IconComponent.prototype, "outline", void 0);
    IconComponent = IconComponent_1 = __decorate([ __param(0, Inject(HDS_ICON_SPRITE_CONFIG)),
        __metadata("design:paramtypes", [Object])
    ], IconComponent);
IconComponent.ɵfac = function IconComponent_Factory(t) { return new (t || IconComponent)(ɵngcc0.ɵɵdirectiveInject(HDS_ICON_SPRITE_CONFIG)); };
IconComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: IconComponent, selectors: [["hl-icon"]], hostVars: 5, hostBindings: function IconComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("id", ctx.id);
        ɵngcc0.ɵɵattribute("data-icon", ctx.icon)("data-size", ctx.size);
        ɵngcc0.ɵɵclassProp("hl-icon", ctx.baseClass);
    } }, inputs: { id: "id", outline: "outline", icon: "icon", size: "size", title: "title" }, decls: 5, vars: 6, consts: [["focusable", "false", "role", "img"], [3, "id", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["iconSymbol", ""], [3, "id"], ["x", "12%", "y", "12%"], ["transform", "scale(0.75)"], [3, "ngTemplateOutlet"]], template: function IconComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵtemplate(1, IconComponent__svg_title_1_Template, 2, 2, "title", 1);
        ɵngcc0.ɵɵtemplate(2, IconComponent__svg_ng_container_2_Template, 5, 2, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(3, IconComponent__svg_ng_template_3_Template, 1, 1, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        var _r2 = ɵngcc0.ɵɵreference(4);
        ɵngcc0.ɵɵattribute("aria-hidden", ctx.title ? null : true)("aria-labelledby", ctx.title ? ctx.titleId : null)("viewBox", ctx.iconViewbox);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showOutline)("ngIfElse", _r2);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], styles: [".hl-icon{display:inline-block;vertical-align:middle;flex-shrink:0}.hl-icon svg{display:block;height:1.5em;width:auto;fill:currentColor}.hl-icon.hl-icon--brand svg,.hl-icon[data-icon*=brand--] svg{height:4em}.hl-icon[data-size=small] svg{height:1em}.hl-icon[data-size=medium] svg{height:1.5em}.hl-icon[data-size=large] svg{height:2em}.hl-icon[data-size=x-large] svg{height:4em}.hl-icon[data-size=xx-large] svg{height:8em}"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IconComponent, [{
        type: Component,
        args: [{
                selector: 'hl-icon',
                template: "<svg\n    focusable=\"false\"\n    role=\"img\"\n    [attr.aria-hidden]=\"title ? null : true\"\n    [attr.aria-labelledby]=\"title ? titleId : null\"\n    [attr.viewBox]=\"iconViewbox\"\n>\n    <title *ngIf=\"title\" [id]=\"titleId\">{{ title }}</title>\n\n    <ng-container *ngIf=\"showOutline; else iconSymbol\">\n        <use [attr.xlink:href]=\"'assets/icons.svg#u-outline'\"></use>\n        <svg x=\"12%\" y=\"12%\">\n            <g transform=\"scale(0.75)\">\n                <ng-container [ngTemplateOutlet]=\"iconSymbol\"></ng-container>\n            </g>\n        </svg>\n    </ng-container>\n\n    <ng-template #iconSymbol>\n        <use [attr.xlink:href]=\"iconHref\"></use>\n    </ng-template>\n</svg>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".hl-icon{display:inline-block;vertical-align:middle;flex-shrink:0}.hl-icon svg{display:block;height:1.5em;width:auto;fill:currentColor}.hl-icon.hl-icon--brand svg,.hl-icon[data-icon*=brand--] svg{height:4em}.hl-icon[data-size=small] svg{height:1em}.hl-icon[data-size=medium] svg{height:1.5em}.hl-icon[data-size=large] svg{height:2em}.hl-icon[data-size=x-large] svg{height:4em}.hl-icon[data-size=xx-large] svg{height:8em}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [HDS_ICON_SPRITE_CONFIG]
            }] }]; }, { id: [{
            type: Input
        }, {
            type: HostBinding
        }], baseClass: [{
            type: HostBinding,
            args: ['class.hl-icon']
        }], outline: [{
            type: Input
        }], icon: [{
            type: HostBinding,
            args: ['attr.data-icon']
        }, {
            type: Input
        }], size: [{
            type: HostBinding,
            args: ['attr.data-size']
        }, {
            type: Input
        }], title: [{
            type: Input
        }] }); })();
    return IconComponent;
}());

var IconModule = /** @class */ (function () {
    function IconModule() {
    }
IconModule.ɵfac = function IconModule_Factory(t) { return new (t || IconModule)(); };
IconModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: IconModule });
IconModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IconModule, [{
        type: NgModule,
        args: [{
                declarations: [IconComponent],
                imports: [CommonModule],
                exports: [IconComponent]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(IconModule, { declarations: function () { return [IconComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [IconComponent]; } }); })();
    return IconModule;
}());

var LoadingSpinnerComponent = /** @class */ (function () {
    function LoadingSpinnerComponent() {
    }
LoadingSpinnerComponent.ɵfac = function LoadingSpinnerComponent_Factory(t) { return new (t || LoadingSpinnerComponent)(); };
LoadingSpinnerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LoadingSpinnerComponent, selectors: [["hds-loading-spinner"]], decls: 3, vars: 0, consts: [[1, "hds-spinner--wrapper"], ["viewBox", "0 0 50 50", 1, "hds-spinner--svg"], ["cx", "25", "cy", "25", "r", "20", "fill", "none", "stroke-width", "5", 1, "hds-spinner--path"]], template: function LoadingSpinnerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(1, "svg", 1);
        ɵngcc0.ɵɵelement(2, "circle", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [".hds-spinner--svg{z-index:2;width:30px;height:30px;-webkit-animation:2s linear infinite rotate;animation:2s linear infinite rotate}.hds-spinner--svg .hds-spinner--path{stroke:#189ec3;stroke-linecap:round;-webkit-animation:1.5s ease-in-out infinite dash;animation:1.5s ease-in-out infinite dash}@-webkit-keyframes fadein{0%{transform:scale(0);opacity:0}100%{transform:scale(1);opacity:1}}@keyframes fadein{0%{transform:scale(0);opacity:0}100%{transform:scale(1);opacity:1}}@-webkit-keyframes fadeout{0%{transform:scale(1);opacity:1}100%{transform:scale(0);opacity:0}}@keyframes fadeout{0%{transform:scale(1);opacity:1}100%{transform:scale(0);opacity:0}}@-webkit-keyframes rotate{100%{transform:rotate(360deg)}}@keyframes rotate{100%{transform:rotate(360deg)}}@-webkit-keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}100%{stroke-dasharray:90,150;stroke-dashoffset:-124}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}100%{stroke-dasharray:90,150;stroke-dashoffset:-124}}"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoadingSpinnerComponent, [{
        type: Component,
        args: [{
                selector: 'hds-loading-spinner',
                template: "<div class=\"hds-spinner--wrapper\">\n    <svg class=\"hds-spinner--svg\" viewBox=\"0 0 50 50\">\n        <circle class=\"hds-spinner--path\" cx=\"25\" cy=\"25\" r=\"20\" fill=\"none\" stroke-width=\"5\"></circle>\n    </svg>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".hds-spinner--svg{z-index:2;width:30px;height:30px;-webkit-animation:2s linear infinite rotate;animation:2s linear infinite rotate}.hds-spinner--svg .hds-spinner--path{stroke:#189ec3;stroke-linecap:round;-webkit-animation:1.5s ease-in-out infinite dash;animation:1.5s ease-in-out infinite dash}@-webkit-keyframes fadein{0%{transform:scale(0);opacity:0}100%{transform:scale(1);opacity:1}}@keyframes fadein{0%{transform:scale(0);opacity:0}100%{transform:scale(1);opacity:1}}@-webkit-keyframes fadeout{0%{transform:scale(1);opacity:1}100%{transform:scale(0);opacity:0}}@keyframes fadeout{0%{transform:scale(1);opacity:1}100%{transform:scale(0);opacity:0}}@-webkit-keyframes rotate{100%{transform:rotate(360deg)}}@keyframes rotate{100%{transform:rotate(360deg)}}@-webkit-keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}100%{stroke-dasharray:90,150;stroke-dashoffset:-124}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}100%{stroke-dasharray:90,150;stroke-dashoffset:-124}}"]
            }]
    }], function () { return []; }, null); })();
    return LoadingSpinnerComponent;
}());

var LoadingSpinnerModule = /** @class */ (function () {
    function LoadingSpinnerModule() {
    }
LoadingSpinnerModule.ɵfac = function LoadingSpinnerModule_Factory(t) { return new (t || LoadingSpinnerModule)(); };
LoadingSpinnerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: LoadingSpinnerModule });
LoadingSpinnerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoadingSpinnerModule, [{
        type: NgModule,
        args: [{
                declarations: [LoadingSpinnerComponent],
                imports: [CommonModule],
                exports: [LoadingSpinnerComponent]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LoadingSpinnerModule, { declarations: function () { return [LoadingSpinnerComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [LoadingSpinnerComponent]; } }); })();
    return LoadingSpinnerModule;
}());

/**
 * Applies custom styling to button-like elements.
 */
var ButtonComponent = /** @class */ (function () {
    function ButtonComponent(el) {
        this.el = el;
        /**
         * @ignore
         */
        this.baseClass = true;
        /**
         * Whether the Button is a secondary action in a set.
         */
        this.secondary = false;
        /**
         * Whether the Button performs a destructive action.
         */
        this.destructive = false;
        /**
         * Whether the button is in loading state or not
         */
        this.loading = false;
        /**
         * The loading button to be displayed, empty string or null to show only the spinner
         */
        this.loadingText = 'Loading...';
        this.isLoadingPristine = true; // use to detect pristine state for loading animations
    }
    ButtonComponent.prototype.ngOnChanges = function (changes) {
        if (this.isLoadingPristine && changes.loading && changes.loading.currentValue) {
            this.isLoadingPristine = false;
        }
    };
    ButtonComponent.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    __decorate([
        HostBinding('class.hl-button'),
        __metadata("design:type", Object)
    ], ButtonComponent.prototype, "baseClass", void 0);
    __decorate([
        Input(), HostBinding('class.hl-button--secondary'),
        __metadata("design:type", Object)
    ], ButtonComponent.prototype, "secondary", void 0);
    __decorate([
        Input(), HostBinding('class.hl-button--destructive'),
        __metadata("design:type", Object)
    ], ButtonComponent.prototype, "destructive", void 0);
    __decorate([
        Input(),
        HostBinding('attr.aria-busy'),
        __metadata("design:type", Object)
    ], ButtonComponent.prototype, "loading", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ButtonComponent.prototype, "loadingText", void 0);
    ButtonComponent = __decorate([ __metadata("design:paramtypes", [ElementRef])
    ], ButtonComponent);
ButtonComponent.ɵfac = function ButtonComponent_Factory(t) { return new (t || ButtonComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ButtonComponent, selectors: [["button", "hlButton", ""], ["a", "hlButton", ""]], hostVars: 7, hostBindings: function ButtonComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-busy", ctx.loading);
        ɵngcc0.ɵɵclassProp("hl-button", ctx.baseClass)("hl-button--secondary", ctx.secondary)("hl-button--destructive", ctx.destructive);
    } }, inputs: { secondary: "secondary", destructive: "destructive", loading: "loading", loadingText: "loadingText" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], attrs: _c0, ngContentSelectors: _c2, decls: 8, vars: 9, consts: [[1, "hl-button__text"], [1, "hds-spinner--button-text"], [1, "hds-spinner--loading-text"]], template: function ButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c1);
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵelement(1, "hds-loading-spinner");
        ɵngcc0.ɵɵelementStart(2, "div", 0);
        ɵngcc0.ɵɵelementStart(3, "span", 1);
        ɵngcc0.ɵɵprojection(4, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "span", 2);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(7, 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("hds-spinner--pristine", ctx.isLoadingPristine)("hds-spinner--loading", ctx.loading)("hds-spinner--hide", !ctx.loading);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("aria-hidden", ctx.loading || null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("aria-hidden", !ctx.loading || null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.loadingText, " ");
    } }, directives: [LoadingSpinnerComponent], styles: [_c5], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line
                selector: 'button[hlButton], a[hlButton]',
                template: "<ng-content select=\"hl-icon[start]\"></ng-content>\n\n<hds-loading-spinner\n    [class.hds-spinner--pristine]=\"isLoadingPristine\"\n    [class.hds-spinner--loading]=\"loading\"\n    [class.hds-spinner--hide]=\"!loading\"\n>\n</hds-loading-spinner>\n<div class=\"hl-button__text\">\n    <span class=\"hds-spinner--button-text\" [attr.aria-hidden]=\"loading || null\">\n        <ng-content></ng-content>\n    </span>\n    <span class=\"hds-spinner--loading-text\" [attr.aria-hidden]=\"!loading || null\">\n        {{ loadingText }}\n    </span>\n</div>\n\n<ng-content select=\"hl-icon[end]\"></ng-content>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".hl-button,.hl-minimal-button{margin:0;padding:.125rem;border:.125rem solid;-webkit-appearance:none;-moz-appearance:none;appearance:none;overflow:visible;font-family:inherit;font-size:1rem;text-decoration:none;text-transform:none;background-color:transparent;color:inherit;cursor:pointer;min-height:2rem;border-radius:.25rem;display:inline-flex;justify-content:center;align-items:center;transition-duration:150ms;transition-property:background-color,box-shadow,color,transform}.hl-button:active,.hl-minimal-button:active{transform:scale(.98)}.hl-button:disabled,.hl-minimal-button:disabled{opacity:.45;cursor:not-allowed;transform:none}.hl-button [class*='__text']:not(:empty),.hl-minimal-button [class*='__text']:not(:empty){padding-left:.25rem;padding-right:.25rem}.hl-button .hl-icon,.hl-minimal-button .hl-icon{flex-shrink:0}.hl-button{position:relative;min-height:3rem;padding:.5rem 2rem;border-radius:999999px}.hl-button:hover{box-shadow:0 0 8px rgba(0,0,0,.36)}.hl-button .hl-icon:first-child{margin-left:-.5rem;margin-right:.25rem}.hl-button .hl-icon:last-child{margin-right:-.5rem;margin-left:.25rem}.hl-button[aria-busy=true]{cursor:not-allowed}.hl-button .hl-button__text{max-height:1.3rem}.hl-button .hds-spinner--svg{width:25px;height:25px}.hl-button .hds-spinner--wrapper{position:absolute;left:10px;top:10px;width:25px;height:25px;opacity:0;-webkit-animation:.5s ease-in-out forwards fadein;animation:.5s ease-in-out forwards fadein}.hl-button .hds-spinner--loading-text{display:block;opacity:0;padding:0 .25rem;left:0;right:0;display:inline-flex;top:12px;justify-content:center;transition:.5s linear;transform:translate(.25rem,-.6rem) rotateX(90deg)}.hl-button .hds-spinner--button-text{opacity:1;transition:.5s linear;transform:translate(0,0) rotateX(0);display:block}.hl-button .hds-spinner--loading .hds-spinner--wrapper{-webkit-animation:.5s ease-in-out forwards fadein;animation:.5s ease-in-out forwards fadein}.hl-button .hds-spinner--loading+.hl-button__text .hds-spinner--loading-text{opacity:1;transform:translate(.25rem,-1.3rem) rotateX(0)}.hl-button .hds-spinner--loading+.hl-button__text .hds-spinner--button-text{opacity:0;transform:translate(0,-.6rem) rotateX(90deg)}.hl-button .hds-spinner--hide .hds-spinner--wrapper{-webkit-animation:.5s ease-in-out forwards fadeout;animation:.5s ease-in-out forwards fadeout}.hl-button .hds-spinner--pristine{opacity:0!important}.hl-button.hl-button--v2,.hl-button:not([class*=hl-button--v]){--bg:var(--hds-button-background, var(--hds-theme-accent-primary, #000));--text:var(--hds-button-text, #fff);background-color:var(--bg);border-color:var(--bg);color:var(--text);transition-property:transform}.hl-button.hl-button--v2:focus,.hl-button:not([class*=hl-button--v]):focus{outline:0;box-shadow:0 0 0 .25rem var(--hds-theme-base-background),0 0 0 calc(.25rem + .0625rem) var(--hds-theme-focus-ring)}.hl-button.hl-button--v2:focus::-moz-focus-inner,.hl-button:not([class*=hl-button--v]):focus::-moz-focus-inner{border-style:none;padding:0}.hl-button.hl-button--v2:focus:-moz-focusring,.hl-button:not([class*=hl-button--v]):focus:-moz-focusring{outline:0}.hl-button.hl-button--v2:active,.hl-button:not([class*=hl-button--v]):active{box-shadow:none;transform:scale(.97)}.hl-button.hl-button--v2:disabled,.hl-button:not([class*=hl-button--v]):disabled{background-color:var(--bg);border-color:var(--bg);color:var(--text);box-shadow:none;transform:none}.hl-button.hl-button--v2.hl-button--secondary,.hl-button:not([class*=hl-button--v]).hl-button--secondary{background-color:transparent;color:var(--bg)}.hl-button.hl-button--v2.hl-button--destructive,.hl-button:not([class*=hl-button--v]).hl-button--destructive{--bg:var(--hds-button-background-destructive, #e91d00);--text:var(--hds-button-text-destructive, #fff)}.hl-button.hl-button--v1{background-color:#ff885e;border-color:#ff885e;color:#fff}.hl-button.hl-button--v1:disabled{box-shadow:none}.hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#000;border-color:currentColor}.hl-button.hl-button--v1.hl-button--destructive{background-color:transparent;border-color:#e91d00;color:#e91d00}.hl-button.hl-button--v1.hl-button--destructive:focus,.hl-button.hl-button--v1.hl-button--destructive:hover{background-color:#e91d00;color:#fff}.hl-button.hl-button--v1.hl-button--destructive:disabled{background-color:transparent;color:#e91d00}.hl-theme--blue .hl-button.hl-button--v1{background-color:#ffe157;border-color:#ffe157;color:#000}.hl-theme--blue .hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#000;border-color:currentColor}.hl-theme--blue .hl-button.hl-button--v1.hl-button--destructive{background-color:#e91d00;border-color:#e91d00;color:#fff}.hl-theme--blue-light .hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#000;border-color:currentColor}.hl-theme--blue-light .hl-button.hl-button--v1.hl-button--destructive{background-color:#e91d00;border-color:#e91d00;color:#fff}.hl-theme--orange .hl-button.hl-button--v1{background-color:#ffe157;border-color:#ffe157;color:#000}.hl-theme--orange .hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#000;border-color:currentColor}.hl-theme--orange .hl-button.hl-button--v1.hl-button--destructive{background-color:#e91d00;border-color:#e91d00;color:#fff}.hl-theme--yellow .hl-button.hl-button--v1{background-color:#ff885e;border-color:#ff885e;color:#fff}.hl-theme--yellow .hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#000;border-color:currentColor}.hl-theme--yellow .hl-button.hl-button--v1.hl-button--destructive{background-color:#e91d00;border-color:#e91d00;color:#fff}.hl-theme--yellow-light .hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#000;border-color:currentColor}.hl-theme--yellow-light .hl-button.hl-button--v1.hl-button--destructive{background-color:#e91d00;border-color:#e91d00;color:#fff}.hl-theme--gray-light .hl-button.hl-button--v1{background-color:#ff885e;border-color:#ff885e;color:#fff}.hl-theme--gray-light .hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#000;border-color:currentColor}.hl-theme--gray-light .hl-button.hl-button--v1.hl-button--destructive{background-color:#e91d00;border-color:#e91d00;color:#fff}.hl-theme--gray-dark .hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#fff;border-color:currentColor}.hl-theme--gray-dark .hl-button.hl-button--v1.hl-button--destructive{background-color:#e91d00;border-color:#e91d00;color:#fff}.hl-minimal-button{border-color:transparent}.hl-minimal-button:hover{background-color:rgba(0,0,0,.06)}.hl-minimal-button:focus{outline:0;border-color:currentColor}.hl-minimal-button:focus::-moz-focus-inner{border-style:none;padding:0}.hl-minimal-button:focus:-moz-focusring{outline:0}.hl-minimal-button:disabled{background-color:transparent}@media screen and (pointer:coarse){.hl-minimal-button{position:var(--hds-tap-target-position,relative)}.hl-minimal-button::after{content:'';position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);height:3rem;width:3rem}}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { baseClass: [{
            type: HostBinding,
            args: ['class.hl-button']
        }], secondary: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.hl-button--secondary']
        }], destructive: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.hl-button--destructive']
        }], loading: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.aria-busy']
        }], loadingText: [{
            type: Input
        }] }); })();
    return ButtonComponent;
}());
/**
 * @deprecated
 * @ignore
 */
var ButtonVersionDirective = /** @class */ (function () {
    function ButtonVersionDirective() {
    }
    Object.defineProperty(ButtonVersionDirective.prototype, "isV1", {
        get: function () {
            return this.version === '1';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonVersionDirective.prototype, "isV2", {
        get: function () {
            return this.version === '2';
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ButtonVersionDirective.prototype, "version", void 0);
    __decorate([
        HostBinding('class.hl-button--v1'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ButtonVersionDirective.prototype, "isV1", null);
    __decorate([
        HostBinding('class.hl-button--v2'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ButtonVersionDirective.prototype, "isV2", null);
ButtonVersionDirective.ɵfac = function ButtonVersionDirective_Factory(t) { return new (t || ButtonVersionDirective)(); };
ButtonVersionDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ButtonVersionDirective, selectors: [["button", "hlButton", "", "version", ""], ["a", "hlButton", "", "version", ""]], hostVars: 4, hostBindings: function ButtonVersionDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hl-button--v1", ctx.isV1)("hl-button--v2", ctx.isV2);
    } }, inputs: { version: "version" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonVersionDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line
                selector: 'button[hlButton][version], a[hlButton][version]'
            }]
    }], function () { return []; }, { isV1: [{
            type: HostBinding,
            args: ['class.hl-button--v1']
        }], isV2: [{
            type: HostBinding,
            args: ['class.hl-button--v2']
        }], version: [{
            type: Input
        }] }); })();
    return ButtonVersionDirective;
}());

/**
 * Error to indicate that a component is improperly configured.
 */
var ComponentConfigurationError = /** @class */ (function (_super) {
    __extends(ComponentConfigurationError, _super);
    /**
     * Create an instance of ComponentConfigurationError to throw.
     * @param message Error message
     * @param exampleUsage A message or code snippet describing correct configuration
     */
    function ComponentConfigurationError(message, exampleUsage) {
        var _this = _super.call(this, exampleUsage ? message + ". \nExample usage: " + exampleUsage : message) || this;
        _this.name = 'ComponentConfigurationError';
        return _this;
    }
    return ComponentConfigurationError;
}(Error));
/**
 * Error to indicate that a component violates an accessibility guideline.
 */
var AccessibilityError = /** @class */ (function (_super) {
    __extends(AccessibilityError, _super);
    /**
     * Create an instance of AccessibilityError to throw.
     * @param message Error message
     * @param exampleUsage A message or code snippet describing the appropriate pattern
     */
    function AccessibilityError(message, exampleUsage) {
        var _this = _super.call(this, message, exampleUsage) || this;
        _this.name = 'AccessibilityError';
        return _this;
    }
    return AccessibilityError;
}(ComponentConfigurationError));

/**
 * A button without default button-like styling.
 */
var MinimalButtonComponent = /** @class */ (function () {
    function MinimalButtonComponent() {
        /**
         * @ignore
         */
        this.baseClass = true;
        /**
         * Set to `true` to visibly hide the button label. The label will still be
         * available to assistive technologies.
         *
         * NOTE: If no `icon` is provided, this must not be set to `true`.
         */
        this.hideLabel = false;
    }
    MinimalButtonComponent.prototype.ngOnInit = function () {
        if (this.hideLabel && !this.icon) {
            throw new ComponentConfigurationError('Either an icon or a label must be visible');
        }
    };
    __decorate([
        HostBinding('class.hl-minimal-button'),
        __metadata("design:type", Object)
    ], MinimalButtonComponent.prototype, "baseClass", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], MinimalButtonComponent.prototype, "icon", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], MinimalButtonComponent.prototype, "hideLabel", void 0);
MinimalButtonComponent.ɵfac = function MinimalButtonComponent_Factory(t) { return new (t || MinimalButtonComponent)(); };
MinimalButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MinimalButtonComponent, selectors: [["button", "hlMinimalButton", ""], ["a", "hlMinimalButton", ""]], hostVars: 2, hostBindings: function MinimalButtonComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hl-minimal-button", ctx.baseClass);
    } }, inputs: { hideLabel: "hideLabel", icon: "icon" }, attrs: _c3, ngContentSelectors: _c4, decls: 3, vars: 3, consts: [[3, "icon", 4, "ngIf"], [1, "hl-minimal-button__text"], [3, "icon"]], template: function MinimalButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, MinimalButtonComponent_hl_icon_0_Template, 1, 1, "hl-icon", 0);
        ɵngcc0.ɵɵelementStart(1, "span", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.icon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("hl-a11y--visually-hidden", ctx.hideLabel);
    } }, directives: [ɵngcc1.NgIf, IconComponent], styles: [_c5], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MinimalButtonComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line
                selector: 'button[hlMinimalButton], a[hlMinimalButton]',
                template: "\n        <hl-icon *ngIf=\"icon\" [icon]=\"icon\"></hl-icon>\n        <span class=\"hl-minimal-button__text\" [class.hl-a11y--visually-hidden]=\"hideLabel\">\n            <ng-content></ng-content>\n        </span>\n    ",
                encapsulation: ViewEncapsulation.None,
                styles: [".hl-button,.hl-minimal-button{margin:0;padding:.125rem;border:.125rem solid;-webkit-appearance:none;-moz-appearance:none;appearance:none;overflow:visible;font-family:inherit;font-size:1rem;text-decoration:none;text-transform:none;background-color:transparent;color:inherit;cursor:pointer;min-height:2rem;border-radius:.25rem;display:inline-flex;justify-content:center;align-items:center;transition-duration:150ms;transition-property:background-color,box-shadow,color,transform}.hl-button:active,.hl-minimal-button:active{transform:scale(.98)}.hl-button:disabled,.hl-minimal-button:disabled{opacity:.45;cursor:not-allowed;transform:none}.hl-button [class*='__text']:not(:empty),.hl-minimal-button [class*='__text']:not(:empty){padding-left:.25rem;padding-right:.25rem}.hl-button .hl-icon,.hl-minimal-button .hl-icon{flex-shrink:0}.hl-button{position:relative;min-height:3rem;padding:.5rem 2rem;border-radius:999999px}.hl-button:hover{box-shadow:0 0 8px rgba(0,0,0,.36)}.hl-button .hl-icon:first-child{margin-left:-.5rem;margin-right:.25rem}.hl-button .hl-icon:last-child{margin-right:-.5rem;margin-left:.25rem}.hl-button[aria-busy=true]{cursor:not-allowed}.hl-button .hl-button__text{max-height:1.3rem}.hl-button .hds-spinner--svg{width:25px;height:25px}.hl-button .hds-spinner--wrapper{position:absolute;left:10px;top:10px;width:25px;height:25px;opacity:0;-webkit-animation:.5s ease-in-out forwards fadein;animation:.5s ease-in-out forwards fadein}.hl-button .hds-spinner--loading-text{display:block;opacity:0;padding:0 .25rem;left:0;right:0;display:inline-flex;top:12px;justify-content:center;transition:.5s linear;transform:translate(.25rem,-.6rem) rotateX(90deg)}.hl-button .hds-spinner--button-text{opacity:1;transition:.5s linear;transform:translate(0,0) rotateX(0);display:block}.hl-button .hds-spinner--loading .hds-spinner--wrapper{-webkit-animation:.5s ease-in-out forwards fadein;animation:.5s ease-in-out forwards fadein}.hl-button .hds-spinner--loading+.hl-button__text .hds-spinner--loading-text{opacity:1;transform:translate(.25rem,-1.3rem) rotateX(0)}.hl-button .hds-spinner--loading+.hl-button__text .hds-spinner--button-text{opacity:0;transform:translate(0,-.6rem) rotateX(90deg)}.hl-button .hds-spinner--hide .hds-spinner--wrapper{-webkit-animation:.5s ease-in-out forwards fadeout;animation:.5s ease-in-out forwards fadeout}.hl-button .hds-spinner--pristine{opacity:0!important}.hl-button.hl-button--v2,.hl-button:not([class*=hl-button--v]){--bg:var(--hds-button-background, var(--hds-theme-accent-primary, #000));--text:var(--hds-button-text, #fff);background-color:var(--bg);border-color:var(--bg);color:var(--text);transition-property:transform}.hl-button.hl-button--v2:focus,.hl-button:not([class*=hl-button--v]):focus{outline:0;box-shadow:0 0 0 .25rem var(--hds-theme-base-background),0 0 0 calc(.25rem + .0625rem) var(--hds-theme-focus-ring)}.hl-button.hl-button--v2:focus::-moz-focus-inner,.hl-button:not([class*=hl-button--v]):focus::-moz-focus-inner{border-style:none;padding:0}.hl-button.hl-button--v2:focus:-moz-focusring,.hl-button:not([class*=hl-button--v]):focus:-moz-focusring{outline:0}.hl-button.hl-button--v2:active,.hl-button:not([class*=hl-button--v]):active{box-shadow:none;transform:scale(.97)}.hl-button.hl-button--v2:disabled,.hl-button:not([class*=hl-button--v]):disabled{background-color:var(--bg);border-color:var(--bg);color:var(--text);box-shadow:none;transform:none}.hl-button.hl-button--v2.hl-button--secondary,.hl-button:not([class*=hl-button--v]).hl-button--secondary{background-color:transparent;color:var(--bg)}.hl-button.hl-button--v2.hl-button--destructive,.hl-button:not([class*=hl-button--v]).hl-button--destructive{--bg:var(--hds-button-background-destructive, #e91d00);--text:var(--hds-button-text-destructive, #fff)}.hl-button.hl-button--v1{background-color:#ff885e;border-color:#ff885e;color:#fff}.hl-button.hl-button--v1:disabled{box-shadow:none}.hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#000;border-color:currentColor}.hl-button.hl-button--v1.hl-button--destructive{background-color:transparent;border-color:#e91d00;color:#e91d00}.hl-button.hl-button--v1.hl-button--destructive:focus,.hl-button.hl-button--v1.hl-button--destructive:hover{background-color:#e91d00;color:#fff}.hl-button.hl-button--v1.hl-button--destructive:disabled{background-color:transparent;color:#e91d00}.hl-theme--blue .hl-button.hl-button--v1{background-color:#ffe157;border-color:#ffe157;color:#000}.hl-theme--blue .hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#000;border-color:currentColor}.hl-theme--blue .hl-button.hl-button--v1.hl-button--destructive{background-color:#e91d00;border-color:#e91d00;color:#fff}.hl-theme--blue-light .hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#000;border-color:currentColor}.hl-theme--blue-light .hl-button.hl-button--v1.hl-button--destructive{background-color:#e91d00;border-color:#e91d00;color:#fff}.hl-theme--orange .hl-button.hl-button--v1{background-color:#ffe157;border-color:#ffe157;color:#000}.hl-theme--orange .hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#000;border-color:currentColor}.hl-theme--orange .hl-button.hl-button--v1.hl-button--destructive{background-color:#e91d00;border-color:#e91d00;color:#fff}.hl-theme--yellow .hl-button.hl-button--v1{background-color:#ff885e;border-color:#ff885e;color:#fff}.hl-theme--yellow .hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#000;border-color:currentColor}.hl-theme--yellow .hl-button.hl-button--v1.hl-button--destructive{background-color:#e91d00;border-color:#e91d00;color:#fff}.hl-theme--yellow-light .hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#000;border-color:currentColor}.hl-theme--yellow-light .hl-button.hl-button--v1.hl-button--destructive{background-color:#e91d00;border-color:#e91d00;color:#fff}.hl-theme--gray-light .hl-button.hl-button--v1{background-color:#ff885e;border-color:#ff885e;color:#fff}.hl-theme--gray-light .hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#000;border-color:currentColor}.hl-theme--gray-light .hl-button.hl-button--v1.hl-button--destructive{background-color:#e91d00;border-color:#e91d00;color:#fff}.hl-theme--gray-dark .hl-button.hl-button--v1.hl-button--secondary{background-color:transparent;color:#fff;border-color:currentColor}.hl-theme--gray-dark .hl-button.hl-button--v1.hl-button--destructive{background-color:#e91d00;border-color:#e91d00;color:#fff}.hl-minimal-button{border-color:transparent}.hl-minimal-button:hover{background-color:rgba(0,0,0,.06)}.hl-minimal-button:focus{outline:0;border-color:currentColor}.hl-minimal-button:focus::-moz-focus-inner{border-style:none;padding:0}.hl-minimal-button:focus:-moz-focusring{outline:0}.hl-minimal-button:disabled{background-color:transparent}@media screen and (pointer:coarse){.hl-minimal-button{position:var(--hds-tap-target-position,relative)}.hl-minimal-button::after{content:'';position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);height:3rem;width:3rem}}"]
            }]
    }], function () { return []; }, { baseClass: [{
            type: HostBinding,
            args: ['class.hl-minimal-button']
        }], hideLabel: [{
            type: Input
        }], icon: [{
            type: Input
        }] }); })();
    return MinimalButtonComponent;
}());

var ButtonModule = /** @class */ (function () {
    function ButtonModule() {
    }
ButtonModule.ɵfac = function ButtonModule_Factory(t) { return new (t || ButtonModule)(); };
ButtonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ButtonModule });
ButtonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, IconModule, LoadingSpinnerModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonModule, [{
        type: NgModule,
        args: [{
                declarations: [ButtonComponent, MinimalButtonComponent, ButtonVersionDirective],
                imports: [CommonModule, IconModule, LoadingSpinnerModule],
                exports: [ButtonComponent, MinimalButtonComponent, ButtonVersionDirective]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ButtonModule, { declarations: function () { return [ButtonComponent, MinimalButtonComponent, ButtonVersionDirective]; }, imports: function () { return [CommonModule, IconModule, LoadingSpinnerModule]; }, exports: function () { return [ButtonComponent, MinimalButtonComponent, ButtonVersionDirective]; } }); })();
    return ButtonModule;
}());

/**
 * Applies custom link styling to links and buttons.
 */
var LinkComponent = /** @class */ (function () {
    function LinkComponent() {
        /**
         * This property has been deprecated. Use the `variant` property instead.
         *
         * @deprecated Use the `variant` input property instead.
         * @todo Remove in v3
         */
        this.type = 'inline';
        /**
         * Variant of link styles to use.
         */
        this.variant = 'inline';
        /**
         * @ignore
         */
        this.isBaseClass = true;
    }
    Object.defineProperty(LinkComponent.prototype, "_variant", {
        /**
         * @ignore
         */
        get: function () {
            return this.variant || this.type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LinkComponent.prototype, "standalone", {
        /**
         * Standalone links only show an underline when the user interacts with them.
         * Set this property to `true` only if the link is intended to appear on its
         * own.
         */
        get: function () {
            return this.isBaseClass && this._variant === 'standalone';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LinkComponent.prototype, "cta", {
        /**
         * CTA links are Standalone links that include a chevron (>) icon and evoke
         * a clear action. Set this property to `true` only if the link is intended
         * to appear on its own.
         */
        get: function () {
            return this.isBaseClass && this._variant === 'cta';
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], LinkComponent.prototype, "type", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], LinkComponent.prototype, "variant", void 0);
    __decorate([
        HostBinding('class.hl-link'),
        __metadata("design:type", Object)
    ], LinkComponent.prototype, "isBaseClass", void 0);
    __decorate([
        HostBinding('class.hl-link--standalone'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], LinkComponent.prototype, "standalone", null);
    __decorate([
        HostBinding('class.hl-link--cta'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], LinkComponent.prototype, "cta", null);
LinkComponent.ɵfac = function LinkComponent_Factory(t) { return new (t || LinkComponent)(); };
LinkComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LinkComponent, selectors: [["a", "hlLink", ""], ["button", "hlLink", ""]], hostVars: 6, hostBindings: function LinkComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hl-link", ctx.isBaseClass)("hl-link--standalone", ctx.standalone)("hl-link--cta", ctx.cta);
    } }, inputs: { type: "type", variant: "variant" }, attrs: _c6, ngContentSelectors: _c4, decls: 1, vars: 0, template: function LinkComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: [".hl-link{margin:0;padding:0;border:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;overflow:visible;font-family:inherit;font-size:1rem;text-decoration:none;text-transform:none;background-color:transparent;color:inherit;cursor:pointer;display:inline;font-size:inherit;line-height:normal;text-align:left;color:var(--hds-link-text,var(--hds-theme-accent-primary,#127691));-webkit-text-decoration:solid underline currentColor;text-decoration:solid underline currentColor;text-decoration-thickness:calc(1em / 16);text-underline-offset:calc(1em / 4);transition-property:filter,text-decoration-color,text-decoration-thickness,-webkit-filter,-webkit-text-decoration-color;transition-duration:150ms}.hl-link:hover{-webkit-filter:brightness(var(--hds-link-brightness-hover, 80%));filter:brightness(var(--hds-link-brightness-hover, 80%));text-decoration-thickness:calc(1em / 8)}.hl-link:focus{outline:0;--hds-theme-focus-ring:currentColor;text-decoration:none;border-radius:.25rem;box-shadow:0 0 0 .125rem var(--hds-theme-focus-ring)}.hl-link:focus::-moz-focus-inner{border-style:none;padding:0}.hl-link:focus:-moz-focusring{outline:0}.hl-link .hl-icon svg{display:inline}.hl-link *+.hl-icon,.hl-link .hl-icon+*{margin-left:.125rem}.hl-link--cta,.hl-link--standalone{-webkit-text-decoration-color:transparent;text-decoration-color:transparent}.hl-link--cta:hover,.hl-link--standalone:hover{-webkit-text-decoration-color:currentColor;text-decoration-color:currentColor}.hl-link--cta{display:inline-block}.hl-link--cta::after{content:'';display:inline-block;vertical-align:bottom;margin-left:.25rem;width:1em;height:1em;position:relative;bottom:.125em;background-size:contain;background-image:url('data:image/svg+xml;charset=utf8,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath d=\"M51.5 48L32 29L38.5 22.5L64 48L38.5 73.5L32 67L51.5 48Z\"/%3E%3C/svg%3E')}.hl-theme--blue .hl-link--cta::after{background-image:url('data:image/svg+xml;charset=utf8,%3Csvg fill=\"%23000\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath d=\"M51.5 48L32 29L38.5 22.5L64 48L38.5 73.5L32 67L51.5 48Z\"/%3E%3C/svg%3E')}.hl-theme--blue-light .hl-link--cta::after{background-image:url('data:image/svg+xml;charset=utf8,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath d=\"M51.5 48L32 29L38.5 22.5L64 48L38.5 73.5L32 67L51.5 48Z\"/%3E%3C/svg%3E')}.hl-theme--orange .hl-link--cta::after,.hl-theme--yellow .hl-link--cta::after{background-image:url('data:image/svg+xml;charset=utf8,%3Csvg fill=\"%23000\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath d=\"M51.5 48L32 29L38.5 22.5L64 48L38.5 73.5L32 67L51.5 48Z\"/%3E%3C/svg%3E')}.hl-theme--gray-light .hl-link--cta::after,.hl-theme--yellow-light .hl-link--cta::after{background-image:url('data:image/svg+xml;charset=utf8,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath d=\"M51.5 48L32 29L38.5 22.5L64 48L38.5 73.5L32 67L51.5 48Z\"/%3E%3C/svg%3E')}.hl-theme--gray-dark .hl-link--cta::after{background-image:url('data:image/svg+xml;charset=utf8,%3Csvg fill=\"%23fff\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath d=\"M51.5 48L32 29L38.5 22.5L64 48L38.5 73.5L32 67L51.5 48Z\"/%3E%3C/svg%3E')}@supports ((-webkit-mask-image:url(\"\")) or (mask-image:url(\"\"))) or (-webkit-mask-image:url(\"\")){.hl-link--cta::after{background-image:none;background-color:currentColor;-webkit-mask-image:url('data:image/svg+xml;charset=utf8,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath d=\"M51.5 48L32 29L38.5 22.5L64 48L38.5 73.5L32 67L51.5 48Z\"/%3E%3C/svg%3E');mask-image:url('data:image/svg+xml;charset=utf8,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath d=\"M51.5 48L32 29L38.5 22.5L64 48L38.5 73.5L32 67L51.5 48Z\"/%3E%3C/svg%3E')}}"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LinkComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line
                selector: 'a[hlLink], button[hlLink]',
                template: '<ng-content></ng-content>',
                encapsulation: ViewEncapsulation.None,
                styles: [".hl-link{margin:0;padding:0;border:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;overflow:visible;font-family:inherit;font-size:1rem;text-decoration:none;text-transform:none;background-color:transparent;color:inherit;cursor:pointer;display:inline;font-size:inherit;line-height:normal;text-align:left;color:var(--hds-link-text,var(--hds-theme-accent-primary,#127691));-webkit-text-decoration:solid underline currentColor;text-decoration:solid underline currentColor;text-decoration-thickness:calc(1em / 16);text-underline-offset:calc(1em / 4);transition-property:filter,text-decoration-color,text-decoration-thickness,-webkit-filter,-webkit-text-decoration-color;transition-duration:150ms}.hl-link:hover{-webkit-filter:brightness(var(--hds-link-brightness-hover, 80%));filter:brightness(var(--hds-link-brightness-hover, 80%));text-decoration-thickness:calc(1em / 8)}.hl-link:focus{outline:0;--hds-theme-focus-ring:currentColor;text-decoration:none;border-radius:.25rem;box-shadow:0 0 0 .125rem var(--hds-theme-focus-ring)}.hl-link:focus::-moz-focus-inner{border-style:none;padding:0}.hl-link:focus:-moz-focusring{outline:0}.hl-link .hl-icon svg{display:inline}.hl-link *+.hl-icon,.hl-link .hl-icon+*{margin-left:.125rem}.hl-link--cta,.hl-link--standalone{-webkit-text-decoration-color:transparent;text-decoration-color:transparent}.hl-link--cta:hover,.hl-link--standalone:hover{-webkit-text-decoration-color:currentColor;text-decoration-color:currentColor}.hl-link--cta{display:inline-block}.hl-link--cta::after{content:'';display:inline-block;vertical-align:bottom;margin-left:.25rem;width:1em;height:1em;position:relative;bottom:.125em;background-size:contain;background-image:url('data:image/svg+xml;charset=utf8,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath d=\"M51.5 48L32 29L38.5 22.5L64 48L38.5 73.5L32 67L51.5 48Z\"/%3E%3C/svg%3E')}.hl-theme--blue .hl-link--cta::after{background-image:url('data:image/svg+xml;charset=utf8,%3Csvg fill=\"%23000\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath d=\"M51.5 48L32 29L38.5 22.5L64 48L38.5 73.5L32 67L51.5 48Z\"/%3E%3C/svg%3E')}.hl-theme--blue-light .hl-link--cta::after{background-image:url('data:image/svg+xml;charset=utf8,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath d=\"M51.5 48L32 29L38.5 22.5L64 48L38.5 73.5L32 67L51.5 48Z\"/%3E%3C/svg%3E')}.hl-theme--orange .hl-link--cta::after,.hl-theme--yellow .hl-link--cta::after{background-image:url('data:image/svg+xml;charset=utf8,%3Csvg fill=\"%23000\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath d=\"M51.5 48L32 29L38.5 22.5L64 48L38.5 73.5L32 67L51.5 48Z\"/%3E%3C/svg%3E')}.hl-theme--gray-light .hl-link--cta::after,.hl-theme--yellow-light .hl-link--cta::after{background-image:url('data:image/svg+xml;charset=utf8,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath d=\"M51.5 48L32 29L38.5 22.5L64 48L38.5 73.5L32 67L51.5 48Z\"/%3E%3C/svg%3E')}.hl-theme--gray-dark .hl-link--cta::after{background-image:url('data:image/svg+xml;charset=utf8,%3Csvg fill=\"%23fff\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath d=\"M51.5 48L32 29L38.5 22.5L64 48L38.5 73.5L32 67L51.5 48Z\"/%3E%3C/svg%3E')}@supports ((-webkit-mask-image:url(\"\")) or (mask-image:url(\"\"))) or (-webkit-mask-image:url(\"\")){.hl-link--cta::after{background-image:none;background-color:currentColor;-webkit-mask-image:url('data:image/svg+xml;charset=utf8,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath d=\"M51.5 48L32 29L38.5 22.5L64 48L38.5 73.5L32 67L51.5 48Z\"/%3E%3C/svg%3E');mask-image:url('data:image/svg+xml;charset=utf8,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath d=\"M51.5 48L32 29L38.5 22.5L64 48L38.5 73.5L32 67L51.5 48Z\"/%3E%3C/svg%3E')}}"]
            }]
    }], function () { return []; }, { type: [{
            type: Input
        }], variant: [{
            type: Input
        }], isBaseClass: [{
            type: HostBinding,
            args: ['class.hl-link']
        }], standalone: [{
            type: HostBinding,
            args: ['class.hl-link--standalone']
        }], cta: [{
            type: HostBinding,
            args: ['class.hl-link--cta']
        }] }); })();
    return LinkComponent;
}());

var LinkModule = /** @class */ (function () {
    function LinkModule() {
    }
LinkModule.ɵfac = function LinkModule_Factory(t) { return new (t || LinkModule)(); };
LinkModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: LinkModule });
LinkModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, IconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LinkModule, [{
        type: NgModule,
        args: [{
                declarations: [LinkComponent],
                imports: [CommonModule, IconModule],
                exports: [LinkComponent]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LinkModule, { declarations: function () { return [LinkComponent]; }, imports: function () { return [CommonModule, IconModule]; }, exports: function () { return [LinkComponent]; } }); })();
    return LinkModule;
}());

/**
 * Wrapper to responsively align and evenly space a group of button-like elements.
 */
var ActionGroupComponent = /** @class */ (function () {
    function ActionGroupComponent() {
        /**
         * @ignore
         */
        this.baseClass = true;
    }
    Object.defineProperty(ActionGroupComponent.prototype, "isAlignCenter", {
        /**
         * @ignore
         */
        get: function () {
            return this.align === 'center';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActionGroupComponent.prototype, "isAlignEnd", {
        /**
         * @ignore
         */
        get: function () {
            return this.align === 'end';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActionGroupComponent.prototype, "isAlignStretch", {
        /**
         * @ignore
         */
        get: function () {
            return this.align === 'stretch';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActionGroupComponent.prototype, "isStacked", {
        /**
         * @ignore
         */
        get: function () {
            return this.align === 'stacked';
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        HostBinding('class.hl-action-group'),
        __metadata("design:type", Object)
    ], ActionGroupComponent.prototype, "baseClass", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ActionGroupComponent.prototype, "align", void 0);
    __decorate([
        HostBinding('class.hl-action-group--center'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ActionGroupComponent.prototype, "isAlignCenter", null);
    __decorate([
        HostBinding('class.hl-action-group--end'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ActionGroupComponent.prototype, "isAlignEnd", null);
    __decorate([
        HostBinding('class.hl-action-group--stretch'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ActionGroupComponent.prototype, "isAlignStretch", null);
    __decorate([
        HostBinding('class.hl-action-group--stacked'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ActionGroupComponent.prototype, "isStacked", null);
ActionGroupComponent.ɵfac = function ActionGroupComponent_Factory(t) { return new (t || ActionGroupComponent)(); };
ActionGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ActionGroupComponent, selectors: [["hl-action-group"]], hostVars: 10, hostBindings: function ActionGroupComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hl-action-group", ctx.baseClass)("hl-action-group--center", ctx.isAlignCenter)("hl-action-group--end", ctx.isAlignEnd)("hl-action-group--stretch", ctx.isAlignStretch)("hl-action-group--stacked", ctx.isStacked);
    } }, inputs: { align: "align" }, ngContentSelectors: _c8, decls: 3, vars: 0, consts: [[1, "hl-action-group__wrapper"]], template: function ActionGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c7);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵprojection(2, 1);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [".hl-action-group{display:flex;justify-content:flex-start}.hl-action-group--center{justify-content:center}.hl-action-group--end{justify-content:flex-end}.hl-action-group .hl-action-group__wrapper{flex-basis:100%;max-width:-webkit-max-content;max-width:-moz-max-content;max-width:max-content;display:flex;flex-wrap:wrap;align-items:center;margin:-.5rem -.375rem}.hl-action-group .hl-action-group__wrapper>*{margin:.5rem .375rem}.hl-action-group--stacked .hl-action-group__wrapper{flex-direction:column}@media screen and (max-width:599px){.hl-action-group--stacked .hl-action-group__wrapper{max-width:100%;flex-grow:1;align-items:stretch}}.hl-action-group--stretch .hl-action-group__wrapper{max-width:unset;flex-grow:1}.hl-action-group .hl-button,.hl-action-group .hl-link{flex-grow:1}"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ActionGroupComponent, [{
        type: Component,
        args: [{
                selector: 'hl-action-group',
                template: "<div class=\"hl-action-group__wrapper\">\n    <ng-content select=\"[hlButton], [hlMinimalButton]\"></ng-content>\n    <ng-content select=\"[hlLink]\"></ng-content>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".hl-action-group{display:flex;justify-content:flex-start}.hl-action-group--center{justify-content:center}.hl-action-group--end{justify-content:flex-end}.hl-action-group .hl-action-group__wrapper{flex-basis:100%;max-width:-webkit-max-content;max-width:-moz-max-content;max-width:max-content;display:flex;flex-wrap:wrap;align-items:center;margin:-.5rem -.375rem}.hl-action-group .hl-action-group__wrapper>*{margin:.5rem .375rem}.hl-action-group--stacked .hl-action-group__wrapper{flex-direction:column}@media screen and (max-width:599px){.hl-action-group--stacked .hl-action-group__wrapper{max-width:100%;flex-grow:1;align-items:stretch}}.hl-action-group--stretch .hl-action-group__wrapper{max-width:unset;flex-grow:1}.hl-action-group .hl-button,.hl-action-group .hl-link{flex-grow:1}"]
            }]
    }], function () { return []; }, { baseClass: [{
            type: HostBinding,
            args: ['class.hl-action-group']
        }], isAlignCenter: [{
            type: HostBinding,
            args: ['class.hl-action-group--center']
        }], isAlignEnd: [{
            type: HostBinding,
            args: ['class.hl-action-group--end']
        }], isAlignStretch: [{
            type: HostBinding,
            args: ['class.hl-action-group--stretch']
        }], isStacked: [{
            type: HostBinding,
            args: ['class.hl-action-group--stacked']
        }], align: [{
            type: Input
        }] }); })();
    return ActionGroupComponent;
}());

var ActionGroupModule = /** @class */ (function () {
    function ActionGroupModule() {
    }
ActionGroupModule.ɵfac = function ActionGroupModule_Factory(t) { return new (t || ActionGroupModule)(); };
ActionGroupModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ActionGroupModule });
ActionGroupModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, ButtonModule, LinkModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ActionGroupModule, [{
        type: NgModule,
        args: [{
                declarations: [ActionGroupComponent],
                imports: [CommonModule, ButtonModule, LinkModule],
                exports: [ActionGroupComponent]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ActionGroupModule, { declarations: function () { return [ActionGroupComponent]; }, imports: function () { return [CommonModule, ButtonModule, LinkModule]; }, exports: function () { return [ActionGroupComponent]; } }); })();
    return ActionGroupModule;
}());

var AlertComponent = /** @class */ (function () {
    /**
     * @ignore
     */
    function AlertComponent(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        /**
         * Unique string that serves as a global identifier for the root HTML element
         * and its children.
         */
        this.id = "hl-alert-" + AlertComponent_1.componentCount++;
        /**
         * The type (general intent) of the alert.
         */
        this.type = "info" /* Info */;
        /**
         * When set to true, displays a close button that removes the alert when clicked.
         */
        this.canBeClosed = false;
        /**
         * Indicates if the alert is open or not.
         * This can be manually toggled as an alternative to the open and close methods.
         */
        this.isOpen = false;
        /**
         * Event emitted after the alert opens.
         */
        this.alertOpen = new EventEmitter();
        /**
         * Event emitted after the alert closes.
         */
        this.alertClose = new EventEmitter();
    }
    AlertComponent_1 = AlertComponent;
    AlertComponent.prototype.ngOnInit = function () {
        this.update();
        if (this.isOpen) {
            this.alertOpen.emit();
        }
    };
    AlertComponent.prototype.ngOnChanges = function () {
        this.update();
    };
    /**
     * Update property values based on component changes.
     *
     * @internal
     */
    AlertComponent.prototype.update = function () {
        this.classMap = this.getClassMap();
        this.iconId = this.getIconId(this.type);
    };
    /**
     * Returns a map of CSS class names (in BEM notation) based on conditional
     * modifiers.
     *
     * @internal
     */
    AlertComponent.prototype.getClassMap = function () {
        var _a;
        return _a = {},
            _a["hl-alert--" + this.type] = Boolean(this.type),
            _a;
    };
    /**
     * Returns the ID of the icon corresponding to the given alert type.
     *
     * @param alertType The type of the alert.
     * @internal
     */
    AlertComponent.prototype.getIconId = function (alertType) {
        switch (alertType) {
            case "info" /* Info */:
                return 'info';
            case "success" /* Success */:
                return 'confirm';
            case "warning" /* Warning */:
                return 'warning';
            case "critical" /* Critical */:
                return 'exclamation';
            default:
                return 'info';
        }
    };
    Object.defineProperty(AlertComponent.prototype, "titleId", {
        /**
         * @ignore
         */
        get: function () {
            return this.id + "__title";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AlertComponent.prototype, "alertContentId", {
        /**
         * @ignore
         */
        get: function () {
            return this.id + "__content";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AlertComponent.prototype, "closeButtonId", {
        /**
         * @ignore
         */
        get: function () {
            return this.id + "__close-button";
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Shows the alert.
     */
    AlertComponent.prototype.onAlertOpen = function () {
        this.alertOpen.emit();
        this.isOpen = true;
        this.changeDetectorRef.detectChanges();
    };
    /**
     * Hides the alert.
     */
    AlertComponent.prototype.onAlertClose = function () {
        this.alertClose.emit();
        this.isOpen = false;
        this.changeDetectorRef.detectChanges();
    };
    var AlertComponent_1;
    /**
     * Tracks the number of instances of the component that have been created.
     * Used to generate IDs for child elements, if an ID was not provided.
     *
     * @internal
     */
    AlertComponent.componentCount = 0;
    AlertComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    __decorate([
        Input(), HostBinding(),
        __metadata("design:type", Object)
    ], AlertComponent.prototype, "id", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], AlertComponent.prototype, "type", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], AlertComponent.prototype, "title", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], AlertComponent.prototype, "canBeClosed", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], AlertComponent.prototype, "isOpen", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], AlertComponent.prototype, "alertOpen", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], AlertComponent.prototype, "alertClose", void 0);
    AlertComponent = AlertComponent_1 = __decorate([ __metadata("design:paramtypes", [ChangeDetectorRef])
    ], AlertComponent);
AlertComponent.ɵfac = function AlertComponent_Factory(t) { return new (t || AlertComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
AlertComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AlertComponent, selectors: [["hl-alert"]], hostVars: 1, hostBindings: function AlertComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("id", ctx.id);
    } }, inputs: { id: "id", type: "type", canBeClosed: "canBeClosed", isOpen: "isOpen", title: "title" }, outputs: { alertOpen: "alertOpen", alertClose: "alertClose" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c4, decls: 1, vars: 1, consts: [["class", "hl-alert", 3, "ngClass", 4, "ngIf"], [1, "hl-alert", 3, "ngClass"], [1, "hl-alert__body"], [1, "hl-alert__icon"], ["size", "medium", 3, "icon"], [1, "hl-alert__info"], ["class", "hl-alert__title hl-font-weight--bold", 3, "id", 4, "ngIf"], [1, "hl-alert__content", 3, "id"], ["hlMinimalButton", "", "class", "hl-alert__close-button", "icon", "close", "hideLabel", "true", 3, "id", "click", 4, "ngIf"], [1, "hl-alert__title", "hl-font-weight--bold", 3, "id"], ["hlMinimalButton", "", "icon", "close", "hideLabel", "true", 1, "hl-alert__close-button", 3, "id", "click"]], template: function AlertComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, AlertComponent_div_0_Template, 9, 9, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isOpen);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass, IconComponent, MinimalButtonComponent], styles: ["hl-alert{display:block}.hl-alert,.hl-alert--info{--status-color:#189ec3}.hl-alert{position:relative;display:block;margin:0;border:2px solid var(--status-color);border-radius:4px;border-left-width:1rem;padding:1rem;box-shadow:0 0 .5rem rgba(0,0,0,.12);width:100%;max-width:40rem;background-color:#fff}.hl-alert__body{display:flex;align-items:flex-start}.hl-alert__icon{display:flex;justify-content:center;align-items:center;flex-shrink:0;border-radius:50%;width:2rem;height:2rem;background-color:var(--status-color);color:#fff}.hl-alert__info{margin-left:1rem;width:100%}.hl-alert__content,.hl-alert__title{margin:0}.hl-alert__content::first-letter,.hl-alert__title::first-letter{text-transform:uppercase}.hl-alert__title{margin-top:.25rem}.hl-alert__content{margin-top:.5rem;font-size:14px}.hl-alert--success{--status-color:#26a668}.hl-alert--warning{--status-color:#ff5f0f}.hl-alert--critical{--status-color:#e91d00}"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AlertComponent, [{
        type: Component,
        args: [{
                selector: 'hl-alert',
                template: "<div\n    *ngIf=\"isOpen\"\n    class=\"hl-alert\"\n    [ngClass]=\"classMap\"\n    [attr.role]=\"type === 'warning' || type === 'critical' ? 'alert' : 'status'\"\n    [attr.aria-labelledby]=\"title ? titleId : null\"\n    [attr.aria-describedby]=\"alertContentId\"\n    [attr.open]=\"isOpen\"\n>\n    <div class=\"hl-alert__body\">\n        <div class=\"hl-alert__icon\">\n            <hl-icon [icon]=\"iconId\" size=\"medium\"></hl-icon>\n        </div>\n\n        <div class=\"hl-alert__info\">\n            <p *ngIf=\"title\" class=\"hl-alert__title hl-font-weight--bold\" [id]=\"titleId\">\n                {{ title }}\n            </p>\n            <div class=\"hl-alert__content\" [id]=\"alertContentId\">\n                <ng-content></ng-content>\n            </div>\n        </div>\n\n        <button\n            *ngIf=\"canBeClosed\"\n            hlMinimalButton\n            class=\"hl-alert__close-button\"\n            icon=\"close\"\n            hideLabel=\"true\"\n            [id]=\"closeButtonId\"\n            (click)=\"onAlertClose()\"\n        >\n            Close\n        </button>\n    </div>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: ["hl-alert{display:block}.hl-alert,.hl-alert--info{--status-color:#189ec3}.hl-alert{position:relative;display:block;margin:0;border:2px solid var(--status-color);border-radius:4px;border-left-width:1rem;padding:1rem;box-shadow:0 0 .5rem rgba(0,0,0,.12);width:100%;max-width:40rem;background-color:#fff}.hl-alert__body{display:flex;align-items:flex-start}.hl-alert__icon{display:flex;justify-content:center;align-items:center;flex-shrink:0;border-radius:50%;width:2rem;height:2rem;background-color:var(--status-color);color:#fff}.hl-alert__info{margin-left:1rem;width:100%}.hl-alert__content,.hl-alert__title{margin:0}.hl-alert__content::first-letter,.hl-alert__title::first-letter{text-transform:uppercase}.hl-alert__title{margin-top:.25rem}.hl-alert__content{margin-top:.5rem;font-size:14px}.hl-alert--success{--status-color:#26a668}.hl-alert--warning{--status-color:#ff5f0f}.hl-alert--critical{--status-color:#e91d00}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { id: [{
            type: Input
        }, {
            type: HostBinding
        }], type: [{
            type: Input
        }], canBeClosed: [{
            type: Input
        }], isOpen: [{
            type: Input
        }], alertOpen: [{
            type: Output
        }], alertClose: [{
            type: Output
        }], title: [{
            type: Input
        }] }); })();
    return AlertComponent;
}());

var AlertModule = /** @class */ (function () {
    function AlertModule() {
    }
AlertModule.ɵfac = function AlertModule_Factory(t) { return new (t || AlertModule)(); };
AlertModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AlertModule });
AlertModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, ButtonModule, IconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AlertModule, [{
        type: NgModule,
        args: [{
                declarations: [AlertComponent],
                entryComponents: [AlertComponent],
                imports: [CommonModule, ButtonModule, IconModule],
                exports: [AlertComponent]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AlertModule, { declarations: function () { return [AlertComponent]; }, imports: function () { return [CommonModule, ButtonModule, IconModule]; }, exports: function () { return [AlertComponent]; } }); })();
    return AlertModule;
}());

/**
 * A simple banner to notify users of information.
 */
var BannerComponent = /** @class */ (function () {
    /**
     * @ignore
     */
    function BannerComponent(cd) {
        this.cd = cd;
        /**
         * @ignore
         */
        this.baseClass = true;
        /**
         * Set to `false` to prevent users from dismissing the banner.
         * Only set this is you will dismiss the banner programmatically.
         */
        this.dismissible = true;
        /**
         * Indicates that the banner has been dismissed. Application code may
         * perform logic here, e.g., to prevent the banner from showing on refresh.
         */
        this.dismiss = new EventEmitter();
        /**
         * Whether the banner is currently visible.
         * @internal
         */
        this.isVisible = true;
    }
    Object.defineProperty(BannerComponent.prototype, "role", {
        /**
         * Accessible role for the banner, determined from its status.
         *
         * @internal
         */
        get: function () {
            return this.status === 'warning' || this.status === 'critical' ? 'alert' : 'status';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Action dispatched when the user closes the banner.
     * @internal
     */
    BannerComponent.prototype.onDismiss = function () {
        this.dismiss.emit();
        this.isVisible = false;
        this.cd.detectChanges();
    };
    BannerComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    __decorate([
        HostBinding('class.hl-banner'),
        __metadata("design:type", Object)
    ], BannerComponent.prototype, "baseClass", void 0);
    __decorate([
        HostBinding('attr.data-anchor'),
        Input(),
        __metadata("design:type", String)
    ], BannerComponent.prototype, "anchor", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], BannerComponent.prototype, "dismissible", void 0);
    __decorate([
        HostBinding('attr.data-status'),
        Input(),
        __metadata("design:type", String)
    ], BannerComponent.prototype, "status", void 0);
    __decorate([
        HostBinding('attr.role'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], BannerComponent.prototype, "role", null);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], BannerComponent.prototype, "title", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], BannerComponent.prototype, "dismiss", void 0);
    BannerComponent = __decorate([ __metadata("design:paramtypes", [ChangeDetectorRef])
    ], BannerComponent);
BannerComponent.ɵfac = function BannerComponent_Factory(t) { return new (t || BannerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
BannerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BannerComponent, selectors: [["hl-banner"]], hostVars: 5, hostBindings: function BannerComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx.role)("data-anchor", ctx.anchor)("data-status", ctx.status);
        ɵngcc0.ɵɵclassProp("hl-banner", ctx.baseClass);
    } }, inputs: { dismissible: "dismissible", anchor: "anchor", status: "status", title: "title" }, outputs: { dismiss: "dismiss" }, ngContentSelectors: _c4, decls: 1, vars: 1, consts: [["class", "hl-banner__wrapper hl-grid-el__contents", 4, "ngIf"], [1, "hl-banner__wrapper", "hl-grid-el__contents"], ["class", "hl-banner__header hl-font--body hl-font-weight--bold", 4, "ngIf"], [1, "hl-banner__contents"], ["hlMinimalButton", "", "class", "hl-banner__close-button", "icon", "close", "hideLabel", "true", 3, "click", 4, "ngIf"], [1, "hl-banner__header", "hl-font--body", "hl-font-weight--bold"], ["hlMinimalButton", "", "icon", "close", "hideLabel", "true", 1, "hl-banner__close-button", 3, "click"]], template: function BannerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, BannerComponent_div_0_Template, 5, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isVisible);
    } }, directives: [ɵngcc1.NgIf, MinimalButtonComponent], styles: [".hl-banner{position:relative;display:flex;align-items:baseline;border:none;background-color:#4d4d4f;color:#fff}.hl-banner[data-anchor=bottom],.hl-banner[data-anchor=top]{position:fixed;left:0;right:0;z-index:100;box-shadow:0 4px 16px rgba(0,0,0,.12),0 8px 32px rgba(0,0,0,.12)}.hl-banner[data-anchor=top]{top:0}.hl-banner[data-anchor=bottom]{bottom:0}.hl-banner[data-status=success]{background-color:#8aca69;color:#fff}.hl-banner[data-status=info]{background-color:rgba(0,92,117,.96);color:#fff}.hl-banner[data-status=warning]{background-color:#ffe157;color:#000}.hl-banner[data-status=critical]{background-color:#e91d00;color:#fff}.hl-banner__wrapper{width:100%;padding-top:1rem;padding-bottom:1rem}:not([class*=hl-grid-el--full-bleed])>.hl-banner__wrapper{padding-left:3rem;padding-right:3rem}@media screen and (max-width:599px){:not([class*=hl-grid-el--full-bleed])>.hl-banner__wrapper{padding-left:1rem;padding-right:1rem}}.hl-banner__contents,.hl-banner__header{margin-right:2rem}.hl-banner__header{margin-bottom:.5rem}.hl-banner__contents{line-height:1.5}.hl-banner__contents .hl-link{color:inherit}.hl-banner__contents :first-child{margin-top:0}.hl-banner__contents :last-child{margin-bottom:0}.hl-banner__close-button{width:2rem;height:2rem;--hds-tap-target-position:absolute;position:absolute;top:.75rem;right:.75rem;margin:0}"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BannerComponent, [{
        type: Component,
        args: [{
                selector: 'hl-banner',
                template: "<div *ngIf=\"isVisible\" class=\"hl-banner__wrapper hl-grid-el__contents\">\n    <h2 *ngIf=\"title\" class=\"hl-banner__header hl-font--body hl-font-weight--bold\">\n        {{ title }}\n    </h2>\n    <div class=\"hl-banner__contents\">\n        <ng-content></ng-content>\n    </div>\n    <button\n        *ngIf=\"dismissible\"\n        hlMinimalButton\n        class=\"hl-banner__close-button\"\n        icon=\"close\"\n        hideLabel=\"true\"\n        (click)=\"onDismiss()\"\n    >\n        Dismiss\n    </button>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".hl-banner{position:relative;display:flex;align-items:baseline;border:none;background-color:#4d4d4f;color:#fff}.hl-banner[data-anchor=bottom],.hl-banner[data-anchor=top]{position:fixed;left:0;right:0;z-index:100;box-shadow:0 4px 16px rgba(0,0,0,.12),0 8px 32px rgba(0,0,0,.12)}.hl-banner[data-anchor=top]{top:0}.hl-banner[data-anchor=bottom]{bottom:0}.hl-banner[data-status=success]{background-color:#8aca69;color:#fff}.hl-banner[data-status=info]{background-color:rgba(0,92,117,.96);color:#fff}.hl-banner[data-status=warning]{background-color:#ffe157;color:#000}.hl-banner[data-status=critical]{background-color:#e91d00;color:#fff}.hl-banner__wrapper{width:100%;padding-top:1rem;padding-bottom:1rem}:not([class*=hl-grid-el--full-bleed])>.hl-banner__wrapper{padding-left:3rem;padding-right:3rem}@media screen and (max-width:599px){:not([class*=hl-grid-el--full-bleed])>.hl-banner__wrapper{padding-left:1rem;padding-right:1rem}}.hl-banner__contents,.hl-banner__header{margin-right:2rem}.hl-banner__header{margin-bottom:.5rem}.hl-banner__contents{line-height:1.5}.hl-banner__contents .hl-link{color:inherit}.hl-banner__contents :first-child{margin-top:0}.hl-banner__contents :last-child{margin-bottom:0}.hl-banner__close-button{width:2rem;height:2rem;--hds-tap-target-position:absolute;position:absolute;top:.75rem;right:.75rem;margin:0}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { baseClass: [{
            type: HostBinding,
            args: ['class.hl-banner']
        }], dismissible: [{
            type: Input
        }], dismiss: [{
            type: Output
        }], role: [{
            type: HostBinding,
            args: ['attr.role']
        }], anchor: [{
            type: HostBinding,
            args: ['attr.data-anchor']
        }, {
            type: Input
        }], status: [{
            type: HostBinding,
            args: ['attr.data-status']
        }, {
            type: Input
        }], title: [{
            type: Input
        }] }); })();
    return BannerComponent;
}());

var BannerModule = /** @class */ (function () {
    function BannerModule() {
    }
BannerModule.ɵfac = function BannerModule_Factory(t) { return new (t || BannerModule)(); };
BannerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: BannerModule });
BannerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, ButtonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BannerModule, [{
        type: NgModule,
        args: [{
                declarations: [BannerComponent],
                imports: [CommonModule, ButtonModule],
                exports: [BannerComponent]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BannerModule, { declarations: function () { return [BannerComponent]; }, imports: function () { return [CommonModule, ButtonModule]; }, exports: function () { return [BannerComponent]; } }); })();
    return BannerModule;
}());

/**
 * A simple container for grouping related elements.
 */
var CardComponent = /** @class */ (function () {
    function CardComponent() {
        /**
         * @ignore
         */
        this.hasBaseClass = true;
        /**
         * The style of the card border.
         */
        this.border = 'default';
        /**
         * When enabled, the card&apos;s `:hover` styles will receive a drop shadow to simulate elevation.
         */
        this.elevation = false;
    }
    Object.defineProperty(CardComponent.prototype, "borderIsHighlight", {
        get: function () {
            return Boolean(this.border === 'highlight');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardComponent.prototype, "borderIsNone", {
        get: function () {
            return Boolean(this.border === 'none');
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        HostBinding('class.hl-card'),
        __metadata("design:type", Object)
    ], CardComponent.prototype, "hasBaseClass", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], CardComponent.prototype, "border", void 0);
    __decorate([
        HostBinding('class.hl-card--border-highlight'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], CardComponent.prototype, "borderIsHighlight", null);
    __decorate([
        HostBinding('class.hl-card--border-none'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], CardComponent.prototype, "borderIsNone", null);
    __decorate([
        Input(), HostBinding('class.hl-card--has-elevation'),
        __metadata("design:type", Object)
    ], CardComponent.prototype, "elevation", void 0);
CardComponent.ɵfac = function CardComponent_Factory(t) { return new (t || CardComponent)(); };
CardComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CardComponent, selectors: [["hl-card"]], hostVars: 8, hostBindings: function CardComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hl-card", ctx.hasBaseClass)("hl-card--has-elevation", ctx.elevation)("hl-card--border-highlight", ctx.borderIsHighlight)("hl-card--border-none", ctx.borderIsNone);
    } }, inputs: { border: "border", elevation: "elevation" }, ngContentSelectors: _c10, decls: 6, vars: 0, consts: [[1, "hl-card__header"], [1, "hl-card__body"], [1, "hl-card__footer"]], template: function CardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c9);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵprojection(3, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵprojection(5, 2);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [".hl-card{--hl-card-content-spacing:4rem;--hl-card-border-color:var(--hds-card-border, rgba(77,77,79,0.2));--hl-card-border-width:1px;position:relative;display:block;padding:3.5rem 0;box-shadow:0 0 0 var(--hl-card-border-width) var(--hl-card-border-color);background-color:var(--hds-card-background,#fff);color:var(--hds-card-text,#000);border-radius:1rem;transition:box-shadow 150ms}@media screen and (min-width:600px) and (max-width:1023px){.hl-card{--hl-card-content-spacing:3.5rem}}.hl-card--border-none{--hl-card-border-color:transparent}.hl-card--border-highlight{--hl-card-border-color:var(\n        --hds-card-border-highlight,\n        var(--hds-theme-accent-primary, #189ec3)\n    );--hl-card-border-width:2px}.hl-card .hl-card__body:empty,.hl-card .hl-card__footer:empty,.hl-card .hl-card__header:empty{display:none}.hl-card .hl-card__header{margin-bottom:1rem;padding:0 var(--hl-card-content-spacing) 1rem var(--hl-card-content-spacing)}.hl-card .hl-card__body{padding:0 var(--hl-card-content-spacing)}.hl-card .hl-card__footer{margin-top:1rem;padding:1rem var(--hl-card-content-spacing) 0 var(--hl-card-content-spacing)}.hl-card.hl-card--has-elevation::after{content:'';position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;border-radius:1rem;box-shadow:0 1px 2.2px rgba(0,0,0,.02),0 2.4px 5.3px rgba(0,0,0,.028),0 4.5px 10px rgba(0,0,0,.035),0 8px 17.9px rgba(0,0,0,.042),0 15px 33.4px rgba(0,0,0,.05),0 36px 80px rgba(0,0,0,.07);transition:opacity 150ms ease-in-out;pointer-events:none}.hl-card.hl-card--has-elevation:focus-within::after,.hl-card.hl-card--has-elevation:hover::after{opacity:1}@media screen and (max-width:1023px){.hl-card{padding:3rem 0}}@media screen and (max-width:599px){.hl-card{--hl-card-content-spacing:1.25rem;padding:2.5rem 0}}"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardComponent, [{
        type: Component,
        args: [{
                selector: 'hl-card',
                template: "<div class=\"hl-card__header\">\n    <ng-content select=\"[slot=header]\"></ng-content>\n</div>\n\n<div class=\"hl-card__body\">\n    <ng-content></ng-content>\n</div>\n\n<div class=\"hl-card__footer\">\n    <ng-content select=\"[slot=footer]\"></ng-content>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".hl-card{--hl-card-content-spacing:4rem;--hl-card-border-color:var(--hds-card-border, rgba(77,77,79,0.2));--hl-card-border-width:1px;position:relative;display:block;padding:3.5rem 0;box-shadow:0 0 0 var(--hl-card-border-width) var(--hl-card-border-color);background-color:var(--hds-card-background,#fff);color:var(--hds-card-text,#000);border-radius:1rem;transition:box-shadow 150ms}@media screen and (min-width:600px) and (max-width:1023px){.hl-card{--hl-card-content-spacing:3.5rem}}.hl-card--border-none{--hl-card-border-color:transparent}.hl-card--border-highlight{--hl-card-border-color:var(\n        --hds-card-border-highlight,\n        var(--hds-theme-accent-primary, #189ec3)\n    );--hl-card-border-width:2px}.hl-card .hl-card__body:empty,.hl-card .hl-card__footer:empty,.hl-card .hl-card__header:empty{display:none}.hl-card .hl-card__header{margin-bottom:1rem;padding:0 var(--hl-card-content-spacing) 1rem var(--hl-card-content-spacing)}.hl-card .hl-card__body{padding:0 var(--hl-card-content-spacing)}.hl-card .hl-card__footer{margin-top:1rem;padding:1rem var(--hl-card-content-spacing) 0 var(--hl-card-content-spacing)}.hl-card.hl-card--has-elevation::after{content:'';position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;border-radius:1rem;box-shadow:0 1px 2.2px rgba(0,0,0,.02),0 2.4px 5.3px rgba(0,0,0,.028),0 4.5px 10px rgba(0,0,0,.035),0 8px 17.9px rgba(0,0,0,.042),0 15px 33.4px rgba(0,0,0,.05),0 36px 80px rgba(0,0,0,.07);transition:opacity 150ms ease-in-out;pointer-events:none}.hl-card.hl-card--has-elevation:focus-within::after,.hl-card.hl-card--has-elevation:hover::after{opacity:1}@media screen and (max-width:1023px){.hl-card{padding:3rem 0}}@media screen and (max-width:599px){.hl-card{--hl-card-content-spacing:1.25rem;padding:2.5rem 0}}"]
            }]
    }], function () { return []; }, { hasBaseClass: [{
            type: HostBinding,
            args: ['class.hl-card']
        }], border: [{
            type: Input
        }], elevation: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.hl-card--has-elevation']
        }], borderIsHighlight: [{
            type: HostBinding,
            args: ['class.hl-card--border-highlight']
        }], borderIsNone: [{
            type: HostBinding,
            args: ['class.hl-card--border-none']
        }] }); })();
    return CardComponent;
}());

var CardModule = /** @class */ (function () {
    function CardModule() {
    }
CardModule.ɵfac = function CardModule_Factory(t) { return new (t || CardModule)(); };
CardModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CardModule });
CardModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardModule, [{
        type: NgModule,
        args: [{
                declarations: [CardComponent],
                imports: [CommonModule],
                exports: [CardComponent]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CardModule, { declarations: function () { return [CardComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CardComponent]; } }); })();
    return CardModule;
}());

/**
 * Allows declarative assignment of placeholder elements.
 *
 * Components that use this directive will have access to the placeholder's
 * container element, which can be used to inject dynamic components:
 *
 * @example
 * ```typescript
 * // example.component.ts
 * @ViewChild(PlaceholderDirective) placeholder: PlaceholderDirective;
 * contents: ComponentRef<MyDynamicComponent>;
 *
 * insertContents() {
 *     this.contents = this.placeholder.insertComponent(MyDynamicComponent);
 *     // Configure the component...
 * }
 * ```
 */
var PlaceholderDirective = /** @class */ (function () {
    /**
     * @ignore
     */
    function PlaceholderDirective(viewContainerRef, resolver) {
        this.viewContainerRef = viewContainerRef;
        this.resolver = resolver;
    }
    /**
     * Inserts a component of the specified type in the placeholder container.
     * @param type Type of the component to insert
     */
    PlaceholderDirective.prototype.insertComponent = function (type) {
        var factory = this.resolver.resolveComponentFactory(type);
        this.viewContainerRef.clear();
        var componentRef = this.viewContainerRef.createComponent(factory);
        return componentRef;
    };
    PlaceholderDirective.ctorParameters = function () { return [
        { type: ViewContainerRef },
        { type: ComponentFactoryResolver }
    ]; };
    PlaceholderDirective = __decorate([ __metadata("design:paramtypes", [ViewContainerRef, ComponentFactoryResolver])
    ], PlaceholderDirective);
PlaceholderDirective.ɵfac = function PlaceholderDirective_Factory(t) { return new (t || PlaceholderDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver)); };
PlaceholderDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: PlaceholderDirective, selectors: [["", "hlPlaceholder", ""]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PlaceholderDirective, [{
        type: Directive,
        args: [{
                selector: '[hlPlaceholder]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ComponentFactoryResolver }]; }, null); })();
    return PlaceholderDirective;
}());

/**
 * Provides a function that validates a FormControl or FormGroup value within
 * its current form context.
 *
 * @example
 * ```html
 * <!-- Set `hlValidationContext` to a reference to a validation function -->
 * <form [formGroup]="form" [hlValidationContext]="myValidatorFunction">
 *     ...
 *     <!--
 *       Controls inside that context will use `myValidatorFunction`
 *       to process their errors
 *     -->
 *     <input type="text" formControlName="my-input" />
 * </form>
 * ```
 */
var ValidationContextDirective = /** @class */ (function () {
    function ValidationContextDirective() {
    }
    __decorate([
        Input('hlValidationContext'),
        __metadata("design:type", Function)
    ], ValidationContextDirective.prototype, "validatorFunction", void 0);
ValidationContextDirective.ɵfac = function ValidationContextDirective_Factory(t) { return new (t || ValidationContextDirective)(); };
ValidationContextDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ValidationContextDirective, selectors: [["", "hlValidationContext", ""]], inputs: { validatorFunction: ["hlValidationContext", "validatorFunction"] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ValidationContextDirective, [{
        type: Directive,
        args: [{
                selector: '[hlValidationContext]'
            }]
    }], function () { return []; }, { validatorFunction: [{
            type: Input,
            args: ['hlValidationContext']
        }] }); })();
    return ValidationContextDirective;
}());

var DirectivesModule = /** @class */ (function () {
    function DirectivesModule() {
    }
DirectivesModule.ɵfac = function DirectivesModule_Factory(t) { return new (t || DirectivesModule)(); };
DirectivesModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DirectivesModule });
DirectivesModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DirectivesModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                exports: [PlaceholderDirective, ValidationContextDirective],
                declarations: [PlaceholderDirective, ValidationContextDirective]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DirectivesModule, { declarations: function () { return [PlaceholderDirective, ValidationContextDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [PlaceholderDirective, ValidationContextDirective]; } }); })();
    return DirectivesModule;
}());

/**
 * Provides a template reference for custom actions of a Form component.
 */
var FormActionsDirective = /** @class */ (function () {
    function FormActionsDirective(template) {
        this.template = template;
    }
    FormActionsDirective.ctorParameters = function () { return [
        { type: TemplateRef }
    ]; };
    FormActionsDirective = __decorate([ __metadata("design:paramtypes", [TemplateRef])
    ], FormActionsDirective);
FormActionsDirective.ɵfac = function FormActionsDirective_Factory(t) { return new (t || FormActionsDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
FormActionsDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FormActionsDirective, selectors: [["ng-template", "hlFormActions", ""]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormActionsDirective, [{
        type: Directive,
        args: [{
                selector: 'ng-template[hlFormActions]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
    return FormActionsDirective;
}());

/**
 * Manages attributes common to all HDS form controls.
 */
var HDSFormControlDirective = /** @class */ (function () {
    /**
     * Creates an instance of `HDSFormControlDirective`.
     *
     * @param ownControl The `NgControl` of the targeted element, if it exists.
     * This will exist if the targeted element is registered directly with the
     * Forms API using `[(ngModel)]`, `formControlName`, or `formControl`.
     * @param parentControl The `NgControl` of the targeted element's parent,
     * if it exists. This will exist if the targeted element is in the template
     * of a component that implements `ControlValueAccessor`.
     */
    function HDSFormControlDirective(ownControl, parentControl) {
        this.ownControl = ownControl;
        this.parentControl = parentControl;
    }
    Object.defineProperty(HDSFormControlDirective.prototype, "ngControl", {
        /**
         * The `NgControl` to use when resolving property values. If the element has
         * its own `NgControl` instance, that instance will be used; otherwise, the
         * `NgControl` of the nearest parent component will be used.
         */
        get: function () {
            return this.ownControl || this.parentControl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HDSFormControlDirective.prototype, "invalid", {
        /**
         * Whether the form control is invalid from the user's perspective.
         *
         * @see [ARIA21: Using Aria-Invalid to Indicate An Error Field](https://www.w3.org/WAI/WCAG21/Techniques/aria/ARIA21)
         */
        get: function () {
            if (!this.ngControl) {
                return null;
            }
            return (this.ngControl.touched || this.ngControl.dirty) && this.ngControl.invalid;
        },
        enumerable: true,
        configurable: true
    });
    HDSFormControlDirective.ctorParameters = function () { return [
        { type: NgControl, decorators: [{ type: Optional }, { type: Self }] },
        { type: NgControl, decorators: [{ type: Optional }, { type: SkipSelf }] }
    ]; };
    __decorate([
        HostBinding('attr.aria-invalid'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], HDSFormControlDirective.prototype, "invalid", null);
    HDSFormControlDirective = __decorate([ __param(0, Optional()), __param(0, Self()),
        __param(1, Optional()), __param(1, SkipSelf()),
        __metadata("design:paramtypes", [NgControl,
            NgControl])
    ], HDSFormControlDirective);
HDSFormControlDirective.ɵfac = function HDSFormControlDirective_Factory(t) { return new (t || HDSFormControlDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.NgControl, 12)); };
HDSFormControlDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: HDSFormControlDirective, selectors: [["", "hdsFormControl", ""], ["input"], ["select"], ["textarea"]], hostVars: 1, hostBindings: function HDSFormControlDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-invalid", ctx.invalid);
    } }, exportAs: ["hdsFormControl"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HDSFormControlDirective, [{
        type: Directive,
        args: [{
                selector: '[hdsFormControl], input, select, textarea',
                exportAs: 'hdsFormControl'
            }]
    }], function () { return [{ type: ɵngcc2.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }] }, { type: ɵngcc2.NgControl, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, { invalid: [{
            type: HostBinding,
            args: ['attr.aria-invalid']
        }] }); })();
    return HDSFormControlDirective;
}());

var FormControlsCommonModule = /** @class */ (function () {
    function FormControlsCommonModule() {
    }
FormControlsCommonModule.ɵfac = function FormControlsCommonModule_Factory(t) { return new (t || FormControlsCommonModule)(); };
FormControlsCommonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FormControlsCommonModule });
FormControlsCommonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormControlsCommonModule, [{
        type: NgModule,
        args: [{
                declarations: [HDSFormControlDirective],
                exports: [HDSFormControlDirective]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FormControlsCommonModule, { declarations: [HDSFormControlDirective], exports: [HDSFormControlDirective] }); })();
    return FormControlsCommonModule;
}());

/**
 * A container element to encapsulate error messages for a form field or group.
 */
var FormFieldErrorComponent = /** @class */ (function () {
    /**
     * Creates a new instance of the component.
     *
     * @param context The injected validation context. This will automatically
     * be inherited from an ancestor of this component.
     */
    function FormFieldErrorComponent(context) {
        this.context = context;
        /**
         * @ignore
         */
        this.baseClass = true;
        /**
         * ARIA role for the container. This ensures that error messages will be
         * announced by screen readers when they change.
         */
        this.role = 'alert';
        /**
         * This property controls whether the status-critical icon appears before the error message
         */
        this.showIcon = false;
        /**
         * If set to `true`, the component will render the control&apos;s errors
         * object as a JSON string for debugging purposes.
         *
         * @internal
         */
        this.debug = false;
    }
    Object.defineProperty(FormFieldErrorComponent.prototype, "invalid", {
        /**
         * Whether the associated control is invalid.
         */
        get: function () {
            return this.control.invalid && (this.control.touched || this.control.dirty);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormFieldErrorComponent.prototype, "errorMessage", {
        /**
         * The error message to display, based on the current set of errors and the
         * validation context of the component.
         */
        get: function () {
            if (!this.context || !this.control.errors) {
                return null;
            }
            return this.context.validatorFunction(this.control.errors);
        },
        enumerable: true,
        configurable: true
    });
    FormFieldErrorComponent.ctorParameters = function () { return [
        { type: ValidationContextDirective }
    ]; };
    __decorate([
        HostBinding('class.hl-form-field-error'),
        __metadata("design:type", Object)
    ], FormFieldErrorComponent.prototype, "baseClass", void 0);
    __decorate([
        HostBinding('attr.role'),
        __metadata("design:type", Object)
    ], FormFieldErrorComponent.prototype, "role", void 0);
    __decorate([
        Input(),
        __metadata("design:type", AbstractControl)
    ], FormFieldErrorComponent.prototype, "control", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], FormFieldErrorComponent.prototype, "showIcon", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], FormFieldErrorComponent.prototype, "debug", void 0);
    FormFieldErrorComponent = __decorate([ __metadata("design:paramtypes", [ValidationContextDirective])
    ], FormFieldErrorComponent);
FormFieldErrorComponent.ɵfac = function FormFieldErrorComponent_Factory(t) { return new (t || FormFieldErrorComponent)(ɵngcc0.ɵɵdirectiveInject(ValidationContextDirective)); };
FormFieldErrorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormFieldErrorComponent, selectors: [["hl-form-field-error"]], hostVars: 3, hostBindings: function FormFieldErrorComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx.role);
        ɵngcc0.ɵɵclassProp("hl-form-field-error", ctx.baseClass);
    } }, inputs: { showIcon: "showIcon", debug: "debug", control: "control" }, decls: 2, vars: 2, consts: [[4, "ngIf"], ["icon", "status-critical", 4, "ngIf"], [1, "hl-a11y--visually-hidden"], ["icon", "status-critical"]], template: function FormFieldErrorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FormFieldErrorComponent_ng_container_0_Template, 5, 2, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, FormFieldErrorComponent_div_1_Template, 6, 3, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.invalid && ctx.errorMessage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.debug);
    } }, directives: [ɵngcc1.NgIf, IconComponent], pipes: [ɵngcc1.JsonPipe], styles: [".hl-form-field-error{margin-bottom:0;font-size:.875rem;line-height:1.42857;letter-spacing:0;display:block;margin-top:.25rem;color:#e91d00}"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormFieldErrorComponent, [{
        type: Component,
        args: [{
                selector: 'hl-form-field-error',
                template: "<ng-container *ngIf=\"invalid && errorMessage\">\n    <hl-icon *ngIf=\"showIcon\" icon=\"status-critical\"></hl-icon>\n    <span class=\"hl-a11y--visually-hidden\">Error: </span> {{ errorMessage }}\n</ng-container>\n\n<div *ngIf=\"debug\">\n    <strong>Debug info: </strong><code>{{ control.errors | json }}</code>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".hl-form-field-error{margin-bottom:0;font-size:.875rem;line-height:1.42857;letter-spacing:0;display:block;margin-top:.25rem;color:#e91d00}"]
            }]
    }], function () { return [{ type: ValidationContextDirective }]; }, { baseClass: [{
            type: HostBinding,
            args: ['class.hl-form-field-error']
        }], role: [{
            type: HostBinding,
            args: ['attr.role']
        }], showIcon: [{
            type: Input
        }], debug: [{
            type: Input
        }], control: [{
            type: Input
        }] }); })();
    return FormFieldErrorComponent;
}());

/**
 * Array of CSS selectors for elements that can receive keyboard focus.
 */
var FOCUSABLE_ELEMENT_SELECTORS = [
    'button',
    'input',
    'select',
    'textarea',
    '[href]',
    '[tabindex]:not([tabindex="-1"])'
];
/**
 * CSS selector targeting all focusable HTML elements.
 */
var FOCUSABLE_ELEMENTS = FOCUSABLE_ELEMENT_SELECTORS.join(',');

/**
 * Container element for a single form control, that handles associating the
 * control with a label, description/help text, and error message handler.
 */
var FormFieldComponent = /** @class */ (function () {
    function FormFieldComponent() {
        /**
         * Default ID for the component, in case one was not provided.
         *
         * @internal
         */
        this._id = "hl-form-field-" + FormFieldComponent_1.componentCount++;
        /**
         * @ignore
         */
        this.baseClass = true;
        /**
         * option to choose between bar or icon based error style
         */
        this.errorStyle = 'bar';
    }
    FormFieldComponent_1 = FormFieldComponent;
    Object.defineProperty(FormFieldComponent.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            this._id = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormFieldComponent.prototype, "firstFocusableElement", {
        /**
         * The first focusable element within the form control. This is the element
         * that is assumed to be the primary interactive element of the control.
         */
        get: function () {
            if (this.input) {
                return this.input.nativeElement.parentElement.querySelector(FOCUSABLE_ELEMENTS);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormFieldComponent.prototype, "invalid", {
        /**
         * Whether the contained control is invalid. Used here only for styling.
         *
         * @internal
         */
        get: function () {
            return this.input && this.formControl.invalid && (this.formControl.touched || this.formControl.dirty);
        },
        enumerable: true,
        configurable: true
    });
    FormFieldComponent.prototype.ngAfterContentInit = function () {
        this.updateDescriptionElements();
    };
    FormFieldComponent.prototype.ngOnChanges = function (changes) {
        if (changes.helpText && changes.helpText.currentValue !== changes.helpText.previousValue) {
            this.updateDescriptionElements();
        }
    };
    /**
     * Associates the relevant description elements with the form control.
     */
    FormFieldComponent.prototype.updateDescriptionElements = function () {
        var _this = this;
        if (this.firstFocusableElement) {
            setTimeout(function () {
                var descriptionElements = _this.helpText
                    ? [_this.id + "-help-text", _this.id + "-error"]
                    : [_this.id + "-error"];
                _this.firstFocusableElement.setAttribute('aria-describedby', descriptionElements.join(' '));
            }, 0);
        }
    };
    var FormFieldComponent_1;
    /**
     * Tracks the number of instances of the component that have been created.
     * Used to generate IDs for child elements, if an ID was not provided.
     *
     * @internal
     */
    FormFieldComponent.componentCount = 0;
    __decorate([
        HostBinding('attr.id'),
        Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], FormFieldComponent.prototype, "id", null);
    __decorate([
        HostBinding('class.hl-form-field'),
        __metadata("design:type", Object)
    ], FormFieldComponent.prototype, "baseClass", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], FormFieldComponent.prototype, "label", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], FormFieldComponent.prototype, "helpText", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], FormFieldComponent.prototype, "maxlength", void 0);
    __decorate([
        Input(), HostBinding('attr.data-error-style'),
        __metadata("design:type", String)
    ], FormFieldComponent.prototype, "errorStyle", void 0);
    __decorate([
        ContentChild(FormControlName),
        __metadata("design:type", FormControlName)
    ], FormFieldComponent.prototype, "formControl", void 0);
    __decorate([
        ContentChild(FormControlName, { read: ElementRef }),
        __metadata("design:type", ElementRef)
    ], FormFieldComponent.prototype, "input", void 0);
    __decorate([
        HostBinding('class.hl-form-field--invalid'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], FormFieldComponent.prototype, "invalid", null);
FormFieldComponent.ɵfac = function FormFieldComponent_Factory(t) { return new (t || FormFieldComponent)(); };
FormFieldComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormFieldComponent, selectors: [["hl-form-field"]], contentQueries: function FormFieldComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, FormControlName, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, FormControlName, 5, ElementRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.formControl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, hostVars: 6, hostBindings: function FormFieldComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-error-style", ctx.errorStyle)("id", ctx.id);
        ɵngcc0.ɵɵclassProp("hl-form-field", ctx.baseClass)("hl-form-field--invalid", ctx.invalid);
    } }, inputs: { errorStyle: "errorStyle", id: "id", label: "label", helpText: "helpText", maxlength: "maxlength" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c12, decls: 8, vars: 6, consts: [[1, "hl-form-field__label-container"], ["class", "hl-form-field__label", 3, "id", 4, "ngIf"], [1, "hl-form-field__help-text-container"], ["class", "hl-form-field__help-text", 3, "id", 4, "ngIf"], ["class", "hl-form-field__help-text hl-form-field__character-count", "aria-live", "polite", 3, "has-error", 4, "ngIf"], [3, "id", "control", "showIcon"], [1, "hl-form-field__label", 3, "id"], [1, "hl-form-field__help-text", 3, "id"], ["aria-live", "polite", 1, "hl-form-field__help-text", "hl-form-field__character-count"]], template: function FormFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c11);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, FormFieldComponent_label_1_Template, 2, 3, "label", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(3, 1);
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵtemplate(5, FormFieldComponent_span_5_Template, 2, 2, "span", 3);
        ɵngcc0.ɵɵtemplate(6, FormFieldComponent_span_6_Template, 2, 4, "span", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(7, "hl-form-field-error", 5);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.helpText);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.maxlength);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", ctx.id + "-error")("control", ctx.formControl)("showIcon", ctx.errorStyle === "icon");
    } }, directives: [ɵngcc1.NgIf, FormFieldErrorComponent], styles: [".hl-form-field{position:relative;display:block}.hl-form-field__label-container{margin-bottom:.25rem;display:flex;align-items:center;gap:1ch}.hl-form-field__label{margin-top:0;margin-bottom:0;font-size:1rem;line-height:1.5;letter-spacing:0;color:#4d4d4f}.hl-form-field__help-text{margin-bottom:0;font-size:.875rem;line-height:1.42857;letter-spacing:0;margin-top:.25rem;color:#4d4d4f}.hl-form-field__character-count{text-align:right}.hl-form-field__help-text-container{display:flex;justify-content:space-between}.hl-form-field::before{content:'';position:absolute;top:0;bottom:0;left:-2rem;width:.75rem;background-color:transparent}.hl-form-field--invalid{padding-bottom:.5rem}.hl-form-field--invalid::before{background-color:#e91d00;transition:background-color 150ms ease-in-out}.hl-form-field[data-error-style=icon]::before{display:none}"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormFieldComponent, [{
        type: Component,
        args: [{
                selector: 'hl-form-field',
                template: "<div class=\"hl-form-field__label-container\">\n    <label *ngIf=\"label\" class=\"hl-form-field__label\" [id]=\"id + '-label'\" [attr.for]=\"firstFocusableElement.id\">{{\n        label\n    }}</label>\n\n    <ng-content select=\"hl-toggletip\"></ng-content>\n</div>\n\n<ng-content></ng-content>\n\n<div class=\"hl-form-field__help-text-container\">\n    <span *ngIf=\"helpText\" [id]=\"id + '-help-text'\" class=\"hl-form-field__help-text\">{{ helpText }}</span>\n\n    <span\n        *ngIf=\"maxlength\"\n        class=\"hl-form-field__help-text hl-form-field__character-count\"\n        [class.has-error]=\"formControl.invalid\"\n        aria-live=\"polite\"\n    >\n        {{ maxlength - formControl.value.length }} characters\n        {{ formControl.value.length === 0 ? 'allowed' : 'remaining' }}\n    </span>\n</div>\n\n<hl-form-field-error\n    [id]=\"id + '-error'\"\n    [control]=\"formControl\"\n    [showIcon]=\"errorStyle === 'icon'\"\n></hl-form-field-error>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".hl-form-field{position:relative;display:block}.hl-form-field__label-container{margin-bottom:.25rem;display:flex;align-items:center;gap:1ch}.hl-form-field__label{margin-top:0;margin-bottom:0;font-size:1rem;line-height:1.5;letter-spacing:0;color:#4d4d4f}.hl-form-field__help-text{margin-bottom:0;font-size:.875rem;line-height:1.42857;letter-spacing:0;margin-top:.25rem;color:#4d4d4f}.hl-form-field__character-count{text-align:right}.hl-form-field__help-text-container{display:flex;justify-content:space-between}.hl-form-field::before{content:'';position:absolute;top:0;bottom:0;left:-2rem;width:.75rem;background-color:transparent}.hl-form-field--invalid{padding-bottom:.5rem}.hl-form-field--invalid::before{background-color:#e91d00;transition:background-color 150ms ease-in-out}.hl-form-field[data-error-style=icon]::before{display:none}"]
            }]
    }], function () { return []; }, { baseClass: [{
            type: HostBinding,
            args: ['class.hl-form-field']
        }], errorStyle: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.data-error-style']
        }], id: [{
            type: HostBinding,
            args: ['attr.id']
        }, {
            type: Input
        }], invalid: [{
            type: HostBinding,
            args: ['class.hl-form-field--invalid']
        }], label: [{
            type: Input
        }], helpText: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], formControl: [{
            type: ContentChild,
            args: [FormControlName]
        }], input: [{
            type: ContentChild,
            args: [FormControlName, { read: ElementRef }]
        }] }); })();
    return FormFieldComponent;
}());

/**
 * Container element for a form question with one or more form controls, that
 * handles accessible markup generation and allows for customizing the layout
 * of the controls within it.
 */
var FormQuestionComponent = /** @class */ (function () {
    /**
     * @ignore
     */
    function FormQuestionComponent(controlContainer) {
        this.controlContainer = controlContainer;
        /**
         * @ignore
         */
        this.baseClass = true;
    }
    Object.defineProperty(FormQuestionComponent.prototype, "formGroup", {
        /**
         * A reference to the form group associated with the component.
         * Used to determine group-level error validation.
         */
        get: function () {
            return this.controlContainer && this.controlContainer.control;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormQuestionComponent.prototype, "invalid", {
        /**
         * Whether the form group has a validation error. Used to select a form
         * control within the group that should receive focus if it is the first
         * invalid control in the form.
         *
         * This property does NOT represent whether a child control of the group has
         * a validation error.
         */
        get: function () {
            return (this.formGroup &&
                (this.formGroup.touched || this.formGroup.dirty) &&
                this.formGroup.errors &&
                Object.keys(this.formGroup.errors).length > 0);
        },
        enumerable: true,
        configurable: true
    });
    FormQuestionComponent.ctorParameters = function () { return [
        { type: ControlContainer }
    ]; };
    __decorate([
        HostBinding('class.hl-form-question'),
        __metadata("design:type", Object)
    ], FormQuestionComponent.prototype, "baseClass", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], FormQuestionComponent.prototype, "question", void 0);
    __decorate([
        HostBinding('class.hl-form-question--reflexive'),
        Input(),
        __metadata("design:type", Boolean)
    ], FormQuestionComponent.prototype, "reflexive", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], FormQuestionComponent.prototype, "contentClasses", void 0);
    __decorate([
        ContentChildren(FormControlName, { descendants: true }),
        __metadata("design:type", QueryList)
    ], FormQuestionComponent.prototype, "formControls", void 0);
    __decorate([
        HostBinding('class.hl-form-question--invalid'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], FormQuestionComponent.prototype, "invalid", null);
    FormQuestionComponent = __decorate([ __metadata("design:paramtypes", [ControlContainer])
    ], FormQuestionComponent);
FormQuestionComponent.ɵfac = function FormQuestionComponent_Factory(t) { return new (t || FormQuestionComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ControlContainer)); };
FormQuestionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormQuestionComponent, selectors: [["hl-form-question"]], contentQueries: function FormQuestionComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, FormControlName, 5);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.formControls = _t);
    } }, hostVars: 6, hostBindings: function FormQuestionComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hl-form-question", ctx.baseClass)("hl-form-question--invalid", ctx.invalid)("hl-form-question--reflexive", ctx.reflexive);
    } }, inputs: { question: "question", reflexive: "reflexive", contentClasses: "contentClasses" }, ngContentSelectors: _c12, decls: 7, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["fieldset", ""], ["toggletip", ""], ["content", ""], [1, "hl-form-question__text"], [3, "ngTemplateOutlet"], [3, "ngClass"], [3, "control", 4, "ngIf"], [3, "control"]], template: function FormQuestionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c11);
        ɵngcc0.ɵɵtemplate(0, FormQuestionComponent_ng_container_0_Template, 5, 3, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, FormQuestionComponent_ng_template_1_Template, 7, 7, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, FormQuestionComponent_ng_template_3_Template, 1, 0, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(5, FormQuestionComponent_ng_template_5_Template, 1, 0, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        var _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.formControls.length === 1)("ngIfElse", _r1);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgClass, FormFieldErrorComponent], styles: [".hl-form-question{position:relative;display:block;margin-bottom:4.5rem}.hl-form-question fieldset,.hl-form-question legend{padding:0;border:none}.hl-form-question fieldset{margin:0}.hl-form-question__text{font-size:1.25rem;line-height:1.4;letter-spacing:0;margin-top:.25rem;margin-bottom:1.5rem}@media screen and (min-width:1024px){.hl-form-question__text{font-size:1.5rem;line-height:1.33333;letter-spacing:-.005em;margin-top:.25rem;margin-bottom:1.5rem}}.hl-form-question__text .hl-toggletip{margin-left:.5rem}.hl-form-question__contents{margin:-.25rem -.25rem -1.5rem}.hl-form-question__contents>*{margin-bottom:1.5rem;padding-left:.25rem;padding-right:.25rem}.hl-form-question .hl-form-field{position:static}.hl-form-question::before{content:'';position:absolute;top:0;bottom:0;left:-2rem;width:.75rem;background-color:transparent}.hl-form-question.ng-dirty.ng-invalid::before,.hl-form-question.ng-touched.ng-invalid::before{background-color:#e91d00;transition:background-color 150ms ease-in-out}.hl-form-question.ng-dirty.ng-invalid .hl-form-field::before,.hl-form-question.ng-touched.ng-invalid .hl-form-field::before{display:none}.hl-form-question--reflexive{border-left:.25rem solid #189ec3;padding-left:1.5rem;padding-bottom:.5rem;margin-left:calc(2rem * var(--reflexive-depth,0))}.hl-form-question--reflexive .hl-form-question__text{margin-top:0;font-size:1.25rem;line-height:1.4;letter-spacing:0;margin-bottom:1.5rem}.hl-form-question--reflexive::before{left:-2.25rem;left:calc(-1 * (2.25rem + 2rem * var(--reflexive-depth,0)))}.hl-form-question+.hl-form-question--reflexive{margin-top:-3rem}"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormQuestionComponent, [{
        type: Component,
        args: [{
                selector: 'hl-form-question',
                template: "<ng-container *ngIf=\"formControls.length === 1; else fieldset\">\n    <div class=\"hl-form-question__text\">{{ question }}<ng-template [ngTemplateOutlet]=\"toggletip\"></ng-template></div>\n    <ng-template [ngTemplateOutlet]=\"content\"></ng-template>\n</ng-container>\n\n<ng-template #fieldset>\n    <fieldset>\n        <legend class=\"hl-form-question__text\">\n            {{ question }}<ng-template [ngTemplateOutlet]=\"toggletip\"></ng-template>\n        </legend>\n\n        <div [ngClass]=\"contentClasses\" [class.hl-form-question__contents]=\"true\">\n            <ng-template [ngTemplateOutlet]=\"content\"></ng-template>\n        </div>\n\n        <hl-form-field-error *ngIf=\"formGroup\" [control]=\"formGroup\"></hl-form-field-error>\n    </fieldset>\n</ng-template>\n\n<ng-template #toggletip><ng-content select=\"hl-toggletip\"></ng-content></ng-template>\n<ng-template #content><ng-content></ng-content></ng-template>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".hl-form-question{position:relative;display:block;margin-bottom:4.5rem}.hl-form-question fieldset,.hl-form-question legend{padding:0;border:none}.hl-form-question fieldset{margin:0}.hl-form-question__text{font-size:1.25rem;line-height:1.4;letter-spacing:0;margin-top:.25rem;margin-bottom:1.5rem}@media screen and (min-width:1024px){.hl-form-question__text{font-size:1.5rem;line-height:1.33333;letter-spacing:-.005em;margin-top:.25rem;margin-bottom:1.5rem}}.hl-form-question__text .hl-toggletip{margin-left:.5rem}.hl-form-question__contents{margin:-.25rem -.25rem -1.5rem}.hl-form-question__contents>*{margin-bottom:1.5rem;padding-left:.25rem;padding-right:.25rem}.hl-form-question .hl-form-field{position:static}.hl-form-question::before{content:'';position:absolute;top:0;bottom:0;left:-2rem;width:.75rem;background-color:transparent}.hl-form-question.ng-dirty.ng-invalid::before,.hl-form-question.ng-touched.ng-invalid::before{background-color:#e91d00;transition:background-color 150ms ease-in-out}.hl-form-question.ng-dirty.ng-invalid .hl-form-field::before,.hl-form-question.ng-touched.ng-invalid .hl-form-field::before{display:none}.hl-form-question--reflexive{border-left:.25rem solid #189ec3;padding-left:1.5rem;padding-bottom:.5rem;margin-left:calc(2rem * var(--reflexive-depth,0))}.hl-form-question--reflexive .hl-form-question__text{margin-top:0;font-size:1.25rem;line-height:1.4;letter-spacing:0;margin-bottom:1.5rem}.hl-form-question--reflexive::before{left:-2.25rem;left:calc(-1 * (2.25rem + 2rem * var(--reflexive-depth,0)))}.hl-form-question+.hl-form-question--reflexive{margin-top:-3rem}"]
            }]
    }], function () { return [{ type: ɵngcc2.ControlContainer }]; }, { baseClass: [{
            type: HostBinding,
            args: ['class.hl-form-question']
        }], invalid: [{
            type: HostBinding,
            args: ['class.hl-form-question--invalid']
        }], question: [{
            type: Input
        }], reflexive: [{
            type: HostBinding,
            args: ['class.hl-form-question--reflexive']
        }, {
            type: Input
        }], contentClasses: [{
            type: Input
        }], formControls: [{
            type: ContentChildren,
            args: [FormControlName, { descendants: true }]
        }] }); })();
    return FormQuestionComponent;
}());

/**
 * A sectioning element to contain a series of form questions.
 */
var FormSectionComponent = /** @class */ (function () {
    function FormSectionComponent() {
        /**
         * @ignore
         */
        this.baseClass = true;
    }
    __decorate([
        HostBinding('class.hl-form-section'),
        __metadata("design:type", Object)
    ], FormSectionComponent.prototype, "baseClass", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], FormSectionComponent.prototype, "heading", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], FormSectionComponent.prototype, "tagline", void 0);
FormSectionComponent.ɵfac = function FormSectionComponent_Factory(t) { return new (t || FormSectionComponent)(); };
FormSectionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormSectionComponent, selectors: [["hl-form-section"]], hostVars: 2, hostBindings: function FormSectionComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hl-form-section", ctx.baseClass);
    } }, inputs: { heading: "heading", tagline: "tagline" }, ngContentSelectors: _c4, decls: 3, vars: 2, consts: [["class", "hl-font--caption hl-font-weight--regular hl-form-section__heading", 4, "ngIf"], ["class", "hl-font--h4 hl-form-section__tagline", 4, "ngIf"], [1, "hl-font--caption", "hl-font-weight--regular", "hl-form-section__heading"], [1, "hl-font--h4", "hl-form-section__tagline"]], template: function FormSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, FormSectionComponent_div_0_Template, 2, 1, "div", 0);
        ɵngcc0.ɵɵtemplate(1, FormSectionComponent_p_1_Template, 2, 1, "p", 1);
        ɵngcc0.ɵɵprojection(2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.heading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tagline);
    } }, directives: [ɵngcc1.NgIf], styles: [".hl-form-section{display:block;margin-bottom:10rem}.hl-form-section:last-of-type{margin-bottom:3rem}.hl-form-section__heading{margin-bottom:1.5rem;padding-bottom:.25rem;border-bottom:.125rem solid;color:var(--hds-theme-accent-primary,#137d9a)}.hl-form-section__tagline{margin-bottom:3rem}"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormSectionComponent, [{
        type: Component,
        args: [{
                selector: 'hl-form-section',
                template: "<!-- TODO: Turn this into a heading with level handling -->\n<div *ngIf=\"heading\" class=\"hl-font--caption hl-font-weight--regular hl-form-section__heading\">{{ heading }}</div>\n\n<p *ngIf=\"tagline\" class=\"hl-font--h4 hl-form-section__tagline\">{{ tagline }}</p>\n\n<ng-content></ng-content>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".hl-form-section{display:block;margin-bottom:10rem}.hl-form-section:last-of-type{margin-bottom:3rem}.hl-form-section__heading{margin-bottom:1.5rem;padding-bottom:.25rem;border-bottom:.125rem solid;color:var(--hds-theme-accent-primary,#137d9a)}.hl-form-section__tagline{margin-bottom:3rem}"]
            }]
    }], function () { return []; }, { baseClass: [{
            type: HostBinding,
            args: ['class.hl-form-section']
        }], heading: [{
            type: Input
        }], tagline: [{
            type: Input
        }] }); })();
    return FormSectionComponent;
}());

var ɵ0 = function (selector) { return ".hl-form-field--invalid " + selector + ", .hl-form-question--invalid " + selector; };
/**
 * Selector matching all focusable elements that are either invalid form
 * controls or child elements of invalid form controls. Used to focus the first
 * invalid control in the `FormComponent`.
 */
var INVALID_FOCUSABLE_ELEMENTS = FOCUSABLE_ELEMENT_SELECTORS.map(ɵ0).join(', ');
/**
 * A native HTML `<form>` with some usability enhancements.
 */
var FormComponent = /** @class */ (function () {
    /**
     * @ignore
     */
    function FormComponent(el) {
        this.el = el;
        /**
         * @ignore
         */
        this.baseClass = true;
        /**
         * @ignore
         */
        this.disableNativeValidation = '';
        /**
         * Text of the submit button for the form.
         */
        this.submitButtonText = 'Submit';
        /**
         * Display behavior for the form-level error summary.
         * The summary links to the first form control with an error.
         */
        this.errorSummary = 'hide';
        /**
         * Whether the error summary is currently visible.
         */
        this.errorSummaryVisible = false;
    }
    Object.defineProperty(FormComponent.prototype, "invalid", {
        /**
         * Whether the form is invalid.
         */
        get: function () {
            return this.formGroup && this.formGroup.invalid && (this.formGroup.touched || this.formGroup.dirty);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormComponent.prototype, "firstInvalidControlId", {
        /**
         * ID of the first invalid focusable control element.
         */
        get: function () {
            var invalidControls = Array.from(this.el.nativeElement.querySelectorAll(INVALID_FOCUSABLE_ELEMENTS));
            if (invalidControls.length > 0) {
                return invalidControls[0].id;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormComponent.prototype, "firstInvalidControl", {
        /**
         * Reference to the first invalid focusable control element.
         */
        get: function () {
            var invalidControls = Array.from(this.el.nativeElement.querySelectorAll(INVALID_FOCUSABLE_ELEMENTS));
            return invalidControls && invalidControls.length > 0 && invalidControls[0];
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Shows the error summary when the form is submitted, if necessary.
     */
    FormComponent.prototype.showErrorSummary = function () {
        if (this.errorSummary !== 'hide' && this.invalid) {
            this.errorSummaryVisible = true;
        }
    };
    /**
     * Sends focus to the first invalid focusable control element.
     */
    FormComponent.prototype.focusFirstInvalidControl = function () {
        if (this.firstInvalidControl) {
            this.firstInvalidControl.focus();
            // `Element.focus()` already scrolls the focused element into view,
            // but Firefox only scrolls it to the nearest edge, whereas
            // WebKit/Chromium browsers scroll it to the center of the screen.
            // This forces Firefox's to match the other browsers'.
            this.firstInvalidControl.scrollIntoView({ block: 'center' });
        }
    };
    FormComponent.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    __decorate([
        HostBinding('class.hl-form'),
        __metadata("design:type", Object)
    ], FormComponent.prototype, "baseClass", void 0);
    __decorate([
        HostBinding('attr.novalidate'),
        __metadata("design:type", Object)
    ], FormComponent.prototype, "disableNativeValidation", void 0);
    __decorate([
        Input(),
        __metadata("design:type", NgForm)
    ], FormComponent.prototype, "formGroup", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], FormComponent.prototype, "submitButtonText", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], FormComponent.prototype, "errorSummary", void 0);
    __decorate([
        ContentChild(FormActionsDirective, { read: TemplateRef }),
        __metadata("design:type", TemplateRef)
    ], FormComponent.prototype, "formActions", void 0);
    __decorate([
        ContentChildren(FormControlName, { descendants: true }),
        __metadata("design:type", QueryList)
    ], FormComponent.prototype, "controls", void 0);
    __decorate([
        HostListener('submit'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FormComponent.prototype, "showErrorSummary", null);
    FormComponent = __decorate([ __metadata("design:paramtypes", [ElementRef])
    ], FormComponent);
FormComponent.ɵfac = function FormComponent_Factory(t) { return new (t || FormComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
FormComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormComponent, selectors: [["form", "hlValidationContext", ""]], contentQueries: function FormComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, FormActionsDirective, 5, TemplateRef);
        ɵngcc0.ɵɵcontentQuery(dirIndex, FormControlName, 5);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.formActions = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.controls = _t);
    } }, hostVars: 3, hostBindings: function FormComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("submit", function FormComponent_submit_HostBindingHandler() { return ctx.showErrorSummary(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("novalidate", ctx.disableNativeValidation);
        ɵngcc0.ɵɵclassProp("hl-form", ctx.baseClass);
    } }, inputs: { submitButtonText: "submitButtonText", errorSummary: "errorSummary", formGroup: "formGroup" }, attrs: _c13, ngContentSelectors: _c4, decls: 8, vars: 9, consts: [[4, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngTemplateOutlet"], ["defaultFormActions", ""], ["alertContents", ""], ["hlButton", "", 1, "hl-form__submit-button", 3, "disabled"], [4, "ngIf"], ["isOpen", "true", "type", "critical", 3, "canBeClosed", "title"], ["hlLink", "", "type", "button", 3, "click", 4, "ngIf"], ["hlLink", "", "type", "button", 3, "click"]], template: function FormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, FormComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵtemplate(2, FormComponent_ng_container_2_Template, 1, 0, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(3, FormComponent_ng_container_3_Template, 1, 0, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(4, FormComponent_ng_template_4_Template, 3, 2, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(6, FormComponent_ng_template_6_Template, 1, 1, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        var _r3 = ɵngcc0.ɵɵreference(5);
        var _r5 = ɵngcc0.ɵɵreference(7);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(5, _c14, ctx.errorSummary === "start"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.formActions || _r3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(7, _c15, ctx.errorSummary === "end"));
    } }, directives: [ɵngcc1.NgTemplateOutlet, ButtonComponent, ɵngcc1.NgIf, AlertComponent, LinkComponent], styles: [".hl-form{margin:2rem}.hl-form>*+*{margin-top:2rem}.hl-form__submit-button{min-width:240px}@media screen and (max-width:599px){.hl-form__submit-button{min-width:unset;width:100%}}"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'form[hlValidationContext]',
                template: "<ng-container\n    *ngTemplateOutlet=\"\n        alertContents;\n        context: { show: errorSummary === 'start', title: 'Some questions below have errors' }\n    \"\n></ng-container>\n\n<ng-content></ng-content>\n\n<ng-container *ngTemplateOutlet=\"formActions || defaultFormActions\"></ng-container>\n\n<ng-container\n    *ngTemplateOutlet=\"\n        alertContents;\n        context: { show: errorSummary === 'end', title: 'Some questions above have errors' }\n    \"\n></ng-container>\n\n<ng-template #defaultFormActions>\n    <div>\n        <button hlButton class=\"hl-form__submit-button\" [disabled]=\"errorSummary === 'hide' && formGroup.invalid\">\n            {{ submitButtonText }}\n        </button>\n    </div>\n</ng-template>\n\n<ng-template #alertContents let-title=\"title\" let-show=\"show\">\n    <ng-container *ngIf=\"errorSummaryVisible && formGroup.invalid && (errorSummary === 'show' || show)\">\n        <hl-alert isOpen=\"true\" [canBeClosed]=\"false\" type=\"critical\" [title]=\"title\">\n            <button *ngIf=\"firstInvalidControl\" hlLink type=\"button\" (click)=\"focusFirstInvalidControl()\">\n                Jump to first error\n            </button>\n        </hl-alert>\n    </ng-container>\n</ng-template>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".hl-form{margin:2rem}.hl-form>*+*{margin-top:2rem}.hl-form__submit-button{min-width:240px}@media screen and (max-width:599px){.hl-form__submit-button{min-width:unset;width:100%}}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { baseClass: [{
            type: HostBinding,
            args: ['class.hl-form']
        }], disableNativeValidation: [{
            type: HostBinding,
            args: ['attr.novalidate']
        }], submitButtonText: [{
            type: Input
        }], errorSummary: [{
            type: Input
        }], showErrorSummary: [{
            type: HostListener,
            args: ['submit']
        }], formGroup: [{
            type: Input
        }], formActions: [{
            type: ContentChild,
            args: [FormActionsDirective, { read: TemplateRef }]
        }], controls: [{
            type: ContentChildren,
            args: [FormControlName, { descendants: true }]
        }] }); })();
    return FormComponent;
}());

var FormComponentsModule = /** @class */ (function () {
    function FormComponentsModule() {
    }
FormComponentsModule.ɵfac = function FormComponentsModule_Factory(t) { return new (t || FormComponentsModule)(); };
FormComponentsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FormComponentsModule });
FormComponentsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            AlertModule,
            ButtonModule,
            CommonModule,
            DirectivesModule,
            FormControlsCommonModule,
            IconModule,
            LinkModule,
            ReactiveFormsModule
        ], FormControlsCommonModule, ReactiveFormsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormComponentsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    FormActionsDirective,
                    FormComponent,
                    FormFieldComponent,
                    FormFieldErrorComponent,
                    FormQuestionComponent,
                    FormSectionComponent
                ],
                imports: [
                    AlertModule,
                    ButtonModule,
                    CommonModule,
                    DirectivesModule,
                    FormControlsCommonModule,
                    IconModule,
                    LinkModule,
                    ReactiveFormsModule
                ],
                exports: [
                    FormActionsDirective,
                    FormComponent,
                    FormFieldComponent,
                    FormFieldErrorComponent,
                    FormQuestionComponent,
                    FormSectionComponent,
                    FormControlsCommonModule,
                    ReactiveFormsModule
                ]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FormComponentsModule, { declarations: function () { return [FormActionsDirective, FormComponent, FormFieldComponent, FormFieldErrorComponent, FormQuestionComponent, FormSectionComponent]; }, imports: function () { return [AlertModule, ButtonModule, CommonModule, DirectivesModule, FormControlsCommonModule, IconModule, LinkModule, ReactiveFormsModule]; }, exports: function () { return [FormActionsDirective, FormComponent, FormFieldComponent, FormFieldErrorComponent, FormQuestionComponent, FormSectionComponent, FormControlsCommonModule, ReactiveFormsModule]; } }); })();
    return FormComponentsModule;
}());

/**
 * Class that fulfills the requirements to register a custom form control
 * using Angular reactive forms.
 */
var CustomFormControl = /** @class */ (function () {
    /**
     * @ignore
     */
    function CustomFormControl(cdRef) {
        this.cdRef = cdRef;
        /**
         * Whether the control is required.
         * This does **NOT** add an Angular validator to the control; you must do
         * that in the form containing the control.
         */
        this.required = false;
        /**
         * Whether the control is disabled.
         *
         * To disable a radio group using Angular reactive forms, set
         * `disabled: true` in the `formState` of the radio group&apos;s
         * `FormControl` object. See the
         * [Angular docs](https://angular.io/api/forms/FormControl#constructor) for
         * more details.
         */
        this.disabled = false;
        /**
         * @ignore
         */
        this.onChange = function () { };
        /**
         * @ignore
         */
        this.onTouched = function () { };
    }
    Object.defineProperty(CustomFormControl.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (newValue) {
            if (newValue !== this._value) {
                this.valueWillChange(newValue);
                this._value = newValue;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Safely updates the value of the control.
     *
     * @param value New value of the control
     *
     * @internal
     */
    CustomFormControl.prototype.writeValue = function (value) {
        this.value = value;
    };
    /**
     * Sets a callback function to run when the value of the control changes.
     *
     * @param fn Callback function
     *
     * @internal
     */
    CustomFormControl.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    /**
     * Sets a callback function to run when the control is interacted with,
     * either by the user or programmatically.
     *
     * @param fn Callback function
     *
     * @internal
     */
    CustomFormControl.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * Sets the disabled state of the control.
     *
     * @param isDisabled Whether the control is disabled
     *
     * @internal
     */
    CustomFormControl.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
        if (this.cdRef) {
            this.cdRef.markForCheck();
        }
    };
    /**
     * Hook for custom controls to update internal state when a value is about
     * to change. If this method has been called, the control&apos;s new value is
     * guaranteed to be different from the existing value.
     *
     * @param newValue The new value of the control
     *
     * @internal
     */
    CustomFormControl.prototype.valueWillChange = function (newValue) { };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], CustomFormControl.prototype, "ariaLabelledBy", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], CustomFormControl.prototype, "ariaDescribedBy", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], CustomFormControl.prototype, "required", void 0);
    __decorate([
        HostBinding('class.hl-form-control--disabled'),
        Input(),
        __metadata("design:type", Object)
    ], CustomFormControl.prototype, "disabled", void 0);
    CustomFormControl = __decorate([
        __param(0, Optional()),
        __metadata("design:paramtypes", [ChangeDetectorRef])
    ], CustomFormControl);
CustomFormControl.ɵfac = function CustomFormControl_Factory(t) { return new (t || CustomFormControl)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef, 8)); };
CustomFormControl.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CustomFormControl, hostVars: 2, hostBindings: function CustomFormControl_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hl-form-control--disabled", ctx.disabled);
    } }, inputs: { required: "required", disabled: "disabled", ariaLabelledBy: "ariaLabelledBy", ariaDescribedBy: "ariaDescribedBy" } });

    return CustomFormControl;
}());

/**
 * A styled checkbox control.
 */
var CheckboxComponent = /** @class */ (function (_super) {
    __extends(CheckboxComponent, _super);
    function CheckboxComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Unique string that serves as a global identifier for the root HTML element
         * and its children.
         */
        _this.id = "hl-checkbox-" + CheckboxComponent_1.componentCount++;
        /**
         * @ignore
         */
        _this.baseClass = true;
        return _this;
    }
    CheckboxComponent_1 = CheckboxComponent;
    Object.defineProperty(CheckboxComponent.prototype, "inputId", {
        /**
         * ID of the input element within the component.
         *
         * @internal
         */
        get: function () {
            return this.id + "-input";
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @ignore
     */
    CheckboxComponent.prototype.onValueChanged = function () {
        this.writeValue(this.checkboxInput.nativeElement.checked);
        this.onChange(this.value);
        this.onTouched();
    };
    var CheckboxComponent_1;
    /**
     * Tracks the number of instances of the component that have been created.
     * Used to generate IDs for child elements, if an ID was not provided.
     *
     * @internal
     */
    CheckboxComponent.componentCount = 0;
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], CheckboxComponent.prototype, "id", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], CheckboxComponent.prototype, "description", void 0);
    __decorate([
        HostBinding('class.hl-checkbox'),
        __metadata("design:type", Object)
    ], CheckboxComponent.prototype, "baseClass", void 0);
    __decorate([
        ViewChild('input'),
        __metadata("design:type", ElementRef)
    ], CheckboxComponent.prototype, "checkboxInput", void 0);
CheckboxComponent.ɵfac = /*@__PURE__*/ function () { var ɵCheckboxComponent_BaseFactory; return function CheckboxComponent_Factory(t) { return (ɵCheckboxComponent_BaseFactory || (ɵCheckboxComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CheckboxComponent)))(t || CheckboxComponent); }; }();
CheckboxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CheckboxComponent, selectors: [["hl-checkbox"]], viewQuery: function CheckboxComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c16, 5);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.checkboxInput = _t.first);
    } }, hostVars: 2, hostBindings: function CheckboxComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hl-checkbox", ctx.baseClass);
    } }, inputs: { id: "id", description: "description" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(function () { return CheckboxComponent_1; }),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c4, decls: 6, vars: 7, consts: [["type", "checkbox", 1, "hl-a11y--visually-hidden", 3, "id", "disabled", "required", "checked", "blur", "change"], ["input", ""], [3, "for"], ["class", "hl-checkbox__description hl-font--legal", 4, "ngIf"], [1, "hl-checkbox__description", "hl-font--legal"]], template: function CheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "input", 0, 1);
        ɵngcc0.ɵɵlistener("blur", function CheckboxComponent_Template_input_blur_0_listener() { return ctx.onTouched(); })("change", function CheckboxComponent_Template_input_change_0_listener() { return ctx.onValueChanged(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "label", 2);
        ɵngcc0.ɵɵelementStart(3, "span");
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵtemplate(5, CheckboxComponent_span_5_Template, 2, 1, "span", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.inputId)("disabled", ctx.disabled)("required", ctx.required)("checked", ctx.value);
        ɵngcc0.ɵɵattribute("aria-describedby", ctx.ariaDescribedBy || null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("for", ctx.inputId);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.description);
    } }, directives: [HDSFormControlDirective, ɵngcc1.NgIf], styles: [".hl-checkbox{--border-color:var(--hds-checkbox-border, #000);--fill-color:var(--hds-checkbox-fill, var(--hds-theme-accent-primary, #189ec3));--text-color:var(--hds-theme-base-text, #000);--border-error-color:var(--hds-checkbox-border-error, #e91d00);--fill-error-color:var(--hds-checkbox-fill-error, #ffe5e5);--focus-shadow-error-color:var(--hds-checkbox-focus-shadow-error, rgba(233, 29, 0, 0.75));display:flex;margin-bottom:.5rem}.hl-checkbox label{display:inline-flex;line-height:1.5}.hl-checkbox label::before{content:'';box-sizing:border-box;flex-shrink:0;height:1.5em;width:1.5em;margin-right:.75rem;border:.125rem solid #000;background-color:var(--hds-input-background,#fff);border-radius:.25rem;border-color:var(--border-color)}.hl-checkbox input:hover+label::before{box-shadow:0 0 8px rgba(0,0,0,.36)}.hl-checkbox input:focus+label::before{box-shadow:0 0 0 .125rem var(--hds-theme-base-background),0 0 0 calc(.125rem + .0625rem) var(--hds-theme-focus-ring)}.hl-checkbox input:checked+label::before{border-color:#189ec3;background-color:#189ec3;background-image:url('data:image/svg+xml;charset=utf8,%3Csvg fill=\"%23fff\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath d=\"M40 56L26.5 42.5l-5.5 6 19 19 35-35-6-5.5z\"/%3E%3C/svg%3E');border-color:var(--fill-color);background-color:var(--fill-color)}.hl-checkbox input:disabled+label{cursor:not-allowed}.hl-checkbox input:disabled+label::before{box-shadow:none;background-color:#f5f5f5;border-color:#c4c4c4}.hl-checkbox__description{display:block;margin-top:.25rem;color:var(--hds-theme-supplementary-text)}.hl-checkbox.hl-form-control--disabled input:checked+label::before{background-image:url('data:image/svg+xml;charset=utf8,%3Csvg fill=\"%23c4c4c4\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath d=\"M40 56L26.5 42.5l-5.5 6 19 19 35-35-6-5.5z\"/%3E%3C/svg%3E')}.hl-checkbox.ng-dirty.ng-invalid input:hover+label::before,.hl-checkbox.ng-dirty.ng-invalid label::before,.hl-checkbox.ng-touched.ng-invalid input:hover+label::before,.hl-checkbox.ng-touched.ng-invalid label::before{background-color:var(--fill-error-color);border-color:var(--border-error-color)}.hl-checkbox.ng-dirty.ng-invalid input:hover:not(:focus)+label::before,.hl-checkbox.ng-touched.ng-invalid input:hover:not(:focus)+label::before{box-shadow:0 0 8px var(--focus-shadow-error-color)}"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'hl-checkbox',
                template: "<input\n    #input\n    [id]=\"inputId\"\n    type=\"checkbox\"\n    class=\"hl-a11y--visually-hidden\"\n    [disabled]=\"disabled\"\n    [required]=\"required\"\n    [checked]=\"value\"\n    [attr.aria-describedby]=\"ariaDescribedBy || null\"\n    (blur)=\"onTouched()\"\n    (change)=\"onValueChanged()\"\n/>\n\n<label [for]=\"inputId\">\n    <span>\n        <ng-content></ng-content>\n        <span *ngIf=\"description\" class=\"hl-checkbox__description hl-font--legal\">{{ description }}</span>\n    </span>\n</label>\n",
                encapsulation: ViewEncapsulation.None,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(function () { return CheckboxComponent_1; }),
                        multi: true
                    }
                ],
                styles: [".hl-checkbox{--border-color:var(--hds-checkbox-border, #000);--fill-color:var(--hds-checkbox-fill, var(--hds-theme-accent-primary, #189ec3));--text-color:var(--hds-theme-base-text, #000);--border-error-color:var(--hds-checkbox-border-error, #e91d00);--fill-error-color:var(--hds-checkbox-fill-error, #ffe5e5);--focus-shadow-error-color:var(--hds-checkbox-focus-shadow-error, rgba(233, 29, 0, 0.75));display:flex;margin-bottom:.5rem}.hl-checkbox label{display:inline-flex;line-height:1.5}.hl-checkbox label::before{content:'';box-sizing:border-box;flex-shrink:0;height:1.5em;width:1.5em;margin-right:.75rem;border:.125rem solid #000;background-color:var(--hds-input-background,#fff);border-radius:.25rem;border-color:var(--border-color)}.hl-checkbox input:hover+label::before{box-shadow:0 0 8px rgba(0,0,0,.36)}.hl-checkbox input:focus+label::before{box-shadow:0 0 0 .125rem var(--hds-theme-base-background),0 0 0 calc(.125rem + .0625rem) var(--hds-theme-focus-ring)}.hl-checkbox input:checked+label::before{border-color:#189ec3;background-color:#189ec3;background-image:url('data:image/svg+xml;charset=utf8,%3Csvg fill=\"%23fff\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath d=\"M40 56L26.5 42.5l-5.5 6 19 19 35-35-6-5.5z\"/%3E%3C/svg%3E');border-color:var(--fill-color);background-color:var(--fill-color)}.hl-checkbox input:disabled+label{cursor:not-allowed}.hl-checkbox input:disabled+label::before{box-shadow:none;background-color:#f5f5f5;border-color:#c4c4c4}.hl-checkbox__description{display:block;margin-top:.25rem;color:var(--hds-theme-supplementary-text)}.hl-checkbox.hl-form-control--disabled input:checked+label::before{background-image:url('data:image/svg+xml;charset=utf8,%3Csvg fill=\"%23c4c4c4\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath d=\"M40 56L26.5 42.5l-5.5 6 19 19 35-35-6-5.5z\"/%3E%3C/svg%3E')}.hl-checkbox.ng-dirty.ng-invalid input:hover+label::before,.hl-checkbox.ng-dirty.ng-invalid label::before,.hl-checkbox.ng-touched.ng-invalid input:hover+label::before,.hl-checkbox.ng-touched.ng-invalid label::before{background-color:var(--fill-error-color);border-color:var(--border-error-color)}.hl-checkbox.ng-dirty.ng-invalid input:hover:not(:focus)+label::before,.hl-checkbox.ng-touched.ng-invalid input:hover:not(:focus)+label::before{box-shadow:0 0 8px var(--focus-shadow-error-color)}"]
            }]
    }], null, { id: [{
            type: Input
        }], description: [{
            type: Input
        }], baseClass: [{
            type: HostBinding,
            args: ['class.hl-checkbox']
        }], checkboxInput: [{
            type: ViewChild,
            args: ['input']
        }] }); })();
    return CheckboxComponent;
}(CustomFormControl));

var CheckboxModule = /** @class */ (function () {
    function CheckboxModule() {
    }
CheckboxModule.ɵfac = function CheckboxModule_Factory(t) { return new (t || CheckboxModule)(); };
CheckboxModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CheckboxModule });
CheckboxModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, FormControlsCommonModule], FormControlsCommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckboxModule, [{
        type: NgModule,
        args: [{
                declarations: [CheckboxComponent],
                imports: [CommonModule, FormControlsCommonModule],
                exports: [CheckboxComponent, FormControlsCommonModule]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CheckboxModule, { declarations: function () { return [CheckboxComponent]; }, imports: function () { return [CommonModule, FormControlsCommonModule]; }, exports: function () { return [CheckboxComponent, FormControlsCommonModule]; } }); })();
    return CheckboxModule;
}());

var _a;
/**
 * Matches any 1- or 2-digit day string.
 */
var DAY = /(0?[1-9]|[1-2][0-9]|3[0-1])/;
/**
 * Matches any 1- or 2-digit month string.
 */
var MONTH = /(0?[1-9]|1[0|1|2])/;
/**
 * Matches any 4-digit year string.
 */
var YEAR = /(\d{4})/;
/**
 * Matches one or more of the following common date separator characters:
 * - Forward slash (`/`)
 * - Hyphen (`-`)
 * - Space (`" "`)
 * - Period (`.`)
 */
var SEPARATORS = /[\/|\-| |.]+/;
/**
 * Matches the date portion of an ISO-8601 date string (`YYYY-MM-DD`).
 *
 * **Note:** This may match invalid dates (e.g., `1999-02-31`).
 */
var ISO = new RegExp("^" + YEAR.source + "-" + MONTH.source + "-" + DAY.source + "$");
/**
 * Matches any date string of the form `MMDDYYYY`, without any date separators.
 * To match a date string with separators, use `MM_DD_YYYY`.
 *
 * **Note:** This may match invalid dates (e.g., `02311999`).
 */
var MonthDayYearNoSeparators = new RegExp("^" + MONTH.source + DAY.source + YEAR.source + "$");
/**
 * Matches any date string of the form `MM_DD_YYYY`, where `_` represents a
 * valid date separator character.
 *
 * **Note:** This may match invalid dates (e.g., `02/31/1999`).
 *
 * @see `SEPARATORS`
 */
var MonthDayYear = new RegExp("^" + MONTH.source + SEPARATORS.source + DAY.source + SEPARATORS.source + YEAR.source + "$");
/**
 * Matches any date string of the form `MM_YYYY`, where `_` represents a
 * valid date separator character.
 */
var MonthYear = new RegExp("^" + MONTH.source + SEPARATORS.source + YEAR.source + "$");
/**
 * A map of formatting regexes for each date format supported by Date Input.
 */
var DATE_REGEXES = (_a = {},
    _a["YYYY-MM-DD" /* ISO */] = ISO,
    _a["MM/DD/YYYY" /* MonthDayYear */] = MonthDayYear,
    _a["MM/YYYY" /* MonthYear */] = MonthYear,
    _a);

/**
 * Parses a formatted date value from an input.
 */
var DateFormatDirective = /** @class */ (function () {
    function DateFormatDirective() {
        /**
         * Date format to use for formatting user input.
         */
        // tslint:disable-next-line:no-input-rename
        this.format = "MM/DD/YYYY" /* MonthDayYear */;
        /**
         * Emitted when the parts of the date input have changed.
         */
        this.datePartsChange = new EventEmitter();
        /**
         * Emitted when the formatted date string has changed.
         */
        this.dateChange = new EventEmitter();
        /**
         * @ignore
         */
        this._dateParts = null;
        /**
         * @ignore
         */
        this._formattedDate = '';
    }
    Object.defineProperty(DateFormatDirective.prototype, "formatRegex", {
        /**
         * Formatting regex for the specified date format.
         */
        get: function () {
            return DATE_REGEXES[this.format] || DATE_REGEXES["MM/DD/YYYY" /* MonthDayYear */];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateFormatDirective.prototype, "dateParts", {
        /**
         * An object containing the year, month, and day of the parsed date input.
         */
        get: function () {
            return this._dateParts;
        },
        set: function (val) {
            this._dateParts = val;
            this.datePartsChange.emit(this._dateParts);
            this.formatParts();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateFormatDirective.prototype, "formattedDate", {
        /**
         * Value of the input, formatted according to the specified date format.
         * If the input value could not be formatted, this will be the empty string.
         */
        get: function () {
            return this._formattedDate;
        },
        set: function (val) {
            this._formattedDate = val;
            this.dateChange.emit(this._formattedDate);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses the given value into the constituent parts of a date, if possible.
     *
     * @param value Value to parse
     */
    DateFormatDirective.prototype.parseDate = function (value) {
        var _a, _b, _c;
        var matchNoSeparators = MonthDayYearNoSeparators.exec(value);
        if (matchNoSeparators) {
            var _d = __read(matchNoSeparators, 4), _ = _d[0], month = _d[1], day = _d[2], year = _d[3];
            this.dateParts = { month: month, day: day, year: year };
            return;
        }
        var match = this.formatRegex.exec(value);
        if (match) {
            var _e = __read(match), _ = _e[0], captureGroups = _e.slice(1);
            var year = void 0;
            var month = void 0;
            var day = void 0;
            switch (this.format) {
                case "YYYY-MM-DD" /* ISO */:
                    _a = __read(captureGroups, 3), year = _a[0], month = _a[1], day = _a[2];
                    this.dateParts = { year: year, month: month.padStart(2, '0'), day: day.padStart(2, '0') };
                    break;
                case "MM/YYYY" /* MonthYear */:
                    _b = __read(captureGroups, 2), month = _b[0], year = _b[1];
                    this.dateParts = { year: year, month: month.padStart(2, '0') };
                    break;
                default:
                    _c = __read(captureGroups, 3), month = _c[0], day = _c[1], year = _c[2];
                    this.dateParts = { year: year, month: month.padStart(2, '0'), day: day.padStart(2, '0') };
            }
        }
        else {
            this.dateParts = null;
        }
    };
    /**
     * Translates the current date parts into a formatted date string.
     */
    DateFormatDirective.prototype.formatParts = function () {
        if (!this.dateParts) {
            this.formattedDate = '';
            return;
        }
        var _a = this.dateParts, year = _a.year, month = _a.month, day = _a.day;
        switch (this.format) {
            case "YYYY-MM-DD" /* ISO */:
                this.formattedDate = year + "-" + month + "-" + day;
                break;
            case "MM/YYYY" /* MonthYear */:
                this.formattedDate = month + "/" + year;
                break;
            default:
                this.formattedDate = month + "/" + day + "/" + year;
        }
    };
    __decorate([
        Input('hdsDateFormat'),
        __metadata("design:type", String)
    ], DateFormatDirective.prototype, "format", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], DateFormatDirective.prototype, "datePartsChange", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], DateFormatDirective.prototype, "dateChange", void 0);
    __decorate([
        HostListener('input', ['$event.target.value']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], DateFormatDirective.prototype, "parseDate", null);
DateFormatDirective.ɵfac = function DateFormatDirective_Factory(t) { return new (t || DateFormatDirective)(); };
DateFormatDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DateFormatDirective, selectors: [["input", "hdsDateFormat", ""]], hostBindings: function DateFormatDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("input", function DateFormatDirective_input_HostBindingHandler($event) { return ctx.parseDate($event.target.value); });
    } }, inputs: { format: ["hdsDateFormat", "format"] }, outputs: { datePartsChange: "datePartsChange", dateChange: "dateChange" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DateFormatDirective, [{
        type: Directive,
        args: [{
                selector: 'input[hdsDateFormat]'
            }]
    }], function () { return []; }, { format: [{
            type: Input,
            args: ['hdsDateFormat']
        }], datePartsChange: [{
            type: Output
        }], dateChange: [{
            type: Output
        }], parseDate: [{
            type: HostListener,
            args: ['input', ['$event.target.value']]
        }] }); })();
    return DateFormatDirective;
}());

/**
 * An input that interprets dates from user-entered text, intended as an
 * alternative to the native `<input type="date">` with better cross-browser
 * and cross-device consistency.
 *
 * NOTE: This component may eventually be enhanced to include a date picker.
 */
var DateInputComponent = /** @class */ (function (_super) {
    __extends(DateInputComponent, _super);
    function DateInputComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Default ID for the component, in case one was not provided.
         *
         * @internal
         */
        _this._id = "hl-date-input-" + DateInputComponent_1.componentCount++;
        /**
         * @ignore
         */
        _this.externalId = null;
        /**
         * @ignore
         */
        _this.baseClass = true;
        /**
         * Format that the user input will be transformed into.
         */
        _this.format = "MM/DD/YYYY" /* MonthDayYear */;
        /**
         * @ignore
         */
        _this._placeholder = '';
        return _this;
    }
    DateInputComponent_1 = DateInputComponent;
    Object.defineProperty(DateInputComponent.prototype, "id", {
        get: function () {
            return this._id;
        },
        /**
         * Unique string that serves as a global identifier for the component.
         * This value will be removed from the host and assigned to its input
         * element, to ensure accessible labeling relationships.
         */
        set: function (value) {
            this._id = value;
            this.externalId = null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateInputComponent.prototype, "placeholder", {
        /**
         * Value of the input&apos;s placeholder text.
         */
        get: function () {
            return this._placeholder || this.format.toLowerCase();
        },
        set: function (val) {
            this._placeholder = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Attempts to format the user input into a standard date string and save
     * it as the native `<input>` value.
     *
     * @internal
     */
    DateInputComponent.prototype.formatInput = function () {
        // If the value could be formatted, save it as the new value.
        // Otherwise, retain the old value so validation makes sense
        var valueToSave = this.formattedValue || this.input.nativeElement.value;
        // Sync the input value with the control value, in case the user changed
        // the input value to something that resolves to the previously saved
        // formatted value
        if (this.input && valueToSave === this.formattedValue) {
            this.input.nativeElement.value = valueToSave;
        }
        if (valueToSave !== this.value) {
            this.writeValue(valueToSave);
            this.onChange(valueToSave);
        }
        this.onTouched();
    };
    /**
     * Validates that the given control has a valid date string value for the
     * expected date format.
     *
     * @param control Control to validate
     *
     * @internal
     */
    DateInputComponent.prototype.validate = function (control) {
        // Allow control to be optional - if required, consumers should add `Validators.required`
        if (!control.value) {
            return null;
        }
        var regex = DATE_REGEXES[this.format];
        // Does the value match the appropriate date format?
        if (!regex.test(control.value)) {
            return {
                invalidDate: { value: control.value, reason: 'Unexpected format', expectedFormat: this.format }
            };
        }
        // The remaining checks require date to have a day
        if (this.format === "MM/YYYY" /* MonthYear */) {
            return null;
        }
        // Convert the value to a Date object and see if the string
        // representations match. If not, the value isn't a real date.
        var date = new Date(control.value);
        var convertedDateString = this.format === "YYYY-MM-DD" /* ISO */
            ? date.toISOString().split('T')[0]
            : date.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });
        if (convertedDateString !== control.value) {
            return {
                invalidDate: {
                    value: control.value,
                    reason: 'Converted Date object does not match value',
                    convertedValue: convertedDateString
                }
            };
        }
        return null;
    };
    /**
     * Updates the selected option in response to programmatic changes to the
     * control value.
     *
     * @param newValue Value the control will have
     */
    DateInputComponent.prototype.valueWillChange = function (newValue) {
        if (this.input) {
            this.input.nativeElement.value = newValue;
            this.formattedValue = newValue;
        }
    };
    var DateInputComponent_1;
    /**
     * Tracks the number of instances of the component that have been created.
     * Used to generate IDs for child elements, if an ID was not provided.
     *
     * @internal
     */
    DateInputComponent.componentCount = 0;
    __decorate([
        HostBinding('attr.id'),
        __metadata("design:type", Object)
    ], DateInputComponent.prototype, "externalId", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], DateInputComponent.prototype, "id", null);
    __decorate([
        HostBinding('class.hl-input'),
        __metadata("design:type", Object)
    ], DateInputComponent.prototype, "baseClass", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateInputComponent.prototype, "birthDate", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateInputComponent.prototype, "format", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], DateInputComponent.prototype, "placeholder", null);
    __decorate([
        ViewChild('hlInput'),
        __metadata("design:type", ElementRef)
    ], DateInputComponent.prototype, "input", void 0);
DateInputComponent.ɵfac = /*@__PURE__*/ function () { var ɵDateInputComponent_BaseFactory; return function DateInputComponent_Factory(t) { return (ɵDateInputComponent_BaseFactory || (ɵDateInputComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(DateInputComponent)))(t || DateInputComponent); }; }();
DateInputComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DateInputComponent, selectors: [["hl-date-input"]], viewQuery: function DateInputComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c17, 5);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, hostVars: 3, hostBindings: function DateInputComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("id", ctx.externalId);
        ɵngcc0.ɵɵclassProp("hl-input", ctx.baseClass);
    } }, inputs: { id: "id", placeholder: "placeholder", birthDate: "birthDate", format: "format" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_VALUE_ACCESSOR, useExisting: DateInputComponent_1, multi: true },
            { provide: NG_VALIDATORS, useExisting: DateInputComponent_1, multi: true }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 6, consts: [["type", "text", 3, "hdsDateFormat", "id", "placeholder", "disabled", "required", "dateChange", "blur"], ["hlInput", ""]], template: function DateInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "input", 0, 1);
        ɵngcc0.ɵɵlistener("dateChange", function DateInputComponent_Template_input_dateChange_0_listener($event) { return ctx.formattedValue = $event; })("blur", function DateInputComponent_Template_input_blur_0_listener() { return ctx.formatInput(); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hdsDateFormat", ctx.format)("id", ctx.id)("placeholder", ctx.placeholder)("disabled", ctx.disabled)("required", ctx.required);
        ɵngcc0.ɵɵattribute("autocomplete", ctx.birthDate ? "bday" : null);
    } }, directives: function () { return [HDSFormControlDirective, ProjectedInputDirective, DateFormatDirective]; }, styles: [_c19], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DateInputComponent, [{
        type: Component,
        args: [{
                selector: 'hl-date-input',
                template: "<input\n    #hlInput\n    [hdsDateFormat]=\"format\"\n    (dateChange)=\"formattedValue = $event\"\n    [id]=\"id\"\n    type=\"text\"\n    [placeholder]=\"placeholder\"\n    [attr.autocomplete]=\"birthDate ? 'bday' : null\"\n    [disabled]=\"disabled\"\n    [required]=\"required\"\n    (blur)=\"formatInput()\"\n/>\n",
                encapsulation: ViewEncapsulation.None,
                providers: [
                    { provide: NG_VALUE_ACCESSOR, useExisting: DateInputComponent_1, multi: true },
                    { provide: NG_VALIDATORS, useExisting: DateInputComponent_1, multi: true }
                ],
                styles: [".hl-input{display:inline-flex;align-items:center;--text-color:var(--hds-theme-base-text, #000);--placeholder-color:var(--hds-input-placeholder, rgba(0, 0, 0, 0.45));--bg:var(--hds-input-background, #fff);--border:var(--hds-input-border, currentColor);--border-focus:var(--hds-theme-accent-primary, #189ec3);--bg-error:var(--hds-input-background-error, #ffe5e5);--border-error:var(--hds-input-border-error, #e91d00);--border-focus-shadow-error:var(--hds-input-focus-shadow-error, rgba(233, 29, 0, 0.75));height:3rem;width:100%;border:.125rem solid var(--border);border-radius:.25rem;background-color:var(--bg);color:var(--text-color);transition-property:background-color,border-color,box-shadow;transition-duration:75ms;overflow:hidden}.hl-input input{-webkit-appearance:none;-moz-appearance:none;appearance:none;margin:0;padding:0 .5rem;height:3rem;flex-basis:100%;min-width:0;max-width:100%;font:inherit}.hl-input input::-webkit-input-placeholder{color:var(--placeholder-color);opacity:.45}.hl-input input::-moz-placeholder{color:var(--placeholder-color);opacity:.45}.hl-input input:-ms-input-placeholder{color:var(--placeholder-color);opacity:.45}.hl-input input::-ms-input-placeholder{color:var(--placeholder-color);opacity:.45}.hl-input input::placeholder{color:var(--placeholder-color);opacity:.45}.hl-input input,.hl-input input:invalid,.hl-input input:valid,.hl-input input[disabled]{color:currentColor;background-color:transparent;border:none}.hl-input input:focus{outline-style:auto}.hl-input:focus-within{border-color:var(--border-focus);box-shadow:0 0 8px rgba(0,0,0,.36)}.hl-input:focus-within input:focus{outline:0}.hl-input:focus-within input:focus::-moz-focus-inner{border-style:none;padding:0}.hl-input:focus-within input:focus:-moz-focusring{outline:0}.hl-input.hl-form-control--disabled{background-color:#f5f5f5;border-color:#c4c4c4;color:#8d8d8d;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.hl-input.hl-form-control--read-only{display:inline-flex;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:auto;min-width:0;background:0 0;border-color:transparent;color:#606062}.hl-input.hl-form-control--read-only:focus-within{border-color:#000;box-shadow:none}.hl-input.hl-form-control--read-only input{height:auto}.hl-input.hl-form-control--read-only input::-webkit-input-placeholder{opacity:0}.hl-input.hl-form-control--read-only input::-moz-placeholder{opacity:0}.hl-input.hl-form-control--read-only input:-ms-input-placeholder{opacity:0}.hl-input.hl-form-control--read-only input::-ms-input-placeholder{opacity:0}.hl-input.hl-form-control--read-only input::placeholder{opacity:0}.hl-input.hl-form-control--invalid,.hl-input.ng-dirty.ng-invalid,.hl-input.ng-touched.ng-invalid{background-color:var(--bg-error);border-color:var(--border-error)}.hl-input.hl-form-control--invalid:focus-within,.hl-input.ng-dirty.ng-invalid:focus-within,.hl-input.ng-touched.ng-invalid:focus-within{box-shadow:0 0 8px var(--border-focus-shadow-error)}.hl-input__icon,.hl-input__prefix,.hl-input__suffix{flex-shrink:0;margin:0 .5rem}"]
            }]
    }], null, { id: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], externalId: [{
            type: HostBinding,
            args: ['attr.id']
        }], baseClass: [{
            type: HostBinding,
            args: ['class.hl-input']
        }], birthDate: [{
            type: Input
        }], format: [{
            type: Input
        }], input: [{
            type: ViewChild,
            args: ['hlInput']
        }] }); })();
    return DateInputComponent;
}(CustomFormControl));

/**
 * Selects a text-based `<input>` element and stores a references to its native
 * HTML element. If the `<input>` is associated with an Angular form, it also
 * stores a reference to the underlying form control object.
 */
var ProjectedInputDirective = /** @class */ (function () {
    /**
     * @ignore
     */
    function ProjectedInputDirective(elementRef, formControl) {
        this.elementRef = elementRef;
        this.formControl = formControl;
    }
    ProjectedInputDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: NgControl, decorators: [{ type: Optional }] }
    ]; };
    ProjectedInputDirective = __decorate([ __param(1, Optional()),
        __metadata("design:paramtypes", [ElementRef, NgControl])
    ], ProjectedInputDirective);
ProjectedInputDirective.ɵfac = function ProjectedInputDirective_Factory(t) { return new (t || ProjectedInputDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.NgControl, 8)); };
ProjectedInputDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ProjectedInputDirective, selectors: [["input", "type", "date"], ["input", "type", "datetime-local"], ["input", "type", "email"], ["input", "type", "month"], ["input", "type", "number"], ["input", "type", "password"], ["input", "type", "search"], ["input", "type", "tel"], ["input", "type", "text"], ["input", "type", "time"], ["input", "type", "url"], ["input", "type", "week"]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProjectedInputDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line
                selector: "\n        input[type=\"date\"],\n        input[type=\"datetime-local\"],\n        input[type=\"email\"],\n        input[type=\"month\"],\n        input[type=\"number\"],\n        input[type=\"password\"],\n        input[type=\"search\"],\n        input[type=\"tel\"],\n        input[type=\"text\"],\n        input[type=\"time\"],\n        input[type=\"url\"],\n        input[type=\"week\"]\n    "
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc2.NgControl, decorators: [{
                type: Optional
            }] }]; }, null); })();
    return ProjectedInputDirective;
}());

/**
 * A wrapper to style the native HTML `<input>` element.
 */
var InputComponent = /** @class */ (function () {
    /**
     * @ignore
     */
    function InputComponent(cdRef) {
        this.cdRef = cdRef;
        /**
         * @ignore
         */
        this.baseClass = true;
    }
    InputComponent_1 = InputComponent;
    Object.defineProperty(InputComponent.prototype, "disabled", {
        /**
         * Whether the projected input is disabled.
         */
        get: function () {
            return this.input.formControl ? this.input.formControl.disabled : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputComponent.prototype, "isInvalid", {
        /**
         * Whether the projected input is invalid.
         */
        get: function () {
            if (!this.input.formControl) {
                return false;
            }
            return this.input.formControl.invalid && (this.input.formControl.touched || this.input.formControl.dirty);
        },
        enumerable: true,
        configurable: true
    });
    InputComponent.prototype.ngAfterContentInit = function () {
        if (!this.input) {
            throw new ComponentConfigurationError('<hl-input> expects an <input> child that is associated with a parent form. See ProjectedInputDirective for more details', '<hl-input><input type="text" formControlName="myInput" /></hl-input>');
        }
        var inputEl = this.input.elementRef.nativeElement;
        inputEl.id = inputEl.id || "hl-input-" + InputComponent_1.componentCount++;
        inputEl.readOnly = this.readOnly || false;
    };
    InputComponent.prototype.ngOnChanges = function (changes) {
        if ('readOnly' in changes && this.input) {
            var inputEl = this.input.elementRef.nativeElement;
            inputEl.size = inputEl.value.length > 1 ? inputEl.value.length : 1;
            inputEl.readOnly = changes.readOnly.currentValue;
        }
    };
    var InputComponent_1;
    /**
     * Tracks the number of instances of the component that have been created.
     * Used to generate IDs for child elements, if an ID was not provided.
     *
     * @internal
     */
    InputComponent.componentCount = 0;
    InputComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    __decorate([
        HostBinding('class.hl-input'),
        __metadata("design:type", Object)
    ], InputComponent.prototype, "baseClass", void 0);
    __decorate([
        HostBinding('class.hl-form-control--disabled'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], InputComponent.prototype, "disabled", null);
    __decorate([
        HostBinding('class.hl-form-control--invalid'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], InputComponent.prototype, "isInvalid", null);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], InputComponent.prototype, "prefix", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], InputComponent.prototype, "suffix", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], InputComponent.prototype, "icon", void 0);
    __decorate([
        HostBinding('class.hl-form-control--read-only'),
        Input(),
        __metadata("design:type", Boolean)
    ], InputComponent.prototype, "readOnly", void 0);
    __decorate([
        ContentChild(ProjectedInputDirective),
        __metadata("design:type", ProjectedInputDirective)
    ], InputComponent.prototype, "input", void 0);
    InputComponent = InputComponent_1 = __decorate([ __metadata("design:paramtypes", [ChangeDetectorRef])
    ], InputComponent);
InputComponent.ɵfac = function InputComponent_Factory(t) { return new (t || InputComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
InputComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InputComponent, selectors: [["hl-input"]], contentQueries: function InputComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, ProjectedInputDirective, 5);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, hostVars: 8, hostBindings: function InputComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hl-input", ctx.baseClass)("hl-form-control--disabled", ctx.disabled)("hl-form-control--invalid", ctx.isInvalid)("hl-form-control--read-only", ctx.readOnly);
    } }, inputs: { prefix: "prefix", suffix: "suffix", icon: "icon", readOnly: "readOnly" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c16, decls: 4, vars: 3, consts: [["class", "hl-input__prefix", "aria-hidden", "true", 4, "ngIf"], ["class", "hl-input__suffix", "aria-hidden", "true", 4, "ngIf"], ["class", "hl-input__icon", 3, "icon", 4, "ngIf"], ["aria-hidden", "true", 1, "hl-input__prefix"], ["aria-hidden", "true", 1, "hl-input__suffix"], [1, "hl-input__icon", 3, "icon"]], template: function InputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c18);
        ɵngcc0.ɵɵtemplate(0, InputComponent_span_0_Template, 2, 1, "span", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵtemplate(2, InputComponent_span_2_Template, 2, 1, "span", 1);
        ɵngcc0.ɵɵtemplate(3, InputComponent_hl_icon_3_Template, 1, 1, "hl-icon", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.prefix);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.suffix);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.icon);
    } }, directives: [ɵngcc1.NgIf, IconComponent], styles: [_c19], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputComponent, [{
        type: Component,
        args: [{
                selector: 'hl-input',
                template: "<span *ngIf=\"prefix\" class=\"hl-input__prefix\" aria-hidden=\"true\">{{ prefix }}</span>\n\n<ng-content select=\"input\"></ng-content>\n\n<span *ngIf=\"suffix\" class=\"hl-input__suffix\" aria-hidden=\"true\">{{ suffix }}</span>\n\n<hl-icon *ngIf=\"icon\" class=\"hl-input__icon\" [icon]=\"icon\"></hl-icon>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".hl-input{display:inline-flex;align-items:center;--text-color:var(--hds-theme-base-text, #000);--placeholder-color:var(--hds-input-placeholder, rgba(0, 0, 0, 0.45));--bg:var(--hds-input-background, #fff);--border:var(--hds-input-border, currentColor);--border-focus:var(--hds-theme-accent-primary, #189ec3);--bg-error:var(--hds-input-background-error, #ffe5e5);--border-error:var(--hds-input-border-error, #e91d00);--border-focus-shadow-error:var(--hds-input-focus-shadow-error, rgba(233, 29, 0, 0.75));height:3rem;width:100%;border:.125rem solid var(--border);border-radius:.25rem;background-color:var(--bg);color:var(--text-color);transition-property:background-color,border-color,box-shadow;transition-duration:75ms;overflow:hidden}.hl-input input{-webkit-appearance:none;-moz-appearance:none;appearance:none;margin:0;padding:0 .5rem;height:3rem;flex-basis:100%;min-width:0;max-width:100%;font:inherit}.hl-input input::-webkit-input-placeholder{color:var(--placeholder-color);opacity:.45}.hl-input input::-moz-placeholder{color:var(--placeholder-color);opacity:.45}.hl-input input:-ms-input-placeholder{color:var(--placeholder-color);opacity:.45}.hl-input input::-ms-input-placeholder{color:var(--placeholder-color);opacity:.45}.hl-input input::placeholder{color:var(--placeholder-color);opacity:.45}.hl-input input,.hl-input input:invalid,.hl-input input:valid,.hl-input input[disabled]{color:currentColor;background-color:transparent;border:none}.hl-input input:focus{outline-style:auto}.hl-input:focus-within{border-color:var(--border-focus);box-shadow:0 0 8px rgba(0,0,0,.36)}.hl-input:focus-within input:focus{outline:0}.hl-input:focus-within input:focus::-moz-focus-inner{border-style:none;padding:0}.hl-input:focus-within input:focus:-moz-focusring{outline:0}.hl-input.hl-form-control--disabled{background-color:#f5f5f5;border-color:#c4c4c4;color:#8d8d8d;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.hl-input.hl-form-control--read-only{display:inline-flex;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:auto;min-width:0;background:0 0;border-color:transparent;color:#606062}.hl-input.hl-form-control--read-only:focus-within{border-color:#000;box-shadow:none}.hl-input.hl-form-control--read-only input{height:auto}.hl-input.hl-form-control--read-only input::-webkit-input-placeholder{opacity:0}.hl-input.hl-form-control--read-only input::-moz-placeholder{opacity:0}.hl-input.hl-form-control--read-only input:-ms-input-placeholder{opacity:0}.hl-input.hl-form-control--read-only input::-ms-input-placeholder{opacity:0}.hl-input.hl-form-control--read-only input::placeholder{opacity:0}.hl-input.hl-form-control--invalid,.hl-input.ng-dirty.ng-invalid,.hl-input.ng-touched.ng-invalid{background-color:var(--bg-error);border-color:var(--border-error)}.hl-input.hl-form-control--invalid:focus-within,.hl-input.ng-dirty.ng-invalid:focus-within,.hl-input.ng-touched.ng-invalid:focus-within{box-shadow:0 0 8px var(--border-focus-shadow-error)}.hl-input__icon,.hl-input__prefix,.hl-input__suffix{flex-shrink:0;margin:0 .5rem}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { baseClass: [{
            type: HostBinding,
            args: ['class.hl-input']
        }], disabled: [{
            type: HostBinding,
            args: ['class.hl-form-control--disabled']
        }], isInvalid: [{
            type: HostBinding,
            args: ['class.hl-form-control--invalid']
        }], prefix: [{
            type: Input
        }], suffix: [{
            type: Input
        }], icon: [{
            type: Input
        }], readOnly: [{
            type: HostBinding,
            args: ['class.hl-form-control--read-only']
        }, {
            type: Input
        }], input: [{
            type: ContentChild,
            args: [ProjectedInputDirective]
        }] }); })();
    return InputComponent;
}());

var InputModule = /** @class */ (function () {
    function InputModule() {
    }
InputModule.ɵfac = function InputModule_Factory(t) { return new (t || InputModule)(); };
InputModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: InputModule });
InputModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, FormControlsCommonModule, IconModule], FormControlsCommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputModule, [{
        type: NgModule,
        args: [{
                declarations: [InputComponent, DateInputComponent, ProjectedInputDirective, DateFormatDirective],
                imports: [CommonModule, FormControlsCommonModule, IconModule],
                exports: [
                    FormControlsCommonModule,
                    InputComponent,
                    DateInputComponent,
                    ProjectedInputDirective,
                    DateFormatDirective
                ]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(InputModule, { declarations: function () { return [InputComponent, DateInputComponent, ProjectedInputDirective, DateFormatDirective]; }, imports: function () { return [CommonModule, FormControlsCommonModule, IconModule]; }, exports: function () { return [FormControlsCommonModule, InputComponent, DateInputComponent, ProjectedInputDirective, DateFormatDirective]; } }); })();
    return InputModule;
}());

/**
 * Normalizes a Combobox value (either user input or an option description)
 * for comparison with other values.
 *
 * @param value Value to normalize
 */
var HDS_COMBOBOX_MATCH_NORMALIZER = function (value) {
    // Most users type in all lowercase
    var normalizedValue = value.toLowerCase();
    // Haven Tech products frequently use Combobox for face amount selection.
    // This will strip out currency-specific characters the user is unlikely to
    // type, so formatted currency values will match user input
    normalizedValue = normalizedValue.replace(/[$,.]/g, '');
    return normalizedValue;
};
var ɵ0$1 = HDS_COMBOBOX_MATCH_NORMALIZER;
/* tslint:disable:no-conflicting-lifecycle */
/**
 * A text input that will automatically suggest values from a given list, based
 * on what the user has entered in the input so far.
 *
 * @todo Refactor ID delegation behavior so consumers can set `id` on the host
 * instead of `inputId`. See DropdownComponent for an example pattern.
 */
var ComboboxComponent = /** @class */ (function (_super) {
    __extends(ComboboxComponent, _super);
    /**
     * @ignore
     */
    function ComboboxComponent(cdRef, elementRef) {
        var _this = _super.call(this, cdRef) || this;
        _this.cdRef = cdRef;
        _this.elementRef = elementRef;
        /**
         * @ignore
         */
        _this.baseClass = true;
        /**
         * Default ID for the combobox input, in case one was not provided.
         *
         * @internal
         */
        _this.id = "hl-combobox-" + ComboboxComponent_1.componentCount++;
        /**
         * Placeholder value for the combobox input.
         */
        _this.placeholder = '';
        /**
         * Set to `true` to force the listbox to be visible as long as focus is
         * within the combobox input.
         *
         * @deprecated
         */
        _this.showListOnFocus = true;
        /**
         * When `showListOnFocus` is `true`, this represents whether the list is
         * currently being shown.
         *
         * @internal
         */
        _this.showList = false;
        /**
         * @ignore
         */
        _this._options = [];
        /**
         * The subset of suggestions that match the current input value.
         *
         * @internal
         */
        _this.matchingSuggestions = [];
        /**
         * Index of the value from `matchingSuggestions` that is currently being
         * suggested to the user.
         *
         * @internal
         */
        _this.currentSuggestionIndex = null;
        return _this;
    }
    ComboboxComponent_1 = ComboboxComponent;
    Object.defineProperty(ComboboxComponent.prototype, "inputId", {
        /**
         * ID to assign to the combobox text input. Allows for proper label association.
         *
         * For best results, use this attribute in conjunction with the `aria-labelledby`
         * attribute.
         *
         * @example
         * ```
         * <label id="my-label-id" for="my-combobox-id">Combobox label</label>
         * <hl-combobox inputId="my-combobox-id" aria-labelledby="my-label-id"></hl-combobox>
         * ```
         */
        get: function () {
            return this._inputId ? this._inputId : this.id;
        },
        set: function (value) {
            this._inputId = value ? value : this.id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboboxComponent.prototype, "suggestions", {
        /**
         * @deprecated Use the `options` input instead.
         */
        set: function (value) {
            this._options = value.map(function (suggestion) { return ({
                value: suggestion,
                description: suggestion
            }); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboboxComponent.prototype, "options", {
        /**
         * A list of options for the user to select from. The descriptions of each
         * options are used to generate suggestions for the user.
         */
        set: function (value) {
            this._options = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboboxComponent.prototype, "matchMessage", {
        /**
         * Message to tell the user how many suggestions match their current query.
         */
        get: function () {
            if (this.numMatches === 0) {
                return 'No matching suggestions';
            }
            if (this.numMatches === 1) {
                return '1 match';
            }
            if (this.numMatches > ComboboxComponent_1.MAX_NUM_MATCHING_SUGGESTIONS) {
                return "Showing " + ComboboxComponent_1.MAX_NUM_MATCHING_SUGGESTIONS + " of " + this.numMatches + " matches";
            }
            return this.numMatches + " matches";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboboxComponent.prototype, "hasCurrentSuggestion", {
        /**
         * Whether a suggestion is currently being offered to the user.
         *
         * @internal
         */
        get: function () {
            return this.currentSuggestionIndex !== null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboboxComponent.prototype, "currentSuggestion", {
        /**
         * Text of the suggestion currently being offered to the user.
         *
         * @internal
         */
        get: function () {
            return this.hasCurrentSuggestion ? this.matchingSuggestions[this.currentSuggestionIndex] : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboboxComponent.prototype, "matchSummaryId", {
        /**
         * ID of the element describing the number of matches for the current query.
         */
        get: function () {
            return this.inputId + "-match-summary";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboboxComponent.prototype, "listboxId", {
        /**
         * ID of the Combobox listbox element.
         *
         * @internal
         */
        get: function () {
            return this.inputId + "-listbox";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboboxComponent.prototype, "currentSuggestionOptionId", {
        /**
         * ID of the listbox option element corresponding to the suggestion
         * currently being offered to the user.
         *
         * Note that, because the listbox displays only matching suggestions, this
         * index corresponds to the `matchingSuggestions` array, not `suggestions`.
         *
         * @internal
         */
        get: function () {
            return this.hasCurrentSuggestion ? this.getOptionId(this.currentSuggestionIndex) : null;
        },
        enumerable: true,
        configurable: true
    });
    ComboboxComponent.prototype.ngOnInit = function () {
        this.clearValueAndCurrentSuggestion();
    };
    /**
     * Updates the list of suggestions if they are changed by the consumer.
     *
     * NOTE: This is safe to include alongside `ngDoCheck` because they do not
     * detect changes on the same properties.
     */
    ComboboxComponent.prototype.ngOnChanges = function (changes) {
        // Prevent matching suggestions from becoming stale when consuming code
        // changes the full suggestions list
        if (changes.suggestions || changes.options) {
            this.clearValueAndCurrentSuggestion();
        }
    };
    /**
     * Updates the disabled state of inner components when necessary.
     *
     * NOTE: This is safe to include alongside `ngOnChanges` because they do not
     * detect changes on the same properties.
     */
    ComboboxComponent.prototype.ngDoCheck = function () {
        var _this = this;
        // Keep this component's disabled state in sync with the input wrapper's
        // disabled state
        if (this.input && this.input.nativeElement.disabled !== this.disabled) {
            // A timeout is required to allow Angular to update the input wrapper
            setTimeout(function () {
                _this.inputWrapper.cdRef.markForCheck();
            }, 0);
        }
    };
    /**
     * Directly updates the value of the control.
     * @param value Value to set
     */
    ComboboxComponent.prototype.writeValue = function (value) {
        if (this.input && !this.disabled) {
            _super.prototype.writeValue.call(this, value);
            // TODO: This won't work for object-valued types
            var firstMatchingOption = this._options.find(function (option) { return option.value === value; });
            this.input.nativeElement.value = firstMatchingOption ? firstMatchingOption.description : '';
        }
    };
    /**
     * Returns the ID of the listbox option element with the given index.
     *
     * @param index Index of the suggestion from `matchingSuggestions`
     * @internal
     */
    ComboboxComponent.prototype.getOptionId = function (index) {
        return this.inputId + "-option-" + index;
    };
    /**
     * Tracks when the combobox input receives focus.
     *
     * @internal
     */
    ComboboxComponent.prototype.handleFocus = function () {
        this.showList = true;
    };
    /**
     * Accepts the current suggestion when focus leaves the Combobox input.
     *
     * @internal
     */
    ComboboxComponent.prototype.handleBlur = function (event) {
        if (this.elementRef.nativeElement.contains(event.relatedTarget)) {
            // The user is clicking the input or an option in the list
            return;
        }
        this.acceptCurrentSuggestion(true);
    };
    /**
     * Handles specific key presses within the Combobox input.
     *
     * @param event Event data object
     * @internal
     */
    ComboboxComponent.prototype.handleKeydown = function (event) {
        switch (event.key) {
            case "Esc" /* Esc */:
            case "Escape" /* Escape */:
                this.clearValueAndCurrentSuggestion();
                break;
            case "ArrowDown" /* ArrowDown */:
                event.preventDefault();
                this.selectNextSuggestion();
                break;
            case "ArrowUp" /* ArrowUp */:
                event.preventDefault();
                this.selectPreviousSuggestion();
                break;
            case "Enter" /* Enter */:
                event.preventDefault();
                this.acceptCurrentSuggestion(true);
                break;
            default:
                break;
        }
    };
    /**
     * Updates the current suggestion based on user input.
     *
     * @param event Event data object
     * @internal
     */
    ComboboxComponent.prototype.handleInput = function (event) {
        var inputValue = this.input.nativeElement.value;
        this.showList = true;
        this.updateMatchingSuggestions(inputValue);
        // If the user didn't enter any new data, they're probably correcting or
        // deleting their input. We shouldn't populate a suggestion until
        // they've finished changing what they've already typed.
        //
        // NOTE: Type-casting to avoid using the `InputEvent` interface
        if (event.data === null) {
            event.preventDefault();
            // If the user completely deleted the value, reset everything
            if (inputValue === '') {
                this.clearValueAndCurrentSuggestion();
            }
        }
        else if (this.hasCurrentSuggestion) {
            this.scrollSelectedOptionIntoView();
        }
    };
    /**
     * Selects the option with the specified index.
     *
     * Note that this method does not take suggestion filtering into account.
     *
     * @param index Index of the option to select
     */
    ComboboxComponent.prototype.selectIndex = function (index) {
        if (index < 0 || index > this._options.length - 1) {
            throw new RangeError('index must be in range of options');
        }
        var option = this._options[index];
        this.writeValue(option.value);
        this.onChange(option.value);
        this.input.nativeElement.value = option.description;
        // The value we just set might be out of range of the current set of
        // suggestions, in which case a subsequent interaction with the Combobox
        // could nullify the value we just set. Updating the suggestions will
        // ensure that the new value is also a suggested value.
        this.updateMatchingSuggestions(option.description);
        // There is a chance that some suggestion's description _contains_ the
        // description for the option we want to select, in which case the above
        // won't set the correct current suggestion index. We'll update it
        // manually to be sure the current suggestion matches the value we set.
        this.currentSuggestionIndex = this.matchingSuggestions.findIndex(function (suggestion) { return suggestion.value === option.value; });
        this.onTouched();
    };
    /**
     * Selects the next option in the list.
     *
     * If no option is currently selected, this will select the first option in
     * the list. If the last option is currently selected, this will not change
     * the selection.
     *
     * Note that this method does not take suggestion filtering into account.
     */
    ComboboxComponent.prototype.selectNext = function () {
        var _this = this;
        if (this.currentSuggestion) {
            var index = this._options.findIndex(function (option) { return option === _this.currentSuggestion; });
            // We're at the end of the list
            if (index === this._options.length - 1) {
                return;
            }
            this.selectIndex(index + 1);
        }
        else {
            this.selectIndex(0);
        }
    };
    /**
     * Selects the previous option in the list.
     *
     * If no option is currently selected, this will select the last option in
     * the list. If the first option is currently selected, this will not change
     * the selection.
     *
     * Note that this method does not take suggestion filtering into account.
     */
    ComboboxComponent.prototype.selectPrevious = function () {
        var _this = this;
        if (this.currentSuggestion) {
            var index = this._options.findIndex(function (option) { return option === _this.currentSuggestion; });
            // We're at the beginning of the list
            if (index === 0) {
                return;
            }
            this.selectIndex(index - 1);
        }
        else {
            this.selectIndex(this._options.length - 1);
        }
    };
    /**
     * Updates the list of matching suggestions to match the given prefix.
     *
     * @param query Prefix to match suggestions against
     * @internal
     */
    ComboboxComponent.prototype.updateMatchingSuggestions = function (query) {
        var normalizedQuery = HDS_COMBOBOX_MATCH_NORMALIZER(query);
        var allMatches = this._options.filter(function (option) {
            return HDS_COMBOBOX_MATCH_NORMALIZER(option.description).includes(normalizedQuery);
        });
        this.numMatches = allMatches.length;
        this.matchingSuggestions = allMatches.slice(0, ComboboxComponent_1.MAX_NUM_MATCHING_SUGGESTIONS);
        // Default to the first matching suggestion
        this.currentSuggestionIndex = this.matchingSuggestions.length > 0 ? 0 : null;
    };
    /**
     * Accepts the current suggestion as the value of the control.
     *
     * @param closeList Whether to close the list after accepting the suggestion
     * @internal
     */
    ComboboxComponent.prototype.acceptCurrentSuggestion = function (closeList) {
        if (closeList === void 0) { closeList = false; }
        if (this.hasCurrentSuggestion) {
            this.writeValue(this.currentSuggestion.value);
            this.onChange(this.currentSuggestion.value);
            this.input.nativeElement.value = this.currentSuggestion.description;
        }
        else {
            this.writeValue(null);
            this.onChange(null);
            this.updateMatchingSuggestions('');
            this.currentSuggestionIndex = null;
        }
        this.onTouched();
        if (closeList) {
            this.showList = false;
        }
        else {
            this.scrollSelectedOptionIntoView();
        }
    };
    /**
     * Clears the current value from the control and resets suggestions.
     *
     * @internal
     */
    ComboboxComponent.prototype.clearValueAndCurrentSuggestion = function () {
        if (this.input) {
            this.input.nativeElement.value = '';
        }
        this.updateMatchingSuggestions('');
        this.currentSuggestionIndex = null;
    };
    /**
     * Selects the specified suggestion as the control value.
     *
     * @param index Index of the suggestion to select from `matchingSuggestions`
     * @internal
     */
    ComboboxComponent.prototype.selectSuggestion = function (index) {
        this.currentSuggestionIndex = index;
        this.acceptCurrentSuggestion(true);
    };
    /**
     * Selects the previous matching suggestion in the list, wrapping to the
     * end of the list if necessary.
     *
     * @internal
     */
    ComboboxComponent.prototype.selectPreviousSuggestion = function () {
        if (!this.matchingSuggestions.length) {
            // There are no suggestions to select
            return;
        }
        if (this.hasCurrentSuggestion && this.currentSuggestionIndex > 0) {
            this.currentSuggestionIndex = this.currentSuggestionIndex - 1;
        }
        else {
            this.currentSuggestionIndex = this.matchingSuggestions.length - 1;
        }
        this.acceptCurrentSuggestion();
    };
    /**
     * Selects the next matching suggestion in the list, wrapping to the
     * beginning of the list if necessary.
     *
     * @internal
     */
    ComboboxComponent.prototype.selectNextSuggestion = function () {
        if (!this.matchingSuggestions.length) {
            // There are no suggestions to select
            return;
        }
        if (this.hasCurrentSuggestion) {
            this.currentSuggestionIndex = (this.currentSuggestionIndex + 1) % this.matchingSuggestions.length;
        }
        else {
            this.currentSuggestionIndex = 0;
        }
        this.acceptCurrentSuggestion();
    };
    /**
     * Attempts to scroll the listbox to the selected suggestion.
     *
     * @internal
     */
    ComboboxComponent.prototype.scrollSelectedOptionIntoView = function () {
        var _this = this;
        // A timeout is required to allow Angular to update the selected element
        setTimeout(function () {
            var listEl = _this.listbox.nativeElement;
            var selectedOptionEl = listEl.querySelector('[aria-selected="true"]');
            var listIsScrollable = listEl.scrollHeight > listEl.clientHeight;
            if (selectedOptionEl && listIsScrollable) {
                var scrollBottom = listEl.clientHeight + listEl.scrollTop;
                var elementBottom = selectedOptionEl.offsetTop + selectedOptionEl.clientHeight;
                if (elementBottom >= scrollBottom) {
                    // The selected element is partially below the bottom edge of the list
                    // Scroll the element into view at the bottom edge of the list
                    listEl.scrollTop = selectedOptionEl.offsetTop - listEl.clientHeight + selectedOptionEl.clientHeight;
                }
                else if (selectedOptionEl.offsetTop < listEl.scrollTop) {
                    // Selected element is partially above the top edge of the list
                    // Scroll the element into view at the top edge of the list
                    listEl.scrollTop = selectedOptionEl.offsetTop;
                }
            }
        }, 0);
    };
    var ComboboxComponent_1;
    /**
     * Tracks the number of instances of the component that have been created.
     * Used to generate IDs for child elements, if an ID was not provided.
     *
     * @internal
     */
    ComboboxComponent.componentCount = 0;
    /**
     * To ensure good performance when the number of suggestions is very high
     * (on the order of 10^4 suggestions), we cap the number of matches that can
     * appear at one time.
     */
    ComboboxComponent.MAX_NUM_MATCHING_SUGGESTIONS = 250;
    ComboboxComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef }
    ]; };
    __decorate([
        HostBinding('class.hl-combobox'),
        __metadata("design:type", Object)
    ], ComboboxComponent.prototype, "baseClass", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], ComboboxComponent.prototype, "inputId", null);
    __decorate([
        Input('aria-labelledby'),
        __metadata("design:type", String)
    ], ComboboxComponent.prototype, "ariaLabelledBy", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ComboboxComponent.prototype, "placeholder", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ComboboxComponent.prototype, "showListOnFocus", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], ComboboxComponent.prototype, "suggestions", null);
    __decorate([
        Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], ComboboxComponent.prototype, "options", null);
    __decorate([
        ViewChild('inputWrapper'),
        __metadata("design:type", InputComponent)
    ], ComboboxComponent.prototype, "inputWrapper", void 0);
    __decorate([
        ViewChild('input', { static: true }),
        __metadata("design:type", ElementRef)
    ], ComboboxComponent.prototype, "input", void 0);
    __decorate([
        ViewChild('listbox'),
        __metadata("design:type", ElementRef)
    ], ComboboxComponent.prototype, "listbox", void 0);
    ComboboxComponent = ComboboxComponent_1 = __decorate([ __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef])
    ], ComboboxComponent);
ComboboxComponent.ɵfac = function ComboboxComponent_Factory(t) { return new (t || ComboboxComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ComboboxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ComboboxComponent, selectors: [["hl-combobox"]], viewQuery: function ComboboxComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c20, 5);
        ɵngcc0.ɵɵviewQuery(_c16, 7);
        ɵngcc0.ɵɵviewQuery(_c21, 5);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputWrapper = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.listbox = _t.first);
    } }, hostVars: 2, hostBindings: function ComboboxComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hl-combobox", ctx.baseClass);
    } }, inputs: { inputId: "inputId", suggestions: "suggestions", options: "options", ariaLabelledBy: ["aria-labelledby", "ariaLabelledBy"], placeholder: "placeholder", showListOnFocus: "showListOnFocus" }, exportAs: ["hlCombobox"], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(function () { return ComboboxComponent_1; }),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 10, vars: 14, consts: [["role", "combobox", "aria-expanded", "false", "aria-haspopup", "listbox"], ["inputWrapper", ""], ["type", "text", "autocomplete", "off", "aria-autocomplete", "both", 3, "id", "placeholder", "focus", "blur", "input", "keydown"], ["input", ""], [1, "hl-combobox__list", 3, "hidden"], ["aria-hidden", "true", 1, "hl-combobox__match-summary", 3, "id"], ["role", "listbox", "tabindex", "-1", 3, "id"], ["listbox", ""], [4, "ngFor", "ngForOf"], ["role", "option", 3, "id", "click"]], template: function ComboboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "hl-input", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "input", 2, 3);
        ɵngcc0.ɵɵlistener("focus", function ComboboxComponent_Template_input_focus_2_listener() { return ctx.handleFocus(); })("blur", function ComboboxComponent_Template_input_blur_2_listener($event) { return ctx.handleBlur($event); })("input", function ComboboxComponent_Template_input_input_2_listener($event) { return ctx.handleInput($event); })("keydown", function ComboboxComponent_Template_input_keydown_2_listener($event) { return ctx.handleKeydown($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "ul", 6, 7);
        ɵngcc0.ɵɵtemplate(9, ComboboxComponent_ng_container_9_Template, 3, 3, "ng-container", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-owns", ctx.listboxId);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("id", ctx.inputId)("placeholder", ctx.placeholder || "");
        ɵngcc0.ɵɵattribute("aria-labelledby", ctx.ariaLabelledBy || null)("aria-controls", ctx.listboxId)("aria-activedescendant", ctx.currentSuggestionOptionId)("disabled", ctx.disabled ? "" : null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !ctx.showList);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", ctx.matchSummaryId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.matchMessage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", ctx.listboxId);
        ɵngcc0.ɵɵattribute("aria-labelledby", ctx.ariaLabelledBy || null)("aria-describedby", ctx.matchSummaryId);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.matchingSuggestions);
    } }, directives: [InputComponent, HDSFormControlDirective, ProjectedInputDirective, ɵngcc1.NgForOf], styles: [".hl-combobox{display:block;position:relative}.hl-combobox__list{z-index:10;box-shadow:0 2px 4px rgba(0,0,0,.12);position:absolute;left:0;top:100%;width:100%;border:.125rem solid var(--hds-listbox-border,#79797c);border-radius:.25rem;background-color:var(--hds-listbox-background,#fff);color:var(--hds-listbox-text,#000)}.hl-combobox__match-summary{padding:.25rem 1rem;border-bottom:thin solid var(--hds-listbox-border,rgba(121,121,124,.25));color:var(--hds-listbox-detail,#606062);font-size:.8em}.hl-combobox ul{max-height:22rem;margin:0;padding:.5rem 0 0;overflow-y:auto;scroll-behavior:auto;list-style-type:none}.hl-combobox ul:empty{visibility:hidden}.hl-combobox li{display:flex;justify-content:space-between;padding:.75rem 1rem;line-height:1.5;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.hl-combobox li:last-child{margin-bottom:.5rem}.hl-combobox li:hover{background-color:var(--hds-listbox-background-hover,var(--hds-listbox-background,#ebfaff));color:var(--hds-listbox-text-hover,var(--hds-listbox-text,#000))}.hl-combobox li[aria-selected=true]{background-color:var(--hds-listbox-background-selected,var(--hds-listbox-background,#ebfaff));color:var(--hds-listbox-text-selected,var(--hds-listbox-text,#000));font-weight:700}.hl-combobox.hl-form-control--disabled{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ComboboxComponent, [{
        type: Component,
        args: [{
                selector: 'hl-combobox',
                exportAs: 'hlCombobox',
                template: "<hl-input #inputWrapper role=\"combobox\" aria-expanded=\"false\" aria-haspopup=\"listbox\" [attr.aria-owns]=\"listboxId\">\n    <input\n        #input\n        type=\"text\"\n        autocomplete=\"off\"\n        [id]=\"inputId\"\n        [placeholder]=\"placeholder || ''\"\n        aria-autocomplete=\"both\"\n        [attr.aria-labelledby]=\"ariaLabelledBy || null\"\n        [attr.aria-controls]=\"listboxId\"\n        [attr.aria-activedescendant]=\"currentSuggestionOptionId\"\n        [attr.disabled]=\"disabled ? '' : null\"\n        (focus)=\"handleFocus()\"\n        (blur)=\"handleBlur($event)\"\n        (input)=\"handleInput($event)\"\n        (keydown)=\"handleKeydown($event)\"\n    />\n</hl-input>\n\n<div class=\"hl-combobox__list\" [hidden]=\"!showList\">\n    <div [id]=\"matchSummaryId\" class=\"hl-combobox__match-summary\" aria-hidden=\"true\">{{ matchMessage }}</div>\n\n    <ul\n        #listbox\n        role=\"listbox\"\n        tabindex=\"-1\"\n        [id]=\"listboxId\"\n        [attr.aria-labelledby]=\"ariaLabelledBy || null\"\n        [attr.aria-describedby]=\"matchSummaryId\"\n    >\n        <ng-container *ngFor=\"let suggestion of matchingSuggestions; let i = index\">\n            <li\n                role=\"option\"\n                [id]=\"getOptionId(i)\"\n                [attr.aria-selected]=\"i === currentSuggestionIndex\"\n                (click)=\"selectSuggestion(i)\"\n            >\n                {{ suggestion.description }}\n            </li>\n        </ng-container>\n    </ul>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(function () { return ComboboxComponent_1; }),
                        multi: true
                    }
                ],
                styles: [".hl-combobox{display:block;position:relative}.hl-combobox__list{z-index:10;box-shadow:0 2px 4px rgba(0,0,0,.12);position:absolute;left:0;top:100%;width:100%;border:.125rem solid var(--hds-listbox-border,#79797c);border-radius:.25rem;background-color:var(--hds-listbox-background,#fff);color:var(--hds-listbox-text,#000)}.hl-combobox__match-summary{padding:.25rem 1rem;border-bottom:thin solid var(--hds-listbox-border,rgba(121,121,124,.25));color:var(--hds-listbox-detail,#606062);font-size:.8em}.hl-combobox ul{max-height:22rem;margin:0;padding:.5rem 0 0;overflow-y:auto;scroll-behavior:auto;list-style-type:none}.hl-combobox ul:empty{visibility:hidden}.hl-combobox li{display:flex;justify-content:space-between;padding:.75rem 1rem;line-height:1.5;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.hl-combobox li:last-child{margin-bottom:.5rem}.hl-combobox li:hover{background-color:var(--hds-listbox-background-hover,var(--hds-listbox-background,#ebfaff));color:var(--hds-listbox-text-hover,var(--hds-listbox-text,#000))}.hl-combobox li[aria-selected=true]{background-color:var(--hds-listbox-background-selected,var(--hds-listbox-background,#ebfaff));color:var(--hds-listbox-text-selected,var(--hds-listbox-text,#000));font-weight:700}.hl-combobox.hl-form-control--disabled{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }]; }, { inputId: [{
            type: Input
        }], suggestions: [{
            type: Input
        }], options: [{
            type: Input
        }], baseClass: [{
            type: HostBinding,
            args: ['class.hl-combobox']
        }], ariaLabelledBy: [{
            type: Input,
            args: ['aria-labelledby']
        }], placeholder: [{
            type: Input
        }], showListOnFocus: [{
            type: Input
        }], inputWrapper: [{
            type: ViewChild,
            args: ['inputWrapper']
        }], input: [{
            type: ViewChild,
            args: ['input', { static: true }]
        }], listbox: [{
            type: ViewChild,
            args: ['listbox']
        }] }); })();
    return ComboboxComponent;
}(CustomFormControl));

var ComboboxModule = /** @class */ (function () {
    function ComboboxModule() {
    }
ComboboxModule.ɵfac = function ComboboxModule_Factory(t) { return new (t || ComboboxModule)(); };
ComboboxModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ComboboxModule });
ComboboxModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, FormControlsCommonModule, IconModule, InputModule], FormControlsCommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ComboboxModule, [{
        type: NgModule,
        args: [{
                declarations: [ComboboxComponent],
                imports: [CommonModule, FormControlsCommonModule, IconModule, InputModule],
                exports: [ComboboxComponent, FormControlsCommonModule]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ComboboxModule, { declarations: function () { return [ComboboxComponent]; }, imports: function () { return [CommonModule, FormControlsCommonModule, IconModule, InputModule]; }, exports: function () { return [ComboboxComponent, FormControlsCommonModule]; } }); })();
    return ComboboxModule;
}());

/**
 * Displays a set of options that the user can select from.
 */
var ListboxComponent = /** @class */ (function () {
    function ListboxComponent(cdRef) {
        this.cdRef = cdRef;
        /**
         * ID for the component. This is used to generate IDs for child elements.
         */
        this.id = "hds-listbox-" + ListboxComponent_1.componentCount++;
        /**
         * List of options for the user to select from.
         */
        this.options = [];
        /**
         * Whether the listbox is directly focusable by the user. Set this to
         * `false` if focus will not shift to the listbox (e.g., in the Combobox,
         * where focus remains on the `<input>`.)
         */
        this.focusable = true;
        /**
         * @ignore
         */
        this._maxOptionsVisible = 250;
        /**
         * @ignore
         */
        this._wrap = false;
        /**
         * @ignore
         */
        this._showSelectionIcon = false;
        /**
         * Emits when the list element loses focus.
         */
        this.listBlur = new EventEmitter();
        /**
         * When the listbox options are filtered, this emits the list of options
         * that match the filter.
         */
        this.filter = new EventEmitter();
        /**
         * When the selected option changes, this emits the selected option.
         */
        this.selectionChange = new EventEmitter();
        /**
         * The list of options that match the current filter.
         */
        this.filteredOptions = [];
    }
    ListboxComponent_1 = ListboxComponent;
    Object.defineProperty(ListboxComponent.prototype, "ariaDescribedBy", {
        /**
         * @ignore
         */
        get: function () {
            var noMatchId = this.id + "-no-matches";
            var numMatchesId = this.id + "-num-matches";
            return [noMatchId, numMatchesId].join(' ');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListboxComponent.prototype, "maxOptionsVisible", {
        get: function () {
            return this._maxOptionsVisible;
        },
        /**
         * The maximum number of options to display before truncating. By default,
         * no more than 250 options will display at a time.
         *
         * For the sake of performance, keep this number as low as possible. We
         * strongly encourage not setting it above 250 unless absolutely necessary.
         */
        set: function (value) {
            this._maxOptionsVisible = value || 250;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListboxComponent.prototype, "wrap", {
        /**
         * Whether the selected option can wrap to the beginning of the list if it
         * advances past the end, or vice versa.
         */
        get: function () {
            return this._wrap;
        },
        /**
         * @ignore
         */
        set: function (value) {
            this._wrap = value === '' || value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListboxComponent.prototype, "showSelectionIcon", {
        /**
         * Whether the selected option should display an icon.
         */
        get: function () {
            return this._showSelectionIcon;
        },
        /**
         * @ignore
         */
        set: function (value) {
            this._showSelectionIcon = value === '' || value;
        },
        enumerable: true,
        configurable: true
    });
    ListboxComponent.prototype.ngOnInit = function () {
        if (!this.ariaLabelledBy) {
            throw new AccessibilityError("<hds-listbox id=\"" + this.id + "\"> must have a labeling element specified by \"aria-labelledby\"");
        }
        this.filteredOptions = this.getFilteredOptions();
        this.filter.emit(this.filteredOptions);
    };
    ListboxComponent.prototype.ngOnChanges = function (changes) {
        if (changes.options || changes.maxOptionsVisible) {
            this.clear();
            this.filterOptions('');
        }
    };
    /**
     * Constructs an ID for the listbox option at the specified index.
     * @param index Index of the option whose ID to return
     * @returns ID of the option at the specified index
     */
    ListboxComponent.prototype.getOptionId = function (index) {
        return typeof index === 'number' ? this.id + "-option-" + index : null;
    };
    /**
     * Focuses the list element of the listbox.
     */
    ListboxComponent.prototype.focus = function () {
        if (this.focusable) {
            this.list.nativeElement.focus();
            this.scrollSelectedOptionIntoView();
        }
    };
    /**
     * Filters the options to those that match the given query.
     * @param query A query string
     */
    ListboxComponent.prototype.filterOptions = function (query) {
        this.filteredOptions = this.getFilteredOptions(query);
        this.filter.emit(this.filteredOptions);
        if (this.filteredOptions.length === 0 || this.filteredOptions.length === this.options.length) {
            this.clear();
        }
        else {
            this.selectFirst();
        }
        this.cdRef.markForCheck();
    };
    /**
     * Returns the list of options that match the given query. Restricts the
     * resulting number of options based on the value of `maxOptions`.
     * @param query A query string
     * @returns The list of options that match the given query
     */
    ListboxComponent.prototype.getFilteredOptions = function (query) {
        var normalizedQuery = query ? query.toLowerCase() : '';
        var matchingOptions = this.options.filter(function (option) {
            var normalizedOption = option.description.toLowerCase();
            // First match against the option text as-is
            if (normalizedOption.includes(normalizedQuery)) {
                return true;
            }
            // If there isn't a direct match, try stripping out any
            // special characters the user may not have typed
            return normalizedOption.replace(/[$,.]/g, '').includes(normalizedQuery);
        });
        this.numMatchingOptions = matchingOptions.length;
        return matchingOptions.slice(0, this.maxOptionsVisible);
    };
    /**
     * Handles a `keydown` event fired from the listbox.
     * TODO: Handle typeahead (https://www.w3.org/TR/wai-aria-practices-1.1/#listbox_kbd_interaction)
     *
     * @param event Event object for a `keydown` action
     * @internal
     */
    ListboxComponent.prototype.handleKeydown = function (event) {
        switch (event.key) {
            case "ArrowDown" /* ArrowDown */:
                event.preventDefault();
                this.selectNext();
                break;
            case "ArrowUp" /* ArrowUp */:
                event.preventDefault();
                this.selectPrevious();
                break;
            case "Home" /* Home */:
                event.preventDefault();
                this.selectFirst();
                break;
            case "End" /* End */:
                event.preventDefault();
                this.selectLast();
                break;
        }
    };
    /**
     * Selects the first visible option in the listbox.
     */
    ListboxComponent.prototype.selectFirst = function () {
        this.selectIndex(0);
    };
    /**
     * Selects the last visible option in the listbox.
     */
    ListboxComponent.prototype.selectLast = function () {
        this.selectIndex(this.filteredOptions.length - 1);
    };
    /**
     * Selects the option just before the currently selected option in the listbox.
     * If the selected option is first in the listbox and wrapping is enabled,
     * the last option will be selected.
     */
    ListboxComponent.prototype.selectPrevious = function () {
        if (typeof this.selectedIndex !== 'number' || (this.wrap && this.selectedIndex === 0)) {
            this.selectLast();
            return;
        }
        this.selectIndex(Math.max(this.selectedIndex - 1, 0));
    };
    /**
     * Selects the option just after the currently selected option in the listbox.
     * If the selected option is last in the listbox and wrapping is enabled,
     * the first option will be selected.
     */
    ListboxComponent.prototype.selectNext = function () {
        if (typeof this.selectedIndex !== 'number' ||
            (this.wrap && this.selectedIndex === this.filteredOptions.length - 1)) {
            this.selectFirst();
            return;
        }
        this.selectIndex(Math.min(this.selectedIndex + 1, this.filteredOptions.length - 1));
    };
    /**
     * Selects the option visible at the specified index.
     * @param index Index of the option to select
     */
    ListboxComponent.prototype.selectIndex = function (index) {
        this.selectedIndex = index;
        var selectedOption = this.filteredOptions[this.selectedIndex];
        if (selectedOption) {
            this.selectionChange.emit(selectedOption);
            this.scrollSelectedOptionIntoView();
        }
        else {
            this.clear();
        }
    };
    /**
     * Selects the given option.
     * @param option Option to select
     */
    ListboxComponent.prototype.selectOption = function (option) {
        var index = this.options.findIndex(function (opt) { return opt.value === option.value; });
        if (index !== -1) {
            this.selectedIndex = index;
            this.selectionChange.emit(option);
        }
        else {
            this.clear();
        }
    };
    /**
     * Clears the current selection.
     */
    ListboxComponent.prototype.clear = function () {
        this.selectedIndex = null;
        this.selectionChange.emit(null);
    };
    /**
     * Scrolls the selected option into view within the listbox.
     */
    ListboxComponent.prototype.scrollSelectedOptionIntoView = function () {
        if (!this.list) {
            return;
        }
        var list = this.list.nativeElement;
        var selectedOption = list.querySelector("#" + this.getOptionId(this.selectedIndex));
        if (!selectedOption) {
            return;
        }
        selectedOption.scrollIntoView({ block: 'nearest' });
    };
    var ListboxComponent_1;
    /**
     * @ignore
     */
    ListboxComponent.componentCount = 0;
    ListboxComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ListboxComponent.prototype, "id", void 0);
    __decorate([
        Input('aria-labelledby'),
        __metadata("design:type", String)
    ], ListboxComponent.prototype, "ariaLabelledBy", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], ListboxComponent.prototype, "options", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], ListboxComponent.prototype, "focusable", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], ListboxComponent.prototype, "maxOptionsVisible", null);
    __decorate([
        Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], ListboxComponent.prototype, "wrap", null);
    __decorate([
        Input(),
        HostBinding('class.hds-listbox--with-selection-icon'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], ListboxComponent.prototype, "showSelectionIcon", null);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], ListboxComponent.prototype, "listBlur", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], ListboxComponent.prototype, "filter", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], ListboxComponent.prototype, "selectionChange", void 0);
    __decorate([
        ViewChild('list', { read: ElementRef }),
        __metadata("design:type", ElementRef)
    ], ListboxComponent.prototype, "list", void 0);
    ListboxComponent = ListboxComponent_1 = __decorate([ __metadata("design:paramtypes", [ChangeDetectorRef])
    ], ListboxComponent);
ListboxComponent.ɵfac = function ListboxComponent_Factory(t) { return new (t || ListboxComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
ListboxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ListboxComponent, selectors: [["hds-listbox"]], viewQuery: function ListboxComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c22, 5, ElementRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.list = _t.first);
    } }, hostVars: 2, hostBindings: function ListboxComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hds-listbox--with-selection-icon", ctx.showSelectionIcon);
    } }, inputs: { id: "id", options: "options", focusable: "focusable", maxOptionsVisible: "maxOptionsVisible", wrap: "wrap", showSelectionIcon: "showSelectionIcon", ariaLabelledBy: ["aria-labelledby", "ariaLabelledBy"] }, outputs: { listBlur: "listBlur", filter: "filter", selectionChange: "selectionChange" }, exportAs: ["hdsListbox"], features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 7, vars: 12, consts: [["aria-hidden", "true", 1, "hds-listbox__details", "hds-listbox__details--border"], [4, "ngIf"], ["aria-hidden", "true", 1, "hds-listbox__details"], ["role", "listbox", 3, "blur", "keydown"], ["list", ""], [4, "ngFor", "ngForOf"], ["role", "option", 3, "click"], ["class", "hds-listbox__selection-icon", "icon", "confirm", 4, "ngIf"], ["icon", "confirm", 1, "hds-listbox__selection-icon"]], template: function ListboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, ListboxComponent_span_1_Template, 4, 6, "span", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, ListboxComponent_span_3_Template, 2, 0, "span", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "ul", 3, 4);
        ɵngcc0.ɵɵlistener("blur", function ListboxComponent_Template_ul_blur_4_listener() { return ctx.listBlur.emit(); })("keydown", function ListboxComponent_Template_ul_keydown_4_listener($event) { return ctx.handleKeydown($event); });
        ɵngcc0.ɵɵtemplate(6, ListboxComponent_ng_container_6_Template, 5, 4, "ng-container", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("id", ctx.id + "-num-matches");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.numMatchingOptions > ctx.maxOptionsVisible);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("id", ctx.id + "-no-matches");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.numMatchingOptions === 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("hl-a11y--visually-hidden", ctx.numMatchingOptions === 0);
        ɵngcc0.ɵɵattribute("id", ctx.id + "-list")("tabindex", ctx.focusable ? 0 : -1)("aria-labelledby", ctx.ariaLabelledBy)("aria-describedby", ctx.ariaDescribedBy)("aria-activedescendant", ctx.focusable ? ctx.getOptionId(ctx.selectedIndex) : null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.filteredOptions);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, IconComponent], pipes: [ɵngcc1.DecimalPipe], styles: ["[_nghost-%COMP%]{--margin-inline:1rem;display:block;border:.125rem solid var(--hds-listbox-border,#79797c);border-radius:.25rem;background-color:var(--hds-listbox-background,#fff);color:var(--hds-listbox-text,#000)}[hidden][_nghost-%COMP%]{display:none}[role=listbox][_ngcontent-%COMP%]{max-height:22rem;margin:0;padding:0;-webkit-padding-before:.25rem;padding-block-start:.25rem;overflow-y:auto;scroll-behavior:auto;list-style-type:none}[role=option][_ngcontent-%COMP%]{padding:.75rem var(--margin-inline);line-height:1.5;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}[role=option][_ngcontent-%COMP%]:last-child{-webkit-margin-after:.25rem;margin-block-end:.25rem}[role=option][_ngcontent-%COMP%]:hover{background-color:var(--hds-listbox-background-hover,var(--hds-listbox-background,#ebfaff));color:var(--hds-listbox-text-hover,var(--hds-listbox-text,#000))}[role=option][aria-selected=true][_ngcontent-%COMP%]{background-color:var(--hds-listbox-background-selected,var(--hds-listbox-background,#ebfaff));color:var(--hds-listbox-text-selected,var(--hds-listbox-text,#000));font-weight:700}.hds-listbox__details[_ngcontent-%COMP%]{margin-top:0;margin-bottom:0;font-size:.875rem;line-height:1.42857;letter-spacing:0;padding:.25rem var(--margin-inline);color:var(--hds-listbox-detail,#606062)}.hds-listbox__details--border[_ngcontent-%COMP%]{-webkit-border-after:thin solid var(--hds-listbox-border,rgba(121,121,124,.25));border-block-end:thin solid var(--hds-listbox-border,rgba(121,121,124,.25))}.hds-listbox__details[_ngcontent-%COMP%]:empty{display:none}.hds-listbox--with-selection-icon[_nghost-%COMP%]{--margin-inline:2rem}.hds-listbox--with-selection-icon[_nghost-%COMP%]   [role=option][_ngcontent-%COMP%]{position:relative}.hds-listbox--with-selection-icon[_nghost-%COMP%]   [role=option][_ngcontent-%COMP%]   .hds-listbox__selection-icon[_ngcontent-%COMP%]{position:absolute;left:.25rem;color:var(--hds-listbox-selection-icon,var(--hds-listbox-text-selected,var(--hds-listbox-text,#137d9a)))}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ListboxComponent, [{
        type: Component,
        args: [{
                selector: 'hds-listbox',
                exportAs: 'hdsListbox',
                template: "<div [attr.id]=\"id + '-num-matches'\" class=\"hds-listbox__details hds-listbox__details--border\" aria-hidden=\"true\">\n    <span *ngIf=\"numMatchingOptions > maxOptionsVisible\"\n        >Showing {{ maxOptionsVisible | number }} of {{ numMatchingOptions | number }} options</span\n    >\n</div>\n\n<div [attr.id]=\"id + '-no-matches'\" class=\"hds-listbox__details\" aria-hidden=\"true\">\n    <span *ngIf=\"numMatchingOptions === 0\">No matching options</span>\n</div>\n\n<ul\n    #list\n    role=\"listbox\"\n    [class.hl-a11y--visually-hidden]=\"numMatchingOptions === 0\"\n    [attr.id]=\"id + '-list'\"\n    [attr.tabindex]=\"focusable ? 0 : -1\"\n    [attr.aria-labelledby]=\"ariaLabelledBy\"\n    [attr.aria-describedby]=\"ariaDescribedBy\"\n    [attr.aria-activedescendant]=\"focusable ? getOptionId(selectedIndex) : null\"\n    (blur)=\"listBlur.emit()\"\n    (keydown)=\"handleKeydown($event)\"\n>\n    <ng-container *ngFor=\"let option of filteredOptions; let i = index\">\n        <li\n            role=\"option\"\n            [attr.id]=\"getOptionId(i)\"\n            [attr.aria-selected]=\"i === selectedIndex\"\n            (click)=\"selectIndex(i)\"\n        >\n            <hl-icon\n                *ngIf=\"showSelectionIcon && i === selectedIndex\"\n                class=\"hds-listbox__selection-icon\"\n                icon=\"confirm\"\n            ></hl-icon>\n            <span>{{ option.description }}</span>\n        </li>\n    </ng-container>\n</ul>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{--margin-inline:1rem;display:block;border:.125rem solid var(--hds-listbox-border,#79797c);border-radius:.25rem;background-color:var(--hds-listbox-background,#fff);color:var(--hds-listbox-text,#000)}:host([hidden]){display:none}[role=listbox]{max-height:22rem;margin:0;padding:0;-webkit-padding-before:.25rem;padding-block-start:.25rem;overflow-y:auto;scroll-behavior:auto;list-style-type:none}[role=option]{padding:.75rem var(--margin-inline);line-height:1.5;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}[role=option]:last-child{-webkit-margin-after:.25rem;margin-block-end:.25rem}[role=option]:hover{background-color:var(--hds-listbox-background-hover,var(--hds-listbox-background,#ebfaff));color:var(--hds-listbox-text-hover,var(--hds-listbox-text,#000))}[role=option][aria-selected=true]{background-color:var(--hds-listbox-background-selected,var(--hds-listbox-background,#ebfaff));color:var(--hds-listbox-text-selected,var(--hds-listbox-text,#000));font-weight:700}.hds-listbox__details{margin-top:0;margin-bottom:0;font-size:.875rem;line-height:1.42857;letter-spacing:0;padding:.25rem var(--margin-inline);color:var(--hds-listbox-detail,#606062)}.hds-listbox__details--border{-webkit-border-after:thin solid var(--hds-listbox-border,rgba(121,121,124,.25));border-block-end:thin solid var(--hds-listbox-border,rgba(121,121,124,.25))}.hds-listbox__details:empty{display:none}:host(.hds-listbox--with-selection-icon){--margin-inline:2rem}:host(.hds-listbox--with-selection-icon) [role=option]{position:relative}:host(.hds-listbox--with-selection-icon) [role=option] .hds-listbox__selection-icon{position:absolute;left:.25rem;color:var(--hds-listbox-selection-icon,var(--hds-listbox-text-selected,var(--hds-listbox-text,#137d9a)))}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { id: [{
            type: Input
        }], options: [{
            type: Input
        }], focusable: [{
            type: Input
        }], listBlur: [{
            type: Output
        }], filter: [{
            type: Output
        }], selectionChange: [{
            type: Output
        }], maxOptionsVisible: [{
            type: Input
        }], wrap: [{
            type: Input
        }], showSelectionIcon: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.hds-listbox--with-selection-icon']
        }], ariaLabelledBy: [{
            type: Input,
            args: ['aria-labelledby']
        }], list: [{
            type: ViewChild,
            args: ['list', { read: ElementRef }]
        }] }); })();
    return ListboxComponent;
}());

var ListboxModule = /** @class */ (function () {
    function ListboxModule() {
    }
ListboxModule.ɵfac = function ListboxModule_Factory(t) { return new (t || ListboxModule)(); };
ListboxModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ListboxModule });
ListboxModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, IconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ListboxModule, [{
        type: NgModule,
        args: [{
                declarations: [ListboxComponent],
                imports: [CommonModule, IconModule],
                exports: [ListboxComponent]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ListboxModule, { declarations: function () { return [ListboxComponent]; }, imports: function () { return [CommonModule, IconModule]; }, exports: function () { return [ListboxComponent]; } }); })();
    return ListboxModule;
}());

/**
 * A dropdown list of options for the user to choose from, implemented using
 * a native `<select>` element.
 */
var DropdownSelectComponent = /** @class */ (function () {
    function DropdownSelectComponent() {
        /**
         * @ignore
         */
        this.baseClass = true;
        /**
         * Text to show in the dropdown box when no value is selected.
         * @TODO This doesn't appear in the select box, only in the options list
         */
        this.placeholder = 'Select an option';
        /**
         * Whether the control value is invalid.
         */
        this.invalid = false;
    }
    __decorate([
        HostBinding('class.hl-dropdown-select'),
        __metadata("design:type", Object)
    ], DropdownSelectComponent.prototype, "baseClass", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], DropdownSelectComponent.prototype, "placeholder", void 0);
    __decorate([
        Input(), HostBinding('class.hl-form-control--invalid'),
        __metadata("design:type", Object)
    ], DropdownSelectComponent.prototype, "invalid", void 0);
DropdownSelectComponent.ɵfac = function DropdownSelectComponent_Factory(t) { return new (t || DropdownSelectComponent)(); };
DropdownSelectComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DropdownSelectComponent, selectors: [["select", "hlDropdown", ""]], hostVars: 4, hostBindings: function DropdownSelectComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hl-dropdown-select", ctx.baseClass)("hl-form-control--invalid", ctx.invalid);
    } }, inputs: { placeholder: "placeholder", invalid: "invalid" }, attrs: _c23, ngContentSelectors: _c25, decls: 3, vars: 1, consts: [["value", "", "disabled", "", "selected", ""]], template: function DropdownSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c24);
        ɵngcc0.ɵɵelementStart(0, "option", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(2);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.placeholder);
    } }, styles: [".hl-dropdown-select{--text-color:var(--hds-theme-base-text, #000);--placeholder-color:var(--hds-input-placeholder, rgba(0, 0, 0, 0.45));--bg:var(--hds-input-background, #fff);--border:var(--hds-input-border, currentColor);--border-focus:var(--hds-theme-accent-primary, #189ec3);--bg-error:var(--hds-input-background-error, #ffe5e5);--border-error:var(--hds-input-border-error, #e91d00);--border-focus-shadow-error:var(--hds-input-focus-shadow-error, rgba(233, 29, 0, 0.75));display:block;font-size:1em;font-family:inherit;line-height:1;height:3rem;width:100%;max-width:100%;margin:0;padding:0 2rem 0 .75rem;border:.125rem solid var(--border);border-radius:.25rem;overflow:hidden;text-overflow:ellipsis;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--bg);color:var(--text-color);background-image:url('data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath fill=\"%234d4d4d\" d=\"M48 52l19-19.5 6.5 6.5L48 64.5 22.5 39l6.5-6.5z\"/%3E%3C/svg%3E'),linear-gradient(to bottom,var(--bg) 0,var(--bg) 100%);background-repeat:no-repeat,repeat;background-position:right 1rem top 50%,0 0;background-size:1rem auto,100%}.hl-dropdown-select:focus{outline:0;border-color:var(--border-focus);box-shadow:0 0 8px rgba(0,0,0,.36)}.hl-dropdown-select:focus::-moz-focus-inner{border-style:none;padding:0}.hl-dropdown-select:focus:-moz-focusring{outline:0}.hl-dropdown-select option[value='']{color:var(--placeholder-color)}.hl-dropdown-select::-ms-expand{display:none}.hl-dropdown-select:disabled{background-image:url('data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath fill=\"%234d4d4d\" d=\"M48 52l19-19.5 6.5 6.5L48 64.5 22.5 39l6.5-6.5z\"/%3E%3C/svg%3E'),linear-gradient(to bottom,#f5f5f5 0,#f5f5f5 100%);border-color:#c4c4c4;color:#8d8d8d;cursor:not-allowed}.hl-dropdown-select.ng-dirty.ng-invalid,.hl-dropdown-select.ng-touched.ng-invalid{background-image:url('data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath fill=\"%234d4d4d\" d=\"M48 52l19-19.5 6.5 6.5L48 64.5 22.5 39l6.5-6.5z\"/%3E%3C/svg%3E'),linear-gradient(to bottom,var(--bg-error) 0,var(--bg-error) 100%);border-color:var(--border-error)}.hl-dropdown-select.ng-dirty.ng-invalid:focus,.hl-dropdown-select.ng-touched.ng-invalid:focus{box-shadow:0 0 8px var(--border-focus-shadow-error)}"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownSelectComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line
                selector: 'select[hlDropdown]',
                template: "\n        <option value=\"\" disabled selected>{{ placeholder }}</option>\n        <ng-content select=\"option\"></ng-content>\n    ",
                encapsulation: ViewEncapsulation.None,
                styles: [".hl-dropdown-select{--text-color:var(--hds-theme-base-text, #000);--placeholder-color:var(--hds-input-placeholder, rgba(0, 0, 0, 0.45));--bg:var(--hds-input-background, #fff);--border:var(--hds-input-border, currentColor);--border-focus:var(--hds-theme-accent-primary, #189ec3);--bg-error:var(--hds-input-background-error, #ffe5e5);--border-error:var(--hds-input-border-error, #e91d00);--border-focus-shadow-error:var(--hds-input-focus-shadow-error, rgba(233, 29, 0, 0.75));display:block;font-size:1em;font-family:inherit;line-height:1;height:3rem;width:100%;max-width:100%;margin:0;padding:0 2rem 0 .75rem;border:.125rem solid var(--border);border-radius:.25rem;overflow:hidden;text-overflow:ellipsis;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--bg);color:var(--text-color);background-image:url('data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath fill=\"%234d4d4d\" d=\"M48 52l19-19.5 6.5 6.5L48 64.5 22.5 39l6.5-6.5z\"/%3E%3C/svg%3E'),linear-gradient(to bottom,var(--bg) 0,var(--bg) 100%);background-repeat:no-repeat,repeat;background-position:right 1rem top 50%,0 0;background-size:1rem auto,100%}.hl-dropdown-select:focus{outline:0;border-color:var(--border-focus);box-shadow:0 0 8px rgba(0,0,0,.36)}.hl-dropdown-select:focus::-moz-focus-inner{border-style:none;padding:0}.hl-dropdown-select:focus:-moz-focusring{outline:0}.hl-dropdown-select option[value='']{color:var(--placeholder-color)}.hl-dropdown-select::-ms-expand{display:none}.hl-dropdown-select:disabled{background-image:url('data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath fill=\"%234d4d4d\" d=\"M48 52l19-19.5 6.5 6.5L48 64.5 22.5 39l6.5-6.5z\"/%3E%3C/svg%3E'),linear-gradient(to bottom,#f5f5f5 0,#f5f5f5 100%);border-color:#c4c4c4;color:#8d8d8d;cursor:not-allowed}.hl-dropdown-select.ng-dirty.ng-invalid,.hl-dropdown-select.ng-touched.ng-invalid{background-image:url('data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Cpath fill=\"%234d4d4d\" d=\"M48 52l19-19.5 6.5 6.5L48 64.5 22.5 39l6.5-6.5z\"/%3E%3C/svg%3E'),linear-gradient(to bottom,var(--bg-error) 0,var(--bg-error) 100%);border-color:var(--border-error)}.hl-dropdown-select.ng-dirty.ng-invalid:focus,.hl-dropdown-select.ng-touched.ng-invalid:focus{box-shadow:0 0 8px var(--border-focus-shadow-error)}"]
            }]
    }], function () { return []; }, { baseClass: [{
            type: HostBinding,
            args: ['class.hl-dropdown-select']
        }], placeholder: [{
            type: Input
        }], invalid: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.hl-form-control--invalid']
        }] }); })();
    return DropdownSelectComponent;
}());

/**
 * Delays the invocation of the given function until a certain amount of time
 * has elapsed since the function was last called.
 *
 * Credit: Jakub Chodorowicz
 * https://github.com/chodorowicz/ts-debounce
 *
 * @param func Function to invoke after the wait time has elapsed
 * @param waitMilliseconds Wait time, in milliseconds
 * @param immediate func will be invoked immediately if this is set to `true`
 */
function debounce(func, waitMilliseconds, immediate) {
    if (waitMilliseconds === void 0) { waitMilliseconds = 100; }
    if (immediate === void 0) { immediate = false; }
    var timeoutId;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var context = this;
        var doLater = function () {
            timeoutId = undefined;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        var shouldCallNow = immediate && timeoutId === undefined;
        if (timeoutId !== undefined) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(doLater, waitMilliseconds);
        if (shouldCallNow) {
            func.apply(context, args);
        }
    };
}

/**
 * A dropdown list of options for the user to choose from, with fully customized
 * markup and styling.
 */
var DropdownComponent = /** @class */ (function (_super) {
    __extends(DropdownComponent, _super);
    function DropdownComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Default ID for the component, in case one was not provided.
         *
         * @internal
         */
        _this._id = "hl-dropdown-" + DropdownComponent_1.componentCount++;
        /**
         * @ignore
         */
        _this.externalId = null;
        /**
         * @ignore
         */
        _this.baseClass = true;
        /**
         * Text to show in the dropdown box when no value is selected.
         */
        _this.placeholder = 'Select an option';
        /**
         * An array of options to display in the dropdown list.
         */
        _this.options = [];
        /**
         * Whether the list is visible to the user.
         *
         * @internal
         */
        _this.isListVisible = false;
        /**
         * A text query used to update the selected option when the user types
         * while the dropdown list is open.
         */
        _this.currentQuery = '';
        /**
         * Whether the list is closing because it lost focus.
         */
        _this.isListClosing = false;
        /**
         * Click handler to reset isListClosing when `click` events bubble up to it.
         * Prevents an edge case where, if a user closes the list by clicking outside
         * the component, they would have been required to click the dropdown button
         * twice to activate it again.
         */
        _this.resetIsListClosingHandler = function () {
            _this.isListClosing = false;
        };
        return _this;
    }
    DropdownComponent_1 = DropdownComponent;
    Object.defineProperty(DropdownComponent.prototype, "id", {
        get: function () {
            return this._id;
        },
        /**
         * Unique string that serves as a global identifier for the component.
         * This value will be removed from the host and assigned to its dropdown
         * button element, to ensure accessible labeling relationships.
         */
        set: function (value) {
            this._id = value;
            this.externalId = null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DropdownComponent.prototype, "buttonLabelingElements", {
        /**
         * A list of IDs for elements that act as labels for the dropdown button.
         */
        get: function () {
            return [this.listLabelingElement, this.id].filter(Boolean).join(' ');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DropdownComponent.prototype, "buttonDescriptionElements", {
        /**
         * A list of IDs for elements that act as descriptions for the dropdown button.
         */
        get: function () {
            return this.ariaDescribedBy || null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DropdownComponent.prototype, "listLabelingElement", {
        /**
         * ID of the element that acts as a label for the dropdown list.
         */
        get: function () {
            return this.ariaLabelledBy || this.id;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Registers that the user has interacted with the control, as a signal to
     * validation logic.
     *
     * @internal
     */
    DropdownComponent.prototype.onButtonBlur = function () {
        // Don't validate the control if the user just opened the list
        if (this.isListVisible) {
            return;
        }
        this.onTouched();
    };
    /**
     * Hides the dropdown list when it loses focus, and sets a flag to indicate
     * that visibility state to other event handlers.
     */
    DropdownComponent.prototype.onListBlur = function () {
        // The list might not be visible when this event handler is called.
        // This ensures we maintain the list's original visibility state if
        // the dropdown button has been clicked.
        var wasListVisible = this.isListVisible;
        this.hideList();
        this.isListClosing = wasListVisible;
    };
    /**
     * Handles a change in the selected option.
     *
     * @param selection Newly selected option reported by the listbox
     */
    DropdownComponent.prototype.onSelectionChange = function (selection) {
        if (selection && selection !== this.selectedOption) {
            this.selectedOption = selection;
            this.writeValue(this.selectedOption.value);
            this.onChange(this.selectedOption.value);
            this.onTouched();
        }
    };
    /**
     * Shows and sends focus to the dropdown list. Attempts to make the
     * selected option visible in long lists.
     *
     * @internal
     */
    DropdownComponent.prototype.showList = function () {
        var _this = this;
        this.isListVisible = true;
        // Set a timeout to ensure the list can be focused before focusing it
        setTimeout(function () {
            _this.listbox.focus();
        }, 0);
    };
    /**
     * Hides the dropdown list and sends focus to the dropdown button.
     *
     * @param focusButton Whether to focus the dropdown button after hiding the list
     *
     * @internal
     */
    DropdownComponent.prototype.hideList = function (focusButton) {
        this.isListVisible = false;
        this.isListClosing = false;
        this.onChange(this.value);
        if (focusButton) {
            this.dropdownButton.nativeElement.focus();
        }
    };
    /**
     * Shows or hides the dropdown list, depending on whether it is currently
     * visible.
     *
     * @param $event Event information
     *
     * @internal
     */
    DropdownComponent.prototype.toggleListVisibility = function (event) {
        if (this.isListVisible || this.isListClosing) {
            event.preventDefault();
            this.hideList(true);
        }
        else {
            this.showList();
        }
    };
    /**
     * Handles `keydown` events on the dropdown button.
     *
     * @param event Keyboard event details
     */
    DropdownComponent.prototype.onButtonKeydown = function (event) {
        switch (event.key) {
            case "ArrowDown" /* ArrowDown */:
                this.showList();
                this.listbox.selectNext();
                break;
            case "ArrowUp" /* ArrowUp */:
                this.showList();
                this.listbox.selectPrevious();
                break;
            default:
                break;
        }
    };
    /**
     * Responds to keyboard events fired while the dropdown list is open.
     *
     * @param event Keyboard event information
     *
     * @internal
     */
    DropdownComponent.prototype.onListKeydown = function (event) {
        var _this = this;
        var key = event.key;
        // Allow Tab and Shift+Tab to shift focus away from the list as normal
        if (key === "Tab" /* Tab */) {
            return;
        }
        if (key === "Enter" /* Enter */) {
            this.toggleListVisibility(event);
            return;
        }
        // Process alphanumeric characters for a matching option
        if (key.length === 1 && key.match(/[A-Za-z0-9 ]/)) {
            event.preventDefault();
            event.stopPropagation();
            this.currentQuery += key;
            debounce(function () { return _this.processTextInput(); }, 250)();
        }
    };
    /**
     * Selects the first option matching the current text query. The query is
     * constructed in `onListKeydown`.
     */
    DropdownComponent.prototype.processTextInput = function () {
        if (!this.currentQuery) {
            return;
        }
        var queryString = this.currentQuery.toLowerCase();
        var firstMatchingOption = this.options.findIndex(function (option) {
            return option.description.toLowerCase().startsWith(queryString);
        });
        if (firstMatchingOption !== undefined && firstMatchingOption !== null && firstMatchingOption !== -1) {
            this.listbox.selectIndex(firstMatchingOption);
        }
        this.currentQuery = '';
    };
    /**
     * Updates the selected option in response to programmatic changes to the
     * control value.
     *
     * @param newValue Value the control will have
     */
    DropdownComponent.prototype.valueWillChange = function (newValue) {
        var newSelectedOption = this.options.find(function (option) { return option.value === newValue; });
        if (!newSelectedOption) {
            this.selectedOption = null;
            if (this.listbox) {
                this.listbox.clear();
            }
        }
        else if (newSelectedOption !== this.selectedOption) {
            this.selectedOption = newSelectedOption;
            if (this.listbox) {
                this.listbox.selectOption(this.selectedOption);
            }
        }
    };
    var DropdownComponent_1;
    /**
     * Tracks the number of instances of the component that have been created.
     * Used to generate IDs for child elements, if an ID was not provided.
     *
     * @internal
     */
    DropdownComponent.componentCount = 0;
    __decorate([
        HostBinding('attr.id'),
        __metadata("design:type", Object)
    ], DropdownComponent.prototype, "externalId", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], DropdownComponent.prototype, "id", null);
    __decorate([
        HostBinding('class.hl-dropdown'),
        __metadata("design:type", Object)
    ], DropdownComponent.prototype, "baseClass", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], DropdownComponent.prototype, "placeholder", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], DropdownComponent.prototype, "options", void 0);
    __decorate([
        ViewChild('button'),
        __metadata("design:type", ElementRef)
    ], DropdownComponent.prototype, "dropdownButton", void 0);
    __decorate([
        ViewChild(ListboxComponent),
        __metadata("design:type", ListboxComponent)
    ], DropdownComponent.prototype, "listbox", void 0);
    __decorate([
        HostListener('document:click'),
        __metadata("design:type", Object)
    ], DropdownComponent.prototype, "resetIsListClosingHandler", void 0);
DropdownComponent.ɵfac = /*@__PURE__*/ function () { var ɵDropdownComponent_BaseFactory; return function DropdownComponent_Factory(t) { return (ɵDropdownComponent_BaseFactory || (ɵDropdownComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(DropdownComponent)))(t || DropdownComponent); }; }();
DropdownComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DropdownComponent, selectors: [["hl-dropdown"]], viewQuery: function DropdownComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c26, 5);
        ɵngcc0.ɵɵviewQuery(ListboxComponent, 5);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdownButton = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.listbox = _t.first);
    } }, hostVars: 3, hostBindings: function DropdownComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function DropdownComponent_click_HostBindingHandler() { return ctx.resetIsListClosingHandler(); }, false, ɵngcc0.ɵɵresolveDocument);
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("id", ctx.externalId);
        ɵngcc0.ɵɵclassProp("hl-dropdown", ctx.baseClass);
    } }, inputs: { id: "id", placeholder: "placeholder", options: "options" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(function () { return DropdownComponent_1; }),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 7, vars: 13, consts: [[1, "hl-dropdown__wrapper", 3, "keyup.esc"], ["hdsFormControl", "", "type", "button", "aria-haspopup", "listbox", 1, "hl-dropdown__button", 3, "id", "disabled", "blur", "click", "keydown"], ["button", ""], [1, "hl-dropdown__button-text"], ["size", "small", 3, "icon"], ["showSelectionIcon", "", 3, "hidden", "aria-labelledby", "options", "click", "keydown", "listBlur", "selectionChange"]], template: function DropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("keyup.esc", function DropdownComponent_Template_div_keyup_esc_0_listener() { return ctx.hideList(true); });
        ɵngcc0.ɵɵelementStart(1, "button", 1, 2);
        ɵngcc0.ɵɵlistener("blur", function DropdownComponent_Template_button_blur_1_listener() { return ctx.onButtonBlur(); })("click", function DropdownComponent_Template_button_click_1_listener($event) { return ctx.toggleListVisibility($event); })("keydown", function DropdownComponent_Template_button_keydown_1_listener($event) { return ctx.onButtonKeydown($event); });
        ɵngcc0.ɵɵelementStart(3, "span", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(5, "hl-icon", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "hds-listbox", 5);
        ɵngcc0.ɵɵlistener("click", function DropdownComponent_Template_hds_listbox_click_6_listener() { return ctx.hideList(); })("keydown", function DropdownComponent_Template_hds_listbox_keydown_6_listener($event) { return ctx.onListKeydown($event); })("listBlur", function DropdownComponent_Template_hds_listbox_listBlur_6_listener() { return ctx.onListBlur(); })("selectionChange", function DropdownComponent_Template_hds_listbox_selectionChange_6_listener($event) { return ctx.onSelectionChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", ctx.id)("disabled", ctx.disabled);
        ɵngcc0.ɵɵattribute("aria-describedby", ctx.buttonDescriptionElements)("aria-expanded", ctx.isListVisible)("aria-labelledby", ctx.buttonLabelingElements)("aria-required", ctx.required || null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("hl-dropdown__placeholder-text", !ctx.selectedOption);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.selectedOption ? ctx.selectedOption.description : ctx.placeholder, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("icon", ctx.isListVisible ? "chevron-up" : "chevron-down");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.isListVisible || null)("aria-labelledby", ctx.listLabelingElement)("options", ctx.options);
    } }, directives: [HDSFormControlDirective, IconComponent, ListboxComponent], styles: [".hl-dropdown{--text-color:var(--hds-theme-base-text, #000);--placeholder-color:var(--hds-input-placeholder, rgba(0, 0, 0, 0.45));--bg:var(--hds-input-background, #fff);--border:var(--hds-input-border, currentColor);--border-focus:var(--hds-theme-accent-primary, #189ec3);--bg-error:var(--hds-input-background-error, #ffe5e5);--border-error:var(--hds-input-border-error, #e91d00);--border-focus-shadow-error:var(--hds-input-focus-shadow-error, rgba(233, 29, 0, 0.75));display:block;width:100%;max-width:100%}.hl-dropdown__wrapper{position:relative;width:100%}.hl-dropdown__button{font-family:inherit;font-size:1rem;margin:0;overflow:visible;text-transform:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;display:inline-flex;justify-content:space-between;align-items:center;height:3rem;width:100%;padding:0 1rem;border:.125rem solid var(--border);border-radius:.25rem;background-color:var(--bg);color:var(--text-color)}.hl-dropdown__button:focus,.hl-dropdown__button[aria-expanded=true]{outline:0;border-color:var(--border-focus);box-shadow:0 0 8px rgba(0,0,0,.36)}.hl-dropdown__button:focus::-moz-focus-inner,.hl-dropdown__button[aria-expanded=true]::-moz-focus-inner{border-style:none;padding:0}.hl-dropdown__button:focus:-moz-focusring,.hl-dropdown__button[aria-expanded=true]:-moz-focusring{outline:0}.hl-dropdown__button:disabled{background-color:#f5f5f5;border-color:#c4c4c4;color:#8d8d8d;cursor:not-allowed}.hl-dropdown__button-text{max-width:calc(100% - 1em);overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.hl-dropdown__placeholder-text{color:var(--placeholder-color);opacity:.45}.hl-dropdown hds-listbox{width:100%;position:absolute;z-index:10;box-shadow:0 2px 4px rgba(0,0,0,.12)}.hl-dropdown.ng-dirty.ng-invalid .hl-dropdown__button,.hl-dropdown.ng-touched.ng-invalid .hl-dropdown__button{background-color:var(--bg-error);border-color:var(--border-error)}.hl-dropdown.ng-dirty.ng-invalid:focus-within .hl-dropdown__button,.hl-dropdown.ng-touched.ng-invalid:focus-within .hl-dropdown__button{box-shadow:0 0 8px var(--border-focus-shadow-error)}"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownComponent, [{
        type: Component,
        args: [{
                selector: 'hl-dropdown',
                template: "<!--\n    Modeled after the Collapsible Dropdown Listbox example from the\n    W3C WAI-ARIA Authoring Practices 1.1:\n    https://www.w3.org/TR/wai-aria-practices/#examples-6\n    https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html\n-->\n\n<div class=\"hl-dropdown__wrapper\" (keyup.esc)=\"hideList(true)\">\n    <button\n        #button\n        hdsFormControl\n        [id]=\"id\"\n        type=\"button\"\n        class=\"hl-dropdown__button\"\n        aria-haspopup=\"listbox\"\n        [attr.aria-describedby]=\"buttonDescriptionElements\"\n        [attr.aria-expanded]=\"isListVisible\"\n        [attr.aria-labelledby]=\"buttonLabelingElements\"\n        [attr.aria-required]=\"required || null\"\n        [disabled]=\"disabled\"\n        (blur)=\"onButtonBlur()\"\n        (click)=\"toggleListVisibility($event)\"\n        (keydown)=\"onButtonKeydown($event)\"\n    >\n        <span class=\"hl-dropdown__button-text\" [class.hl-dropdown__placeholder-text]=\"!selectedOption\">\n            {{ selectedOption ? selectedOption.description : placeholder }}\n        </span>\n        <hl-icon [icon]=\"isListVisible ? 'chevron-up' : 'chevron-down'\" size=\"small\"></hl-icon>\n    </button>\n\n    <hds-listbox\n        showSelectionIcon\n        [hidden]=\"!isListVisible || null\"\n        [aria-labelledby]=\"listLabelingElement\"\n        [options]=\"options\"\n        (click)=\"hideList()\"\n        (keydown)=\"onListKeydown($event)\"\n        (listBlur)=\"onListBlur()\"\n        (selectionChange)=\"onSelectionChange($event)\"\n    ></hds-listbox>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(function () { return DropdownComponent_1; }),
                        multi: true
                    }
                ],
                styles: [".hl-dropdown{--text-color:var(--hds-theme-base-text, #000);--placeholder-color:var(--hds-input-placeholder, rgba(0, 0, 0, 0.45));--bg:var(--hds-input-background, #fff);--border:var(--hds-input-border, currentColor);--border-focus:var(--hds-theme-accent-primary, #189ec3);--bg-error:var(--hds-input-background-error, #ffe5e5);--border-error:var(--hds-input-border-error, #e91d00);--border-focus-shadow-error:var(--hds-input-focus-shadow-error, rgba(233, 29, 0, 0.75));display:block;width:100%;max-width:100%}.hl-dropdown__wrapper{position:relative;width:100%}.hl-dropdown__button{font-family:inherit;font-size:1rem;margin:0;overflow:visible;text-transform:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;display:inline-flex;justify-content:space-between;align-items:center;height:3rem;width:100%;padding:0 1rem;border:.125rem solid var(--border);border-radius:.25rem;background-color:var(--bg);color:var(--text-color)}.hl-dropdown__button:focus,.hl-dropdown__button[aria-expanded=true]{outline:0;border-color:var(--border-focus);box-shadow:0 0 8px rgba(0,0,0,.36)}.hl-dropdown__button:focus::-moz-focus-inner,.hl-dropdown__button[aria-expanded=true]::-moz-focus-inner{border-style:none;padding:0}.hl-dropdown__button:focus:-moz-focusring,.hl-dropdown__button[aria-expanded=true]:-moz-focusring{outline:0}.hl-dropdown__button:disabled{background-color:#f5f5f5;border-color:#c4c4c4;color:#8d8d8d;cursor:not-allowed}.hl-dropdown__button-text{max-width:calc(100% - 1em);overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.hl-dropdown__placeholder-text{color:var(--placeholder-color);opacity:.45}.hl-dropdown hds-listbox{width:100%;position:absolute;z-index:10;box-shadow:0 2px 4px rgba(0,0,0,.12)}.hl-dropdown.ng-dirty.ng-invalid .hl-dropdown__button,.hl-dropdown.ng-touched.ng-invalid .hl-dropdown__button{background-color:var(--bg-error);border-color:var(--border-error)}.hl-dropdown.ng-dirty.ng-invalid:focus-within .hl-dropdown__button,.hl-dropdown.ng-touched.ng-invalid:focus-within .hl-dropdown__button{box-shadow:0 0 8px var(--border-focus-shadow-error)}"]
            }]
    }], null, { id: [{
            type: Input
        }], externalId: [{
            type: HostBinding,
            args: ['attr.id']
        }], baseClass: [{
            type: HostBinding,
            args: ['class.hl-dropdown']
        }], placeholder: [{
            type: Input
        }], options: [{
            type: Input
        }], dropdownButton: [{
            type: ViewChild,
            args: ['button']
        }], listbox: [{
            type: ViewChild,
            args: [ListboxComponent]
        }], resetIsListClosingHandler: [{
            type: HostListener,
            args: ['document:click']
        }] }); })();
    return DropdownComponent;
}(CustomFormControl));

var DropdownModule = /** @class */ (function () {
    function DropdownModule() {
    }
DropdownModule.ɵfac = function DropdownModule_Factory(t) { return new (t || DropdownModule)(); };
DropdownModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DropdownModule });
DropdownModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, FormControlsCommonModule, IconModule, ListboxModule], FormControlsCommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownModule, [{
        type: NgModule,
        args: [{
                declarations: [DropdownComponent, DropdownSelectComponent],
                imports: [CommonModule, FormControlsCommonModule, IconModule, ListboxModule],
                exports: [DropdownComponent, DropdownSelectComponent, FormControlsCommonModule]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DropdownModule, { declarations: function () { return [DropdownComponent, DropdownSelectComponent]; }, imports: function () { return [CommonModule, FormControlsCommonModule, IconModule, ListboxModule]; }, exports: function () { return [DropdownComponent, DropdownSelectComponent, FormControlsCommonModule]; } }); })();
    return DropdownModule;
}());

/**
 * A full-page loading screen.
 */
var LoadingScreenComponent = /** @class */ (function () {
    function LoadingScreenComponent() {
        /**
         * Title to show on the loading screen.
         */
        this.title = 'Loading...';
        /**
         * @ignore
         */
        this.baseClass = true;
    }
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], LoadingScreenComponent.prototype, "title", void 0);
    __decorate([
        HostBinding('class.hl-loading-screen'),
        __metadata("design:type", Object)
    ], LoadingScreenComponent.prototype, "baseClass", void 0);
LoadingScreenComponent.ɵfac = function LoadingScreenComponent_Factory(t) { return new (t || LoadingScreenComponent)(); };
LoadingScreenComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LoadingScreenComponent, selectors: [["hl-loading-screen"]], hostVars: 2, hostBindings: function LoadingScreenComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hl-loading-screen", ctx.baseClass);
    } }, inputs: { title: "title" }, ngContentSelectors: _c4, decls: 5, vars: 1, consts: [["icon", "brand--HL_Mark", "size", "xx-large", 1, "hl-loading-screen__icon"], [1, "hl-loading-screen__title"], [1, "hl-loading-screen__contents"]], template: function LoadingScreenComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "hl-icon", 0);
        ɵngcc0.ɵɵelementStart(1, "h2", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.title || "Loading...");
    } }, directives: [IconComponent], styles: [".hl-loading-screen{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10000;display:flex;flex-direction:column;justify-content:center;align-items:center;padding:2rem 4rem 5vh;text-align:center;background-color:#1bb2dd;color:#fff}.hl-loading-screen .hl-loading-screen__title{margin-top:1em;margin-bottom:0}@media screen and (max-width:599px){.hl-loading-screen .hl-loading-screen__icon .hl-icon{height:4em}}@-webkit-keyframes pulse{10%,90%{opacity:1}50%{opacity:.5}}@keyframes pulse{10%,90%{opacity:1}50%{opacity:.5}}.hl-loading-screen__icon{-webkit-animation:5s ease-in-out 3s infinite pulse;animation:5s ease-in-out 3s infinite pulse}"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoadingScreenComponent, [{
        type: Component,
        args: [{
                selector: 'hl-loading-screen',
                template: "<hl-icon icon=\"brand--HL_Mark\" size=\"xx-large\" class=\"hl-loading-screen__icon\"></hl-icon>\n<h2 class=\"hl-loading-screen__title\">{{ title || 'Loading...' }}</h2>\n\n<div class=\"hl-loading-screen__contents\">\n    <ng-content></ng-content>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".hl-loading-screen{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10000;display:flex;flex-direction:column;justify-content:center;align-items:center;padding:2rem 4rem 5vh;text-align:center;background-color:#1bb2dd;color:#fff}.hl-loading-screen .hl-loading-screen__title{margin-top:1em;margin-bottom:0}@media screen and (max-width:599px){.hl-loading-screen .hl-loading-screen__icon .hl-icon{height:4em}}@-webkit-keyframes pulse{10%,90%{opacity:1}50%{opacity:.5}}@keyframes pulse{10%,90%{opacity:1}50%{opacity:.5}}.hl-loading-screen__icon{-webkit-animation:5s ease-in-out 3s infinite pulse;animation:5s ease-in-out 3s infinite pulse}"]
            }]
    }], function () { return []; }, { title: [{
            type: Input
        }], baseClass: [{
            type: HostBinding,
            args: ['class.hl-loading-screen']
        }] }); })();
    return LoadingScreenComponent;
}());

var LoadingScreenModule = /** @class */ (function () {
    function LoadingScreenModule() {
    }
LoadingScreenModule.ɵfac = function LoadingScreenModule_Factory(t) { return new (t || LoadingScreenModule)(); };
LoadingScreenModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: LoadingScreenModule });
LoadingScreenModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, IconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoadingScreenModule, [{
        type: NgModule,
        args: [{
                declarations: [LoadingScreenComponent],
                imports: [CommonModule, IconModule],
                exports: [LoadingScreenComponent]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LoadingScreenModule, { declarations: function () { return [LoadingScreenComponent]; }, imports: function () { return [CommonModule, IconModule]; }, exports: function () { return [LoadingScreenComponent]; } }); })();
    return LoadingScreenModule;
}());

/**
 * An interface that application code can extend to create components to inject
 * into the contents of a Modal container.
 */
var BaseModalContents = /** @class */ (function () {
    function BaseModalContents() {
        /**
         * Whether the user will be allowed to dismiss the modal.
         */
        this.allowDismiss = true;
        /**
         * Event to emit when one of the response methods is called.
         */
        this.closeModal = new EventEmitter();
    }
    /**
     * @ignore
     */
    BaseModalContents.prototype.ngOnInit = function () {
        this.allowDismiss = this.config && !this.config.hideDismiss;
    };
    /**
     * Tells the ModalContainer to confirm the modal with the given response.
     */
    BaseModalContents.prototype.confirm = function () {
        this.onConfirm();
        this.closeModal.emit(__assign(__assign({}, this.responseData), { userAction: 'confirm' }));
    };
    /**
     * Tells the ModalContainer to cancel the modal with the given response.
     */
    BaseModalContents.prototype.cancel = function () {
        this.onCancel();
        this.closeModal.emit(__assign(__assign({}, this.responseData), { userAction: 'cancel' }));
    };
    /**
     * Tells the ModalContainer to dismiss the modal with the given response.
     */
    BaseModalContents.prototype.dismiss = function () {
        if (this.allowDismiss) {
            this.onDismiss();
            this.closeModal.emit(__assign(__assign({}, this.responseData), { userAction: 'dismiss' }));
        }
    };
    /**
     * Controls whether the user is allowed to confirm the modal. Override this
     * method to introduce custom logic specific to your modal contents.
     */
    BaseModalContents.prototype.canConfirm = function () {
        return true;
    };
    /**
     * Called just before the modal is confirmed. Update the `reponse` in this
     * method as appropriate.
     */
    BaseModalContents.prototype.onConfirm = function () { };
    /**
     * Called just before the modal is canceled. Update the `reponse` in this
     * method as appropriate.
     */
    BaseModalContents.prototype.onCancel = function () { };
    /**
     * Called just before the modal is dismissed. Update the `reponse` in this
     * method as appropriate.
     */
    BaseModalContents.prototype.onDismiss = function () { };
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], BaseModalContents.prototype, "closeModal", void 0);
BaseModalContents.ɵfac = function BaseModalContents_Factory(t) { return new (t || BaseModalContents)(); };
BaseModalContents.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: BaseModalContents, outputs: { closeModal: "closeModal" } });

    return BaseModalContents;
}());

/**
 * A simple component to display a text string in a Modal container.
 */
var BasicModalContentsComponent = /** @class */ (function (_super) {
    __extends(BasicModalContentsComponent, _super);
    function BasicModalContentsComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
BasicModalContentsComponent.ɵfac = /*@__PURE__*/ function () { var ɵBasicModalContentsComponent_BaseFactory; return function BasicModalContentsComponent_Factory(t) { return (ɵBasicModalContentsComponent_BaseFactory || (ɵBasicModalContentsComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(BasicModalContentsComponent)))(t || BasicModalContentsComponent); }; }();
BasicModalContentsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BasicModalContentsComponent, selectors: [["ng-component"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 1, template: function BasicModalContentsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.config.text);
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BasicModalContentsComponent, [{
        type: Component,
        args: [{
                template: " <p>{{ config.text }}</p> "
            }]
    }], null, null); })();
    return BasicModalContentsComponent;
}(BaseModalContents));

/**
 * A modal dialog to display above the main page content.
 */
var ModalComponent = /** @class */ (function () {
    /**
     * @ignore
     */
    function ModalComponent(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        /**
         * @ignore
         */
        this.baseClass = true;
        /**
         * Whether the modal is intended as an alert dialog. See the
         * [WAI-ARIA Authoring Practices](https://www.w3.org/TR/wai-aria-practices/#alertdialog)
         * for more detail.
         */
        this.isAlert = false;
        /**
         * Configuration for the modal's Confirm button.
         */
        this.confirmButton = { text: 'Confirm' };
        /**
         * Configuration for the modal's Cancel button.
         */
        this.cancelButton = { text: 'Cancel' };
        /**
         * Whether the user will be able to dismiss the modal either with the button
         * in the upper-right corner or by typing the `Esc` key.
         */
        this.allowDismiss = true;
        /**
         * Event to let the `ModalService` know that the modal is ready to be
         * destroyed.
         */
        this.destroy = new EventEmitter();
    }
    Object.defineProperty(ModalComponent.prototype, "focusableElements", {
        /**
         * A list of focusable elements inside the modal container.
         */
        get: function () {
            return Array.from(this.modalContainer.nativeElement.querySelectorAll(FOCUSABLE_ELEMENTS));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModalComponent.prototype, "allowConfirm", {
        /**
         * Whether the user is currently allowed to confirm the modal.
         * This flag can be updated dynamically by logic in the modal contents.
         */
        get: function () {
            if (this.contents) {
                return this.contents.instance.canConfirm();
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    ModalComponent.prototype.ngOnInit = function () {
        if (this.config) {
            this.title = this.config.title;
            this.size = this.config.size || 'medium';
            this.isAlert = !!this.config.isAlert;
            this.allowDismiss = !this.config.hideDismiss;
            if (this.config.buttons) {
                this.confirmButton = __assign(__assign({}, this.confirmButton), this.config.buttons.confirm);
                this.cancelButton = __assign(__assign({}, this.cancelButton), this.config.buttons.cancel);
            }
            if (this.allowDismiss) {
                this.setupDismissHandler();
            }
        }
        else {
            throw new ComponentConfigurationError('ModalComponent must be initialized with a configuration object');
        }
    };
    ModalComponent.prototype.ngAfterViewInit = function () {
        this.loadModalContents();
        this.changeDetectorRef.detectChanges();
        // TODO: Set initial focus to primary action button instead
        this.focusModalElement('first');
    };
    ModalComponent.prototype.ngOnDestroy = function () {
        if (this.contents) {
            this.contents.destroy();
        }
    };
    /**
     * Action dispatched when the user activates the Confirm button.
     */
    ModalComponent.prototype.confirm = function () {
        if (this.allowConfirm) {
            this.contents.instance.confirm();
        }
    };
    /**
     * Action dispatched when the user activates the Cancel button.
     */
    ModalComponent.prototype.cancel = function () {
        this.contents.instance.cancel();
    };
    /**
     * Action dispatched when the user activates the Dismiss button.
     */
    ModalComponent.prototype.dismiss = function () {
        if (this.allowDismiss) {
            this.contents.instance.dismiss();
        }
    };
    /**
     * @ignore
     */
    ModalComponent.prototype.getSizeClass = function () {
        return this.size ? "hl-modal__container--" + this.size : null;
    };
    /**
     * Prevents click events from propagating outsite the Modal while it is open.
     * @param event Event data
     */
    ModalComponent.prototype.onDialogClicked = function (event) {
        event.stopPropagation();
    };
    /**
     * Handles the user's focus when they tab out of the end of the Modal
     * @param event Focus event data
     */
    ModalComponent.prototype.onFocusTrapStartReached = function (event) {
        event.stopPropagation();
        this.focusModalElement('last');
    };
    /**
     * Handles the user's focus when they tab out of the beginning of the Modal
     * @param event Focus event data
     */
    ModalComponent.prototype.onFocusTrapEndReached = function (event) {
        event.stopPropagation();
        this.focusModalElement('first');
    };
    /**
     * Sets up an event handler to dismiss the Modal when the `Esc` key is pressed
     */
    ModalComponent.prototype.setupDismissHandler = function () {
        var _this = this;
        var dismissHandler = function (e) {
            if (e.key === "Esc" /* Esc */ || e.key === "Escape" /* Escape */) {
                _this.dismiss();
                document.body.removeEventListener('keydown', dismissHandler);
            }
        };
        document.body.addEventListener('keydown', dismissHandler);
    };
    /**
     * Loads the Modal's contents component.
     */
    ModalComponent.prototype.loadModalContents = function () {
        var _this = this;
        this.contents = this.contentPlaceholder.insertComponent(this.contentsType);
        this.contents.instance.config = this.config;
        var closeSubscription = this.contents.instance.closeModal.subscribe(function (response) {
            closeSubscription.unsubscribe();
            _this.destroy.emit(response);
        });
    };
    /**
     * Sends focus to the specified element within the Modal.
     * @param which Choice to focus either the "first" or "last" focusable element
     */
    ModalComponent.prototype.focusModalElement = function (which) {
        var el;
        if (which === 'first') {
            el = this.focusableElements[0];
        }
        else {
            el = this.focusableElements[this.focusableElements.length - 1];
        }
        try {
            el.focus();
        }
        catch (e) {
            console.warn('ModalComponent can not focus any elements!');
        }
    };
    ModalComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    __decorate([
        HostBinding('class.hl-modal'),
        __metadata("design:type", Object)
    ], ModalComponent.prototype, "baseClass", void 0);
    __decorate([
        ViewChild(PlaceholderDirective),
        __metadata("design:type", PlaceholderDirective)
    ], ModalComponent.prototype, "contentPlaceholder", void 0);
    __decorate([
        ViewChild('modalContainer'),
        __metadata("design:type", ElementRef)
    ], ModalComponent.prototype, "modalContainer", void 0);
    __decorate([
        ViewChild('focusTrapStart'),
        __metadata("design:type", ElementRef)
    ], ModalComponent.prototype, "focusTrapStart", void 0);
    __decorate([
        ViewChild('focusTrapEnd'),
        __metadata("design:type", ElementRef)
    ], ModalComponent.prototype, "focusTrapEnd", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], ModalComponent.prototype, "destroy", void 0);
    ModalComponent = __decorate([ __metadata("design:paramtypes", [ChangeDetectorRef])
    ], ModalComponent);
ModalComponent.ɵfac = function ModalComponent_Factory(t) { return new (t || ModalComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
ModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ModalComponent, selectors: [["hl-modal"]], viewQuery: function ModalComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(PlaceholderDirective, 5);
        ɵngcc0.ɵɵviewQuery(_c27, 5);
        ɵngcc0.ɵɵviewQuery(_c28, 5);
        ɵngcc0.ɵɵviewQuery(_c29, 5);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentPlaceholder = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.modalContainer = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.focusTrapStart = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.focusTrapEnd = _t.first);
    } }, hostVars: 2, hostBindings: function ModalComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hl-modal", ctx.baseClass);
    } }, outputs: { destroy: "destroy" }, decls: 13, vars: 6, consts: [["tabindex", "0", 3, "focus"], ["focusTrapStart", ""], ["aria-labelledby", "hl-modal__title", "aria-modal", "true", 1, "hl-modal__container", 3, "ngClass", "click"], ["modalContainer", ""], [1, "hl-modal__header"], ["id", "hl-modal__title", 1, "hl-modal__title", "hl-font--h4", "hl-font-weight--bold"], ["hlMinimalButton", "", "class", "hl-modal__dismiss-button", "icon", "close", "hideLabel", "true", 3, "click", 4, "ngIf"], ["id", "hl-modal__contents", 1, "hl-modal__contents"], ["hlPlaceholder", ""], ["class", "hl-modal__button-container", 4, "ngIf"], ["focusTrapEnd", ""], ["hlMinimalButton", "", "icon", "close", "hideLabel", "true", 1, "hl-modal__dismiss-button", 3, "click"], [1, "hl-modal__button-container"], ["align", "end"], ["hlButton", "", "secondary", "true", "class", "hl-modal__button", 3, "click", 4, "ngIf"], ["hlButton", "", "class", "hl-modal__button", 3, "disabled", "click", 4, "ngIf"], ["hlButton", "", "secondary", "true", 1, "hl-modal__button", 3, "click"], ["hlButton", "", 1, "hl-modal__button", 3, "disabled", "click"]], template: function ModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵlistener("focus", function ModalComponent_Template_div_focus_0_listener($event) { return ctx.onFocusTrapStartReached($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2, 3);
        ɵngcc0.ɵɵlistener("click", function ModalComponent_Template_div_click_2_listener($event) { return ctx.onDialogClicked($event); });
        ɵngcc0.ɵɵelementStart(4, "header", 4);
        ɵngcc0.ɵɵelementStart(5, "h2", 5);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, ModalComponent_button_7_Template, 2, 0, "button", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "section", 7);
        ɵngcc0.ɵɵelementContainer(9, 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, ModalComponent_footer_10_Template, 4, 2, "footer", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 0, 10);
        ɵngcc0.ɵɵlistener("focus", function ModalComponent_Template_div_focus_11_listener($event) { return ctx.onFocusTrapEndReached($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.getSizeClass());
        ɵngcc0.ɵɵattribute("aria-describedby", ctx.isAlert ? "hl-modal__contents" : null)("role", ctx.isAlert ? "alertdialog" : "dialog");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.allowDismiss);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !(ctx.confirmButton.hide && ctx.cancelButton.hide));
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf, PlaceholderDirective, MinimalButtonComponent, ActionGroupComponent, ButtonComponent], styles: [".hl-modal{position:fixed;top:0;bottom:0;left:0;right:0;z-index:1000;box-shadow:0 4px 16px rgba(0,0,0,.12),0 8px 32px rgba(0,0,0,.12),0 16px 32px rgba(0,0,0,.12);display:flex;justify-content:center;align-items:center;background-color:rgba(0,0,0,.5)}.hl-modal__container{position:relative;margin:2rem;padding:3.5rem 0 2rem;max-height:calc(100vh - 2 * 2rem);max-width:100%;display:flex;flex-direction:column;border-radius:.25rem;background-color:#fff;z-index:1000;box-shadow:0 4px 16px rgba(0,0,0,.12),0 8px 32px rgba(0,0,0,.12),0 16px 32px rgba(0,0,0,.12)}.hl-modal__container>*{padding-left:1.5rem;padding-right:1.5rem}@media screen and (max-width:599px){.hl-modal__container{margin:1.5rem;max-height:calc(100vh - 2 * 1.5rem)}}.hl-modal__container--small{width:375px}.hl-modal__container--medium{width:500px}.hl-modal__container--large{width:750px}.hl-modal__title{margin-bottom:1.25rem;font-size:1.5rem;font-weight:400;padding-right:.5rem}.hl-modal .hl-modal__dismiss-button{position:absolute;top:.5rem;right:.5rem}.hl-modal__contents{overflow-y:auto}.hl-modal__contents>*>:first-child,.hl-modal__contents>:first-child{margin-top:0}.hl-modal__contents>*>:last-child,.hl-modal__contents>:last-child{margin-bottom:0}.hl-modal__contents>*>*{margin:1.25rem 0}.hl-modal__button-container{padding-top:2rem;margin-top:2.5rem;border-top:1px solid #79797c;flex-shrink:0}.hl-modal__button{min-width:150px}.hl-modal__action-group{margin-left:-1.5rem;margin-right:-1.5rem;padding-left:1.5rem;padding-right:1.5rem;padding-top:2rem;margin-top:2.5rem;border-top:1px solid #79797c}"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalComponent, [{
        type: Component,
        args: [{
                selector: 'hl-modal',
                template: "<div #focusTrapStart tabindex=\"0\" (focus)=\"onFocusTrapStartReached($event)\">\n    <!-- Focus trap -->\n</div>\n\n<div\n    #modalContainer\n    aria-labelledby=\"hl-modal__title\"\n    aria-modal=\"true\"\n    class=\"hl-modal__container\"\n    [attr.aria-describedby]=\"isAlert ? 'hl-modal__contents' : null\"\n    [attr.role]=\"isAlert ? 'alertdialog' : 'dialog'\"\n    [ngClass]=\"getSizeClass()\"\n    (click)=\"onDialogClicked($event)\"\n>\n    <header class=\"hl-modal__header\">\n        <h2 id=\"hl-modal__title\" class=\"hl-modal__title hl-font--h4 hl-font-weight--bold\">\n            {{ title }}\n        </h2>\n\n        <button\n            *ngIf=\"allowDismiss\"\n            hlMinimalButton\n            class=\"hl-modal__dismiss-button\"\n            icon=\"close\"\n            hideLabel=\"true\"\n            (click)=\"dismiss()\"\n        >\n            Dismiss\n        </button>\n    </header>\n\n    <section id=\"hl-modal__contents\" class=\"hl-modal__contents\">\n        <ng-container hlPlaceholder></ng-container>\n    </section>\n\n    <footer *ngIf=\"!(confirmButton.hide && cancelButton.hide)\" class=\"hl-modal__button-container\">\n        <hl-action-group align=\"end\">\n            <button *ngIf=\"!cancelButton.hide\" hlButton secondary=\"true\" class=\"hl-modal__button\" (click)=\"cancel()\">\n                {{ cancelButton.text }}\n            </button>\n            <button\n                *ngIf=\"!confirmButton.hide\"\n                hlButton\n                class=\"hl-modal__button\"\n                [disabled]=\"!allowConfirm\"\n                (click)=\"confirm()\"\n            >\n                {{ confirmButton.text }}\n            </button>\n        </hl-action-group>\n    </footer>\n</div>\n\n<div #focusTrapEnd tabindex=\"0\" (focus)=\"onFocusTrapEndReached($event)\">\n    <!-- Focus trap -->\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".hl-modal{position:fixed;top:0;bottom:0;left:0;right:0;z-index:1000;box-shadow:0 4px 16px rgba(0,0,0,.12),0 8px 32px rgba(0,0,0,.12),0 16px 32px rgba(0,0,0,.12);display:flex;justify-content:center;align-items:center;background-color:rgba(0,0,0,.5)}.hl-modal__container{position:relative;margin:2rem;padding:3.5rem 0 2rem;max-height:calc(100vh - 2 * 2rem);max-width:100%;display:flex;flex-direction:column;border-radius:.25rem;background-color:#fff;z-index:1000;box-shadow:0 4px 16px rgba(0,0,0,.12),0 8px 32px rgba(0,0,0,.12),0 16px 32px rgba(0,0,0,.12)}.hl-modal__container>*{padding-left:1.5rem;padding-right:1.5rem}@media screen and (max-width:599px){.hl-modal__container{margin:1.5rem;max-height:calc(100vh - 2 * 1.5rem)}}.hl-modal__container--small{width:375px}.hl-modal__container--medium{width:500px}.hl-modal__container--large{width:750px}.hl-modal__title{margin-bottom:1.25rem;font-size:1.5rem;font-weight:400;padding-right:.5rem}.hl-modal .hl-modal__dismiss-button{position:absolute;top:.5rem;right:.5rem}.hl-modal__contents{overflow-y:auto}.hl-modal__contents>*>:first-child,.hl-modal__contents>:first-child{margin-top:0}.hl-modal__contents>*>:last-child,.hl-modal__contents>:last-child{margin-bottom:0}.hl-modal__contents>*>*{margin:1.25rem 0}.hl-modal__button-container{padding-top:2rem;margin-top:2.5rem;border-top:1px solid #79797c;flex-shrink:0}.hl-modal__button{min-width:150px}.hl-modal__action-group{margin-left:-1.5rem;margin-right:-1.5rem;padding-left:1.5rem;padding-right:1.5rem;padding-top:2rem;margin-top:2.5rem;border-top:1px solid #79797c}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { baseClass: [{
            type: HostBinding,
            args: ['class.hl-modal']
        }], destroy: [{
            type: Output
        }], contentPlaceholder: [{
            type: ViewChild,
            args: [PlaceholderDirective]
        }], modalContainer: [{
            type: ViewChild,
            args: ['modalContainer']
        }], focusTrapStart: [{
            type: ViewChild,
            args: ['focusTrapStart']
        }], focusTrapEnd: [{
            type: ViewChild,
            args: ['focusTrapEnd']
        }] }); })();
    return ModalComponent;
}());

var ModalModule = /** @class */ (function () {
    function ModalModule() {
    }
ModalModule.ɵfac = function ModalModule_Factory(t) { return new (t || ModalModule)(); };
ModalModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ModalModule });
ModalModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, DirectivesModule, ActionGroupModule, ButtonModule, IconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalModule, [{
        type: NgModule,
        args: [{
                declarations: [ModalComponent, BasicModalContentsComponent],
                entryComponents: [ModalComponent, BasicModalContentsComponent],
                imports: [CommonModule, DirectivesModule, ActionGroupModule, ButtonModule, IconModule],
                exports: [ModalComponent, BasicModalContentsComponent]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ModalModule, { declarations: function () { return [ModalComponent, BasicModalContentsComponent]; }, imports: function () { return [CommonModule, DirectivesModule, ActionGroupModule, ButtonModule, IconModule]; }, exports: function () { return [ModalComponent, BasicModalContentsComponent]; } }); })();
    return ModalModule;
}());

/**
 * Indicates a navigation item in a NavListComponent.
 */
var NavListItemDirective = /** @class */ (function () {
    /**
     * @ignore
     */
    function NavListItemDirective(template) {
        this.template = template;
    }
    NavListItemDirective.ctorParameters = function () { return [
        { type: TemplateRef }
    ]; };
    NavListItemDirective = __decorate([ __metadata("design:paramtypes", [TemplateRef])
    ], NavListItemDirective);
NavListItemDirective.ɵfac = function NavListItemDirective_Factory(t) { return new (t || NavListItemDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
NavListItemDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NavListItemDirective, selectors: [["", "hlNavItem", ""]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavListItemDirective, [{
        type: Directive,
        args: [{
                selector: '[hlNavItem]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
    return NavListItemDirective;
}());

/**
 * Indicates the contents of a custom toggle button for a navigation sub-list.
 */
var NavSublistToggleDirective = /** @class */ (function () {
    /**
     * @ignore
     */
    function NavSublistToggleDirective(template) {
        this.template = template;
    }
    NavSublistToggleDirective.ctorParameters = function () { return [
        { type: TemplateRef }
    ]; };
    NavSublistToggleDirective = __decorate([ __metadata("design:paramtypes", [TemplateRef])
    ], NavSublistToggleDirective);
NavSublistToggleDirective.ɵfac = function NavSublistToggleDirective_Factory(t) { return new (t || NavSublistToggleDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
NavSublistToggleDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NavSublistToggleDirective, selectors: [["", "hlNavSublistToggle", ""]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavSublistToggleDirective, [{
        type: Directive,
        args: [{
                selector: '[hlNavSublistToggle]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
    return NavSublistToggleDirective;
}());
/**
 * A sub-list of navigation items.
 */
var NavSublistComponent = /** @class */ (function () {
    /**
     * @ignore
     */
    function NavSublistComponent(elementRef, cd) {
        var _this = this;
        this.elementRef = elementRef;
        this.cd = cd;
        /**
         * @ignore
         */
        this.baseClass = true;
        /**
         * ID of the component element. An ID will be generated if not provided.
         */
        this.id = "hl-nav-sublist-" + NavSublistComponent_1.componentCount++;
        /**
         * Whether the sub-list is expanded.
         */
        this.expanded = false;
        /**
         * Event that fires when the expanded state of the sub-list is toggled.
         */
        this.toggle = new EventEmitter();
        /**
         * Closes the sublist, without managing focus.
         */
        this.close = function () {
            _this.expanded = false;
            _this.toggle.emit(_this.expanded);
            _this.cd.detectChanges();
        };
        // Expose public method for parent Nav List component (using Angular Element API)
        // Open issue: https://github.com/angular/angular/issues/22114
        this.elementRef.nativeElement.close = this.close;
    }
    NavSublistComponent_1 = NavSublistComponent;
    Object.defineProperty(NavSublistComponent.prototype, "listContainerId", {
        /**
         * ID of the sublist container.
         *
         * @internal
         */
        get: function () {
            return this.id + "__list-container";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavSublistComponent.prototype, "listHeadingId", {
        /**
         * ID of the sublist heading.
         *
         * @internal
         */
        get: function () {
            return this.id + "__heading";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavSublistComponent.prototype, "toggleButtonId", {
        /**
         * ID of the toggle button.
         *
         * @internal
         */
        get: function () {
            return this.id + "__toggle";
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Toggles the visibility of the sublist.
     */
    NavSublistComponent.prototype.toggleExpanded = function () {
        this.expanded = !this.expanded;
        this.toggle.emit(this.expanded);
        this.cd.detectChanges();
    };
    /**
     * Closes the sublist, and sends focus to its toggle button.
     */
    NavSublistComponent.prototype.closeAndFocusToggleButton = function () {
        this.close();
        this.toggleButton.nativeElement.focus();
    };
    var NavSublistComponent_1;
    /**
     * Tracks the number of instances of the component that have been created.
     * Used to generate IDs for child elements, if an ID was not provided.
     *
     * @internal
     */
    NavSublistComponent.componentCount = 0;
    NavSublistComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: ChangeDetectorRef }
    ]; };
    __decorate([
        HostBinding('class.hl-nav-sublist'),
        __metadata("design:type", Object)
    ], NavSublistComponent.prototype, "baseClass", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], NavSublistComponent.prototype, "id", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], NavSublistComponent.prototype, "toggleLabel", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], NavSublistComponent.prototype, "heading", void 0);
    __decorate([
        ViewChild('toggleButton', { read: ElementRef }),
        __metadata("design:type", ElementRef)
    ], NavSublistComponent.prototype, "toggleButton", void 0);
    __decorate([
        ContentChild(NavSublistToggleDirective),
        __metadata("design:type", NavSublistToggleDirective)
    ], NavSublistComponent.prototype, "toggleButtonContents", void 0);
    __decorate([
        ContentChildren(NavListItemDirective),
        __metadata("design:type", QueryList)
    ], NavSublistComponent.prototype, "items", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], NavSublistComponent.prototype, "toggle", void 0);
    NavSublistComponent = NavSublistComponent_1 = __decorate([ __metadata("design:paramtypes", [ElementRef, ChangeDetectorRef])
    ], NavSublistComponent);
NavSublistComponent.ɵfac = function NavSublistComponent_Factory(t) { return new (t || NavSublistComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
NavSublistComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NavSublistComponent, selectors: [["hl-nav-sublist"]], contentQueries: function NavSublistComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NavSublistToggleDirective, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, NavListItemDirective, 4);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.toggleButtonContents = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.items = _t);
    } }, viewQuery: function NavSublistComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c30, 5, ElementRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.toggleButton = _t.first);
    } }, hostVars: 2, hostBindings: function NavSublistComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hl-nav-sublist", ctx.baseClass);
    } }, inputs: { id: "id", toggleLabel: "toggleLabel", heading: "heading" }, outputs: { toggle: "toggle" }, ngContentSelectors: _c4, decls: 11, vars: 10, consts: [["hlMinimalButton", "", 1, "hl-nav-sublist__toggle", 3, "id", "click"], ["toggleButton", ""], [4, "ngIf", "ngIfElse"], ["size", "small", 1, "hl-nav-sublist__toggle-icon", 3, "icon"], [1, "hl-nav-sublist__panel", 3, "id", "keyup.esc"], ["role", "list", 1, "hl-nav-sublist__items"], ["class", "hl-nav-sublist__item", 4, "ngIf"], ["class", "hl-nav-sublist__item", 4, "ngFor", "ngForOf"], ["defaultToggle", ""], [4, "ngTemplateOutlet"], [1, "hl-nav-sublist__item"], [1, "hl-nav-sublist__heading", 3, "id"], [3, "ngTemplateOutlet"]], template: function NavSublistComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "button", 0, 1);
        ɵngcc0.ɵɵlistener("click", function NavSublistComponent_Template_button_click_0_listener() { return ctx.toggleExpanded(); });
        ɵngcc0.ɵɵtemplate(2, NavSublistComponent_ng_container_2_Template, 2, 1, "ng-container", 2);
        ɵngcc0.ɵɵelement(3, "hl-icon", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵlistener("keyup.esc", function NavSublistComponent_Template_div_keyup_esc_4_listener() { return ctx.closeAndFocusToggleButton(); });
        ɵngcc0.ɵɵelementStart(5, "ul", 5);
        ɵngcc0.ɵɵtemplate(6, NavSublistComponent_li_6_Template, 3, 2, "li", 6);
        ɵngcc0.ɵɵtemplate(7, NavSublistComponent_li_7_Template, 2, 1, "li", 7);
        ɵngcc0.ɵɵprojection(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, NavSublistComponent_ng_template_9_Template, 1, 1, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        var _r4 = ɵngcc0.ɵɵreference(10);
        ɵngcc0.ɵɵproperty("id", ctx.toggleButtonId);
        ɵngcc0.ɵɵattribute("aria-controls", ctx.listContainerId)("aria-expanded", ctx.expanded);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.toggleButtonContents)("ngIfElse", _r4);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("icon", ctx.expanded ? "chevron-up" : "chevron-down");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", ctx.listContainerId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("aria-labelledby", ctx.heading ? ctx.listHeadingId : null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.heading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
    } }, directives: [MinimalButtonComponent, ɵngcc1.NgIf, IconComponent, ɵngcc1.NgForOf, ɵngcc1.NgTemplateOutlet], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavSublistComponent, [{
        type: Component,
        args: [{
                selector: 'hl-nav-sublist',
                template: "<!-- TODO: [HL-27778] This component is basically a disclosure widget. Can it use the Disclosure pattern? -->\n<button\n    #toggleButton\n    hlMinimalButton\n    class=\"hl-nav-sublist__toggle\"\n    [attr.aria-controls]=\"listContainerId\"\n    [attr.aria-expanded]=\"expanded\"\n    (click)=\"toggleExpanded()\"\n    [id]=\"toggleButtonId\"\n>\n    <ng-container *ngIf=\"toggleButtonContents; else defaultToggle\">\n        <ng-container *ngTemplateOutlet=\"toggleButtonContents.template\"></ng-container>\n    </ng-container>\n    <hl-icon\n        [icon]=\"expanded ? 'chevron-up' : 'chevron-down'\"\n        size=\"small\"\n        class=\"hl-nav-sublist__toggle-icon\"\n    ></hl-icon>\n</button>\n\n<div [id]=\"listContainerId\" class=\"hl-nav-sublist__panel\" (keyup.esc)=\"closeAndFocusToggleButton()\">\n    <ul role=\"list\" class=\"hl-nav-sublist__items\" [attr.aria-labelledby]=\"heading ? listHeadingId : null\">\n        <li *ngIf=\"heading\" class=\"hl-nav-sublist__item\">\n            <p [id]=\"listHeadingId\" class=\"hl-nav-sublist__heading\">\n                {{ heading }}\n            </p>\n        </li>\n\n        <li *ngFor=\"let item of items\" class=\"hl-nav-sublist__item\">\n            <ng-container [ngTemplateOutlet]=\"item.template\"></ng-container>\n        </li>\n\n        <ng-content></ng-content>\n    </ul>\n</div>\n\n<ng-template #defaultToggle>{{ toggleLabel }}</ng-template>\n"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { baseClass: [{
            type: HostBinding,
            args: ['class.hl-nav-sublist']
        }], id: [{
            type: Input
        }], toggle: [{
            type: Output
        }], toggleLabel: [{
            type: Input
        }], heading: [{
            type: Input
        }], toggleButton: [{
            type: ViewChild,
            args: ['toggleButton', { read: ElementRef }]
        }], toggleButtonContents: [{
            type: ContentChild,
            args: [NavSublistToggleDirective]
        }], items: [{
            type: ContentChildren,
            args: [NavListItemDirective]
        }] }); })();
    return NavSublistComponent;
}());

/**
 * A list of navigation items, with support for sub-list menus.
 */
var NavListComponent = /** @class */ (function () {
    /**
     * @ignore
     */
    function NavListComponent(elementRef) {
        this.elementRef = elementRef;
        /**
         * Orientation of the list items.
         */
        this.orientation = 'horizontal';
        /**
         * List of subscriptions to sub-list toggle events.
         */
        this.subscriptions = [];
        /**
         * The sub-list that is currently expanded.
         * When the Nav List is used as an Angular Element, this refers to the DOM element node representing the active sublist.
         *
         * @internal
         */
        this.activeSublist = null;
        /**
         * Whether this component instance is hosted by a Custom Element.
         * See https://angular.io/guide/elements for more information.
         *
         * @internal
         */
        this.isAngularElement = false;
    }
    NavListComponent.prototype.ngOnInit = function () {
        if (!this.label) {
            throw new AccessibilityError('NavListComponent must be provided a `label`');
        }
    };
    NavListComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.sublists.changes.subscribe(function () {
            _this.sublists.forEach(function (list) {
                var subscription = list.toggle.subscribe(function () {
                    _this.updateActiveSublist(list);
                });
                _this.subscriptions.push(subscription);
            });
        });
    };
    NavListComponent.prototype.onClick = function (event) {
        if (!this.activeSublist) {
            return;
        }
        var sublistEl = this.isAngularElement
            ? this.activeSublist
            : this.activeSublist.elementRef.nativeElement;
        // Check if active sublist was clicked
        if (sublistEl.contains(event.target)) {
            event.stopPropagation();
        }
        else {
            this.closeActiveSublist();
        }
    };
    NavListComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (subscription) { return subscription.unsubscribe(); });
    };
    /**
     * Updates which sublist in the Nav List is active.
     *
     * @param sublist The newly-active sublist
     */
    NavListComponent.prototype.updateActiveSublist = function (sublist) {
        if (!this.activeSublist) {
            this.activeSublist = sublist;
            return;
        }
        if (sublist !== this.activeSublist) {
            this.closeActiveSublist(); // Only allow one open sublist at a time
            this.activeSublist = sublist;
        }
    };
    /**
     * Closes the active sublist, if there is one.
     */
    NavListComponent.prototype.closeActiveSublist = function () {
        if (this.activeSublist) {
            // Close the active sublist
            this.activeSublist.close();
            this.activeSublist = null;
        }
    };
    /**
     * Closes the active sublist when focus leaves it.
     *
     * @param elReceivingFocus Reference to the element receiving focus
     */
    NavListComponent.prototype.onFocusout = function (elReceivingFocus) {
        if (!this.activeSublist) {
            return;
        }
        if (!this.elementRef.nativeElement.contains(elReceivingFocus)) {
            this.closeActiveSublist();
        }
    };
    NavListComponent.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], NavListComponent.prototype, "label", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], NavListComponent.prototype, "orientation", void 0);
    __decorate([
        ContentChildren(NavListItemDirective),
        __metadata("design:type", QueryList)
    ], NavListComponent.prototype, "items", void 0);
    __decorate([
        ContentChildren(NavSublistComponent, { descendants: true }),
        __metadata("design:type", QueryList)
    ], NavListComponent.prototype, "sublists", void 0);
    __decorate([
        HostListener('document:click', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], NavListComponent.prototype, "onClick", null);
    __decorate([
        HostListener('document:keyup.esc'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NavListComponent.prototype, "closeActiveSublist", null);
    __decorate([
        HostListener('focusout', ['$event.relatedTarget']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], NavListComponent.prototype, "onFocusout", null);
    NavListComponent = __decorate([ __metadata("design:paramtypes", [ElementRef])
    ], NavListComponent);
NavListComponent.ɵfac = function NavListComponent_Factory(t) { return new (t || NavListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NavListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NavListComponent, selectors: [["hl-nav-list"]], contentQueries: function NavListComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NavListItemDirective, 4);
        ɵngcc0.ɵɵcontentQuery(dirIndex, NavSublistComponent, 5);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.items = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.sublists = _t);
    } }, hostBindings: function NavListComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function NavListComponent_click_HostBindingHandler($event) { return ctx.onClick($event); }, false, ɵngcc0.ɵɵresolveDocument)("keyup.esc", function NavListComponent_keyup_esc_HostBindingHandler() { return ctx.closeActiveSublist(); }, false, ɵngcc0.ɵɵresolveDocument)("focusout", function NavListComponent_focusout_HostBindingHandler($event) { return ctx.onFocusout($event.relatedTarget); });
    } }, inputs: { orientation: "orientation", label: "label" }, ngContentSelectors: _c4, decls: 4, vars: 4, consts: [[1, "hl-nav-list"], ["role", "list", 1, "hl-nav-list__items"], ["class", "hl-nav-list__item", 4, "ngFor", "ngForOf"], [1, "hl-nav-list__item"], [3, "ngTemplateOutlet"]], template: function NavListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "nav", 0);
        ɵngcc0.ɵɵelementStart(1, "ul", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵtemplate(3, NavListComponent_li_3_Template, 2, 1, "li", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hl-nav-list--vertical", ctx.orientation === "vertical");
        ɵngcc0.ɵɵattribute("aria-label", ctx.label);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgTemplateOutlet], styles: [".hl-nav-list__items{margin:0;padding:0;display:flex;align-items:baseline;list-style-type:none;line-height:1.5}.hl-nav-list__item{flex-shrink:0;padding:.5rem;position:relative}.hl-nav-list a,.hl-nav-list button{margin:0;padding:.125rem .5rem;border:.125rem solid transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none;overflow:visible;font-family:inherit;font-size:1rem;text-decoration:none;text-transform:none;background-color:transparent;color:inherit;cursor:pointer;min-height:2rem;border-radius:.25rem;display:inline-flex;justify-content:center;align-items:center;transition-duration:150ms;transition-property:background-color,box-shadow,color,transform}.hl-nav-list a:active,.hl-nav-list button:active{transform:scale(.98)}.hl-nav-list a [class*='__text']:not(:empty),.hl-nav-list button [class*='__text']:not(:empty){padding-left:.25rem;padding-right:.25rem}.hl-nav-list a .hl-icon,.hl-nav-list button .hl-icon{flex-shrink:0}.hl-nav-list a:hover,.hl-nav-list button:hover{background-color:rgba(0,0,0,.06)}.hl-nav-list a:focus,.hl-nav-list button:focus{outline:0;border-color:currentColor}.hl-nav-list a:focus::-moz-focus-inner,.hl-nav-list button:focus::-moz-focus-inner{border-style:none;padding:0}.hl-nav-list a:focus:-moz-focusring,.hl-nav-list button:focus:-moz-focusring{outline:0}.hl-nav-list a:disabled,.hl-nav-list button:disabled{opacity:.45;cursor:not-allowed;transform:none;background-color:transparent}.hl-nav-sublist__toggle-icon{margin-left:.25rem}.hl-nav-sublist__panel{position:absolute;top:100%;left:.5rem;width:-webkit-max-content;width:-moz-max-content;width:max-content;line-height:normal;background-color:#fff;color:#000;opacity:1;visibility:visible;transform:scale(1);transform-origin:top;transition:visibility .1s,opacity .1s,transform .1s;z-index:10;box-shadow:0 2px 4px rgba(0,0,0,.12)}.hl-nav-sublist__toggle>*{display:flex;align-items:flex-end}.hl-nav-sublist__toggle[aria-expanded=false]+.hl-nav-sublist__panel{opacity:0;visibility:hidden;transform:scale(.9)}.hl-nav-sublist__heading{margin:0;padding:1rem;border-bottom:.5px solid #b3b3b3;font-size:.75em;letter-spacing:.05em;text-transform:uppercase}.hl-nav-sublist__items{list-style-type:none;margin:0;padding:.5rem 0}.hl-nav-sublist__item a,.hl-nav-sublist__item button{display:block;width:100%;padding:.5rem 1rem;text-align:left}.hl-nav-sublist__item a:hover,.hl-nav-sublist__item button:hover{background-color:#ebfaff}.hl-nav-sublist button [class*='__text']{padding:0}.hl-nav-list--vertical .hl-nav-list__items{flex-direction:column;width:200px;width:-webkit-max-content;width:-moz-max-content;width:max-content}.hl-nav-list--vertical .hl-nav-list__item{padding:0 .5rem}@media screen and (max-width:599px){.hl-nav-list{position:relative}.hl-nav-list__items{overflow-x:auto}.hl-nav-list__item{position:static}.hl-nav-list--vertical .hl-nav-list__items{width:unset;flex-direction:row}.hl-nav-list--vertical .hl-nav-list__item{padding:.5rem}.hl-nav-sublist__panel{top:100%;left:0;right:0;width:unset}}@media screen and (min-width:600px){.hl-nav-list--vertical .hl-nav-sublist__panel{top:0;left:100%}}"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavListComponent, [{
        type: Component,
        args: [{
                selector: 'hl-nav-list',
                template: "<nav class=\"hl-nav-list\" [attr.aria-label]=\"label\" [class.hl-nav-list--vertical]=\"orientation === 'vertical'\">\n    <ul role=\"list\" class=\"hl-nav-list__items\">\n        <ng-content></ng-content>\n\n        <li *ngFor=\"let item of items\" class=\"hl-nav-list__item\">\n            <ng-container [ngTemplateOutlet]=\"item.template\"></ng-container>\n        </li>\n    </ul>\n</nav>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".hl-nav-list__items{margin:0;padding:0;display:flex;align-items:baseline;list-style-type:none;line-height:1.5}.hl-nav-list__item{flex-shrink:0;padding:.5rem;position:relative}.hl-nav-list a,.hl-nav-list button{margin:0;padding:.125rem .5rem;border:.125rem solid transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none;overflow:visible;font-family:inherit;font-size:1rem;text-decoration:none;text-transform:none;background-color:transparent;color:inherit;cursor:pointer;min-height:2rem;border-radius:.25rem;display:inline-flex;justify-content:center;align-items:center;transition-duration:150ms;transition-property:background-color,box-shadow,color,transform}.hl-nav-list a:active,.hl-nav-list button:active{transform:scale(.98)}.hl-nav-list a [class*='__text']:not(:empty),.hl-nav-list button [class*='__text']:not(:empty){padding-left:.25rem;padding-right:.25rem}.hl-nav-list a .hl-icon,.hl-nav-list button .hl-icon{flex-shrink:0}.hl-nav-list a:hover,.hl-nav-list button:hover{background-color:rgba(0,0,0,.06)}.hl-nav-list a:focus,.hl-nav-list button:focus{outline:0;border-color:currentColor}.hl-nav-list a:focus::-moz-focus-inner,.hl-nav-list button:focus::-moz-focus-inner{border-style:none;padding:0}.hl-nav-list a:focus:-moz-focusring,.hl-nav-list button:focus:-moz-focusring{outline:0}.hl-nav-list a:disabled,.hl-nav-list button:disabled{opacity:.45;cursor:not-allowed;transform:none;background-color:transparent}.hl-nav-sublist__toggle-icon{margin-left:.25rem}.hl-nav-sublist__panel{position:absolute;top:100%;left:.5rem;width:-webkit-max-content;width:-moz-max-content;width:max-content;line-height:normal;background-color:#fff;color:#000;opacity:1;visibility:visible;transform:scale(1);transform-origin:top;transition:visibility .1s,opacity .1s,transform .1s;z-index:10;box-shadow:0 2px 4px rgba(0,0,0,.12)}.hl-nav-sublist__toggle>*{display:flex;align-items:flex-end}.hl-nav-sublist__toggle[aria-expanded=false]+.hl-nav-sublist__panel{opacity:0;visibility:hidden;transform:scale(.9)}.hl-nav-sublist__heading{margin:0;padding:1rem;border-bottom:.5px solid #b3b3b3;font-size:.75em;letter-spacing:.05em;text-transform:uppercase}.hl-nav-sublist__items{list-style-type:none;margin:0;padding:.5rem 0}.hl-nav-sublist__item a,.hl-nav-sublist__item button{display:block;width:100%;padding:.5rem 1rem;text-align:left}.hl-nav-sublist__item a:hover,.hl-nav-sublist__item button:hover{background-color:#ebfaff}.hl-nav-sublist button [class*='__text']{padding:0}.hl-nav-list--vertical .hl-nav-list__items{flex-direction:column;width:200px;width:-webkit-max-content;width:-moz-max-content;width:max-content}.hl-nav-list--vertical .hl-nav-list__item{padding:0 .5rem}@media screen and (max-width:599px){.hl-nav-list{position:relative}.hl-nav-list__items{overflow-x:auto}.hl-nav-list__item{position:static}.hl-nav-list--vertical .hl-nav-list__items{width:unset;flex-direction:row}.hl-nav-list--vertical .hl-nav-list__item{padding:.5rem}.hl-nav-sublist__panel{top:100%;left:0;right:0;width:unset}}@media screen and (min-width:600px){.hl-nav-list--vertical .hl-nav-sublist__panel{top:0;left:100%}}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { orientation: [{
            type: Input
        }], onClick: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], closeActiveSublist: [{
            type: HostListener,
            args: ['document:keyup.esc']
        }], onFocusout: [{
            type: HostListener,
            args: ['focusout', ['$event.relatedTarget']]
        }], label: [{
            type: Input
        }], items: [{
            type: ContentChildren,
            args: [NavListItemDirective]
        }], sublists: [{
            type: ContentChildren,
            args: [NavSublistComponent, { descendants: true }]
        }] }); })();
    return NavListComponent;
}());

var NavListModule = /** @class */ (function () {
    function NavListModule() {
    }
NavListModule.ɵfac = function NavListModule_Factory(t) { return new (t || NavListModule)(); };
NavListModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NavListModule });
NavListModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, ButtonModule, IconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavListModule, [{
        type: NgModule,
        args: [{
                declarations: [NavListItemDirective, NavListComponent, NavSublistComponent, NavSublistToggleDirective],
                imports: [CommonModule, ButtonModule, IconModule],
                exports: [NavListItemDirective, NavListComponent, NavSublistComponent, NavSublistToggleDirective]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NavListModule, { declarations: function () { return [NavListItemDirective, NavListComponent, NavSublistComponent, NavSublistToggleDirective]; }, imports: function () { return [CommonModule, ButtonModule, IconModule]; }, exports: function () { return [NavListItemDirective, NavListComponent, NavSublistComponent, NavSublistToggleDirective]; } }); })();
    return NavListModule;
}());

/**
 * Creates a progress bar component
 */
var ProgressComponent = /** @class */ (function () {
    function ProgressComponent() {
        // We calculate a unique ID per component, so there's always an ID
        // even if the consumer doesn't provide one
        this.id = "hl-progress-" + ProgressComponent_1.componentCount++;
    }
    ProgressComponent_1 = ProgressComponent;
    ProgressComponent.prototype.ngOnInit = function () {
        this.checkRequiredFields();
    };
    ProgressComponent.prototype.ngOnChanges = function () {
        this.checkRequiredFields();
    };
    ProgressComponent.prototype.checkRequiredFields = function () {
        // Consumers must provide at least one type of label.
        if (!this.label && !this.labelledBy) {
            throw new ComponentConfigurationError('A Label is required');
        }
    };
    ProgressComponent.prototype.visibleAriaLabel = function () {
        if (this.visibleLabel) {
            return null;
        }
        else {
            return this.label;
        }
    };
    ProgressComponent.prototype.ariaLabelledBy = function () {
        if (!this.labelledBy) {
            return null;
        }
        else {
            return this.labelledBy;
        }
    };
    ProgressComponent.prototype.progressID = function () {
        if (!this.labelledBy) {
            return null;
        }
        else {
            return this.id;
        }
    };
    var ProgressComponent_1;
    ProgressComponent.componentCount = 0;
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], ProgressComponent.prototype, "max", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], ProgressComponent.prototype, "value", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ProgressComponent.prototype, "label", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ProgressComponent.prototype, "labelledBy", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], ProgressComponent.prototype, "visibleLabel", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ProgressComponent.prototype, "id", void 0);
    ProgressComponent = ProgressComponent_1 = __decorate([ __metadata("design:paramtypes", [])
    ], ProgressComponent);
ProgressComponent.ɵfac = function ProgressComponent_Factory(t) { return new (t || ProgressComponent)(); };
ProgressComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ProgressComponent, selectors: [["hl-progress"]], inputs: { id: "id", max: "max", value: "value", label: "label", labelledBy: "labelledBy", visibleLabel: "visibleLabel" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 6, consts: [[4, "ngIf"], [3, "max", "value"]], template: function ProgressComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ProgressComponent_label_0_Template, 2, 2, "label", 0);
        ɵngcc0.ɵɵelement(1, "progress", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.labelledBy && ctx.visibleLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("max", ctx.max);
        ɵngcc0.ɵɵpropertyInterpolate("value", ctx.value);
        ɵngcc0.ɵɵattribute("id", ctx.progressID())("aria-labelledby", ctx.ariaLabelledBy())("aria-label", ctx.visibleAriaLabel());
    } }, directives: [ɵngcc1.NgIf], styles: ["[_nghost-%COMP%]{display:block}progress[_ngcontent-%COMP%]{-webkit-appearance:none;-moz-appearance:none;appearance:none;width:100%;height:4px;border:none;background-color:var(--hds-progress-background,var(--hds-stepper-background,#e0e0e0))}progress[_ngcontent-%COMP%]::-webkit-progress-bar{height:4px;background-color:var(--hds-progress-background,var(--hds-stepper-background,#e0e0e0));border-radius:999999px}progress[_ngcontent-%COMP%]::-moz-progress-bar{background-color:var(--hds-progress-fill,var(--hds-stepper-accent,var(--hds-theme-accent-primary,#ff5a1f)));border-radius:999999px;height:100%}progress[_ngcontent-%COMP%]::-webkit-progress-value{background-color:var(--hds-progress-fill,var(--hds-stepper-accent,var(--hds-theme-accent-primary,#ff5a1f)));border-radius:999999px;height:100%}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProgressComponent, [{
        type: Component,
        args: [{
                selector: 'hl-progress',
                template: "<label *ngIf=\"!labelledBy && visibleLabel\" [attr.for]=\"progressID()\">\n    {{ label }}\n</label>\n<progress\n    [attr.id]=\"progressID()\"\n    [attr.aria-labelledby]=\"ariaLabelledBy()\"\n    [attr.aria-label]=\"visibleAriaLabel()\"\n    max=\"{{ max }}\"\n    value=\"{{ value }}\"\n>\n</progress>\n",
                styles: [":host{display:block}progress{-webkit-appearance:none;-moz-appearance:none;appearance:none;width:100%;height:4px;border:none;background-color:var(--hds-progress-background,var(--hds-stepper-background,#e0e0e0))}progress::-webkit-progress-bar{height:4px;background-color:var(--hds-progress-background,var(--hds-stepper-background,#e0e0e0));border-radius:999999px}progress::-moz-progress-bar{background-color:var(--hds-progress-fill,var(--hds-stepper-accent,var(--hds-theme-accent-primary,#ff5a1f)));border-radius:999999px;height:100%}progress::-webkit-progress-value{background-color:var(--hds-progress-fill,var(--hds-stepper-accent,var(--hds-theme-accent-primary,#ff5a1f)));border-radius:999999px;height:100%}"]
            }]
    }], function () { return []; }, { id: [{
            type: Input
        }], max: [{
            type: Input
        }], value: [{
            type: Input
        }], label: [{
            type: Input
        }], labelledBy: [{
            type: Input
        }], visibleLabel: [{
            type: Input
        }] }); })();
    return ProgressComponent;
}());

var ProgressModule = /** @class */ (function () {
    function ProgressModule() {
    }
ProgressModule.ɵfac = function ProgressModule_Factory(t) { return new (t || ProgressModule)(); };
ProgressModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ProgressModule });
ProgressModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProgressModule, [{
        type: NgModule,
        args: [{
                declarations: [ProgressComponent],
                entryComponents: [ProgressComponent],
                imports: [CommonModule],
                exports: [ProgressComponent]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ProgressModule, { declarations: function () { return [ProgressComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ProgressComponent]; } }); })();
    return ProgressModule;
}());

/**
 * A styled group of radio options for the user to choose from.
 */
var RadioGroupComponent = /** @class */ (function (_super) {
    __extends(RadioGroupComponent, _super);
    function RadioGroupComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Unique string that serves as a global identifier for the root HTML element
         * and its children.
         */
        _this.id = "hl-radio-group-" + RadioGroupComponent_1.componentCount++;
        /**
         * Controls how the options are displayed.
         */
        _this.display = 'stacked';
        /**
         * An array of options to display in the group.
         */
        _this.options = [];
        /**
         * @ignore
         */
        _this.baseClass = true;
        return _this;
    }
    RadioGroupComponent_1 = RadioGroupComponent;
    Object.defineProperty(RadioGroupComponent.prototype, "isStacked", {
        /**
         * @ignore
         */
        get: function () {
            return this.display === 'stacked';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RadioGroupComponent.prototype, "isInline", {
        /**
         * @ignore
         */
        get: function () {
            return this.display === 'inline';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * ID of the radio group option of the specified index.
     *
     * @param index Index of the option
     *
     * @internal
     */
    RadioGroupComponent.prototype.getOptionId = function (index) {
        return this.id + "-option-" + index;
    };
    /**
     * Selects the specified radio option.
     *
     * @param value Value of the selected option
     */
    RadioGroupComponent.prototype.selectOption = function (value) {
        this.writeValue(value);
        this.onChange(value);
        this.onTouched();
    };
    var RadioGroupComponent_1;
    /**
     * Tracks the number of instances of the component that have been created.
     * Used to generate IDs for child elements, if an ID was not provided.
     *
     * @internal
     */
    RadioGroupComponent.componentCount = 0;
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], RadioGroupComponent.prototype, "id", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], RadioGroupComponent.prototype, "display", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], RadioGroupComponent.prototype, "options", void 0);
    __decorate([
        HostBinding('class.hl-radio-group'),
        __metadata("design:type", Object)
    ], RadioGroupComponent.prototype, "baseClass", void 0);
    __decorate([
        HostBinding('class.hl-radio-group--stacked'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], RadioGroupComponent.prototype, "isStacked", null);
    __decorate([
        HostBinding('class.hl-radio-group--inline'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], RadioGroupComponent.prototype, "isInline", null);
RadioGroupComponent.ɵfac = /*@__PURE__*/ function () { var ɵRadioGroupComponent_BaseFactory; return function RadioGroupComponent_Factory(t) { return (ɵRadioGroupComponent_BaseFactory || (ɵRadioGroupComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(RadioGroupComponent)))(t || RadioGroupComponent); }; }();
RadioGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RadioGroupComponent, selectors: [["hl-radio-group"]], hostVars: 6, hostBindings: function RadioGroupComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hl-radio-group--stacked", ctx.isStacked)("hl-radio-group--inline", ctx.isInline)("hl-radio-group", ctx.baseClass);
    } }, inputs: { id: "id", display: "display", options: "options" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(function () { return RadioGroupComponent_1; }),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 1, consts: [[1, "hl-radio-group__options"], ["class", "hl-radio-group__option", 4, "ngFor", "ngForOf"], [1, "hl-radio-group__option"], ["type", "radio", 1, "hl-a11y--visually-hidden", 3, "id", "name", "value", "required", "disabled", "checked", "blur", "change"], [3, "for"]], template: function RadioGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, RadioGroupComponent_div_1_Template, 4, 9, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.options);
    } }, directives: [ɵngcc1.NgForOf, HDSFormControlDirective], styles: [".hl-radio-group{--border-color:var(--hds-radio-border, #000);--fill-color:var(--hds-radio-fill, var(--hds-theme-accent-primary, #189ec3));--text-color:var(--hds-theme-base-text, #000);--border-error-color:var(--hds-radio-border-error, #e91d00);--fill-error-color:var(--hds-radio-fill-error, #ffe5e5);--focus-shadow-error-color:var(--hds-radio-focus-shadow-error, rgba(233, 29, 0, 0.75));display:block;color:var(--text-color)}.hl-radio-group__option{display:flex;align-items:baseline;margin-bottom:1.5rem}.hl-radio-group__option label{display:inline-flex;line-height:1.5}.hl-radio-group__option label::before{content:'';box-sizing:border-box;flex-shrink:0;height:1.5em;width:1.5em;margin-right:.75rem;border:.125rem solid #000;background-color:var(--hds-input-background,#fff);border-color:var(--border-color);border-radius:999999px}.hl-radio-group__option input:hover+label::before{box-shadow:0 0 8px rgba(0,0,0,.36)}.hl-radio-group__option input:focus+label::before{box-shadow:0 0 0 .125rem var(--hds-theme-base-background),0 0 0 calc(.125rem + .0625rem) var(--hds-theme-focus-ring)}.hl-radio-group__option input:checked+label::before{border-color:#189ec3;background-color:#189ec3}.hl-radio-group__option input:disabled+label{cursor:not-allowed}.hl-radio-group__option input:disabled+label::before{background-color:#f5f5f5;border-color:#c4c4c4;box-shadow:none}.hl-radio-group__option input:checked+label::before{background-image:url('data:image/svg+xml;charset=utf8,%3Csvg fill=\"%23fff\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Ccircle cx=\"48\" cy=\"48\" r=\"24\"/%3E%3C/svg%3E');border-color:var(--fill-color);background-color:var(--fill-color)}.hl-radio-group--inline .hl-radio-group__options{display:flex;flex-wrap:wrap;align-items:baseline}.hl-radio-group--inline .hl-radio-group__option{margin-right:5rem}.hl-radio-group.hl-form-control--disabled .hl-radio-group__option input:checked+label::before{background-image:url('data:image/svg+xml;charset=utf8,%3Csvg fill=\"%23c4c4c4\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Ccircle cx=\"48\" cy=\"48\" r=\"24\"/%3E%3C/svg%3E')}.hl-radio-group input:disabled+label::before{background-color:#f5f5f5;border-color:#c4c4c4}.hl-radio-group.ng-dirty.ng-invalid .hl-radio-group__option input:hover+label::before,.hl-radio-group.ng-dirty.ng-invalid .hl-radio-group__option label::before,.hl-radio-group.ng-touched.ng-invalid .hl-radio-group__option input:hover+label::before,.hl-radio-group.ng-touched.ng-invalid .hl-radio-group__option label::before{background-color:var(--fill-error-color);border-color:var(--border-error-color)}.hl-radio-group.ng-dirty.ng-invalid .hl-radio-group__option input:hover:not(:focus)+label::before,.hl-radio-group.ng-touched.ng-invalid .hl-radio-group__option input:hover:not(:focus)+label::before{box-shadow:0 0 8px var(--focus-shadow-error-color)}"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RadioGroupComponent, [{
        type: Component,
        args: [{
                selector: 'hl-radio-group',
                template: "<div class=\"hl-radio-group__options\">\n    <div *ngFor=\"let option of options; let i = index\" class=\"hl-radio-group__option\">\n        <input\n            type=\"radio\"\n            class=\"hl-a11y--visually-hidden\"\n            [id]=\"getOptionId(i)\"\n            [name]=\"id\"\n            [value]=\"option.value\"\n            [required]=\"required\"\n            [disabled]=\"disabled || option.disabled\"\n            [checked]=\"value === option.value\"\n            [attr.aria-describedby]=\"ariaDescribedBy\"\n            (blur)=\"onTouched()\"\n            (change)=\"selectOption(option.value)\"\n        />\n\n        <label [for]=\"getOptionId(i)\">\n            {{ option.description }}\n        </label>\n    </div>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(function () { return RadioGroupComponent_1; }),
                        multi: true
                    }
                ],
                styles: [".hl-radio-group{--border-color:var(--hds-radio-border, #000);--fill-color:var(--hds-radio-fill, var(--hds-theme-accent-primary, #189ec3));--text-color:var(--hds-theme-base-text, #000);--border-error-color:var(--hds-radio-border-error, #e91d00);--fill-error-color:var(--hds-radio-fill-error, #ffe5e5);--focus-shadow-error-color:var(--hds-radio-focus-shadow-error, rgba(233, 29, 0, 0.75));display:block;color:var(--text-color)}.hl-radio-group__option{display:flex;align-items:baseline;margin-bottom:1.5rem}.hl-radio-group__option label{display:inline-flex;line-height:1.5}.hl-radio-group__option label::before{content:'';box-sizing:border-box;flex-shrink:0;height:1.5em;width:1.5em;margin-right:.75rem;border:.125rem solid #000;background-color:var(--hds-input-background,#fff);border-color:var(--border-color);border-radius:999999px}.hl-radio-group__option input:hover+label::before{box-shadow:0 0 8px rgba(0,0,0,.36)}.hl-radio-group__option input:focus+label::before{box-shadow:0 0 0 .125rem var(--hds-theme-base-background),0 0 0 calc(.125rem + .0625rem) var(--hds-theme-focus-ring)}.hl-radio-group__option input:checked+label::before{border-color:#189ec3;background-color:#189ec3}.hl-radio-group__option input:disabled+label{cursor:not-allowed}.hl-radio-group__option input:disabled+label::before{background-color:#f5f5f5;border-color:#c4c4c4;box-shadow:none}.hl-radio-group__option input:checked+label::before{background-image:url('data:image/svg+xml;charset=utf8,%3Csvg fill=\"%23fff\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Ccircle cx=\"48\" cy=\"48\" r=\"24\"/%3E%3C/svg%3E');border-color:var(--fill-color);background-color:var(--fill-color)}.hl-radio-group--inline .hl-radio-group__options{display:flex;flex-wrap:wrap;align-items:baseline}.hl-radio-group--inline .hl-radio-group__option{margin-right:5rem}.hl-radio-group.hl-form-control--disabled .hl-radio-group__option input:checked+label::before{background-image:url('data:image/svg+xml;charset=utf8,%3Csvg fill=\"%23c4c4c4\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"%3E%3Ccircle cx=\"48\" cy=\"48\" r=\"24\"/%3E%3C/svg%3E')}.hl-radio-group input:disabled+label::before{background-color:#f5f5f5;border-color:#c4c4c4}.hl-radio-group.ng-dirty.ng-invalid .hl-radio-group__option input:hover+label::before,.hl-radio-group.ng-dirty.ng-invalid .hl-radio-group__option label::before,.hl-radio-group.ng-touched.ng-invalid .hl-radio-group__option input:hover+label::before,.hl-radio-group.ng-touched.ng-invalid .hl-radio-group__option label::before{background-color:var(--fill-error-color);border-color:var(--border-error-color)}.hl-radio-group.ng-dirty.ng-invalid .hl-radio-group__option input:hover:not(:focus)+label::before,.hl-radio-group.ng-touched.ng-invalid .hl-radio-group__option input:hover:not(:focus)+label::before{box-shadow:0 0 8px var(--focus-shadow-error-color)}"]
            }]
    }], null, { isStacked: [{
            type: HostBinding,
            args: ['class.hl-radio-group--stacked']
        }], isInline: [{
            type: HostBinding,
            args: ['class.hl-radio-group--inline']
        }], id: [{
            type: Input
        }], display: [{
            type: Input
        }], options: [{
            type: Input
        }], baseClass: [{
            type: HostBinding,
            args: ['class.hl-radio-group']
        }] }); })();
    return RadioGroupComponent;
}(CustomFormControl));

var RadioGroupModule = /** @class */ (function () {
    function RadioGroupModule() {
    }
RadioGroupModule.ɵfac = function RadioGroupModule_Factory(t) { return new (t || RadioGroupModule)(); };
RadioGroupModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: RadioGroupModule });
RadioGroupModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, FormControlsCommonModule, ReactiveFormsModule], FormControlsCommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RadioGroupModule, [{
        type: NgModule,
        args: [{
                declarations: [RadioGroupComponent],
                imports: [CommonModule, FormControlsCommonModule, ReactiveFormsModule],
                exports: [FormControlsCommonModule, RadioGroupComponent]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(RadioGroupModule, { declarations: function () { return [RadioGroupComponent]; }, imports: function () { return [CommonModule, FormControlsCommonModule, ReactiveFormsModule]; }, exports: function () { return [FormControlsCommonModule, RadioGroupComponent]; } }); })();
    return RadioGroupModule;
}());

/**
 * Groups and describes a related set of skeleton components for the sake of
 * easy layout and accessibility.
 *
 * **Note:** Every child of this component is intentionally hidden from screen
 * readers. As a consequence of that, this component should only contain
 * Skeleton Placeholder and Skeleton Text components, or other purely
 * presentational elements.
 */
var SkeletonGroupComponent = /** @class */ (function () {
    function SkeletonGroupComponent() {
    }
    SkeletonGroupComponent.prototype.ngOnInit = function () {
        if (!this.loadingText) {
            throw new AccessibilityError('<hds-skeleton-group> must have loading text so screen reader users will know what type of content the group represents');
        }
    };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SkeletonGroupComponent.prototype, "loadingText", void 0);
SkeletonGroupComponent.ɵfac = function SkeletonGroupComponent_Factory(t) { return new (t || SkeletonGroupComponent)(); };
SkeletonGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SkeletonGroupComponent, selectors: [["hds-skeleton-group"]], inputs: { loadingText: "loadingText" }, ngContentSelectors: _c4, decls: 4, vars: 1, consts: [["aria-hidden", "true"], [1, "hl-a11y--visually-hidden"]], template: function SkeletonGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "span", 1);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.loadingText);
    } }, styles: ["div[aria-hidden=true][_ngcontent-%COMP%]{display:contents}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SkeletonGroupComponent, [{
        type: Component,
        args: [{
                selector: 'hds-skeleton-group',
                template: "<div aria-hidden=\"true\">\n    <ng-content></ng-content>\n</div>\n\n<span class=\"hl-a11y--visually-hidden\">{{ loadingText }}</span>\n",
                styles: ["div[aria-hidden=true]{display:contents}"]
            }]
    }], function () { return []; }, { loadingText: [{
            type: Input
        }] }); })();
    return SkeletonGroupComponent;
}());

/**
 * A placeholder element that represents arbitrary loading content. Can be used
 * either on its own or inside of a Skeleton Group.
 *
 * **Tip:** Try to match the dimensions of the Skeleton Placeholder with the
 * dimensions of the content that will eventually replace it. A closer match to
 * the final UI will minimize layout shift, leading to a less jarring change for
 * the user when the real content loads.
 */
var SkeletonPlaceholderComponent = /** @class */ (function () {
    function SkeletonPlaceholderComponent() {
        /**
         * @ignore
         */
        this.baseClass = true;
    }
    Object.defineProperty(SkeletonPlaceholderComponent.prototype, "ariaHidden", {
        /**
         * @ignore
         */
        get: function () {
            return !this.loadingText;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        HostBinding('class.hds-skeleton'),
        __metadata("design:type", Object)
    ], SkeletonPlaceholderComponent.prototype, "baseClass", void 0);
    __decorate([
        Input(), HostBinding('style.height'),
        __metadata("design:type", String)
    ], SkeletonPlaceholderComponent.prototype, "height", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SkeletonPlaceholderComponent.prototype, "loadingText", void 0);
    __decorate([
        HostBinding('attr.aria-hidden'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SkeletonPlaceholderComponent.prototype, "ariaHidden", null);
SkeletonPlaceholderComponent.ɵfac = function SkeletonPlaceholderComponent_Factory(t) { return new (t || SkeletonPlaceholderComponent)(); };
SkeletonPlaceholderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SkeletonPlaceholderComponent, selectors: [["hds-skeleton-placeholder"]], hostVars: 5, hostBindings: function SkeletonPlaceholderComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-hidden", ctx.ariaHidden);
        ɵngcc0.ɵɵstyleProp("height", ctx.height);
        ɵngcc0.ɵɵclassProp("hds-skeleton", ctx.baseClass);
    } }, inputs: { height: "height", loadingText: "loadingText" }, decls: 1, vars: 1, consts: [["class", "hl-a11y--visually-hidden", 4, "ngIf"], [1, "hl-a11y--visually-hidden"]], template: function SkeletonPlaceholderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SkeletonPlaceholderComponent_span_0_Template, 2, 1, "span", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.loadingText);
    } }, directives: [ɵngcc1.NgIf], styles: ["[_nghost-%COMP%] { display: block; min-height: 1rem; }"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SkeletonPlaceholderComponent, [{
        type: Component,
        args: [{
                selector: 'hds-skeleton-placeholder',
                template: '<span *ngIf="loadingText" class="hl-a11y--visually-hidden">{{ loadingText }}</span>',
                styles: [':host { display: block; min-height: 1rem; }']
            }]
    }], function () { return []; }, { baseClass: [{
            type: HostBinding,
            args: ['class.hds-skeleton']
        }], ariaHidden: [{
            type: HostBinding,
            args: ['attr.aria-hidden']
        }], height: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['style.height']
        }], loadingText: [{
            type: Input
        }] }); })();
    return SkeletonPlaceholderComponent;
}());

/**
 * Renders a series of placeholder elements that approximate the look and feel
 * of a block of text. Can be used either on its own or inside of a Skeleton
 * Group.
 *
 * **Tip:** Try to match the type styles and the number of lines in the Skeleton
 * Text with that of the text that will eventually replace it. A closer match to
 * the final UI will minimize layout shift, leading to a less jarring change for
 * the user when the real content loads.
 *
 * This component will adapt to the HDS type specimen CSS classes
 * (`.hl-font--*`). Add a specimen class to the component to mimic the size and
 * spacing of that type specimen.
 */
var SkeletonTextComponent = /** @class */ (function () {
    function SkeletonTextComponent() {
        /**
         * The number of lines of skeleton text to display.
         */
        this.lines = 5;
        /**
         * Minimum width any line can be, as a percentage of the component width.
         */
        this.minLineWidth = 30;
        /**
         * Maximum width any line can be, as a percentage of the component width.
         */
        this.maxLineWidth = 100;
        /**
         * @ignore
         */
        this.lineWidths = [];
    }
    Object.defineProperty(SkeletonTextComponent.prototype, "ariaHidden", {
        /**
         * @ignore
         */
        get: function () {
            return !this.loadingText;
        },
        enumerable: true,
        configurable: true
    });
    SkeletonTextComponent.prototype.ngOnChanges = function () {
        var _this = this;
        this.lineWidths = Array.from(Array(this.lines)).map(function (_) { return _this.getRandomWidth(); });
    };
    /**
     * @ignore
     */
    SkeletonTextComponent.prototype.getRandomWidth = function () {
        var lineWidth = Math.floor(this.minLineWidth + Math.random() * (this.maxLineWidth - this.minLineWidth + 1));
        return lineWidth + "%";
    };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], SkeletonTextComponent.prototype, "lines", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], SkeletonTextComponent.prototype, "minLineWidth", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], SkeletonTextComponent.prototype, "maxLineWidth", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SkeletonTextComponent.prototype, "loadingText", void 0);
    __decorate([
        HostBinding('attr.aria-hidden'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SkeletonTextComponent.prototype, "ariaHidden", null);
SkeletonTextComponent.ɵfac = function SkeletonTextComponent_Factory(t) { return new (t || SkeletonTextComponent)(); };
SkeletonTextComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SkeletonTextComponent, selectors: [["hds-skeleton-text"]], hostVars: 1, hostBindings: function SkeletonTextComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-hidden", ctx.ariaHidden);
    } }, inputs: { lines: "lines", minLineWidth: "minLineWidth", maxLineWidth: "maxLineWidth", loadingText: "loadingText" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [["class", "hds-skeleton", 3, "width", 4, "ngFor", "ngForOf"], ["class", "hl-a11y--visually-hidden", 4, "ngIf"], [1, "hds-skeleton"], [1, "hl-a11y--visually-hidden"]], template: function SkeletonTextComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SkeletonTextComponent_p_0_Template, 2, 3, "p", 0);
        ɵngcc0.ɵɵtemplate(1, SkeletonTextComponent_span_1_Template, 2, 1, "span", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.lineWidths);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loadingText);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgIf], styles: ["[_nghost-%COMP%]{display:block}p[_ngcontent-%COMP%]{max-width:100%;margin:0;font-size:inherit;line-height:inherit;-webkit-mask-image:linear-gradient(to top,transparent,transparent calc((100% - 1em)/ 2),#fff calc((100% - 1em)/ 2),#fff calc(calc((100% - 1em)/ 2) + 1em),transparent calc(calc((100% - 1em)/ 2) + 1em),transparent);mask-image:linear-gradient(to top,transparent,transparent calc((100% - 1em)/ 2),#fff calc((100% - 1em)/ 2),#fff calc(calc((100% - 1em)/ 2) + 1em),transparent calc(calc((100% - 1em)/ 2) + 1em),transparent)}@media screen and (forced-colors:active){p[_ngcontent-%COMP%]{outline-offset:-2px;-webkit-mask-image:none;mask-image:none}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SkeletonTextComponent, [{
        type: Component,
        args: [{
                selector: 'hds-skeleton-text',
                template: "<p *ngFor=\"let lineWidth of lineWidths\" class=\"hds-skeleton\" [attr.aria-hidden]=\"true\" [style.width]=\"lineWidth\">\n    &#8203;\n</p>\n<span *ngIf=\"loadingText\" class=\"hl-a11y--visually-hidden\">{{ loadingText }}</span>\n",
                styles: [":host{display:block}p{max-width:100%;margin:0;font-size:inherit;line-height:inherit;-webkit-mask-image:linear-gradient(to top,transparent,transparent calc((100% - 1em)/ 2),#fff calc((100% - 1em)/ 2),#fff calc(calc((100% - 1em)/ 2) + 1em),transparent calc(calc((100% - 1em)/ 2) + 1em),transparent);mask-image:linear-gradient(to top,transparent,transparent calc((100% - 1em)/ 2),#fff calc((100% - 1em)/ 2),#fff calc(calc((100% - 1em)/ 2) + 1em),transparent calc(calc((100% - 1em)/ 2) + 1em),transparent)}@media screen and (forced-colors:active){p{outline-offset:-2px;-webkit-mask-image:none;mask-image:none}}"]
            }]
    }], function () { return []; }, { lines: [{
            type: Input
        }], minLineWidth: [{
            type: Input
        }], maxLineWidth: [{
            type: Input
        }], ariaHidden: [{
            type: HostBinding,
            args: ['attr.aria-hidden']
        }], loadingText: [{
            type: Input
        }] }); })();
    return SkeletonTextComponent;
}());

var SkeletonModule = /** @class */ (function () {
    function SkeletonModule() {
    }
SkeletonModule.ɵfac = function SkeletonModule_Factory(t) { return new (t || SkeletonModule)(); };
SkeletonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SkeletonModule });
SkeletonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SkeletonModule, [{
        type: NgModule,
        args: [{
                declarations: [SkeletonGroupComponent, SkeletonPlaceholderComponent, SkeletonTextComponent],
                imports: [CommonModule],
                exports: [SkeletonGroupComponent, SkeletonPlaceholderComponent, SkeletonTextComponent]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SkeletonModule, { declarations: function () { return [SkeletonGroupComponent, SkeletonPlaceholderComponent, SkeletonTextComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [SkeletonGroupComponent, SkeletonPlaceholderComponent, SkeletonTextComponent]; } }); })();
    return SkeletonModule;
}());

/**
 * Creates step component to be used only by hds-step-list
 */
var StepListStepComponent = /** @class */ (function () {
    function StepListStepComponent(el) {
        this.el = el;
    }
    StepListStepComponent.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], StepListStepComponent.prototype, "number", void 0);
    StepListStepComponent = __decorate([ __metadata("design:paramtypes", [ElementRef])
    ], StepListStepComponent);
StepListStepComponent.ɵfac = function StepListStepComponent_Factory(t) { return new (t || StepListStepComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
StepListStepComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: StepListStepComponent, selectors: [["a", "hdsStep", ""]], inputs: { number: "number" }, attrs: _c31, ngContentSelectors: _c4, decls: 9, vars: 2, consts: [[1, "hds-step__step"], [1, "hds-step__circle"], [1, "hl-a11y--visually-hidden"], ["icon", "confirm", 1, "hds-step__icon"], ["aria-hidden", "true", 1, "hds-step__number"], [1, "hds-step__text"]], template: function StepListStepComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(4, "hl-icon", 3);
        ɵngcc0.ɵɵelementStart(5, "span", 4);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "span", 5);
        ɵngcc0.ɵɵprojection(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("Step ", ctx.number, ",");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.number);
    } }, directives: [IconComponent], styles: ["[_nghost-%COMP%]{--step-size:24px}.hds-step__circle[_ngcontent-%COMP%]{width:var(--step-size);height:var(--step-size);display:flex;justify-content:center;align-items:center;background-color:var(--hds-theme-base-background,#fff);color:var(--hds-theme-supplementary-text);border:2px solid var(--hds-stepper-background,#e0e0e0);border-radius:999999px}.hds-step__circle[_ngcontent-%COMP%] > .hds-step__icon[_ngcontent-%COMP%]{display:none}@media screen and (min-width:768px) and (max-width:1023px){[_nghost-%COMP%]{--step-size:20px}.hds-step__circle[_ngcontent-%COMP%] > .hds-step__icon[_ngcontent-%COMP%]{font-size:12px}}.hds-step__number[_ngcontent-%COMP%], .hds-step__text[_ngcontent-%COMP%]{margin-top:0;margin-bottom:0;font-size:.75rem;line-height:1.33333;letter-spacing:0;text-align:center}.hds-step__text[_ngcontent-%COMP%]{position:absolute;width:150px;top:24px;color:var(--hds-theme-supplementary-text)}.hds-step__step[_ngcontent-%COMP%]{width:100%;display:flex;align-items:center;justify-content:center;flex-direction:column;position:relative}@media screen and (max-width:767px){[_nghost-%COMP%]{--step-size:12px}.hds-step__circle[_ngcontent-%COMP%] > .hds-step__icon[_ngcontent-%COMP%], .hds-step__text.hds-step__text--complete[_ngcontent-%COMP%], .hds-step__text.hds-step__text--incomplete[_ngcontent-%COMP%]{display:none}.hds-step__text.hds-step__text--current[_ngcontent-%COMP%]{top:-24px}.hds-step__number[_ngcontent-%COMP%]{display:none}}.hds-step__first-step[_nghost-%COMP%]   .hds-step__step[_ngcontent-%COMP%]{align-items:flex-start}.hds-step__first-step[_nghost-%COMP%]   .hds-step__step[_ngcontent-%COMP%]   .hds-step__text[_ngcontent-%COMP%]{text-align:left}.hds-step__last-step[_nghost-%COMP%]   .hds-step__step[_ngcontent-%COMP%]{align-items:flex-end}.hds-step__last-step[_nghost-%COMP%]   .hds-step__step[_ngcontent-%COMP%]   .hds-step__text[_ngcontent-%COMP%]{text-align:right}.hds-step__active-step[_nghost-%COMP%]   .hds-step__number[_ngcontent-%COMP%]{display:inline-block}.hds-step__active-step[_nghost-%COMP%]   .hds-step__text[_ngcontent-%COMP%]{font-weight:700;color:var(--hds-theme-base-text)}.hds-step__active-step[_nghost-%COMP%]   .hds-step__icon[_ngcontent-%COMP%]{display:none}.hds-step__active-step[_nghost-%COMP%]   .hds-step__circle[_ngcontent-%COMP%]{background-color:var(--hds-stepper-accent,var(--hds-theme-accent-primary,#ff5a1f));color:#fff;border:none}.hds-step__complete-step[_nghost-%COMP%]   .hds-step__circle[_ngcontent-%COMP%]{background-color:var(--hds-stepper-accent,var(--hds-theme-accent-primary,#ff5a1f));color:#fff;border:none}.hds-step__complete-step[_nghost-%COMP%]   .hds-step__number[_ngcontent-%COMP%]{display:none}.hds-step__complete-step[_nghost-%COMP%]   .hds-step__icon[_ngcontent-%COMP%]{display:inline-block}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StepListStepComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line
                selector: 'a[hdsStep]',
                template: "<div class=\"hds-step__step\">\n    <div class=\"hds-step__circle\">\n        <span class=\"hl-a11y--visually-hidden\">Step {{ number }},</span>\n\n        <hl-icon class=\"hds-step__icon\" icon=\"confirm\"></hl-icon>\n        <span class=\"hds-step__number\" aria-hidden=\"true\">{{ number }}</span>\n    </div>\n    <span class=\"hds-step__text\">\n        <ng-content></ng-content>\n    </span>\n</div>\n",
                styles: [":host{--step-size:24px}.hds-step__circle{width:var(--step-size);height:var(--step-size);display:flex;justify-content:center;align-items:center;background-color:var(--hds-theme-base-background,#fff);color:var(--hds-theme-supplementary-text);border:2px solid var(--hds-stepper-background,#e0e0e0);border-radius:999999px}.hds-step__circle>.hds-step__icon{display:none}@media screen and (min-width:768px) and (max-width:1023px){:host{--step-size:20px}.hds-step__circle>.hds-step__icon{font-size:12px}}.hds-step__number,.hds-step__text{margin-top:0;margin-bottom:0;font-size:.75rem;line-height:1.33333;letter-spacing:0;text-align:center}.hds-step__text{position:absolute;width:150px;top:24px;color:var(--hds-theme-supplementary-text)}.hds-step__step{width:100%;display:flex;align-items:center;justify-content:center;flex-direction:column;position:relative}@media screen and (max-width:767px){:host{--step-size:12px}.hds-step__circle>.hds-step__icon,.hds-step__text.hds-step__text--complete,.hds-step__text.hds-step__text--incomplete{display:none}.hds-step__text.hds-step__text--current{top:-24px}.hds-step__number{display:none}}:host(.hds-step__first-step) .hds-step__step{align-items:flex-start}:host(.hds-step__first-step) .hds-step__step .hds-step__text{text-align:left}:host(.hds-step__last-step) .hds-step__step{align-items:flex-end}:host(.hds-step__last-step) .hds-step__step .hds-step__text{text-align:right}:host(.hds-step__active-step) .hds-step__number{display:inline-block}:host(.hds-step__active-step) .hds-step__text{font-weight:700;color:var(--hds-theme-base-text)}:host(.hds-step__active-step) .hds-step__icon{display:none}:host(.hds-step__active-step) .hds-step__circle{background-color:var(--hds-stepper-accent,var(--hds-theme-accent-primary,#ff5a1f));color:#fff;border:none}:host(.hds-step__complete-step) .hds-step__circle{background-color:var(--hds-stepper-accent,var(--hds-theme-accent-primary,#ff5a1f));color:#fff;border:none}:host(.hds-step__complete-step) .hds-step__number{display:none}:host(.hds-step__complete-step) .hds-step__icon{display:inline-block}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { number: [{
            type: Input
        }] }); })();
    return StepListStepComponent;
}());

/**
 * Creates a Step List component
 */
var StepListComponent = /** @class */ (function () {
    function StepListComponent(el, cd, render) {
        this.el = el;
        this.cd = cd;
        this.render = render;
        /**
         * Sets the label for A11Y to the progress bar, use a descriptive text of what this progress represents.
         * Example: 'Siging up progress'
         */
        this.progressLabel = 'Progress bar';
        /**
         * Set the attribute to flag an active element from the list
         */
        this.active = 'active';
        /**
         * @ignore
         */
        /* istanbul ignore next */
        this.totalStepsSubject = new BehaviorSubject(0);
        /**
         * @ignore
         */
        /* istanbul ignore next */
        this.totalSteps$ = this.totalStepsSubject.asObservable();
        /**
         * @ignore
         */
        /* istanbul ignore next */
        this.activeStepSubject = new BehaviorSubject(0);
        /**
         * @ignore
         */
        /* istanbul ignore next */
        this.activeStep$ = this.activeStepSubject.asObservable();
    }
    /* istanbul ignore next */
    StepListComponent.prototype.ngOnChanges = function (changes) {
        if (changes.totalProgress) {
            this.totalStepsSubject.next(changes.totalProgress.currentValue);
            this.cd.detectChanges();
        }
        if (changes.currentProgress) {
            this.activeStepSubject.next(changes.currentProgress.currentValue);
            this.cd.detectChanges();
        }
    };
    StepListComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        if (this.currentProgress > 0) {
            this.activeStepSubject.next(this.currentProgress);
        }
        var listEl = this.el.nativeElement.querySelector('.hds-step-list__list');
        var completedFlag = true;
        this.steps.forEach(function (step, index) {
            step.number = index + 1;
            var liWrapper = _this.render.createElement('li');
            _this.render.appendChild(liWrapper, step.el.nativeElement);
            _this.render.appendChild(listEl, liWrapper);
            if (step.el.nativeElement.getAttribute(_this.active) !== null) {
                if (_this.currentProgress === 0) {
                    _this.activeStepSubject.next(index);
                }
                _this.render.addClass(step.el.nativeElement, 'hds-step__active-step');
                completedFlag = false;
            }
            if (completedFlag) {
                _this.render.addClass(step.el.nativeElement, 'hds-step__complete-step');
            }
            if (_this.isFirstStep(index)) {
                _this.render.addClass(step.el.nativeElement, 'hds-step__first-step');
            }
            if (_this.isLastStep(index)) {
                _this.render.addClass(step.el.nativeElement, 'hds-step__last-step');
            }
        });
        if (this.totalProgress > 0) {
            this.totalStepsSubject.next(this.totalProgress);
        }
        else {
            this.totalStepsSubject.next(this.steps.length - 1);
        }
    };
    StepListComponent.prototype.isFirstStep = function (index) {
        return index === 0;
    };
    StepListComponent.prototype.isLastStep = function (index) {
        return index === this.steps.length - 1;
    };
    StepListComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: ChangeDetectorRef },
        { type: Renderer2 }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], StepListComponent.prototype, "progressLabel", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], StepListComponent.prototype, "totalProgress", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], StepListComponent.prototype, "currentProgress", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], StepListComponent.prototype, "active", void 0);
    __decorate([
        ContentChildren(StepListStepComponent),
        __metadata("design:type", QueryList)
    ], StepListComponent.prototype, "steps", void 0);
    StepListComponent = __decorate([ __metadata("design:paramtypes", [ElementRef, ChangeDetectorRef, Renderer2])
    ], StepListComponent);
StepListComponent.ɵfac = function StepListComponent_Factory(t) { return new (t || StepListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
StepListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: StepListComponent, selectors: [["hds-step-list"]], contentQueries: function StepListComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, StepListStepComponent, 4);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.steps = _t);
    } }, inputs: { progressLabel: "progressLabel", active: "active", totalProgress: "totalProgress", currentProgress: "currentProgress" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c33, decls: 6, vars: 7, consts: [[1, "hds-step-list__progress"], [3, "max", "value", "label"], ["role", "list", 1, "hds-step-list__list"]], template: function StepListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c32);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "hl-progress", 1);
        ɵngcc0.ɵɵpipe(2, "async");
        ɵngcc0.ɵɵpipe(3, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "ul", 2);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("max", ɵngcc0.ɵɵpipeBind1(2, 3, ctx.totalSteps$))("value", ɵngcc0.ɵɵpipeBind1(3, 5, ctx.activeStep$))("label", ctx.progressLabel);
    } }, directives: [ProgressComponent], pipes: [ɵngcc1.AsyncPipe], styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column}[_nghost-%COMP%]   .hds-step-list__list[_ngcontent-%COMP%]{list-style:none;display:flex;width:100%;justify-content:space-between;padding:0}[_nghost-%COMP%]   .hds-step-list__progress[_ngcontent-%COMP%]{position:relative}[_nghost-%COMP%]   .hds-step-list__progress[_ngcontent-%COMP%]   hl-progress[_ngcontent-%COMP%]{position:absolute;width:100%;padding:0 6px;top:9px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StepListComponent, [{
        type: Component,
        args: [{
                selector: 'hds-step-list',
                template: "<div class=\"hds-step-list__progress\">\n    <hl-progress [max]=\"totalSteps$ | async\" [value]=\"activeStep$ | async\" [label]=\"progressLabel\"></hl-progress>\n</div>\n<ul role=\"list\" class=\"hds-step-list__list\">\n    <ng-content select=\"[hdsStep]\"></ng-content>\n</ul>\n",
                styles: [":host{display:flex;flex-direction:column}:host .hds-step-list__list{list-style:none;display:flex;width:100%;justify-content:space-between;padding:0}:host .hds-step-list__progress{position:relative}:host .hds-step-list__progress hl-progress{position:absolute;width:100%;padding:0 6px;top:9px}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.Renderer2 }]; }, { progressLabel: [{
            type: Input
        }], active: [{
            type: Input
        }], totalProgress: [{
            type: Input
        }], currentProgress: [{
            type: Input
        }], steps: [{
            type: ContentChildren,
            args: [StepListStepComponent]
        }] }); })();
    return StepListComponent;
}());

var StepListModule = /** @class */ (function () {
    function StepListModule() {
    }
StepListModule.ɵfac = function StepListModule_Factory(t) { return new (t || StepListModule)(); };
StepListModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: StepListModule });
StepListModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, ProgressModule, IconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StepListModule, [{
        type: NgModule,
        args: [{
                declarations: [StepListComponent, StepListStepComponent],
                imports: [CommonModule, ProgressModule, IconModule],
                exports: [StepListComponent, StepListStepComponent]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(StepListModule, { declarations: function () { return [StepListComponent, StepListStepComponent]; }, imports: function () { return [CommonModule, ProgressModule, IconModule]; }, exports: function () { return [StepListComponent, StepListStepComponent]; } }); })();
    return StepListModule;
}());

/**
 * Creates step component to be used only by hl-stepper
 */
var StepComponent = /** @class */ (function () {
    function StepComponent() {
        /**
         * Sets the current state for the component, allowed values 'incomplete' | 'current' | 'complete'
         * Defaults to 'incomplete'
         */
        this.state = 'incomplete';
    }
    StepComponent.prototype.stepClass = function (element) {
        return this.state ? "hl-step__" + element + "--" + this.state : null;
    };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], StepComponent.prototype, "state", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], StepComponent.prototype, "number", void 0);
StepComponent.ɵfac = function StepComponent_Factory(t) { return new (t || StepComponent)(); };
StepComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: StepComponent, selectors: [["hl-step"], ["button", "hlStep", ""], ["a", "hlStep", ""]], inputs: { state: "state", number: "number" }, ngContentSelectors: _c4, decls: 10, vars: 6, consts: [["role", "listitem", 1, "hl-step__step"], [1, "hl-step__circle", 3, "ngClass"], [1, "hl-a11y--visually-hidden"], ["class", "hl-step__icon", "icon", "confirm", 4, "ngIf"], ["class", "hl-step__number", "aria-hidden", "true", 4, "ngIf"], [1, "hl-step__text", 3, "ngClass"], ["icon", "confirm", 1, "hl-step__icon"], ["aria-hidden", "true", 1, "hl-step__number"]], template: function StepComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, StepComponent_hl_icon_4_Template, 1, 0, "hl-icon", 3);
        ɵngcc0.ɵɵtemplate(5, StepComponent_span_5_Template, 2, 1, "span", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "span", 5);
        ɵngcc0.ɵɵprojection(7);
        ɵngcc0.ɵɵelementStart(8, "span", 2);
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.stepClass("circle"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1("Step ", ctx.number, ",");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.state === "complete");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.state !== "complete");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.stepClass("text"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(", ", ctx.state, "");
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf, IconComponent], styles: ["[_nghost-%COMP%]{--step-size:24px}button[_nghost-%COMP%]{margin:0;padding:0;border:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;overflow:visible;font-family:inherit;font-size:1rem;text-decoration:none;text-transform:none;background-color:transparent;color:inherit;cursor:pointer}.hl-step--first[_nghost-%COMP%]   .hl-step__step[_ngcontent-%COMP%]{align-items:flex-start}.hl-step--first[_nghost-%COMP%]   .hl-step__text[_ngcontent-%COMP%]{text-align:left}.hl-step--last[_nghost-%COMP%]   .hl-step__step[_ngcontent-%COMP%]{align-items:flex-end}.hl-step--last[_nghost-%COMP%]   .hl-step__text[_ngcontent-%COMP%]{text-align:right}.hl-step__circle[_ngcontent-%COMP%]{width:var(--step-size);height:var(--step-size);display:flex;justify-content:center;align-items:center;background-color:var(--hds-theme-base-background,#fff);color:var(--hds-theme-supplementary-text);border:2px solid var(--hds-stepper-background,#e0e0e0);border-radius:999999px}@media screen and (min-width:768px) and (max-width:1023px){[_nghost-%COMP%]{--step-size:20px}.hl-step__circle[_ngcontent-%COMP%] > .hl-step__icon[_ngcontent-%COMP%]{font-size:12px}}.hl-step__circle--complete[_ngcontent-%COMP%], .hl-step__circle--current[_ngcontent-%COMP%]{background-color:var(--hds-stepper-accent,var(--hds-theme-accent-primary,#ff5a1f));color:#fff;border:none}.hl-step__number[_ngcontent-%COMP%], .hl-step__text[_ngcontent-%COMP%]{margin-top:0;margin-bottom:0;font-size:.75rem;line-height:1.33333;letter-spacing:0;text-align:center}.hl-step__text[_ngcontent-%COMP%]{position:absolute;width:150px;top:24px;color:var(--hds-theme-supplementary-text)}.hl-step--active[_nghost-%COMP%]   .hl-step__text[_ngcontent-%COMP%]{font-weight:700;color:var(--hds-theme-base-text)}.hl-step__step[_ngcontent-%COMP%]{width:100%;display:flex;align-items:center;justify-content:center;flex-direction:column;position:relative}@media screen and (max-width:767px){[_nghost-%COMP%]{--step-size:12px}.hl-step__circle[_ngcontent-%COMP%] > .hl-step__icon[_ngcontent-%COMP%], .hl-step__text.hl-step__text--complete[_ngcontent-%COMP%], .hl-step__text.hl-step__text--incomplete[_ngcontent-%COMP%]{display:none}.hl-step__text.hl-step__text--current[_ngcontent-%COMP%]{top:-24px}.hl-step__number[_ngcontent-%COMP%]{display:none}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StepComponent, [{
        type: Component,
        args: [{
                selector: 'hl-step, button[hlStep], a[hlStep]',
                template: "<div class=\"hl-step__step\" role=\"listitem\">\n    <div class=\"hl-step__circle\" [ngClass]=\"stepClass('circle')\">\n        <span class=\"hl-a11y--visually-hidden\">Step {{ number }},</span>\n\n        <hl-icon class=\"hl-step__icon\" *ngIf=\"state === 'complete'\" icon=\"confirm\"></hl-icon>\n        <span class=\"hl-step__number\" *ngIf=\"state !== 'complete'\" aria-hidden=\"true\">{{ number }}</span>\n    </div>\n    <span class=\"hl-step__text\" [ngClass]=\"stepClass('text')\">\n        <!-- A11Y descriptions -->\n        <ng-content></ng-content>\n        <span class=\"hl-a11y--visually-hidden\">, {{ state }}</span>\n    </span>\n</div>\n",
                styles: [":host{--step-size:24px}:host(button){margin:0;padding:0;border:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;overflow:visible;font-family:inherit;font-size:1rem;text-decoration:none;text-transform:none;background-color:transparent;color:inherit;cursor:pointer}:host(.hl-step--first) .hl-step__step{align-items:flex-start}:host(.hl-step--first) .hl-step__text{text-align:left}:host(.hl-step--last) .hl-step__step{align-items:flex-end}:host(.hl-step--last) .hl-step__text{text-align:right}.hl-step__circle{width:var(--step-size);height:var(--step-size);display:flex;justify-content:center;align-items:center;background-color:var(--hds-theme-base-background,#fff);color:var(--hds-theme-supplementary-text);border:2px solid var(--hds-stepper-background,#e0e0e0);border-radius:999999px}@media screen and (min-width:768px) and (max-width:1023px){:host{--step-size:20px}.hl-step__circle>.hl-step__icon{font-size:12px}}.hl-step__circle--complete,.hl-step__circle--current{background-color:var(--hds-stepper-accent,var(--hds-theme-accent-primary,#ff5a1f));color:#fff;border:none}.hl-step__number,.hl-step__text{margin-top:0;margin-bottom:0;font-size:.75rem;line-height:1.33333;letter-spacing:0;text-align:center}.hl-step__text{position:absolute;width:150px;top:24px;color:var(--hds-theme-supplementary-text)}:host(.hl-step--active) .hl-step__text{font-weight:700;color:var(--hds-theme-base-text)}.hl-step__step{width:100%;display:flex;align-items:center;justify-content:center;flex-direction:column;position:relative}@media screen and (max-width:767px){:host{--step-size:12px}.hl-step__circle>.hl-step__icon,.hl-step__text.hl-step__text--complete,.hl-step__text.hl-step__text--incomplete{display:none}.hl-step__text.hl-step__text--current{top:-24px}.hl-step__number{display:none}}"]
            }]
    }], function () { return []; }, { state: [{
            type: Input
        }], number: [{
            type: Input
        }] }); })();
    return StepComponent;
}());

/**
 * Creates a stepper component
 * @deprecated Use the `Step List` component instead.
 */
var StepperComponent = /** @class */ (function () {
    function StepperComponent() {
        this._currentStep = 1;
        /**
         * Numeric value from 0 - 100 for the percentage of the progress bar complete value
         */
        this.progressValue = 0;
        /**
         * Array of strings for the steps labels
         */
        this.stepList = [];
        /**
         * Used for A11Y as a label to the step list and progress bar
         */
        this.stepperLabel = 'Step list';
        this.activeStepChange = new EventEmitter();
    }
    Object.defineProperty(StepperComponent.prototype, "currentStep", {
        get: function () {
            return this._currentStep;
        },
        /**
         * The current step in the stepper, based index 1
         */
        set: function (value) {
            this._currentStep = value;
            if (this.activeStep !== this._currentStep - 1) {
                this.setActiveStep(this._currentStep - 1);
            }
        },
        enumerable: true,
        configurable: true
    });
    StepperComponent.prototype.ngOnInit = function () {
        this.activeStep = this.activeStep || this.currentStep - 1;
    };
    StepperComponent.prototype.stepState = function (index) {
        return this.currentStep === ++index ? 'current' : this.currentStep > index ? 'complete' : 'incomplete';
    };
    StepperComponent.prototype.isIncomplete = function (index) {
        return this.currentStep <= index;
    };
    StepperComponent.prototype.stepNumber = function (index) {
        return this.numbered ? ++index : null;
    };
    StepperComponent.prototype.setActiveStep = function (index) {
        this.activeStep = index;
        this.activeStepChange.emit(this.activeStep);
    };
    __decorate([
        Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], StepperComponent.prototype, "currentStep", null);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], StepperComponent.prototype, "activeStep", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], StepperComponent.prototype, "progressValue", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], StepperComponent.prototype, "stepList", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], StepperComponent.prototype, "numbered", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], StepperComponent.prototype, "stepperLabel", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], StepperComponent.prototype, "activeStepChange", void 0);
StepperComponent.ɵfac = function StepperComponent_Factory(t) { return new (t || StepperComponent)(); };
StepperComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: StepperComponent, selectors: [["hl-stepper"]], inputs: { progressValue: "progressValue", stepList: "stepList", stepperLabel: "stepperLabel", currentStep: "currentStep", activeStep: "activeStep", numbered: "numbered" }, outputs: { activeStepChange: "activeStepChange" }, decls: 4, vars: 6, consts: [[1, "hl-stepper__progress"], ["max", "100", 3, "value", "label"], ["role", "list", 1, "hl-stepper__step-container"], [4, "ngFor", "ngForOf"], [4, "ngIf", "ngIfElse"], ["stepWithAction", ""], ["state", "incomplete", 3, "number"], ["hlStep", "", 3, "state", "number", "click"]], template: function StepperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "hl-progress", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, StepperComponent_ng_container_3_Template, 4, 2, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("value", ctx.progressValue)("label", ctx.stepperLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattributeInterpolate3("aria-label", "", ctx.stepperLabel, ", step ", ctx.currentStep, " of ", ctx.stepList.length, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.stepList);
    } }, directives: [ProgressComponent, ɵngcc1.NgForOf, ɵngcc1.NgIf, StepComponent], styles: ["[_nghost-%COMP%]{display:block;padding-bottom:1.25rem}.hl-stepper__step-container[_ngcontent-%COMP%]{display:flex;width:100%;justify-content:space-between;margin-top:-15px}@media screen and (min-width:768px) and (max-width:1023px){.hl-stepper__step-container[_ngcontent-%COMP%]{margin-top:-13px}}@media screen and (max-width:767px){[_nghost-%COMP%]{padding-top:24px}.hl-stepper__step-container[_ngcontent-%COMP%]{margin-top:-9px}}.hl-stepper__progress[_ngcontent-%COMP%]{padding:0 6px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StepperComponent, [{
        type: Component,
        args: [{
                selector: 'hl-stepper',
                template: "<div class=\"hl-stepper__progress\">\n    <hl-progress max=\"100\" [value]=\"progressValue\" [label]=\"stepperLabel\"></hl-progress>\n</div>\n<div\n    class=\"hl-stepper__step-container\"\n    role=\"list\"\n    attr.aria-label=\"{{ stepperLabel }}, step {{ currentStep }} of {{ stepList.length }}\"\n>\n    <ng-container *ngFor=\"let step of stepList; index as i; let first = first; let last = last\">\n        <ng-container *ngIf=\"isIncomplete(i); else stepWithAction\">\n            <hl-step\n                [class.hl-step--first]=\"first\"\n                [class.hl-step--last]=\"last\"\n                [class.hl-step--active]=\"i === activeStep\"\n                state=\"incomplete\"\n                [number]=\"stepNumber(i)\"\n                >{{ step }}</hl-step\n            >\n        </ng-container>\n        <ng-template #stepWithAction>\n            <button\n                hlStep\n                [class.hl-step--first]=\"first\"\n                [class.hl-step--last]=\"last\"\n                [class.hl-step--active]=\"i === activeStep\"\n                [state]=\"stepState(i)\"\n                [number]=\"stepNumber(i)\"\n                (click)=\"setActiveStep(i)\"\n            >\n                {{ step }}\n            </button>\n        </ng-template>\n    </ng-container>\n</div>\n",
                styles: [":host{display:block;padding-bottom:1.25rem}.hl-stepper__step-container{display:flex;width:100%;justify-content:space-between;margin-top:-15px}@media screen and (min-width:768px) and (max-width:1023px){.hl-stepper__step-container{margin-top:-13px}}@media screen and (max-width:767px){:host{padding-top:24px}.hl-stepper__step-container{margin-top:-9px}}.hl-stepper__progress{padding:0 6px}"]
            }]
    }], function () { return []; }, { progressValue: [{
            type: Input
        }], stepList: [{
            type: Input
        }], stepperLabel: [{
            type: Input
        }], activeStepChange: [{
            type: Output
        }], currentStep: [{
            type: Input
        }], activeStep: [{
            type: Input
        }], numbered: [{
            type: Input
        }] }); })();
    return StepperComponent;
}());

var StepperModule = /** @class */ (function () {
    function StepperModule() {
    }
StepperModule.ɵfac = function StepperModule_Factory(t) { return new (t || StepperModule)(); };
StepperModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: StepperModule });
StepperModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, ProgressModule, IconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StepperModule, [{
        type: NgModule,
        args: [{
                declarations: [StepperComponent, StepComponent],
                entryComponents: [StepperComponent, StepComponent],
                imports: [CommonModule, ProgressModule, IconModule],
                exports: [StepperComponent]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(StepperModule, { declarations: function () { return [StepperComponent, StepComponent]; }, imports: function () { return [CommonModule, ProgressModule, IconModule]; }, exports: function () { return [StepperComponent]; } }); })();
    return StepperModule;
}());

/**
 * Provides a template reference for custom contents of a Tab label.
 */
var TabLabelDirective = /** @class */ (function () {
    function TabLabelDirective(template) {
        this.template = template;
    }
    TabLabelDirective.ctorParameters = function () { return [
        { type: TemplateRef }
    ]; };
    TabLabelDirective = __decorate([ __metadata("design:paramtypes", [TemplateRef])
    ], TabLabelDirective);
TabLabelDirective.ɵfac = function TabLabelDirective_Factory(t) { return new (t || TabLabelDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
TabLabelDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TabLabelDirective, selectors: [["ng-template", "hdsTabLabel", ""]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TabLabelDirective, [{
        type: Directive,
        args: [{
                selector: 'ng-template[hdsTabLabel]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
    return TabLabelDirective;
}());

/**
 * Holds the contents of a tab within the Tab Group.
 */
var TabComponent = /** @class */ (function () {
    function TabComponent() {
        /**
         * ID for the tab group. One will be auto-generated if not provided.
         */
        this.id = "hds-tab-" + TabComponent_1.componentCount++;
    }
    TabComponent_1 = TabComponent;
    TabComponent.prototype.ngAfterContentInit = function () {
        if (!this.label && !this.labelTemplate) {
            throw new AccessibilityError("<hds-tab id=\"" + this.id + "\"> must either provide a \"label\" or contain an <ng-template hdsTabLabel>");
        }
    };
    var TabComponent_1;
    /**
     * Tracks the number of instances of the component that have been created.
     *
     * @internal
     */
    TabComponent.componentCount = 0;
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TabComponent.prototype, "id", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TabComponent.prototype, "label", void 0);
    __decorate([
        ContentChild(TabLabelDirective, { read: TemplateRef }),
        __metadata("design:type", TemplateRef)
    ], TabComponent.prototype, "labelTemplate", void 0);
    __decorate([
        ViewChild(TemplateRef, { static: true }),
        __metadata("design:type", TemplateRef)
    ], TabComponent.prototype, "tabContents", void 0);
TabComponent.ɵfac = function TabComponent_Factory(t) { return new (t || TabComponent)(); };
TabComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TabComponent, selectors: [["hds-tab"]], contentQueries: function TabComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TabLabelDirective, 5, TemplateRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.labelTemplate = _t.first);
    } }, viewQuery: function TabComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TemplateRef, 7);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabContents = _t.first);
    } }, inputs: { id: "id", label: "label" }, exportAs: ["hdsTab"], ngContentSelectors: _c4, decls: 1, vars: 0, template: function TabComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, TabComponent_ng_template_0_Template, 1, 0, "ng-template");
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TabComponent, [{
        type: Component,
        args: [{
                selector: 'hds-tab',
                exportAs: 'hdsTab',
                template: "<!-- Provide a template to project Tab contents into the appropriate place in the Tab Group. -->\n<ng-template>\n    <ng-content></ng-content>\n</ng-template>\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { id: [{
            type: Input
        }], label: [{
            type: Input
        }], labelTemplate: [{
            type: ContentChild,
            args: [TabLabelDirective, { read: TemplateRef }]
        }], tabContents: [{
            type: ViewChild,
            args: [TemplateRef, { static: true }]
        }] }); })();
    return TabComponent;
}());

/**
 * Allows the user to select from a set of tabbed content.
 */
var TabGroupComponent = /** @class */ (function () {
    function TabGroupComponent() {
        /**
         * ID for the tab group. One will be auto-generated if not provided.
         */
        this.id = "hds-tab-group-" + TabGroupComponent_1.componentCount++;
        /**
         * Alignment of the tabs relative to the tabpanel.
         */
        this.alignment = 'start';
        /**
         * Whether the tab group automatically activates a tab when its
         * corresponding button receives focus.
         */
        this._autoActivate = false;
        /**
         * Index of the currently selected tab.
         */
        this.selectedIndex = 0;
        /**
         * Emits the currently selected index when it changes.
         */
        this.selectedIndexChange = new EventEmitter();
        /**
         * Emits the currently selected tab when it changes.
         * NOTE: This does not emit the initially selected tab.
         */
        this.tabChange = new EventEmitter();
    }
    TabGroupComponent_1 = TabGroupComponent;
    Object.defineProperty(TabGroupComponent.prototype, "autoActivate", {
        get: function () {
            return this._autoActivate;
        },
        set: function (value) {
            this._autoActivate = value !== null && "" + value !== 'false';
        },
        enumerable: true,
        configurable: true
    });
    TabGroupComponent.prototype.ngOnInit = function () {
        if (!this.label) {
            throw new AccessibilityError("<hds-tab-group id=\"" + this.id + "\"> must specify a \"label\"");
        }
    };
    /**
     * Returns the ID of the button that activates the given tab.
     *
     * @param tab Tab whose button ID to return
     * @returns ID of the button that activates the given tab
     */
    TabGroupComponent.prototype.getButtonId = function (tab) {
        return tab.id + "-button";
    };
    /**
     * Handles `keydown` events on the `tablist`.
     *
     * @param event Event data
     */
    TabGroupComponent.prototype.handleTablistKeydown = function (event) {
        switch (event.key) {
            case "Home" /* Home */:
                event.stopPropagation();
                this.selectFirstTab();
                break;
            case "End" /* End */:
                event.stopPropagation();
                this.selectLastTab();
                break;
        }
    };
    /**
     * Selects the first tab in the tab list. If `autoActivate` is true, this
     * also activates the tab.
     */
    TabGroupComponent.prototype.selectFirstTab = function () {
        this.selectTab(0);
    };
    /**
     * Selects the last tab in the tab list. If `autoActivate` is true, this
     * also activates the tab.
     */
    TabGroupComponent.prototype.selectLastTab = function () {
        this.selectTab(this._tabs.length - 1);
    };
    /**
     * Selects the tab of the given index, wrapping around the tab list if
     * necessary. If `autoActivate` is true, this also activates the tab.
     *
     * @param index Index of the tab to select
     */
    TabGroupComponent.prototype.selectTab = function (index) {
        // The WAI-ARIA Authoring Practices dictate that tab selection should wrap
        var numTabs = this._tabs.length;
        var nextIndex = ((index % numTabs) + numTabs) % numTabs;
        var nextButton = this._tabButtons.find(function (_, i) { return i === nextIndex; });
        nextButton.nativeElement.focus();
        if (this.autoActivate) {
            this.activateTab(nextIndex);
        }
    };
    /**
     * Activates the tab of the given index.
     *
     * @param index Index of the tab to activate
     */
    TabGroupComponent.prototype.activateTab = function (index) {
        if (typeof index === 'number' && index >= 0 && index < this._tabs.length) {
            this.selectedIndex = index;
            this.selectedIndexChange.emit(this.selectedIndex);
            this.onTabActivated();
        }
    };
    /**
     * @ignore
     */
    TabGroupComponent.prototype.onTabActivated = function () {
        var _this = this;
        var selectedTab = this._tabs.find(function (_, i) { return i === _this.selectedIndex; });
        this.tabChange.emit(selectedTab);
    };
    var TabGroupComponent_1;
    /**
     * Tracks the number of instances of the component that have been created.
     *
     * @internal
     */
    TabGroupComponent.componentCount = 0;
    __decorate([
        Input(), HostBinding('attr.id'),
        __metadata("design:type", String)
    ], TabGroupComponent.prototype, "id", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TabGroupComponent.prototype, "label", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TabGroupComponent.prototype, "alignment", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], TabGroupComponent.prototype, "autoActivate", null);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], TabGroupComponent.prototype, "selectedIndex", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], TabGroupComponent.prototype, "selectedIndexChange", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], TabGroupComponent.prototype, "tabChange", void 0);
    __decorate([
        ContentChildren(TabComponent),
        __metadata("design:type", QueryList)
    ], TabGroupComponent.prototype, "_tabs", void 0);
    __decorate([
        ViewChildren('tabButton', { read: ElementRef }),
        __metadata("design:type", QueryList)
    ], TabGroupComponent.prototype, "_tabButtons", void 0);
TabGroupComponent.ɵfac = function TabGroupComponent_Factory(t) { return new (t || TabGroupComponent)(); };
TabGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TabGroupComponent, selectors: [["hds-tab-group"]], contentQueries: function TabGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TabComponent, 4);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._tabs = _t);
    } }, viewQuery: function TabGroupComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c34, 5, ElementRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._tabButtons = _t);
    } }, hostVars: 1, hostBindings: function TabGroupComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("id", ctx.id);
    } }, inputs: { id: "id", alignment: "alignment", selectedIndex: "selectedIndex", autoActivate: "autoActivate", label: "label" }, outputs: { selectedIndexChange: "selectedIndexChange", tabChange: "tabChange" }, exportAs: ["hdsTabGroup"], decls: 3, vars: 4, consts: [["role", "tablist", 3, "keydown"], ["role", "tab", 3, "click", "keydown.arrowright", "keydown.arrowleft", 4, "ngFor", "ngForOf"], ["role", "tabpanel", "tabindex", "0", 4, "ngFor", "ngForOf"], ["role", "tab", 3, "click", "keydown.arrowright", "keydown.arrowleft"], ["tabButton", ""], [4, "ngIf", "ngIfElse"], ["defaultLabel", ""], [3, "ngTemplateOutlet"], ["role", "tabpanel", "tabindex", "0"], [4, "ngIf"]], template: function TabGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("keydown", function TabGroupComponent_Template_div_keydown_0_listener($event) { return ctx.handleTablistKeydown($event); });
        ɵngcc0.ɵɵtemplate(1, TabGroupComponent_button_1_Template, 5, 6, "button", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, TabGroupComponent_div_2_Template, 2, 4, "div", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ctx.label)("data-align", ctx.alignment);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx._tabs);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx._tabs);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], styles: ["[_nghost-%COMP%]{display:block}[role=tablist][_ngcontent-%COMP%]{display:flex;overflow-x:auto}[role=tablist][data-align=center][_ngcontent-%COMP%]::after, [role=tablist][data-align=center][_ngcontent-%COMP%]::before, [role=tablist][data-align=end][_ngcontent-%COMP%]::before, [role=tablist][data-align=start][_ngcontent-%COMP%]::after{content:'';width:100%;-webkit-border-after:1px solid #79797c;border-block-end:1px solid #79797c}[role=tablist][data-align=start][_ngcontent-%COMP%]{justify-content:flex-start}[role=tablist][data-align=center][_ngcontent-%COMP%]{justify-content:center}[role=tablist][data-align=end][_ngcontent-%COMP%]{justify-content:flex-end}[role=tablist][data-align=stretch][_ngcontent-%COMP%]{justify-content:stretch}[role=tablist][data-align=stretch][_ngcontent-%COMP%]   [role=tab][_ngcontent-%COMP%]{flex-grow:1}[role=tab][_ngcontent-%COMP%]{margin:0;padding:.5rem 2rem;border:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;overflow:visible;font-family:inherit;font-size:1rem;text-decoration:none;text-transform:none;background-color:transparent;color:inherit;cursor:pointer;position:relative;min-height:3rem;-webkit-border-after:thin solid #79797c;border-block-end:thin solid #79797c;display:flex;justify-content:center;align-items:center;color:var(--hds-theme-supplementary-text);line-height:1.5;text-align:center;white-space:nowrap}[role=tab][_ngcontent-%COMP%]::after{content:'';position:absolute;height:.5rem;left:0;right:0;bottom:-1px;background-color:var(--hds-theme-accent-primary,#189ec3);opacity:0;transition:opacity 150ms ease-out}[role=tab][_ngcontent-%COMP%]:hover::after{opacity:.2}[role=tab][aria-selected=true][_ngcontent-%COMP%]{color:var(--hds-theme-base-text)}[role=tab][aria-selected=true][_ngcontent-%COMP%]::after{opacity:1}[role=tabpanel][_ngcontent-%COMP%]{padding:2rem 0}[role=tab][_ngcontent-%COMP%]:focus, [role=tabpanel][_ngcontent-%COMP%]:focus{outline:.125rem solid var(--hds-theme-focus-ring);outline-offset:-.125rem}[role=tab][_ngcontent-%COMP%]:focus:not(:focus-visible), [role=tabpanel][_ngcontent-%COMP%]:focus:not(:focus-visible){outline:0}[role=tab][_ngcontent-%COMP%]:focus-visible, [role=tabpanel][_ngcontent-%COMP%]:focus-visible{outline:.125rem solid var(--hds-theme-focus-ring);outline-offset:-.125rem}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TabGroupComponent, [{
        type: Component,
        args: [{
                selector: 'hds-tab-group',
                exportAs: 'hdsTabGroup',
                template: "<div role=\"tablist\" [attr.aria-label]=\"label\" [attr.data-align]=\"alignment\" (keydown)=\"handleTablistKeydown($event)\">\n    <button\n        *ngFor=\"let tab of _tabs; index as i\"\n        #tabButton\n        role=\"tab\"\n        [attr.id]=\"getButtonId(tab)\"\n        [attr.tabindex]=\"selectedIndex === i ? null : -1\"\n        [attr.aria-controls]=\"tab.id\"\n        [attr.aria-selected]=\"selectedIndex === i ? 'true' : 'false'\"\n        (click)=\"activateTab(i)\"\n        (keydown.arrowright)=\"selectTab(i + 1)\"\n        (keydown.arrowleft)=\"selectTab(i - 1)\"\n    >\n        <ng-template *ngIf=\"tab.labelTemplate; else defaultLabel\" [ngTemplateOutlet]=\"tab.labelTemplate\"></ng-template>\n        <ng-template #defaultLabel>{{ tab.label }}</ng-template>\n    </button>\n</div>\n\n<div\n    *ngFor=\"let tab of _tabs; index as i\"\n    role=\"tabpanel\"\n    tabindex=\"0\"\n    [attr.id]=\"tab.id\"\n    [attr.hidden]=\"selectedIndex !== i ? '' : null\"\n    [attr.aria-labelledby]=\"getButtonId(tab)\"\n>\n    <ng-template *ngIf=\"tab.tabContents\" [ngTemplateOutlet]=\"tab.tabContents\"></ng-template>\n</div>\n",
                styles: [":host{display:block}[role=tablist]{display:flex;overflow-x:auto}[role=tablist][data-align=center]::after,[role=tablist][data-align=center]::before,[role=tablist][data-align=end]::before,[role=tablist][data-align=start]::after{content:'';width:100%;-webkit-border-after:1px solid #79797c;border-block-end:1px solid #79797c}[role=tablist][data-align=start]{justify-content:flex-start}[role=tablist][data-align=center]{justify-content:center}[role=tablist][data-align=end]{justify-content:flex-end}[role=tablist][data-align=stretch]{justify-content:stretch}[role=tablist][data-align=stretch] [role=tab]{flex-grow:1}[role=tab]{margin:0;padding:.5rem 2rem;border:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;overflow:visible;font-family:inherit;font-size:1rem;text-decoration:none;text-transform:none;background-color:transparent;color:inherit;cursor:pointer;position:relative;min-height:3rem;-webkit-border-after:thin solid #79797c;border-block-end:thin solid #79797c;display:flex;justify-content:center;align-items:center;color:var(--hds-theme-supplementary-text);line-height:1.5;text-align:center;white-space:nowrap}[role=tab]::after{content:'';position:absolute;height:.5rem;left:0;right:0;bottom:-1px;background-color:var(--hds-theme-accent-primary,#189ec3);opacity:0;transition:opacity 150ms ease-out}[role=tab]:hover::after{opacity:.2}[role=tab][aria-selected=true]{color:var(--hds-theme-base-text)}[role=tab][aria-selected=true]::after{opacity:1}[role=tabpanel]{padding:2rem 0}[role=tab]:focus,[role=tabpanel]:focus{outline:.125rem solid var(--hds-theme-focus-ring);outline-offset:-.125rem}[role=tab]:focus:not(:focus-visible),[role=tabpanel]:focus:not(:focus-visible){outline:0}[role=tab]:focus-visible,[role=tabpanel]:focus-visible{outline:.125rem solid var(--hds-theme-focus-ring);outline-offset:-.125rem}"]
            }]
    }], function () { return []; }, { id: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.id']
        }], alignment: [{
            type: Input
        }], selectedIndex: [{
            type: Input
        }], selectedIndexChange: [{
            type: Output
        }], tabChange: [{
            type: Output
        }], autoActivate: [{
            type: Input
        }], label: [{
            type: Input
        }], _tabs: [{
            type: ContentChildren,
            args: [TabComponent]
        }], _tabButtons: [{
            type: ViewChildren,
            args: ['tabButton', { read: ElementRef }]
        }] }); })();
    return TabGroupComponent;
}());

var TabsModule = /** @class */ (function () {
    function TabsModule() {
    }
TabsModule.ɵfac = function TabsModule_Factory(t) { return new (t || TabsModule)(); };
TabsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TabsModule });
TabsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TabsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [TabComponent, TabGroupComponent, TabLabelDirective],
                exports: [TabComponent, TabGroupComponent, TabLabelDirective]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TabsModule, { declarations: function () { return [TabComponent, TabGroupComponent, TabLabelDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [TabComponent, TabGroupComponent, TabLabelDirective]; } }); })();
    return TabsModule;
}());

/**
 * Selects a <textarea> element (possibly associated with an Angular form) and
 * stores a reference to its native HTML element and, if available, its
 * associated `FormControl`.
 */
var ProjectedTextareaDirective = /** @class */ (function () {
    /**
     * @ignore
     */
    function ProjectedTextareaDirective(elementRef, formControl) {
        this.elementRef = elementRef;
        this.formControl = formControl;
    }
    ProjectedTextareaDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: NgControl, decorators: [{ type: Optional }] }
    ]; };
    ProjectedTextareaDirective = __decorate([ __param(1, Optional()),
        __metadata("design:paramtypes", [ElementRef, NgControl])
    ], ProjectedTextareaDirective);
ProjectedTextareaDirective.ɵfac = function ProjectedTextareaDirective_Factory(t) { return new (t || ProjectedTextareaDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.NgControl, 8)); };
ProjectedTextareaDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ProjectedTextareaDirective, selectors: [["textarea"]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProjectedTextareaDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line
                selector: 'textarea'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc2.NgControl, decorators: [{
                type: Optional
            }] }]; }, null); })();
    return ProjectedTextareaDirective;
}());
/**
 * A multi-line text input control.
 */
var TextareaComponent = /** @class */ (function () {
    function TextareaComponent() {
        /**
         * @ignore
         */
        this.isBaseClass = true;
        /**
         * Resize behavior of the textarea.
         */
        this.resize = 'manual';
    }
    TextareaComponent_1 = TextareaComponent;
    Object.defineProperty(TextareaComponent.prototype, "disabled", {
        /**
         * Whether the projected textarea is disabled.
         */
        get: function () {
            return this.textarea.formControl && this.textarea.formControl.disabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextareaComponent.prototype, "invalid", {
        /**
         * Whether the projected textarea is invalid.
         */
        get: function () {
            if (!this.textarea.formControl) {
                return false;
            }
            var control = this.textarea.formControl;
            return control.invalid && (control.touched || control.dirty);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextareaComponent.prototype, "reflectedValue", {
        /**
         * Reflection of the textarea's current value.
         *
         * When `resize='auto'`, the reflected value is inserted into a pseudo-
         * element of the component container, which is positioned in the same space
         * as the textarea to force the container to auto-resize to fit the value
         * (credit to
         * [CSS-Tricks](https://css-tricks.com/the-cleanest-trick-for-autogrowing-textareas/)).
         */
        get: function () {
            return this.shouldReflectValue() && this.textarea ? this.textarea.elementRef.nativeElement.value : null;
        },
        enumerable: true,
        configurable: true
    });
    TextareaComponent.prototype.ngAfterContentInit = function () {
        if (!this.textarea) {
            throw new ComponentConfigurationError('<hl-textarea> expects a <textarea> child that is associated with a parent form. See ' +
                'ProjectedTextareaDirective for more details', '<hl-textarea>\n\t<textarea formControlName="myTextarea"></textarea>\n</hl-textarea>');
        }
        var textareaEl = this.textarea.elementRef.nativeElement;
        textareaEl.id = textareaEl.id || "hl-textarea-" + TextareaComponent_1.componentCount++;
        textareaEl.readOnly = this.readOnly || false;
    };
    TextareaComponent.prototype.ngOnChanges = function (changes) {
        if ('readOnly' in changes && this.textarea) {
            var textareaEl = this.textarea.elementRef.nativeElement;
            textareaEl.readOnly = changes.readOnly.currentValue;
        }
    };
    /**
     * Returns true when the textarea's current value should be reflected,
     * based on the specified resize behavior.
     *
     * @internal
     */
    TextareaComponent.prototype.shouldReflectValue = function () {
        return this.resize === 'auto' || this.readOnly;
    };
    var TextareaComponent_1;
    /**
     * Tracks the number of instances of the component that have been created.
     * Used to generate IDs for child elements, if an ID was not provided.
     *
     * @internal
     */
    TextareaComponent.componentCount = 0;
    __decorate([
        HostBinding('class.hl-textarea'),
        __metadata("design:type", Object)
    ], TextareaComponent.prototype, "isBaseClass", void 0);
    __decorate([
        HostBinding('attr.data-resize'),
        Input(),
        __metadata("design:type", String)
    ], TextareaComponent.prototype, "resize", void 0);
    __decorate([
        ContentChild(ProjectedTextareaDirective),
        __metadata("design:type", ProjectedTextareaDirective)
    ], TextareaComponent.prototype, "textarea", void 0);
    __decorate([
        HostBinding('class.hl-form-control--disabled'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], TextareaComponent.prototype, "disabled", null);
    __decorate([
        HostBinding('class.hl-form-control--invalid'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], TextareaComponent.prototype, "invalid", null);
    __decorate([
        HostBinding('class.hl-form-control--read-only'),
        Input(),
        __metadata("design:type", Boolean)
    ], TextareaComponent.prototype, "readOnly", void 0);
    __decorate([
        HostBinding('attr.data-reflect-value'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], TextareaComponent.prototype, "reflectedValue", null);
TextareaComponent.ɵfac = function TextareaComponent_Factory(t) { return new (t || TextareaComponent)(); };
TextareaComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TextareaComponent, selectors: [["hl-textarea"]], contentQueries: function TextareaComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, ProjectedTextareaDirective, 5);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.textarea = _t.first);
    } }, hostVars: 10, hostBindings: function TextareaComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-resize", ctx.resize)("data-reflect-value", ctx.reflectedValue);
        ɵngcc0.ɵɵclassProp("hl-textarea", ctx.isBaseClass)("hl-form-control--disabled", ctx.disabled)("hl-form-control--invalid", ctx.invalid)("hl-form-control--read-only", ctx.readOnly);
    } }, inputs: { resize: "resize", readOnly: "readOnly" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c36, decls: 1, vars: 0, template: function TextareaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c35);
        ɵngcc0.ɵɵprojection(0);
    } }, styles: [".hl-textarea{display:-ms-grid;display:grid;height:auto!important;max-width:100%;--text-color:var(--hds-theme-base-text, #000);--placeholder-color:var(--hds-input-placeholder, rgba(0, 0, 0, 0.45));--bg:var(--hds-input-background, #fff);--border:var(--hds-input-border, currentColor);--border-focus:var(--hds-theme-accent-primary, #189ec3);--bg-error:var(--hds-input-background-error, #ffe5e5);--border-error:var(--hds-input-border-error, #e91d00);--border-focus-shadow-error:var(--hds-input-focus-shadow-error, rgba(233, 29, 0, 0.75));border:.125rem solid var(--border);border-radius:.25rem;background-color:var(--bg);line-height:1.5;margin:4px 0}.hl-textarea textarea,.hl-textarea::after{font:inherit;padding:.5rem}.hl-textarea textarea{width:100%;min-height:calc(4 * 24px + 2 * .5rem);border:none;border-radius:.25rem;resize:vertical}.hl-textarea textarea:invalid,.hl-textarea textarea:valid,.hl-textarea textarea[disabled]{color:currentColor;background-color:transparent;border:none}.hl-textarea textarea::-webkit-input-placeholder{color:rgba(0,0,0,.45);opacity:.45}.hl-textarea textarea::-moz-placeholder{color:rgba(0,0,0,.45);opacity:.45}.hl-textarea textarea:-ms-input-placeholder{color:rgba(0,0,0,.45);opacity:.45}.hl-textarea textarea::-ms-input-placeholder{color:rgba(0,0,0,.45);opacity:.45}.hl-textarea textarea::placeholder{color:rgba(0,0,0,.45);opacity:.45}.hl-textarea:focus-within{border-color:var(--border-focus);box-shadow:0 0 8px rgba(0,0,0,.36)}.hl-textarea:focus-within textarea:focus{outline:0}.hl-textarea:focus-within textarea:focus::-moz-focus-inner{border-style:none;padding:0}.hl-textarea:focus-within textarea:focus:-moz-focusring{outline:0}.hl-textarea.hl-form-control--disabled{background-color:#f5f5f5;border-color:#c4c4c4;color:#8d8d8d}.hl-textarea.hl-form-control--read-only{background:0 0;border-color:transparent}.hl-textarea.hl-form-control--read-only:focus-within{border-color:#000;box-shadow:none}.hl-textarea.hl-form-control--read-only textarea{min-height:auto;color:#606062}.hl-textarea.hl-form-control--invalid{background-color:var(--bg-error);border-color:var(--border-error)}.hl-textarea.hl-form-control--invalid:focus-within{box-shadow:0 0 8px var(--border-focus-shadow-error)}.hl-textarea[data-resize=none] textarea{resize:none}.hl-textarea[data-resize=auto]::after,.hl-textarea[readonly=true]::after{content:attr(data-reflect-value) \" \";white-space:pre-wrap;visibility:hidden}.hl-textarea[data-resize=auto] textarea,.hl-textarea[data-resize=auto]::after,.hl-textarea[readonly=true] textarea,.hl-textarea[readonly=true]::after{-ms-grid-row:1;-ms-grid-row-span:1;grid-row:1/2;grid-column:1/-1}.hl-textarea[data-resize=auto] textarea,.hl-textarea[readonly=true] textarea{resize:none;overflow:hidden}"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TextareaComponent, [{
        type: Component,
        args: [{
                selector: 'hl-textarea',
                template: '<ng-content select="textarea"></ng-content>',
                encapsulation: ViewEncapsulation.None,
                styles: [".hl-textarea{display:-ms-grid;display:grid;height:auto!important;max-width:100%;--text-color:var(--hds-theme-base-text, #000);--placeholder-color:var(--hds-input-placeholder, rgba(0, 0, 0, 0.45));--bg:var(--hds-input-background, #fff);--border:var(--hds-input-border, currentColor);--border-focus:var(--hds-theme-accent-primary, #189ec3);--bg-error:var(--hds-input-background-error, #ffe5e5);--border-error:var(--hds-input-border-error, #e91d00);--border-focus-shadow-error:var(--hds-input-focus-shadow-error, rgba(233, 29, 0, 0.75));border:.125rem solid var(--border);border-radius:.25rem;background-color:var(--bg);line-height:1.5;margin:4px 0}.hl-textarea textarea,.hl-textarea::after{font:inherit;padding:.5rem}.hl-textarea textarea{width:100%;min-height:calc(4 * 24px + 2 * .5rem);border:none;border-radius:.25rem;resize:vertical}.hl-textarea textarea:invalid,.hl-textarea textarea:valid,.hl-textarea textarea[disabled]{color:currentColor;background-color:transparent;border:none}.hl-textarea textarea::-webkit-input-placeholder{color:rgba(0,0,0,.45);opacity:.45}.hl-textarea textarea::-moz-placeholder{color:rgba(0,0,0,.45);opacity:.45}.hl-textarea textarea:-ms-input-placeholder{color:rgba(0,0,0,.45);opacity:.45}.hl-textarea textarea::-ms-input-placeholder{color:rgba(0,0,0,.45);opacity:.45}.hl-textarea textarea::placeholder{color:rgba(0,0,0,.45);opacity:.45}.hl-textarea:focus-within{border-color:var(--border-focus);box-shadow:0 0 8px rgba(0,0,0,.36)}.hl-textarea:focus-within textarea:focus{outline:0}.hl-textarea:focus-within textarea:focus::-moz-focus-inner{border-style:none;padding:0}.hl-textarea:focus-within textarea:focus:-moz-focusring{outline:0}.hl-textarea.hl-form-control--disabled{background-color:#f5f5f5;border-color:#c4c4c4;color:#8d8d8d}.hl-textarea.hl-form-control--read-only{background:0 0;border-color:transparent}.hl-textarea.hl-form-control--read-only:focus-within{border-color:#000;box-shadow:none}.hl-textarea.hl-form-control--read-only textarea{min-height:auto;color:#606062}.hl-textarea.hl-form-control--invalid{background-color:var(--bg-error);border-color:var(--border-error)}.hl-textarea.hl-form-control--invalid:focus-within{box-shadow:0 0 8px var(--border-focus-shadow-error)}.hl-textarea[data-resize=none] textarea{resize:none}.hl-textarea[data-resize=auto]::after,.hl-textarea[readonly=true]::after{content:attr(data-reflect-value) \" \";white-space:pre-wrap;visibility:hidden}.hl-textarea[data-resize=auto] textarea,.hl-textarea[data-resize=auto]::after,.hl-textarea[readonly=true] textarea,.hl-textarea[readonly=true]::after{-ms-grid-row:1;-ms-grid-row-span:1;grid-row:1/2;grid-column:1/-1}.hl-textarea[data-resize=auto] textarea,.hl-textarea[readonly=true] textarea{resize:none;overflow:hidden}"]
            }]
    }], function () { return []; }, { isBaseClass: [{
            type: HostBinding,
            args: ['class.hl-textarea']
        }], resize: [{
            type: HostBinding,
            args: ['attr.data-resize']
        }, {
            type: Input
        }], disabled: [{
            type: HostBinding,
            args: ['class.hl-form-control--disabled']
        }], invalid: [{
            type: HostBinding,
            args: ['class.hl-form-control--invalid']
        }], reflectedValue: [{
            type: HostBinding,
            args: ['attr.data-reflect-value']
        }], textarea: [{
            type: ContentChild,
            args: [ProjectedTextareaDirective]
        }], readOnly: [{
            type: HostBinding,
            args: ['class.hl-form-control--read-only']
        }, {
            type: Input
        }] }); })();
    return TextareaComponent;
}());

var TextareaModule = /** @class */ (function () {
    function TextareaModule() {
    }
TextareaModule.ɵfac = function TextareaModule_Factory(t) { return new (t || TextareaModule)(); };
TextareaModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TextareaModule });
TextareaModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, DirectivesModule, FormControlsCommonModule], FormControlsCommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TextareaModule, [{
        type: NgModule,
        args: [{
                declarations: [TextareaComponent, ProjectedTextareaDirective],
                imports: [CommonModule, DirectivesModule, FormControlsCommonModule],
                exports: [FormControlsCommonModule, TextareaComponent, ProjectedTextareaDirective]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TextareaModule, { declarations: function () { return [TextareaComponent, ProjectedTextareaDirective]; }, imports: function () { return [CommonModule, DirectivesModule, FormControlsCommonModule]; }, exports: function () { return [FormControlsCommonModule, TextareaComponent, ProjectedTextareaDirective]; } }); })();
    return TextareaModule;
}());

/**
 * Dependency Injection: Window Provider
 * https://brianflove.com/2018-01-11/angular-window-provider/
 */
/**
 * Injection token for injecting the `window` object into a component.
 */
var WINDOW = new InjectionToken('WindowToken');
/**
 * Abstract class to obtain a reference to the global `window` object.
 * Must be implemented by a provider class.
 */
var WindowRef = /** @class */ (function () {
    function WindowRef() {
    }
    return WindowRef;
}());
/**
 * Provides a reference to the browser's global `window` object.
 */
var BrowserWindowRef = /** @class */ (function (_super) {
    __extends(BrowserWindowRef, _super);
    function BrowserWindowRef() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BrowserWindowRef.prototype, "nativeWindow", {
        get: function () {
            return window;
        },
        enumerable: true,
        configurable: true
    });
BrowserWindowRef.ɵfac = /*@__PURE__*/ function () { var ɵBrowserWindowRef_BaseFactory; return function BrowserWindowRef_Factory(t) { return (ɵBrowserWindowRef_BaseFactory || (ɵBrowserWindowRef_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(BrowserWindowRef)))(t || BrowserWindowRef); }; }();
BrowserWindowRef.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: BrowserWindowRef, factory: function (t) { return BrowserWindowRef.ɵfac(t); } });

    return BrowserWindowRef;
}(WindowRef));
/**
 * Factory that returns a reference to the native `window` object in browser contexts.
 * @param browserWindowRef Provider for the browser's global `window` object`
 * @param platformId Angular platform ID
 */
function windowFactory(browserWindowRef, platformId) {
    if (isPlatformBrowser(platformId)) {
        return browserWindowRef.nativeWindow;
    }
    return new Object();
}
var browserWindowProvider = {
    provide: WindowRef,
    useClass: BrowserWindowRef
};
var windowProvider = {
    provide: WINDOW,
    useFactory: windowFactory,
    deps: [WindowRef, PLATFORM_ID]
};
var WINDOW_PROVIDERS = [browserWindowProvider, windowProvider];

/**
 * Service to manage scroll event listeners.
 */
var HDSScrollService = /** @class */ (function () {
    /**
     * @ignore
     */
    function HDSScrollService(ngZone, document, window) {
        var _this = this;
        this.ngZone = ngZone;
        /**
         * Whether the `addEventListener` method supports registering events as
         * passive. Registering a scroll event as passive can mitigate some
         * performance issues.
         */
        this.passiveSupported = this.isPassiveSupported();
        /**
         * Subject to track scroll events.
         *
         * @internal
         */
        this.scrollSubject = new Subject();
        /**
         * Observable that emits when a scroll event is detected on the document.
         * For the sake of performance, these events are debounced to 20ms.
         */
        this.scroll$ = this.scrollSubject.pipe(debounceTime(20));
        this.document = document;
        this.window = window;
        // Avoid triggering change detection whenever the listener runs
        this.ngZone.runOutsideAngular(function () {
            var options = _this.passiveSupported ? { capture: true, passive: true } : true;
            _this.document.addEventListener('scroll', function () { return _this.scrollSubject.next(); }, options);
        });
    }
    /**
     * Detects whether `addEventListener` supports registering events as passive
     * in the current browsing context. Registering a scroll event as passive
     * can mitigate some performance issues.
     *
     * @internal
     */
    HDSScrollService.prototype.isPassiveSupported = function () {
        var passiveSupported = false;
        try {
            var options = {
                get passive() {
                    passiveSupported = true;
                    return false;
                }
            };
            this.window.addEventListener('scroll', null, options);
            this.window.removeEventListener('scroll', null, options);
        }
        catch (error) {
            passiveSupported = false;
        }
        return passiveSupported;
    };
    HDSScrollService.ctorParameters = function () { return [
        { type: NgZone },
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [WINDOW,] }] }
    ]; };
    HDSScrollService.ɵprov = ɵɵdefineInjectable({ factory: function HDSScrollService_Factory() { return new HDSScrollService(ɵɵinject(NgZone), ɵɵinject(DOCUMENT), ɵɵinject(WINDOW)); }, token: HDSScrollService, providedIn: "root" });
    HDSScrollService = __decorate([ __param(1, Inject(DOCUMENT)), __param(2, Inject(WINDOW)),
        __metadata("design:paramtypes", [NgZone, Object, Object])
    ], HDSScrollService);
HDSScrollService.ɵfac = function HDSScrollService_Factory(t) { return new (t || HDSScrollService)(ɵngcc0.ɵɵinject(ɵngcc0.NgZone), ɵngcc0.ɵɵinject(DOCUMENT), ɵngcc0.ɵɵinject(WINDOW)); };
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HDSScrollService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.NgZone }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [WINDOW]
            }] }]; }, null); })();
    return HDSScrollService;
}());

/**
 * Service to retrieve the dimensions of the viewport.
 */
var HDSViewportService = /** @class */ (function () {
    /**
     * @ignore
     */
    function HDSViewportService(document, window) {
        this.document = document;
        this.window = window;
    }
    /**
     * Returns the current dimensions of the viewport.
     */
    HDSViewportService.prototype.getViewport = function () {
        return {
            height: Math.max(this.document.documentElement.clientHeight || 0, this.window.innerHeight || 0),
            width: Math.max(this.document.documentElement.clientWidth || 0, this.window.innerWidth || 0)
        };
    };
    HDSViewportService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [WINDOW,] }] }
    ]; };
    HDSViewportService.ɵprov = ɵɵdefineInjectable({ factory: function HDSViewportService_Factory() { return new HDSViewportService(ɵɵinject(DOCUMENT), ɵɵinject(WINDOW)); }, token: HDSViewportService, providedIn: "root" });
    HDSViewportService = __decorate([ __param(0, Inject(DOCUMENT)), __param(1, Inject(WINDOW)),
        __metadata("design:paramtypes", [Object, Object])
    ], HDSViewportService);
HDSViewportService.ɵfac = function HDSViewportService_Factory(t) { return new (t || HDSViewportService)(ɵngcc0.ɵɵinject(DOCUMENT), ɵngcc0.ɵɵinject(WINDOW)); };
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HDSViewportService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [WINDOW]
            }] }]; }, null); })();
    return HDSViewportService;
}());

/**
 * Resolves the position of one DOM element relative to another.
 *
 * @todo Allow different resolution strategies
 */
var RelativePositionStrategy = /** @class */ (function () {
    /**
     * Creates a new RelativePositionStrategy for the given source and target.
     *
     * @param source The element against which the target element will be positioned
     * @param target The element to be positioned
     */
    function RelativePositionStrategy(source, target, viewportService) {
        this.source = source;
        this.target = target;
        this.viewportService = viewportService;
        this.source = source;
        this.target = target;
    }
    /**
     * Calculates the most appropriate orientation and coordinates for the
     * tooltip, based on its preferred position or a heuristic.
     *
     * @param viewport Size of the viewport
     * @param preferredOrientation The preferred placement of the tooltip
     */
    RelativePositionStrategy.prototype.resolveTargetPosition = function (preferredOrientation) {
        var viewport = this.viewportService.getViewport();
        var sourceBoundingBox = this.source.getBoundingClientRect();
        var targetBoundingBox = this.target.getBoundingClientRect();
        var sourceViewportMargins = {
            bottom: viewport.height - sourceBoundingBox.bottom,
            left: sourceBoundingBox.left,
            top: sourceBoundingBox.top,
            right: viewport.width - sourceBoundingBox.right
        };
        var orientation;
        // Use the preferred position if it doesn't cause the tooltip to overflow the viewport
        if (preferredOrientation !== 'auto' &&
            this.isTargetOrientationValid(preferredOrientation, viewport, sourceViewportMargins, sourceBoundingBox, targetBoundingBox)) {
            orientation = preferredOrientation;
        }
        else {
            // Otherwise, choose the optimal position based on a heuristic
            orientation = this.getOptimalTargetOrientation(viewport, sourceViewportMargins, sourceBoundingBox, targetBoundingBox);
        }
        return __assign({ orientation: orientation }, this.getTargetCoordinates(orientation, sourceBoundingBox, targetBoundingBox));
    };
    /**
     * Calculates the optimal orientation of the tooltip, based on the available
     * space around its trigger element.
     *
     * @param viewport Size of the viewport
     * @param sourceViewportMargins Distance from the source element to each viewport edge
     * @param sourceBoundingBox Bounding box for the source element
     * @param targetBoundingBox Bounding box for the target element
     */
    RelativePositionStrategy.prototype.getOptimalTargetOrientation = function (viewport, sourceViewportMargins, sourceBoundingBox, targetBoundingBox) {
        var e_1, _a;
        // Sort position options in order of available space, greatest to least
        var preferenceOrder = Object.keys(sourceViewportMargins).sort(function (x, y) { return sourceViewportMargins[y] - sourceViewportMargins[x]; });
        // Return the first valid position in the preference order
        var validPositions = this.getValidTargetOrientations(viewport, sourceViewportMargins, sourceBoundingBox, targetBoundingBox);
        try {
            for (var preferenceOrder_1 = __values(preferenceOrder), preferenceOrder_1_1 = preferenceOrder_1.next(); !preferenceOrder_1_1.done; preferenceOrder_1_1 = preferenceOrder_1.next()) {
                var preference = preferenceOrder_1_1.value;
                if (validPositions.includes(preference)) {
                    return preference;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (preferenceOrder_1_1 && !preferenceOrder_1_1.done && (_a = preferenceOrder_1.return)) _a.call(preferenceOrder_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        // If no preferred positions have sufficient space for the tooltip,
        // return the one with the most available space
        return preferenceOrder[0];
    };
    /**
     * Returns a list of orientations that could accommodate the size of the
     * target element relative to the source element.
     *
     * @param viewport Size of the viewport
     * @param sourceViewportMargins Distance from the source element to each viewport edge
     * @param sourceBoundingBox Bounding box for the source element
     * @param targetBoundingBox Bounding box for the tooltip element
     */
    RelativePositionStrategy.prototype.getValidTargetOrientations = function (viewport, sourceViewportMargins, sourceBoundingBox, targetBoundingBox) {
        var _this = this;
        return Object.keys(sourceViewportMargins).filter(function (orientation) {
            return _this.isTargetOrientationValid(orientation, viewport, sourceViewportMargins, sourceBoundingBox, targetBoundingBox);
        });
    };
    /**
     * Determines whether the specified orientation could accommodate the size
     * of the target element.
     *
     * @param orientation Orientation to test for validity
     * @param viewport Size of the viewport
     * @param viewportMargins Distance from the trigger element to each viewport edge
     * @param sourceBoundingBox Bounding box for the source element
     * @param targetBoundingBox Bounding box for the tooltip element
     */
    RelativePositionStrategy.prototype.isTargetOrientationValid = function (orientation, viewport, viewportMargins, sourceBoundingBox, targetBoundingBox) {
        var paddedWidth = targetBoundingBox.width + 2 * RelativePositionStrategy.VIEWPORT_MARGIN;
        var paddedHeight = targetBoundingBox.height + 2 * RelativePositionStrategy.VIEWPORT_MARGIN;
        var targetCoordinates = this.getTargetCoordinates(orientation, sourceBoundingBox, targetBoundingBox);
        var horizontallyVisible = targetCoordinates.x > RelativePositionStrategy.VIEWPORT_MARGIN &&
            targetCoordinates.x + targetBoundingBox.width < viewport.width - RelativePositionStrategy.VIEWPORT_MARGIN;
        var verticallyVisible = targetCoordinates.y > RelativePositionStrategy.VIEWPORT_MARGIN &&
            targetCoordinates.y + targetBoundingBox.height < viewport.height - RelativePositionStrategy.VIEWPORT_MARGIN;
        switch (orientation) {
            case 'bottom':
                return viewportMargins.bottom >= paddedHeight && horizontallyVisible;
            case 'left':
                return viewportMargins.left >= paddedWidth && verticallyVisible;
            case 'right':
                return viewportMargins.right >= paddedWidth && verticallyVisible;
            case 'top':
                return viewportMargins.top >= paddedHeight && horizontallyVisible;
        }
    };
    /**
     * Returns the DOM coordinates of the target box for the given orientation,
     * relative to the viewport.
     *
     * @param orientation Orientation of the tooltip element
     * @param sourceBoundingBox Bounding box for the trigger element
     * @param targetBoundingBox Bounding box for the tooltip element
     */
    RelativePositionStrategy.prototype.getTargetCoordinates = function (orientation, sourceBoundingBox, targetBoundingBox) {
        switch (orientation) {
            case 'bottom':
                return {
                    x: sourceBoundingBox.left + sourceBoundingBox.width / 2 - targetBoundingBox.width / 2,
                    y: sourceBoundingBox.bottom
                };
            case 'left':
                return {
                    x: sourceBoundingBox.left - targetBoundingBox.width,
                    y: sourceBoundingBox.top + sourceBoundingBox.height / 2 - targetBoundingBox.height / 2
                };
            case 'top':
                return {
                    x: sourceBoundingBox.left + sourceBoundingBox.width / 2 - targetBoundingBox.width / 2,
                    y: sourceBoundingBox.top - targetBoundingBox.height
                };
            case 'right':
                return {
                    x: sourceBoundingBox.right,
                    y: sourceBoundingBox.top + sourceBoundingBox.height / 2 - targetBoundingBox.height / 2
                };
        }
    };
    /**
     * The minimum space required between the target element and the edge of the
     * viewport, measured in pixels.
     *
     * @todo Make configurable?
     */
    RelativePositionStrategy.VIEWPORT_MARGIN = 16;
    return RelativePositionStrategy;
}());

/**
 * Base class for components that create custom tooltips.
 */
var TooltipBaseComponent = /** @class */ (function () {
    /**
     * @ignore
     */
    function TooltipBaseComponent(renderer, scrollService, viewportService, platformId, window) {
        this.renderer = renderer;
        this.scrollService = scrollService;
        this.viewportService = viewportService;
        this.platformId = platformId;
        /**
         * Preferred position for the tooltip, relative to its trigger.
         *
         * @internal
         */
        this._preferredOrientation = 'right';
        /**
         * @internal
         */
        this.cleanupResizeObserver = function () { };
        this.window = window;
    }
    /**
     * Initializes the positioning and observation logic for the tooltip.
     *
     * @param triggerElement HTML element of the tooltip trigger
     * @param tooltipElement HTML element of the tooltip
     *
     * @internal
     */
    TooltipBaseComponent.prototype.init = function (triggerElement, tooltipElement) {
        var _this = this;
        this.triggerElement = triggerElement;
        this.tooltipElement = tooltipElement;
        this.positionStrategy = new RelativePositionStrategy(this.triggerElement, this.tooltipElement, this.viewportService);
        this.scrollListener = this.scrollService.scroll$.subscribe(function () { return _this.updatePosition(); });
        this.setupResizeObserver(triggerElement, tooltipElement);
        this.renderer.setStyle(this.tooltipElement, 'will-change', 'transform, opacity');
        this.updatePosition();
    };
    TooltipBaseComponent.prototype.setupResizeObserver = function (triggerElement, tooltipElement) {
        var _this = this;
        if (!this.window || !('ResizeObserver' in this.window)) {
            // ResizeObserver not supported or otherwise unavailable
            return;
        }
        var observer = new ResizeObserver(function () { return _this.updatePosition(); });
        // The tooltip's position might need to change when its size changes
        observer.observe(tooltipElement);
        // The trigger's position might change if it or any of its ancestors is resized
        var elementToObserve = triggerElement;
        while (elementToObserve) {
            observer.observe(elementToObserve);
            elementToObserve = elementToObserve.parentElement;
        }
        this.cleanupResizeObserver = function () { return observer.disconnect(); };
    };
    /**
     * Cleans up the positioning and observation logic for the tooltip.
     *
     * @internal
     */
    TooltipBaseComponent.prototype.destroy = function () {
        this.scrollListener.unsubscribe();
        this.cleanupResizeObserver();
    };
    /**
     * Re-renders the tooltip in the most appropriate position on the screen,
     * according to its preferred position or a heuristic.
     *
     * @internal
     */
    TooltipBaseComponent.prototype.updatePosition = function () {
        if (!this.triggerElement || !this.tooltipElement || !this.positionStrategy) {
            return;
        }
        if (isPlatformBrowser(this.platformId)) {
            var position = this.positionStrategy.resolveTargetPosition(this._preferredOrientation);
            this.renderer.setAttribute(this.tooltipElement, 'data-position', position.orientation);
            var transform = "translate3d(" + (Math.round(position.x) || 0) + "px, " + (Math.round(position.y) || 0) + "px, 0)";
            this.renderer.setStyle(this.tooltipElement, 'transform', transform);
        }
    };
    return TooltipBaseComponent;
}());

var ToggletipComponent = /** @class */ (function (_super) {
    __extends(ToggletipComponent, _super);
    /**
     * @ignore
     */
    function ToggletipComponent(renderer, scrollService, viewportService, platformId, window) {
        var _this = _super.call(this, renderer, scrollService, viewportService, platformId, window) || this;
        /**
         * Unique string that serves as a global identifier for the root HTML element
         * and its children.
         */
        _this.id = "hl-toggletip-" + ToggletipComponent_1.componentCount++;
        /**
         * @ignore
         */
        _this.baseClass = true;
        /**
         * This component accepts projected content instead of a `text` input.
         *
         * @ignore
         */
        _this.label = 'More info';
        /**
         * Whether the toggletip is currently expanded.
         */
        _this.expanded = false;
        return _this;
    }
    ToggletipComponent_1 = ToggletipComponent;
    Object.defineProperty(ToggletipComponent.prototype, "tooltipId", {
        /**
         * ID of the tooltip element within the component.
         *
         * @internal
         */
        get: function () {
            return this.id + "-tooltip";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ToggletipComponent.prototype, "preferredOrientation", {
        /**
         * Preferred position for the tooltip, relative to its trigger.
         */
        get: function () {
            return this._preferredOrientation;
        },
        /**
         * Preferred position for the tooltip, relative to its trigger.
         */
        set: function (value) {
            if (value !== this._preferredOrientation) {
                this._preferredOrientation = value;
                this.updatePosition();
            }
        },
        enumerable: true,
        configurable: true
    });
    ToggletipComponent.prototype.ngAfterViewInit = function () {
        this.init(this.toggleButton.nativeElement, this.tooltip.nativeElement);
    };
    ToggletipComponent.prototype.ngOnDestroy = function () {
        this.destroy();
    };
    /**
     * Toggles whether the toggletip is currently expanded.
     */
    ToggletipComponent.prototype.toggle = function () {
        this.expanded = !this.expanded;
    };
    var ToggletipComponent_1;
    /**
     * Tracks the number of instances of the component that have been created.
     * Used to generate IDs for child elements, if an ID was not provided.
     *
     * @internal
     */
    ToggletipComponent.componentCount = 0;
    ToggletipComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: HDSScrollService },
        { type: HDSViewportService },
        { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [WINDOW,] }] }
    ]; };
    __decorate([
        Input(),
        HostBinding('attr.id'),
        __metadata("design:type", Object)
    ], ToggletipComponent.prototype, "id", void 0);
    __decorate([
        HostBinding('class.hl-toggletip'),
        __metadata("design:type", Object)
    ], ToggletipComponent.prototype, "baseClass", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ToggletipComponent.prototype, "label", void 0);
    __decorate([
        Input('position'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], ToggletipComponent.prototype, "preferredOrientation", null);
    __decorate([
        ViewChild('toggleButton', { read: ElementRef }),
        __metadata("design:type", ElementRef)
    ], ToggletipComponent.prototype, "toggleButton", void 0);
    __decorate([
        ViewChild('tooltip', { read: ElementRef }),
        __metadata("design:type", ElementRef)
    ], ToggletipComponent.prototype, "tooltip", void 0);
    ToggletipComponent = ToggletipComponent_1 = __decorate([ __param(3, Inject(PLATFORM_ID)),
        __param(4, Inject(WINDOW)),
        __metadata("design:paramtypes", [Renderer2,
            HDSScrollService,
            HDSViewportService, String, Object])
    ], ToggletipComponent);
ToggletipComponent.ɵfac = function ToggletipComponent_Factory(t) { return new (t || ToggletipComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(HDSScrollService), ɵngcc0.ɵɵdirectiveInject(HDSViewportService), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID), ɵngcc0.ɵɵdirectiveInject(WINDOW)); };
ToggletipComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ToggletipComponent, selectors: [["hl-toggletip"]], viewQuery: function ToggletipComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c30, 5, ElementRef);
        ɵngcc0.ɵɵviewQuery(_c37, 5, ElementRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.toggleButton = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tooltip = _t.first);
    } }, hostVars: 3, hostBindings: function ToggletipComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("id", ctx.id);
        ɵngcc0.ɵɵclassProp("hl-toggletip", ctx.baseClass);
    } }, inputs: { preferredOrientation: ["position", "preferredOrientation"], id: "id", label: "label" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c4, decls: 6, vars: 4, consts: [["type", "button", 1, "hl-toggletip-trigger", 3, "click"], ["toggleButton", ""], ["icon", "help"], ["role", "tooltip", "aria-live", "polite", 1, "hl-tooltip"], ["tooltip", ""]], template: function ToggletipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "button", 0, 1);
        ɵngcc0.ɵɵlistener("click", function ToggletipComponent_Template_button_click_0_listener() { return ctx.toggle(); });
        ɵngcc0.ɵɵelement(2, "hl-icon", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "span", 3, 4);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ctx.label)("aria-describedby", ctx.tooltipId)("aria-expanded", ctx.expanded);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵattribute("id", ctx.tooltipId);
    } }, directives: [IconComponent], styles: [_c38], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToggletipComponent, [{
        type: Component,
        args: [{
                selector: 'hl-toggletip',
                template: "<button\n    #toggleButton\n    type=\"button\"\n    class=\"hl-toggletip-trigger\"\n    [attr.aria-label]=\"label\"\n    [attr.aria-describedby]=\"tooltipId\"\n    [attr.aria-expanded]=\"expanded\"\n    (click)=\"toggle()\"\n>\n    <hl-icon icon=\"help\"></hl-icon>\n</button>\n\n<span #tooltip [attr.id]=\"tooltipId\" class=\"hl-tooltip\" role=\"tooltip\" aria-live=\"polite\">\n    <ng-content></ng-content>\n</span>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".hl-tooltip{display:block;box-sizing:border-box;position:fixed;top:0;left:0;max-width:275px;padding:.75rem 1.25rem;border-radius:.25rem;margin-top:0;margin-bottom:0;font-size:.875rem;line-height:1.42857;letter-spacing:0;z-index:10;box-shadow:0 2px 4px rgba(0,0,0,.12);background-color:#4d4d4f;color:#fff;opacity:0;transition:opacity 75ms ease-out;pointer-events:none}@supports ((-webkit-filter:drop-shadow(0 2px 4px rgba(0,0,0,0.12))) or (filter:drop-shadow(0 2px 4px rgba(0,0,0,0.12)))){.hl-tooltip{box-shadow:unset;-webkit-filter:drop-shadow(0 2px 4px rgba(0, 0, 0, .12));filter:drop-shadow(0 2px 4px rgba(0, 0, 0, .12))}}.hl-toggletip-trigger[aria-expanded=true]+.hl-tooltip,.hl-tooltip-trigger:focus+.hl-tooltip,.hl-tooltip-trigger:hover+.hl-tooltip{opacity:1;pointer-events:initial}.hl-tooltip::before{content:'';position:absolute;height:0;width:0;border:8px solid transparent}.hl-tooltip[data-position=bottom]{margin-top:16px}.hl-tooltip[data-position=bottom]::before{top:-16px;left:50%;transform:translateX(-50%);border-bottom-color:#4d4d4f}.hl-tooltip[data-position=left]{margin-left:-16px}.hl-tooltip[data-position=left]::before{right:-16px;top:50%;transform:translateY(-50%);border-left-color:#4d4d4f}.hl-tooltip[data-position=right]{margin-left:16px}.hl-tooltip[data-position=right]::before{left:-16px;top:50%;transform:translateY(-50%);border-right-color:#4d4d4f}.hl-tooltip[data-position=top]{margin-top:-16px}.hl-tooltip[data-position=top]::before{bottom:-16px;left:50%;transform:translateX(-50%);border-top-color:#4d4d4f}.hl-toggletip{display:inline-block;height:1.25rem;width:1.25rem;flex-shrink:0}.hl-toggletip .hl-toggletip-trigger{margin:0;padding:0;border:.125rem solid transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none;overflow:visible;font-family:inherit;font-size:1rem;text-decoration:none;text-transform:none;background-color:transparent;cursor:pointer;height:100%;width:100%;border-radius:999999px;background-color:var(--hds-toggletip-accent,var(--hds-theme-accent-primary,#127691));color:#fff}.hl-toggletip .hl-toggletip-trigger:hover{box-shadow:0 0 8px rgba(0,0,0,.36)}.hl-toggletip .hl-toggletip-trigger:focus{outline:0;box-shadow:0 0 0 .125rem var(--hds-theme-base-background),0 0 0 calc(.125rem + .0625rem) var(--hds-theme-focus-ring)}.hl-toggletip .hl-toggletip-trigger:focus::-moz-focus-inner{border-style:none;padding:0}.hl-toggletip .hl-toggletip-trigger:focus:-moz-focusring{outline:0}.hl-toggletip .hl-toggletip-trigger[aria-expanded=true]{background-color:transparent;border-color:currentColor;color:var(--hds-toggletip-accent,var(--hds-theme-accent-primary,#127691))}.hl-toggletip .hl-toggletip-trigger .hl-icon{display:block;height:100%;width:100%}"]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: HDSScrollService }, { type: HDSViewportService }, { type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [WINDOW]
            }] }]; }, { preferredOrientation: [{
            type: Input,
            args: ['position']
        }], id: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.id']
        }], baseClass: [{
            type: HostBinding,
            args: ['class.hl-toggletip']
        }], label: [{
            type: Input
        }], toggleButton: [{
            type: ViewChild,
            args: ['toggleButton', { read: ElementRef }]
        }], tooltip: [{
            type: ViewChild,
            args: ['tooltip', { read: ElementRef }]
        }] }); })();
    return ToggletipComponent;
}(TooltipBaseComponent));

/**
 * Component that shows a tooltip to label or describe the target element.
 */
var TooltipComponent = /** @class */ (function (_super) {
    __extends(TooltipComponent, _super);
    /**
     * @ignore
     */
    function TooltipComponent(elementRef, renderer, scrollService, viewportService, platformId, window) {
        var _this = _super.call(this, renderer, scrollService, viewportService, platformId, window) || this;
        _this.elementRef = elementRef;
        /**
         * @ignore
         */
        _this.id = "hl-tooltip-" + TooltipComponent_1.componentCount++;
        /**
         * @ignore
         */
        _this.baseClass = true;
        /**
         * @ignore
         */
        _this.role = 'tooltip';
        /**
         * The type of contents the tooltip contains. A tooltip with a type of
         * "label" is associated with its triggering element via `aria-labelledby`;
         * a tooltip with a type of "description" is associated by `aria-describedby`.
         */
        _this.type = 'description';
        return _this;
    }
    TooltipComponent_1 = TooltipComponent;
    Object.defineProperty(TooltipComponent.prototype, "preferredOrientation", {
        /**
         * Preferred position for the tooltip, relative to its trigger.
         */
        get: function () {
            return this._preferredOrientation;
        },
        /**
         * Preferred position for the tooltip, relative to its trigger.
         */
        set: function (value) {
            if (value !== this._preferredOrientation) {
                this._preferredOrientation = value;
                this.updatePosition();
            }
        },
        enumerable: true,
        configurable: true
    });
    TooltipComponent.prototype.ngOnInit = function () {
        this.init(this.trigger, this.elementRef.nativeElement);
    };
    TooltipComponent.prototype.ngAfterViewInit = function () {
        this.updateTriggerAttributes();
    };
    TooltipComponent.prototype.ngOnDestroy = function () {
        this.destroy();
    };
    /**
     * Updates the tooltip's trigger element with the necessary attributes to
     * make it work with the tooltip.
     *
     * @internal
     */
    TooltipComponent.prototype.updateTriggerAttributes = function () {
        this.renderer.addClass(this.trigger, 'hl-tooltip-trigger');
        var attribute = this.type === 'label' ? 'aria-labelledby' : 'aria-describedby';
        // Add tooltip ID to the existing list of description/labelling elements
        var elements = [this.trigger.getAttribute(attribute), this.id].filter(Boolean).join(' ');
        this.renderer.setAttribute(this.trigger, attribute, elements);
    };
    var TooltipComponent_1;
    /**
     * Tracks the number of instances of the component that have been created.
     * Used to generate IDs for child elements, if an ID was not provided.
     *
     * @internal
     */
    TooltipComponent.componentCount = 0;
    TooltipComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: HDSScrollService },
        { type: HDSViewportService },
        { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [WINDOW,] }] }
    ]; };
    __decorate([
        HostBinding('attr.id'),
        __metadata("design:type", String)
    ], TooltipComponent.prototype, "id", void 0);
    __decorate([
        HostBinding('class.hl-tooltip'),
        __metadata("design:type", Object)
    ], TooltipComponent.prototype, "baseClass", void 0);
    __decorate([
        HostBinding('attr.role'),
        __metadata("design:type", Object)
    ], TooltipComponent.prototype, "role", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TooltipComponent.prototype, "type", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TooltipComponent.prototype, "text", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], TooltipComponent.prototype, "trigger", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], TooltipComponent.prototype, "preferredOrientation", null);
    TooltipComponent = TooltipComponent_1 = __decorate([ __param(4, Inject(PLATFORM_ID)),
        __param(5, Inject(WINDOW)),
        __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            HDSScrollService,
            HDSViewportService, String, Object])
    ], TooltipComponent);
TooltipComponent.ɵfac = function TooltipComponent_Factory(t) { return new (t || TooltipComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(HDSScrollService), ɵngcc0.ɵɵdirectiveInject(HDSViewportService), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID), ɵngcc0.ɵɵdirectiveInject(WINDOW)); };
TooltipComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TooltipComponent, selectors: [["hl-tooltip"]], hostVars: 4, hostBindings: function TooltipComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("id", ctx.id)("role", ctx.role);
        ɵngcc0.ɵɵclassProp("hl-tooltip", ctx.baseClass);
    } }, inputs: { preferredOrientation: "preferredOrientation", type: "type", text: "text", trigger: "trigger" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, template: function TooltipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0);
    } if (rf & 2) {
        ɵngcc0.ɵɵtextInterpolate(ctx.text);
    } }, styles: [_c38], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TooltipComponent, [{
        type: Component,
        args: [{
                selector: 'hl-tooltip',
                template: "{{ text }}",
                encapsulation: ViewEncapsulation.None,
                styles: [".hl-tooltip{display:block;box-sizing:border-box;position:fixed;top:0;left:0;max-width:275px;padding:.75rem 1.25rem;border-radius:.25rem;margin-top:0;margin-bottom:0;font-size:.875rem;line-height:1.42857;letter-spacing:0;z-index:10;box-shadow:0 2px 4px rgba(0,0,0,.12);background-color:#4d4d4f;color:#fff;opacity:0;transition:opacity 75ms ease-out;pointer-events:none}@supports ((-webkit-filter:drop-shadow(0 2px 4px rgba(0,0,0,0.12))) or (filter:drop-shadow(0 2px 4px rgba(0,0,0,0.12)))){.hl-tooltip{box-shadow:unset;-webkit-filter:drop-shadow(0 2px 4px rgba(0, 0, 0, .12));filter:drop-shadow(0 2px 4px rgba(0, 0, 0, .12))}}.hl-toggletip-trigger[aria-expanded=true]+.hl-tooltip,.hl-tooltip-trigger:focus+.hl-tooltip,.hl-tooltip-trigger:hover+.hl-tooltip{opacity:1;pointer-events:initial}.hl-tooltip::before{content:'';position:absolute;height:0;width:0;border:8px solid transparent}.hl-tooltip[data-position=bottom]{margin-top:16px}.hl-tooltip[data-position=bottom]::before{top:-16px;left:50%;transform:translateX(-50%);border-bottom-color:#4d4d4f}.hl-tooltip[data-position=left]{margin-left:-16px}.hl-tooltip[data-position=left]::before{right:-16px;top:50%;transform:translateY(-50%);border-left-color:#4d4d4f}.hl-tooltip[data-position=right]{margin-left:16px}.hl-tooltip[data-position=right]::before{left:-16px;top:50%;transform:translateY(-50%);border-right-color:#4d4d4f}.hl-tooltip[data-position=top]{margin-top:-16px}.hl-tooltip[data-position=top]::before{bottom:-16px;left:50%;transform:translateX(-50%);border-top-color:#4d4d4f}.hl-toggletip{display:inline-block;height:1.25rem;width:1.25rem;flex-shrink:0}.hl-toggletip .hl-toggletip-trigger{margin:0;padding:0;border:.125rem solid transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none;overflow:visible;font-family:inherit;font-size:1rem;text-decoration:none;text-transform:none;background-color:transparent;cursor:pointer;height:100%;width:100%;border-radius:999999px;background-color:var(--hds-toggletip-accent,var(--hds-theme-accent-primary,#127691));color:#fff}.hl-toggletip .hl-toggletip-trigger:hover{box-shadow:0 0 8px rgba(0,0,0,.36)}.hl-toggletip .hl-toggletip-trigger:focus{outline:0;box-shadow:0 0 0 .125rem var(--hds-theme-base-background),0 0 0 calc(.125rem + .0625rem) var(--hds-theme-focus-ring)}.hl-toggletip .hl-toggletip-trigger:focus::-moz-focus-inner{border-style:none;padding:0}.hl-toggletip .hl-toggletip-trigger:focus:-moz-focusring{outline:0}.hl-toggletip .hl-toggletip-trigger[aria-expanded=true]{background-color:transparent;border-color:currentColor;color:var(--hds-toggletip-accent,var(--hds-theme-accent-primary,#127691))}.hl-toggletip .hl-toggletip-trigger .hl-icon{display:block;height:100%;width:100%}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: HDSScrollService }, { type: HDSViewportService }, { type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [WINDOW]
            }] }]; }, { preferredOrientation: [{
            type: Input
        }], id: [{
            type: HostBinding,
            args: ['attr.id']
        }], baseClass: [{
            type: HostBinding,
            args: ['class.hl-tooltip']
        }], role: [{
            type: HostBinding,
            args: ['attr.role']
        }], type: [{
            type: Input
        }], text: [{
            type: Input
        }], trigger: [{
            type: Input
        }] }); })();
    return TooltipComponent;
}(TooltipBaseComponent));

/**
 * Assigns a tooltip to the host element.
 */
var TooltipDirective = /** @class */ (function () {
    /**
     * @ignore
     */
    function TooltipDirective(templateRef, vcRef, resolver) {
        this.templateRef = templateRef;
        this.vcRef = vcRef;
        this.resolver = resolver;
    }
    TooltipDirective.prototype.ngOnInit = function () {
        var viewRef = this.vcRef.createEmbeddedView(this.templateRef);
        var triggerElement = viewRef.rootNodes[0];
        var factory = this.resolver.resolveComponentFactory(TooltipComponent);
        var tooltipRef = this.vcRef.createComponent(factory);
        this.tooltip = tooltipRef.instance;
        this.tooltip.text = this.text;
        this.tooltip.trigger = triggerElement;
        if (this.type) {
            this.tooltip.type = this.type;
        }
        if (this.preferredOrientation) {
            this.tooltip.preferredOrientation = this.preferredOrientation;
        }
    };
    TooltipDirective.prototype.ngOnChanges = function (changes) {
        if (!this.tooltip) {
            return;
        }
        for (var prop in changes) {
            if (changes.hasOwnProperty(prop) && ['text', 'type', 'preferredOrientation'].includes(prop)) {
                this.tooltip[prop] = changes[prop].currentValue;
            }
        }
    };
    TooltipDirective.ctorParameters = function () { return [
        { type: TemplateRef },
        { type: ViewContainerRef },
        { type: ComponentFactoryResolver }
    ]; };
    __decorate([
        Input('hlTooltip'),
        __metadata("design:type", String)
    ], TooltipDirective.prototype, "text", void 0);
    __decorate([
        Input('hlTooltipType'),
        __metadata("design:type", String)
    ], TooltipDirective.prototype, "type", void 0);
    __decorate([
        Input('hlTooltipPosition'),
        __metadata("design:type", String)
    ], TooltipDirective.prototype, "preferredOrientation", void 0);
    TooltipDirective = __decorate([ __metadata("design:paramtypes", [TemplateRef,
            ViewContainerRef,
            ComponentFactoryResolver])
    ], TooltipDirective);
TooltipDirective.ɵfac = function TooltipDirective_Factory(t) { return new (t || TooltipDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver)); };
TooltipDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TooltipDirective, selectors: [["", "hlTooltip", ""]], inputs: { text: ["hlTooltip", "text"], type: ["hlTooltipType", "type"], preferredOrientation: ["hlTooltipPosition", "preferredOrientation"] }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TooltipDirective, [{
        type: Directive,
        args: [{
                selector: '[hlTooltip]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ComponentFactoryResolver }]; }, { text: [{
            type: Input,
            args: ['hlTooltip']
        }], type: [{
            type: Input,
            args: ['hlTooltipType']
        }], preferredOrientation: [{
            type: Input,
            args: ['hlTooltipPosition']
        }] }); })();
    return TooltipDirective;
}());

var TooltipsModule = /** @class */ (function () {
    function TooltipsModule() {
    }
TooltipsModule.ɵfac = function TooltipsModule_Factory(t) { return new (t || TooltipsModule)(); };
TooltipsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TooltipsModule });
TooltipsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [WINDOW_PROVIDERS], imports: [[CommonModule, IconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TooltipsModule, [{
        type: NgModule,
        args: [{
                declarations: [TooltipComponent, TooltipDirective, ToggletipComponent],
                imports: [CommonModule, IconModule],
                exports: [TooltipComponent, TooltipDirective, ToggletipComponent],
                entryComponents: [TooltipComponent],
                providers: [WINDOW_PROVIDERS]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TooltipsModule, { declarations: function () { return [TooltipComponent, TooltipDirective, ToggletipComponent]; }, imports: function () { return [CommonModule, IconModule]; }, exports: function () { return [TooltipComponent, TooltipDirective, ToggletipComponent]; } }); })();
    return TooltipsModule;
}());

/**
 * When you create a new component, add its module to this array.
 */
var COMPONENT_MODULES = [
    ActionGroupModule,
    AlertModule,
    BannerModule,
    ButtonModule,
    CardModule,
    CheckboxModule,
    ComboboxModule,
    DropdownModule,
    FormComponentsModule,
    IconModule,
    InputModule,
    LinkModule,
    ListboxModule,
    LoadingScreenModule,
    LoadingSpinnerModule,
    ModalModule,
    NavListModule,
    ProgressModule,
    RadioGroupModule,
    SkeletonModule,
    StepperModule,
    StepListModule,
    TabsModule,
    TextareaModule,
    TooltipsModule
];
var ComponentsModule = /** @class */ (function () {
    function ComponentsModule() {
    }
ComponentsModule.ɵfac = function ComponentsModule_Factory(t) { return new (t || ComponentsModule)(); };
ComponentsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ComponentsModule });
ComponentsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [__spread([CommonModule], COMPONENT_MODULES), ActionGroupModule, AlertModule, BannerModule, ButtonModule, CardModule, CheckboxModule, ComboboxModule, DropdownModule, FormComponentsModule, IconModule, InputModule, LinkModule, ListboxModule, LoadingScreenModule, LoadingSpinnerModule, ModalModule, NavListModule, ProgressModule, RadioGroupModule, SkeletonModule, StepperModule, StepListModule, TabsModule, TextareaModule, TooltipsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ComponentsModule, [{
        type: NgModule,
        args: [{
                imports: __spread([CommonModule], COMPONENT_MODULES),
                exports: __spread(COMPONENT_MODULES)
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ComponentsModule, { imports: function () { return [CommonModule, ActionGroupModule, AlertModule, BannerModule, ButtonModule, CardModule, CheckboxModule, ComboboxModule, DropdownModule, FormComponentsModule, IconModule, InputModule, LinkModule, ListboxModule, LoadingScreenModule, LoadingSpinnerModule, ModalModule, NavListModule, ProgressModule, RadioGroupModule, SkeletonModule, StepperModule, StepListModule, TabsModule, TextareaModule, TooltipsModule]; }, exports: function () { return [ActionGroupModule, AlertModule, BannerModule, ButtonModule, CardModule, CheckboxModule, ComboboxModule, DropdownModule, FormComponentsModule, IconModule, InputModule, LinkModule, ListboxModule, LoadingScreenModule, LoadingSpinnerModule, ModalModule, NavListModule, ProgressModule, RadioGroupModule, SkeletonModule, StepperModule, StepListModule, TabsModule, TextareaModule, TooltipsModule]; } }); })();
    return ComponentsModule;
}());

/**
 * Currency formatter for insurance face amount values.
 */
var FACE_AMOUNT_FORMAT = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});
/**
 * Formats an insurance face amount.
 */
var FaceAmountPipe = /** @class */ (function () {
    function FaceAmountPipe() {
    }
    /**
     * Formats an insurance face amount as a USD string.
     * @param value Face amount, in USD
     */
    FaceAmountPipe.prototype.transform = function (value) {
        return FACE_AMOUNT_FORMAT.format(value);
    };
FaceAmountPipe.ɵfac = function FaceAmountPipe_Factory(t) { return new (t || FaceAmountPipe)(); };
FaceAmountPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "faceAmount", type: FaceAmountPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FaceAmountPipe, [{
        type: Pipe,
        args: [{
                name: 'faceAmount'
            }]
    }], function () { return []; }, null); })();
    return FaceAmountPipe;
}());

/**
 * Formats a phone number according to US conventions.
 */
var PhoneNumberPipe = /** @class */ (function () {
    function PhoneNumberPipe() {
    }
    /**
     * Formats the given value as a phone number abiding by the [North American
     * Numbering Plan](https://en.wikipedia.org/wiki/North_American_Numbering_Plan).
     *
     * @param value Phone number to format
     *
     * @returns
     * * If `value` has exactly 7 digits: `xxx-xxxx`
     * * If `value` has exactly 10 digits: `(xxx) xxx-xxxx`
     * * If `value` has exactly 11 digits: `x (xxx) xxx-xxxx`
     * * Otherwise, returns `value` stripped of all non-digit characters
     */
    PhoneNumberPipe.prototype.transform = function (value) {
        var formattedValue = value.toString().replace(/\D/g, '');
        switch (formattedValue.length) {
            case 7:
                return formattedValue.substring(0, 3) + "-" + formattedValue.substring(3);
            case 10:
                return "(" + formattedValue.substring(0, 3) + ") " + formattedValue.substring(3, 6) + "-" + formattedValue.substring(6);
            case 11:
                return formattedValue.substring(0, 1) + " (" + formattedValue.substring(1, 4) + ") " + formattedValue.substring(4, 7) + "-" + formattedValue.substring(7);
            default:
                return formattedValue;
        }
    };
PhoneNumberPipe.ɵfac = function PhoneNumberPipe_Factory(t) { return new (t || PhoneNumberPipe)(); };
PhoneNumberPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "phone", type: PhoneNumberPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PhoneNumberPipe, [{
        type: Pipe,
        args: [{
                name: 'phone'
            }]
    }], function () { return []; }, null); })();
    return PhoneNumberPipe;
}());

/**
 * Currency formatter for insurance premium values.
 */
var PREMIUM_FORMAT = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
});
/**
 * Formats an insurance premium cost.
 */
var PremiumPipe = /** @class */ (function () {
    function PremiumPipe() {
    }
    /**
     * Formats an insurance premium as a USD string.
     * @param value Premium value, in USD
     */
    PremiumPipe.prototype.transform = function (value) {
        return PREMIUM_FORMAT.format(value);
    };
PremiumPipe.ɵfac = function PremiumPipe_Factory(t) { return new (t || PremiumPipe)(); };
PremiumPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "premium", type: PremiumPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PremiumPipe, [{
        type: Pipe,
        args: [{
                name: 'premium'
            }]
    }], function () { return []; }, null); })();
    return PremiumPipe;
}());

var PipesModule = /** @class */ (function () {
    function PipesModule() {
    }
PipesModule.ɵfac = function PipesModule_Factory(t) { return new (t || PipesModule)(); };
PipesModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PipesModule });
PipesModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PipesModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [FaceAmountPipe, PhoneNumberPipe, PremiumPipe],
                exports: [FaceAmountPipe, PhoneNumberPipe, PremiumPipe]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PipesModule, { declarations: function () { return [FaceAmountPipe, PhoneNumberPipe, PremiumPipe]; }, imports: function () { return [CommonModule]; }, exports: function () { return [FaceAmountPipe, PhoneNumberPipe, PremiumPipe]; } }); })();
    return PipesModule;
}());

/**
 * Service to show and hide modal dialogs.
 */
var ModalService = /** @class */ (function () {
    /**
     * @ignore
     */
    function ModalService(resolver, appRef, injector) {
        this.resolver = resolver;
        this.appRef = appRef;
        this.injector = injector;
        /**
         * @ignore
         */
        this.responseSubject = new Subject();
        /**
         * An Observable to subscribe to user responses to the modal.
         */
        this.response = this.responseSubject.asObservable();
    }
    /**
     * Creates a modal dialog.
     * @param contentsType Component model for the modal contents
     * @param config Data to provide the modal and contents components
     */
    ModalService.prototype.create = function (contentsType, config) {
        var _this = this;
        // Only allow one modal open at a time
        if (this.componentRef) {
            return;
        }
        this.previouslyFocusedElement = document.activeElement;
        // Create a new ModalComponent and attach it to the <body> element
        var factory = this.resolver.resolveComponentFactory(ModalComponent);
        var componentRef = factory.create(this.injector);
        this.appRef.attachView(componentRef.hostView);
        var domElement = componentRef.hostView
            .rootNodes[0];
        document.body.appendChild(domElement);
        // Prevent users from scrolling the main content while the modal is active
        document.body.classList.add('hl-a11y--modal-active');
        // Inject data into the ModalComponent instance
        this.componentRef = componentRef;
        this.componentRef.instance.contentsType = contentsType;
        this.componentRef.instance.config = config;
        this.componentRef.changeDetectorRef.detectChanges();
        // Listen for the ModalComponent to announce that it should be destroyed
        this.destroySubscription = this.componentRef.instance.destroy.subscribe(function (response) {
            _this.destroy();
            _this.responseSubject.next(response);
            _this.destroySubscription.unsubscribe();
        });
        return this.componentRef.instance;
    };
    /**
     * Creates a modal dialog configured to show the user a simple message
     * without any follow-up actions.
     * @param title Title of the modal
     * @param text Text to notify the user of
     */
    ModalService.prototype.createNotification = function (title, text) {
        var config = {
            title: title,
            text: text,
            size: 'medium',
            isAlert: true,
            buttons: { confirm: { hide: true }, cancel: { hide: true } }
        };
        return this.create(BasicModalContentsComponent, config);
    };
    /**
     * Creates a modal dialog configured for the user to acknowledge a message.
     * @param title Title of the modal
     * @param text Text for the user to acknowledge
     * @param buttonText Text of the confirm button
     */
    ModalService.prototype.createAcknowledgement = function (title, text, buttonText) {
        if (buttonText === void 0) { buttonText = 'OK'; }
        var config = {
            title: title,
            text: text,
            size: 'medium',
            isAlert: true,
            buttons: {
                confirm: { text: buttonText },
                cancel: { hide: true }
            }
        };
        return this.create(BasicModalContentsComponent, config);
    };
    /**
     * Creates a modal dialog configured to show the user a message they must
     * confirm. This pattern is useful to double-check that users intended to
     * perform an action.
     * @param title Title of the modal
     * @param text Text for the user to confirm
     */
    ModalService.prototype.createConfirmation = function (title, text) {
        var config = {
            title: title,
            text: text,
            size: 'medium',
            isAlert: true,
            buttons: { confirm: { text: 'Yes' }, cancel: { text: 'No' } }
        };
        return this.create(BasicModalContentsComponent, config);
    };
    /**
     * Destroys the active modal dialog.
     */
    ModalService.prototype.destroy = function () {
        if (!this.componentRef) {
            return;
        }
        this.appRef.detachView(this.componentRef.hostView);
        this.componentRef.destroy();
        this.componentRef = null;
        // Allow users to scroll the main content again
        document.body.classList.remove('hl-a11y--modal-active');
        // Restore focus to the element that had it before the modal opened
        this.previouslyFocusedElement.focus();
    };
    ModalService.ctorParameters = function () { return [
        { type: ComponentFactoryResolver },
        { type: ApplicationRef },
        { type: Injector }
    ]; };
    ModalService = __decorate([ __metadata("design:paramtypes", [ComponentFactoryResolver,
            ApplicationRef,
            Injector])
    ], ModalService);
ModalService.ɵfac = function ModalService_Factory(t) { return new (t || ModalService)(ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
ModalService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ModalService, factory: function (t) { return ModalService.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ApplicationRef }, { type: ɵngcc0.Injector }]; }, null); })();
    return ModalService;
}());

var DesignSystemModule = /** @class */ (function () {
    function DesignSystemModule() {
    }
DesignSystemModule.ɵfac = function DesignSystemModule_Factory(t) { return new (t || DesignSystemModule)(); };
DesignSystemModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DesignSystemModule });
DesignSystemModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [ModalService, WINDOW_PROVIDERS], imports: [[CommonModule, ReactiveFormsModule, ComponentsModule, DirectivesModule, PipesModule], ComponentsModule, DirectivesModule, PipesModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DesignSystemModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, ReactiveFormsModule, ComponentsModule, DirectivesModule, PipesModule],
                exports: [ComponentsModule, DirectivesModule, PipesModule],
                providers: [ModalService, WINDOW_PROVIDERS]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DesignSystemModule, { imports: function () { return [CommonModule, ReactiveFormsModule, ComponentsModule, DirectivesModule, PipesModule]; }, exports: function () { return [ComponentsModule, DirectivesModule, PipesModule]; } }); })();
    return DesignSystemModule;
}());

/**
 * Matches dates of the format "mm/dd/yyyy".
 *
 * NOTE: This regex allows strings that have a valid format but are not valid
 * dates (e.g., 02/31/2000). Be sure to validate those cases in your logic.
 */
var DATE_REGEX = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[1-2][0-9]|3[0-1])\/\d{4}$/;
/**
 * A set of helper functions for input validation.
 */
var ValidationUtils = /** @class */ (function () {
    function ValidationUtils() {
    }
    /**
     * Returns whether the given control is in an invalid state.
     * @param control Control to test
     */
    ValidationUtils.isInvalid = function (control) {
        return (control.touched || control.dirty) && control.invalid;
    };
    /**
     * If the given control is invalid, returns an object containing the error
     * message for each validation key. Application logic may use this to
     * decide which error message to display when multiple errors apply.
     * @param control Control to test
     */
    ValidationUtils.getErrorMessages = function (control) {
        if (this.isInvalid(control)) {
            var errors = {};
            for (var key in control.errors) {
                if (control.errors.hasOwnProperty(key)) {
                    var error = this.ERROR_MESSAGES[key];
                    if (error) {
                        errors[key] = error;
                    }
                }
            }
            return errors;
        }
    };
    /**
     * If the given control fails the specified validation check, returns the
     * error message for that check.
     * @param control Control to test
     * @param key Key of the validation error
     */
    ValidationUtils.getErrorMessage = function (control, key) {
        if (this.isInvalid(control) && key in control.errors) {
            return this.ERROR_MESSAGES[key];
        }
    };
    /**
     * Default error messages for common validation scenarios.
     */
    ValidationUtils.ERROR_MESSAGES = {
        allRequired: 'All of the above fields are required',
        inArray: 'Please enter one of the suggested values',
        invalidDate: 'Please enter a valid date (mm/dd/yyyy)',
        required: 'Required'
    };
    return ValidationUtils;
}());
/**
 * Custom validator functions for Angular forms.
 */
var CustomValidators = /** @class */ (function () {
    function CustomValidators() {
    }
    CustomValidators.allRequired = function (group) {
        var e_1, _a;
        var missingControlValues = [];
        try {
            for (var _b = __values(Object.keys(group.controls)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                var controlValue = group.controls[key].value;
                if (controlValue === undefined || controlValue === null || controlValue === '') {
                    missingControlValues.push(key);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (missingControlValues.length > 0) {
            return { allRequired: { missingValues: missingControlValues } };
        }
        return null;
    };
    /**
     * Validates that the control value is a valid date.
     * @param control Form control to validate
     *
     * @deprecated The Date Input component now provides its own date validator
     * based on its specified date format. This validator will be deleted in a
     * future release.
     *
     * @todo Remove in v2
     */
    CustomValidators.dateValidator = function (control) {
        // Sanity check: Is the value date-like?
        if (!DATE_REGEX.test(control.value)) {
            return { invalidDate: { value: control.value } };
        }
        // Convert the value to a Date object and see if the string
        // representations match. If not, the value isn't a real date
        var dateObj = new Date(control.value);
        var dateObjString = dateObj.toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
        if (dateObjString !== control.value) {
            return { invalidDate: { value: control.value } };
        }
        return null;
    };
    /**
     * Returns a function that validates that the control value belongs to the
     * specified array.
     *
     * @param array Array containing the allowed values of the control
     */
    CustomValidators.inArray = function (array) {
        var validator = function (control) {
            if (!array.includes(control.value)) {
                return { inArray: { array: array, value: control.value } };
            }
            return null;
        };
        return validator;
    };
    return CustomValidators;
}());

/*
 * Public API Surface of havendtc-design-system
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ActionGroupComponent, ActionGroupModule, AlertComponent, AlertModule, BannerComponent, BannerModule, BaseModalContents, BasicModalContentsComponent, BrowserWindowRef, ButtonComponent, ButtonModule, ButtonVersionDirective, CardComponent, CardModule, CheckboxComponent, CheckboxModule, ComboboxComponent, ComboboxModule, ComponentsModule, CustomFormControl, CustomValidators, DEFAULT_CONFIG, DateFormatDirective, DateInputComponent, DesignSystemModule, DirectivesModule, DropdownComponent, DropdownModule, DropdownSelectComponent, FaceAmountPipe, FormActionsDirective, FormComponent, FormComponentsModule, FormControlsCommonModule, FormFieldComponent, FormFieldErrorComponent, FormQuestionComponent, FormSectionComponent, HDSFormControlDirective, HDSScrollService, HDSViewportService, HDS_ICON_SPRITE_CONFIG, IconComponent, IconModule, InputComponent, InputModule, LinkComponent, LinkModule, ListboxComponent, ListboxModule, LoadingScreenComponent, LoadingScreenModule, LoadingSpinnerComponent, LoadingSpinnerModule, MinimalButtonComponent, ModalComponent, ModalModule, ModalService, NavListComponent, NavListItemDirective, NavListModule, NavSublistComponent, NavSublistToggleDirective, PhoneNumberPipe, PipesModule, PlaceholderDirective, PremiumPipe, ProgressComponent, ProgressModule, ProjectedInputDirective, ProjectedTextareaDirective, RadioGroupComponent, RadioGroupModule, SkeletonGroupComponent, SkeletonModule, SkeletonPlaceholderComponent, SkeletonTextComponent, StepListComponent, StepListModule, StepListStepComponent, StepperComponent, StepperModule, TabComponent, TabGroupComponent, TabLabelDirective, TabsModule, TextareaComponent, TextareaModule, ToggletipComponent, TooltipComponent, TooltipDirective, TooltipsModule, ValidationContextDirective, ValidationUtils, WINDOW, WINDOW_PROVIDERS, WindowRef, windowFactory, ɵ0$1 as ɵ0, StepComponent as ɵa, TooltipBaseComponent as ɵb };

//# sourceMappingURL=hit-haven-design-system.js.map